export default {
	data: [
      {
          "x": [
              -0.769119835518147,
              0.666251871432207,
              -0.338984153807151,
              -0.814676392962919,
              -0.701948540369477,
              -0.257001707371675,
              -0.752184274641455,
              -0.733600587807335,
              -0.505151974490573,
              -0.216907980723855,
              -2.5261470537201,
              -2.86195126423776,
              -1.93215805142198,
              -1.81981507698458,
              -1.48032021999434,
              -1.74173392644103,
              -1.27051046406612,
              -1.94143207539767,
              -3.39025598661306,
              -2.37224674797656,
              -1.84312853674815,
              -1.69673206645223,
              -1.25600127288547,
              -0.136897602149168,
              -1.00192447797556,
              -1.48331136764036,
              -0.0652820516889038,
              -1.22381517613669,
              -1.17385936572159,
              -1.82981994774438,
              -1.51310209714015,
              -2.70774461172238,
              0.217830735638997,
              -1.21740844791256,
              -3.02204014095405,
              -0.170502203893898,
              -0.779464111868859,
              -1.1380879046757,
              -1.42557639704052,
              0.306972556259973,
              -2.53374909525607,
              -2.10118562077763,
              -0.97459670226626,
              -1.45900793831668,
              -3.02358616963538,
              -1.23520351272009,
              -0.990010125007869,
              -0.380235656446489,
              0.127305678336088,
              -1.08802766459349,
              -1.92932471532295,
              -0.962700810203783,
              -0.346868379302263,
              -2.54402455027054,
              -0.139437333191455,
              -2.47148357056094,
              -3.57929882812138,
              -2.61413116153698,
              -2.24280724072952,
              -1.36008468955664,
              -1.05866373818629,
              -1.39658675310786,
              -1.23673833366083,
              -1.25414774995435,
              -1.08745452416145,
              -0.417690756668467,
              -4.69500133743537,
              -0.932232663946004,
              -0.00581749899937145,
              -1.02747605755023,
              0.013254515060353,
              -2.33748717763115,
              -0.447076216679842,
              0.979137434237785,
              -0.00882003147822191,
              -0.630795354112293,
              0.0126840978669651,
              0.0380857178454375,
              -0.516209997871723,
              2.31057804260819,
              -0.398381642825327,
              -0.433090029941667,
              -0.313158296450149,
              0.0749918439915883,
              -1.55801580821807,
              1.09554572479896,
              0.294159252282797,
              0.81164608301694,
              -0.792888874502789,
              -0.972077635456609,
              0.125271769163954,
              -1.17936147045744,
              -1.13488120460972,
              0.409383344790053,
              -1.76322679776356,
              -1.05090121966493,
              -1.47978573152067,
              -2.12413842521333,
              -0.744960155627861,
              -1.32488752990549,
              -2.39189146308611,
              -3.76535847463492,
              -2.37235581863071,
              -1.37303102046268,
              -2.41603346992103,
              -1.59559289889007,
              -0.160491591893268,
              -1.92425425128739,
              0.808200441937659,
              1.40633513042072,
              -0.184422943497085,
              -0.0330597087467946,
              -0.430774674596828,
              -0.614448198674859,
              -1.1778188509007,
              -0.964307103927527,
              -1.38039812963938,
              -0.0398228187169476,
              -0.663636779735951,
              -0.0598338520289226,
              -1.44979152318885,
              -2.80922890595895,
              -1.39401666058484,
              -1.94823166715715,
              -0.583301852246685,
              -1.30013029371971,
              -1.24391053608142,
              -0.275927190594939,
              -0.234320855073012,
              0.471352410381866,
              0.167362977681354,
              -0.608115829435625,
              -0.48182855612446,
              -0.32484262764444,
              0.941240366366108,
              -0.739993970852497,
              -2.54334719955823,
              -0.425797232884044,
              0.054739970539599,
              -0.830034807103121,
              -0.74843725959703,
              -0.186297520010872,
              -0.40691161889993,
              -1.54841252925458,
              2.44748025376402,
              0.0825307370814991,
              1.19079001773556,
              -0.391285238111476,
              -0.696458297764026,
              1.32481423172024,
              -0.984269516247207,
              -0.529251397472587,
              0.248100922248678,
              -0.571529946369864,
              -0.225005809201415,
              -0.558687553263334,
              -1.14572207369935,
              -0.14407459948943,
              -0.928482802412089,
              -2.43211244324427,
              -0.149830157174976,
              -0.379308820768582,
              -0.433172779850803,
              -2.1742880787024,
              -0.243899533483811,
              -0.600538600734243,
              0.744755493500423,
              0.325674340140968,
              0.0283556883418266,
              0.213227949000301,
              -0.338566888878769,
              0.0161100656360979,
              -1.56282835013262,
              -0.401402990271047,
              -0.754274110327936,
              -1.02898316005069,
              -0.0798300885044185,
              -0.445556885852932,
              -0.458170020224363,
              -1.86143108402857,
              0.00632748833074487,
              -0.333518019155321,
              -0.242802855244224,
              0.634675728816014,
              -0.575517728608911,
              -0.357470951130889,
              -0.340892653397592,
              -0.507358439179112,
              -2.08397886194028,
              -1.10119698763393,
              -0.447784009595339,
              -0.364815968300232,
              2.54168665537986,
              -0.752756338784188,
              -0.384754531988173,
              -0.162418877201149,
              -0.0972252583337917,
              -1.03751051842266,
              1.11613549686144,
              -0.085848541532079,
              -0.452747179624227,
              0.257121640837363,
              0.165771735766799,
              0.0615389676516068,
              0.694935815126239,
              -0.24892518324062,
              -0.628320382690407,
              -1.84999035295071,
              -0.243631531578,
              -0.669324856393467,
              -0.639964603192978,
              -0.833239806414826,
              -1.18863057459869,
              -0.172337980102755,
              -1.99674798487826,
              -0.591631496728147,
              -0.316046887731393,
              -0.872677893386223,
              -1.53270347528268,
              -0.44540235937297,
              0.0967249775285556,
              0.227544365564732,
              -0.0983088680494854,
              -0.12496083940948,
              -0.475643279854665,
              -0.799387125749603,
              -0.639965860068797,
              -0.105170392201345,
              0.973868107591784,
              -0.893316514473218,
              -0.936349275525156,
              -0.374787312167194,
              -0.0287378482525162,
              -0.766835864107846,
              -0.474222273304413,
              -0.649297124956466,
              -0.666970823142184,
              0.0853311907092394,
              -0.612381714138875,
              -0.727229605982824,
              -0.450684046525726,
              -0.804035052534006,
              0.0299932120932995,
              -0.618152257595996,
              0.204923115910287,
              2.26910644057851,
              -0.0370969186622728,
              0.977135432157674,
              -0.312710742270292,
              -1.2206737119508,
              -0.144663010496453,
              -0.14333302178955,
              0.894544085590231,
              -0.743999245827465,
              -0.453988039870607,
              -0.623090319748289,
              -0.396308505500909,
              0.957570296136802,
              -0.0971217108349055,
              -1.30911976863402,
              0.259951963179508,
              -0.0323778443672916,
              -0.0456539715212348,
              -0.590097365574568,
              -0.711735870311156,
              -0.755557865557754,
              0.199018126461405,
              0.0529778085590747,
              -1.1781041370005,
              -1.84750703626923,
              -0.0106269286469258,
              -0.511938278262022,
              -0.621298258374662,
              -1.18859741678498,
              -1.34866597412756,
              -0.575277911851719,
              -1.248363837793,
              -0.712250630915895,
              -0.399751175905173,
              -1.44887415294539,
              -0.111319379296548,
              -2.24671715551216,
              0.32460948133869,
              -0.568588940374913,
              -1.24962209906545,
              -0.114177475432086,
              -0.185818516199866,
              0.0329130321378847,
              -0.386825837783341,
              -1.03026391917996,
              -0.675418220345309,
              -0.824315469873142,
              -0.556225363066283,
              -1.01580353005241,
              -0.314583055449211,
              -0.239883036244068,
              -0.625006606056792,
              -0.206144904158703,
              -0.386796813373912,
              0.584189768272976,
              -0.412810349952088,
              -1.53036887681548,
              -0.029214467569656,
              -0.0902714861462643,
              -0.236045285941438,
              -2.08193877320574,
              -0.162851073387538,
              1.41469206043964,
              -0.722038365894976,
              1.38693731783042,
              -0.364199428377607,
              -0.0941204618003013,
              -0.0909607320260553,
              0.359281463566908,
              0.121763191736184,
              -1.02460793016749,
              -1.19832007422778,
              -1.36486358340779,
              -0.617510967404846,
              -0.860283796837388,
              -0.603087174113173,
              -0.822776683465622,
              0.971164223873922,
              -1.63646697345578,
              -1.82555517470826,
              -0.366463468620787,
              -0.272070364858147,
              -0.750996841283309,
              0.766944202108292,
              -0.931840877456928,
              0.474384668291174,
              -1.13438249629973,
              -0.736837672562946,
              -0.88340603693249,
              -0.0249104259412212,
              -0.349550354075262,
              -0.106722030422673,
              -0.6005654431054,
              -0.184280233008059,
              -0.924976967517465,
              -0.401299244029589,
              -0.00897891285970492,
              -0.332490213614365,
              -0.928272076617302,
              0.440894834084824,
              0.598713907957797,
              2.28562234083936,
              -0.222843029031139,
              -0.341376399665639,
              0.314700487029335,
              -1.10678607135484,
              -0.399343365556601,
              -0.527301206056703,
              -0.635162081285447,
              -0.351126794269518,
              0.0106322048833586,
              -0.138881789009421,
              0.633147232639744,
              -1.00805372029718,
              -0.795970964440792,
              0.0765133666688146,
              -0.28338014582912,
              -0.640975400065488,
              -0.0395360968007067,
              0.194036145087634,
              -0.521962010734996,
              0.072535332254219,
              -0.291133556483481,
              -0.462354193216019,
              -0.433863007278661,
              -0.266047766564824,
              -0.406402033892846,
              0.327284915703894,
              -1.25605846079492,
              -1.3119531885581,
              -0.843595749639451,
              0.0424083181525944,
              -0.549324436107474,
              -1.91531150444027,
              -0.842809985222934,
              -0.555747878903962,
              -0.185950395507263,
              0.186525292720853,
              -0.40047594310736,
              -1.37351086677117,
              -0.51625400752256,
              1.16283980120484,
              -0.566019959487617,
              1.50356789645815,
              -2.37142378174749,
              -0.27596037077668,
              0.786940480848255,
              -0.499564577287961,
              -3.16268863308849,
              -1.77584535267378,
              -0.0702876945013767,
              0.00219063471854641,
              -0.470862711831017,
              -0.465059393724688,
              -0.90418714038125,
              0.292167441430128,
              -0.347499411896494,
              -0.525095449139241,
              -0.965079867842232,
              -1.65606357727981,
              -0.514649238373434,
              -0.252742444503391,
              -0.538581355890879,
              -0.411450209892893,
              -0.0732283471800592,
              0.294662297861246,
              1.83810131824459,
              -0.567973887683004,
              -0.133620656408114,
              -0.58320096948696,
              -0.245780523385317,
              -1.0978508394848,
              -0.262242463633617,
              -1.62488481983942,
              -0.967233423798675,
              -0.106734025576483,
              -0.543919660301298,
              -0.33450518363568,
              -0.130433678906836,
              0.428839963534154,
              0.902912231491051,
              -0.371991059650853,
              -0.194248484524042,
              -0.228857659489677,
              0.208000276186981,
              0.206552065634289,
              -0.431484315854131,
              -0.825932405055619,
              -0.0897802767354297,
              -0.251869656273923,
              -0.251366501049406,
              -0.199886353672413,
              0.173609256736567,
              -0.166093603701323,
              -0.525018050542626,
              -0.137134839089437,
              0.0654937321828015,
              0.513940191325677,
              -0.332309558730273,
              -0.368287075312618,
              -0.707788428750585,
              0.172134990216101,
              -0.880784434527274,
              -0.656516011368625,
              -0.693331427996811,
              -0.639425128008332,
              1.42145554984168,
              0.26074419141662,
              -1.20398030390197,
              -0.956615804263389,
              -0.258327712463391,
              -0.353456520997448,
              -0.378315424756056,
              -0.561747927011825,
              -0.461615749013378,
              -0.648293653257166,
              -0.6014697548533,
              -0.543048140086532,
              -0.890847994409932,
              0.130827286028187,
              0.462898686356293,
              -1.03103320667455,
              -0.552713713413523,
              -1.72785446578579,
              -0.309351410493095,
              0.0669218939689475,
              -0.568293990799608,
              -1.27031334628616,
              -0.346994924557943,
              0.820729138010248,
              -1.03001053477718,
              -0.782490607199529,
              0.105981199952624,
              -0.859522811228,
              -1.5579564017398,
              -0.567622061662933,
              0.0905534588736401,
              -0.745696988522918,
              -0.429596255151828,
              -0.187494248867726,
              -0.398804659284601,
              -0.152073844807123,
              -0.452898225025314,
              -0.729692237891415,
              -0.784312114660738,
              -0.427403747279544,
              -0.811023353782753,
              -1.2754902625925,
              -0.922130650800773,
              -1.12857158139422,
              -1.07353381307422,
              -1.38989748488478,
              -0.391003982781724,
              -1.13863461158982,
              -0.64015782904514,
              -0.417333413094267,
              -0.392734274256336,
              -0.207002168233706,
              -0.395460874355388,
              1.06791267550091,
              -0.498718171066243,
              -0.456599943262007,
              -1.10165580584538,
              -1.95732470587254,
              3.33344056879286,
              -0.562621424762753,
              -1.25764301296128,
              -0.0752644570356312,
              -2.46953365390451,
              -3.51398463024392,
              -0.392223195099156,
              -0.341448623944212,
              -0.734280689932109,
              -1.22165054736998,
              -0.490047453775435,
              -1.56014376564871,
              -0.404702658672352,
              -0.237416305204684,
              -0.293592396684613,
              -2.14843856541798,
              -0.145588416350936,
              -0.319499021585009,
              -0.496041212273873,
              -0.696194051728297,
              -0.0419977430984994,
              -0.262720924932815,
              -1.28333399793513,
              -0.404285500211449,
              0.789821331932219,
              -0.214218811343957,
              0.118030546411424,
              0.113109711406813,
              0.554117559662275,
              0.205898534151216,
              -1.02072516051213,
              -0.964404387706422,
              1.20564155509021,
              0.131071263885999,
              -0.785717026923367,
              -0.177152159357074,
              -0.0630037464880538,
              -0.370796746562105,
              -0.0464856962959638,
              -0.398237077459511,
              0.184953174946619,
              -0.283026274103251,
              -0.543869474627118,
              -0.640821924542198,
              -0.199509566472541,
              -0.225565537355431,
              0.242520909431518,
              0.733363976338896,
              1.88819959975486,
              -0.838818708598544,
              -0.683763722201937,
              -1.13073068378012,
              -0.970731022503672,
              -0.274340819131517,
              0.0921475010177742,
              -0.727240418828162,
              -0.344886116839229,
              -0.59583123560106,
              -0.553658418735267,
              -0.497724293595513,
              -0.506941218749093,
              -0.255543351660617,
              -0.0143179431830698,
              -0.564654026592034,
              0.108852312438947,
              -0.580257508797303,
              -0.582955595637321,
              0.320414529397651,
              -1.02670132136833,
              -0.349238580809285,
              -0.0677835906406626,
              -0.383202215785359,
              -0.325627419160586,
              -0.560943565945758,
              -0.709154201602182,
              -0.48559998292159,
              -0.52304326891019,
              -0.799515777277339,
              1.21461654542609,
              -0.633708860333566,
              -0.223162867574529,
              0.758860836831877,
              -2.62706280984057,
              0.764174566508796,
              0.268910482344961,
              0.143036527645376,
              -1.11614698056525,
              -1.32777412173232,
              -0.231779851421061,
              -1.16314792349848,
              -1.22965712758949,
              -1.29683018739993,
              -0.0480854694582856,
              -0.523184523550295,
              -0.238407307889089,
              -1.07775216072322,
              -1.51959809783028,
              0.257130153497256,
              0.0704678925807117,
              -1.17143846166303,
              -0.629021793348787,
              -0.0876824399213047,
              0.237800771083579,
              -0.675932381287584,
              -0.530299052474858,
              -0.747071297203583,
              -0.333430681032735,
              -0.182116440714312,
              0.721293597989877,
              -0.154404671567206,
              0.186354640541803,
              -1.97971162761643,
              -1.97249484746441,
              2.42184931198004,
              -0.681113092295325,
              1.61447353809342,
              -1.09951163082737,
              -3.04487037585706,
              -2.79477434047649,
              -3.49985037433257,
              -0.524387768783599,
              -1.19630933488746,
              0.00891806914125143,
              -0.00548320716957718,
              -0.235977231805375,
              -0.397495082427833,
              0.981070292121143,
              -2.88970332996587,
              -3.83037514769421,
              -0.233697819990547,
              -0.345446318455226,
              -0.456955362124649,
              0.176579282874551,
              -0.80614731591959,
              0.977952398556558,
              -0.00786408697068719,
              -0.548272547637166,
              0.20321662054253,
              0.85234604403535,
              -1.37159876718697,
              -1.53511449500386,
              0.61265683208403,
              -0.297102055449147,
              -0.229565060288229,
              -0.00205997742785574,
              -1.6480450898643,
              -0.915875846986286,
              -0.484133827186207,
              -0.292584243444431,
              -0.765991032019932,
              0.591991893204077,
              -0.869476136167139,
              -0.21167595067405,
              -0.641819248796136,
              -0.464473937969554,
              -1.72749224406118,
              -0.287722704760143,
              -0.339398642059554,
              -0.334415287036482,
              0.248413821918962,
              0.583184573412849,
              -0.997403740836551,
              -0.379273268111807,
              -1.98763602042869,
              0.327381641743315,
              0.525345065018962,
              2.18239084182111,
              -0.521882262895046,
              -0.531525458854726,
              0.190630484678612,
              1.09500244532514,
              -0.0299898860980784,
              0.686540211461678,
              -0.268526558587247,
              0.0225132679570492,
              -1.7160163237398,
              -0.357951737295333,
              1.78280626803642,
              -0.166026463933497,
              -0.440614529913978,
              -1.47236830956721,
              -0.293370753096392,
              -0.155115359214836,
              -0.797441738511949,
              -0.985019312326605,
              0.0662917140330177,
              0.352723637867781,
              -0.483708139333294,
              -0.735119201443086,
              -0.534240015445588,
              -0.676105389814401,
              -0.83174318483537,
              -0.224853748901026,
              -0.381366481080735,
              -0.588533628045169,
              -0.364776810830468,
              0.849717876184398,
              -0.968994719182319,
              0.474604350290203,
              2.01508660561208,
              -4.05309997659378,
              -0.116278237714559,
              0.101658420067666,
              -1.30232180929673,
              -0.899699339663754,
              0.664843164078617,
              -0.782747048378585,
              -0.768936173571405,
              -0.213460294346587,
              -1.5637305731947,
              -0.298403404651149,
              -0.458561716132015,
              -0.494104968251227,
              3.4030512418191,
              -0.841185087740215,
              -0.0244456375879248,
              -0.65302845100777,
              -0.138000504651208,
              -0.379525716482642,
              -1.55227567829171,
              -1.21226662797956,
              -0.73197153204464,
              0.0415637140999586,
              -0.489989935831513,
              1.88603254926337,
              -0.787498782476287,
              -0.60160992451452,
              -0.318466845035872,
              -0.657331145104369,
              -0.421410843441132,
              -0.163807488027969,
              -0.194677823447699,
              -0.682325949186093,
              -0.10256395316438,
              -0.858498268637151,
              2.0599583456549,
              0.703518038332646,
              -0.935519527062043,
              -0.0582761058859922,
              -0.183849602893921,
              0.731995022676765,
              -0.482312194990784,
              -1.94888032278551,
              -0.181484992973389,
              -0.857915017174391,
              -0.544732195138536,
              -0.669089148721777,
              -0.6736602617106,
              -0.866448612105751,
              0.286172788518218,
              0.158212593911511,
              0.330339577297473,
              -0.247523288734138,
              -0.340902508373798,
              -0.977062268817718,
              -0.25901858667817,
              -2.97531724300774,
              0.0405020601375814,
              -1.93006799992877,
              -3.76056897431387,
              -3.31165613560488,
              -1.44230157399551,
              -1.67938547382028,
              -2.6291967866305,
              -1.11218620395898,
              -1.58838385093534,
              -0.251506027489582,
              -0.301368715977451,
              -0.285219069670704,
              -0.580671443704161,
              -0.643306204322131,
              -0.160590303151267,
              0.301668230075617,
              -0.0683088978141212,
              2.52583167319904,
              0.852188438486161,
              -0.703447891406257,
              0.549039332100275,
              -0.247454339291716,
              -0.64946282634691,
              -0.172419956790755,
              -0.27526416707714,
              -1.03414660351045,
              -0.983268015286286,
              -0.409245703254315,
              -0.877343761120712,
              1.16257695416818,
              -0.633909100618282,
              -0.924461159294231,
              0.390464186011846,
              -6.18875346723342,
              0.437219929452061,
              -0.613714186760912,
              0.782188297307061,
              -1.11057177386053,
              -0.855922207156734,
              0.312931538425602,
              -0.207407992183858,
              -0.652885909361088,
              -1.26597532005885,
              -0.783480299190473,
              -0.526237922325155,
              -0.633702428558896,
              -0.638132935791857,
              -0.264623835290905,
              -0.934271556499585,
              -0.953103204856565,
              -0.991227651982756,
              1.08150424819488,
              -0.272607094907897,
              -0.548731635092889,
              -0.207052468210673,
              -0.3434415683631,
              -0.715111889492852,
              -0.664622400494524,
              -0.337481151285754,
              -0.781668778405628,
              -0.933709450356234,
              0.887623668959014,
              0.320603138832745,
              -0.824572065525517,
              0.189212204287402,
              0.0547875927848198,
              -0.0354028654039551,
              -1.47639222671517,
              -0.745780294976118,
              -0.892460670604572,
              -0.538746493209426,
              -0.697389126603857,
              -0.788415789963703,
              -0.536908426655986,
              -0.652048202084574,
              -0.703679697961949,
              -0.356268871288084,
              -0.641996007266608,
              -1.04022882318225,
              1.21207764717003,
              -0.790506186478818,
              -0.80084717702095,
              -0.426690366699763,
              -0.295841774933766,
              0.697049357227308,
              -0.928535086245831,
              0.992873439343769,
              -0.0619116059634225,
              0.279485348048424,
              0.144235512707446,
              -0.353450967841156,
              -1.22714250149188,
              -0.526814499515361,
              0.131886167992464,
              -0.488500884573691,
              -0.107547461431605,
              -0.0978020218996328,
              -1.5525560768873,
              1.01224188205075,
              -0.265695726871852,
              -0.231544293807022,
              -0.57071121241561,
              -0.394193333809508,
              0.0734739594539846,
              -0.140744552326101,
              -0.421828577273575,
              0.389482076134975,
              -0.535135445867943,
              -0.269509058276632,
              -2.09690136757456,
              -1.64864670522278,
              -1.46223484985821,
              -0.869152731227996,
              -0.767144136770004,
              0.913115462897237,
              -1.22033151658182,
              -0.75250507027423,
              -0.23606980075869,
              -0.783814192854001,
              -0.263413398099004,
              -0.451823481648087,
              -0.345741744871992,
              -0.233069200789711,
              1.8452069849393,
              -0.542735339287425,
              -0.319641630609026,
              -0.158491259185086,
              -0.0606977461026764,
              -0.197044002188162,
              -0.677807886165824,
              -0.439841411964623,
              0.342402984565637,
              -0.111626439842303,
              -0.444445319318084,
              -0.612762581815496,
              -0.0441880243342953,
              0.844728001573322,
              0.635571022635734,
              -0.461012951460336,
              1.10092913780455,
              0.853643214450776,
              -0.610966763297259,
              -0.742893346833436,
              -0.195695810986498,
              -1.18566839731929,
              0.451958870694651,
              -1.0110143665428,
              -0.531697245906228,
              -2.31052093368079,
              -0.597204952391807,
              -0.836081580277952,
              -0.129299900919887,
              -0.681560262115805,
              -0.523984853196353,
              -0.134344601700103,
              2.50517680244607,
              -0.486711737553604,
              -0.264202953241497,
              0.570738617360356,
              -1.20782616575864,
              0.343290764446451,
              1.41895557960105,
              -0.444868751613804,
              -1.50938251531111,
              0.136022371070592,
              -0.118304773447964,
              -0.342873465155504,
              -0.143783559774085,
              -0.641816078875064,
              -0.296912811243473,
              -0.477403784115751,
              -1.80919441478719,
              0.577057338668518,
              0.43157272373624,
              -0.301850641370812,
              0.164552057394202,
              -0.564462167020065,
              -0.503826418419396,
              -0.915924187310029,
              0.479656396217568,
              -2.44073056839736,
              -1.25944370935681,
              -0.410051927632451,
              -0.26371104326782,
              -0.500353264233063,
              -0.927666197176213,
              0.0147286123928222,
              -0.199533197399854,
              0.204811181682036,
              0.979267564476561,
              -0.861839137169888,
              -1.35463540956723,
              0.0199008117508036,
              -0.683485913766646,
              -0.390241401241965,
              -1.52272560479037,
              0.14641386307253,
              -0.798327921752874,
              -0.563480092913683,
              0.172921557268872,
              -0.665410879520214,
              0.0761709568426578,
              -0.481575670468707,
              0.0562391401586058,
              -0.644113962266467,
              -0.21880104849074,
              -0.558709139185905,
              -0.58849294077118,
              -0.591067767487043,
              -0.242433570854257,
              0.0132122111410943,
              -0.642193127129516,
              -0.486419233645445,
              1.31417545623972,
              0.882515092370577,
              0.379807581239929,
              1.2406484745328,
              0.497417817854593,
              0.705789208051914,
              -0.41087003134312,
              -0.318658536818779,
              0.733639282601863,
              -0.686023834619249,
              -2.29855717165169,
              -0.60801336693915,
              -0.365616231602587,
              -0.127706584666131,
              -0.424176191908887,
              -0.428929554625883,
              0.703328739069604,
              -0.630123227188215,
              -1.45427024798637,
              0.5060267576327,
              -0.232418486193837,
              -0.0739036386313605,
              -3.25655126364877,
              -0.343942332977969,
              -1.56961300760673,
              -0.199189682081385,
              -0.31266091221144,
              -2.64390019080701,
              -0.824908178978683,
              -0.366896808380282,
              -1.09731163761735,
              -0.159451224741964,
              0.134697486718476,
              -0.0965496344118624,
              -0.777026641023997,
              0.117765909400445,
              -1.03704782942138,
              0.0912451338388814,
              0.931057029677317,
              -1.20159676040364,
              -0.280216928735591,
              -0.847153540306422,
              -0.910211141391445,
              -0.2002852414144,
              0.417476998664856,
              -0.441939235764954,
              0.242757562260196,
              0.188755945765324,
              -1.49282760093309,
              0.030081160452756,
              0.55572350518825,
              -0.919483544329424,
              -0.0743044154506858,
              0.05248101075305,
              -0.962229170386387,
              -0.413560721565138,
              -0.361589320081858,
              0.0044054787700506,
              -0.269218876492159,
              -0.218007485769729,
              0.145423291540016,
              -0.563984169410055,
              -0.124479897903367,
              -2.42400135116329,
              -0.282790511532248,
              -0.461792790771715,
              -0.667651819681305,
              -0.623296744176172,
              -0.974560590370306,
              -0.132334582053532,
              -0.467178769998162,
              -0.347833599090588,
              0.856262201504538,
              -0.872950392023154,
              -1.27833083328633,
              0.333097379324158,
              0.901840255059754,
              -0.810478684491178,
              0.669420929405876,
              -0.463544899399293,
              -0.0868692111727345,
              -0.75806687668976,
              -0.0311778909580001,
              0.445104133856526,
              -3.78953363013405,
              -3.89295270556614,
              -3.91440029224114,
              -0.305183962376275,
              -0.0526953051738834,
              -0.433487237721239,
              -0.614271836448518,
              0.643830722569741,
              1.07333818645133,
              -2.60646559437999,
              -0.871350581709439,
              -2.02798283527903,
              -2.05587952124198,
              -0.815411180983961,
              -0.499843920385907,
              -1.75799915573103,
              -0.885509137258517,
              -0.182828413124943,
              -1.09757502767045,
              -0.559745936968404,
              -1.09001433089518,
              -0.824685533513461,
              -0.0136270173780779,
              0.0524815510359947,
              0.0550352128573639,
              -0.4758619404248,
              0.0575170520791378,
              -0.732531718192147,
              -0.46819924876965,
              -0.447191630106906,
              -0.313776105094635,
              -0.3205243443635,
              0.00040736374207212,
              -0.546752248705873,
              -2.00662535944755,
              -0.298336675866211,
              0.316625175084757,
              -0.926209614494974,
              -0.484888666285691,
              -0.206770483701261,
              -0.701144927539209,
              -1.04602415434429,
              -0.934250404315938,
              -2.25509951529334,
              -1.05356254713716,
              -0.572085044736636,
              -0.519207092749361,
              -1.11266786621788,
              -1.18866545616593,
              -0.498894106781026,
              -0.188425968293784,
              -0.646644875731985,
              0.201797236930262,
              -0.478796084745319,
              -0.448596507054639,
              -0.303755688084907,
              -0.379964695948362,
              -0.862428107193661,
              0.110974389855459,
              -0.584194740294264,
              -0.618114809074133,
              -0.382689894286183,
              -1.03270835392747,
              -0.245694017403665,
              -0.468038311064908,
              1.44234914023162,
              -0.537279126631634,
              0.0126856928302604,
              0.426676453523777,
              -1.80000946205068,
              0.0360948753768383,
              -0.34787459420181,
              -1.07430491081579,
              1.31432693151299,
              -2.86512865243541,
              1.00155162929704,
              -0.143811975453671,
              -0.239023836106136,
              -0.0992492225094102,
              -0.437689838394546,
              -0.0785455104267067,
              0.949442788662814,
              -0.256120694907685,
              -0.25254783520234,
              -0.113925444875071,
              0.0126119964405219,
              -0.587943588725377,
              0.949814129764736,
              -0.264997459097513,
              0.570681135710066,
              -0.449988870101925,
              -0.399488468867122,
              -0.587156352398629,
              -0.458956503234973,
              -0.565116762778445,
              -0.84606986358688,
              -0.141159243176594,
              0.0984498180113881,
              -1.09520016089146,
              0.00797201555187432,
              -0.846155312442001,
              -0.618060079412073,
              -0.382789863683305,
              -1.03874356385273,
              -0.378523072295161,
              -0.257590576383371,
              -0.254714303393808,
              -0.291882070116556,
              -0.989720062395284,
              -0.816536946399193,
              -1.89940450621161,
              -0.890752552519221,
              -0.446427493200261,
              -0.538915375428062,
              0.323477693770472,
              -0.275236372021989,
              0.0241507393410679,
              1.09326634503653,
              0.241768422259196,
              -0.501454667505335,
              -0.184607063114645,
              0.183066015165042,
              -0.733328850154545,
              -0.246969433531933,
              -0.536997803407112,
              -0.784853894308116,
              -0.837281153272097,
              0.260146631689392,
              -1.22403537575573,
              -1.06839894688511,
              -0.351988076480981,
              -0.383333754681236,
              -0.103623670762425,
              -0.629557773808328,
              0.422790317299438,
              0.421910285325141,
              -0.921304433340348,
              -0.619645393352758,
              -0.742753351990438,
              0.244003076657581,
              1.63700904962651,
              -1.43859187926716,
              -1.32523520386941,
              -0.932188671288787,
              -0.990557230900169,
              -1.00121161305441,
              -0.426778485903426,
              -0.522706420133582,
              0.45275863010789,
              0.12081220903105,
              -0.696583645739865,
              -0.399764277602643,
              -2.22188617568403,
              -1.65756170838433,
              -4.31865651154248,
              0.142418386866176,
              -0.464346208356959,
              0.350988141101442,
              -0.184691963849912,
              -0.010932791507374,
              -0.109198324603679,
              0.870374677664943,
              0.542915366956876,
              0.459833742595154,
              -1.09810730380717,
              -2.47730982685597,
              -0.424437615138513,
              -0.683028148741398,
              -0.635526692756869,
              -0.076390760920588,
              -0.161771468244278,
              -1.5493525575868,
              -0.492442063146139,
              -0.742673004207085,
              -0.812872172114619,
              0.25145006251422,
              -0.397539055259435,
              -0.410534140023827,
              -0.275256237451207,
              -0.626221401574519,
              -0.17114245202719,
              -0.748136926888491,
              -0.312974398283233,
              -0.624269634134958,
              -0.842945149282478,
              -0.353027538465568,
              -1.90936830508904,
              -0.124133305711042,
              0.508733237136342,
              -0.413126326383584,
              -2.72872621757853,
              -0.24779733706455,
              -0.737978849389308,
              0.355324961223674,
              -0.0384191664682925,
              -0.34428057178538,
              -0.20614798963355,
              0.456407647715304,
              -0.903323560013746,
              -0.407790646794354,
              -0.463496408629174,
              -0.0213777003868621,
              -0.562573555779027,
              -0.402178048530335,
              -0.72282085563265,
              -0.45993060187343,
              -0.704414941653056,
              -0.430283942986689,
              -0.349180273516963,
              -0.641352235298766,
              -1.04286698403134,
              -0.0274487875516966,
              -0.582717896038355,
              -1.77690190023562,
              -0.423582634870857,
              -0.644070685470257,
              -0.105576597100721,
              0.0321672771014762,
              0.184516724377747,
              -0.32064620242418,
              -0.236805796391323,
              -0.716452371338788,
              -0.977040939553977,
              -0.992159206656538,
              -0.447730043078443,
              -0.236317508339593,
              -0.530372664014105,
              -0.426793007271549,
              -0.0110046702712876,
              -0.462004105799717,
              -0.296672869806753,
              0.483956736862325,
              -1.07773095211646,
              0.692800179900112,
              -0.55928865361958,
              -0.742791472455746,
              -0.708202468643851,
              -0.00727997050876616,
              -0.123218441559235,
              -1.77154366445084,
              -1.93980816460884,
              -0.372643943752109,
              -0.443011106723438,
              -2.76826797393982,
              -4.13831123013444,
              -0.613539382807778,
              -1.29853372076876,
              -0.163811296828771,
              -0.333399778157371,
              -0.66277121322605,
              -1.27909719588543,
              0.472788468397681,
              -0.634248401878892,
              -0.690878401962234,
              -0.388056967354661,
              1.56375301796213,
              -0.169474755664771,
              0.0766195086297392,
              0.431988500276961,
              -0.35219206712754,
              -1.15132506374718,
              -1.6906290923492,
              -0.603676213701195,
              -0.506628271948478,
              -0.629092311885417,
              -0.655723464440082,
              -0.771927099394126,
              -0.412691073021849,
              0.0544021416298895,
              -0.545413685785792,
              -0.5897858089573,
              -0.660220062006309,
              0.227163283595147,
              0.134621571357037,
              -0.146295280009668,
              1.79813249835649,
              -0.0665511913768099,
              -0.0490115272501653,
              -0.491595739025836,
              0.116347573897338,
              -0.137609932906972,
              0.0125712847637759,
              0.295513674054712,
              -0.220352769734546,
              -0.919866440849073,
              2.19426815487959,
              -0.495441371614879,
              -1.3043149846154,
              0.214221814521769,
              -1.01108463319206,
              1.71400041330308,
              0.12581584062864,
              -0.978733937358446,
              -1.85960733336712,
              -0.805666740213586,
              -0.479760098078858,
              -0.626478025259822,
              0.103485557247248,
              -0.00747972632712557,
              0.128645131166795,
              -1.78681783698387,
              -2.08410747805671,
              -0.0595930180162424,
              -0.395643395935592,
              -0.334762366608042,
              -0.249689463274485,
              -2.62098000240981,
              -0.254970715433272,
              -1.30244198294605,
              0.00580975285419483,
              0.545803032456278,
              -0.748346544869727,
              -0.459435543971912,
              0.774438412252783,
              0.619084220056894,
              -0.445721606258526,
              -0.789575419887577,
              -0.460081012897795,
              -0.627621149870186,
              -1.77031104631071,
              0.289133517003056,
              -0.635362266671521,
              -1.17542531998378,
              -0.467882087054695,
              -0.521088619476553,
              -0.806629326779682,
              -0.877079427254649,
              0.79928653345969,
              -0.577773688929576,
              -1.05343244328367,
              0.0441673432947333,
              -1.54248578509713,
              -0.118432011904924,
              -0.431203054557775,
              -0.234909244584972,
              -0.70783302519257,
              1.71227686482474,
              -0.559469397276419,
              -0.26634850118558,
              -0.586294100401841,
              3.53380879427049,
              -0.962101378666901,
              -0.945004886366259,
              -0.149155095936598,
              -0.766902004079309,
              -0.547965439492893,
              0.544432977547233,
              0.0507237141088341,
              -0.483021734177091,
              0.151408016653662,
              -0.0791283225465575,
              -0.240292775541855,
              0.740368080794443,
              -0.29548222541137,
              -0.440994231777258,
              0.187448603842692,
              -0.0635095755418089,
              -1.43835193927206,
              -0.548331857794157,
              -0.573975773685079,
              -0.767664555606158,
              0.327609320874475,
              -0.80398039441341,
              -0.55897302291815,
              -0.201981600749189,
              0.0603210345831504,
              0.179591443713842,
              -0.0377383500403458,
              -0.306675090900779,
              -0.544277005077099,
              0.723477338221018,
              0.925975391007271,
              -1.11826225750862,
              0.273642218467133,
              -1.69237130400738,
              -0.0397408611476708,
              -0.632091276028509,
              -0.503142616077959,
              -1.30661312813869,
              1.12377536098813,
              -0.541118134115673,
              0.190087381964215
          ],
          "y": [
              0.29688799771058,
              -0.279430879287358,
              0.134619047797193,
              0.272947538577463,
              -1.12173969851944,
              0.118208661629672,
              -1.60521875550385,
              0.146907778115577,
              -0.647826417183894,
              0.534425956119431,
              -3.88919633889845,
              2.09217251029,
              -1.93048153534233,
              0.169051933172131,
              -0.448874952203866,
              0.115655507529313,
              1.54758515522161,
              -1.75432474038619,
              -4.41612034833071,
              -0.209551325225671,
              -1.02561066294575,
              -0.862233089036494,
              1.45068342584886,
              0.928230321393388,
              -1.61068812720539,
              -2.45708304209739,
              0.877050623878316,
              -0.536311983320354,
              -0.564679611527735,
              -1.8200242062227,
              -0.439330784924388,
              0.757242041391614,
              1.05284527858515,
              -1.48244347550342,
              -0.608641816742788,
              -0.203269623067489,
              1.84218357325816,
              -1.39034178359793,
              0.354705168117158,
              0.802046506983119,
              -3.05900163166175,
              -0.195176671972633,
              1.0121117510081,
              0.339433737720099,
              -2.88819756728899,
              1.37684626646067,
              -1.96842620424291,
              0.333654536019201,
              1.19776131442535,
              0.707495288605751,
              -2.16642497771694,
              -1.71342872239736,
              1.2757690423541,
              1.19490739339647,
              2.34919188603833,
              -1.77889214495194,
              -0.664042576303026,
              -0.260018484134551,
              -2.38997101943768,
              0.343903811588656,
              -0.260267695108205,
              -2.17497771591461,
              -1.56624384499335,
              0.270728019344899,
              -1.39894331289605,
              1.99317236520112,
              0.72030712068486,
              3.69389881436183,
              1.36961641523344,
              -1.05097035612124,
              1.33369168143682,
              -2.79016192225628,
              -0.272268084472579,
              0.228319615376365,
              0.614036392671496,
              -0.0597424251235387,
              0.140612278706897,
              0.181512308809131,
              0.245572870123502,
              -0.22636088827527,
              0.0324665558994592,
              0.0462496421075186,
              0.220766434581718,
              0.413423131911651,
              -1.5675133256629,
              0.497749514591728,
              0.328774170502691,
              -0.523390814931478,
              0.176467306725209,
              -0.115901431026294,
              0.101975109719377,
              0.459784548897057,
              -1.6836455834127,
              2.21280346082484,
              -0.14195388310585,
              -1.90476104906661,
              -0.0790428124207162,
              -1.89901894597497,
              0.109595713712941,
              0.337363903925342,
              -0.372422011220727,
              -3.67735350790073,
              -1.21739665761674,
              -1.82445259095554,
              -2.52072476848593,
              0.0649340714120692,
              -0.387413632395384,
              3.11400991737422,
              0.303804528562528,
              -0.339416512039718,
              1.05435022287498,
              -0.281418663150559,
              0.451838104339004,
              0.252764480219805,
              1.97961311632621,
              -1.20479239807951,
              0.109786579810687,
              0.167446241765996,
              0.85125560992676,
              -0.252478411368949,
              -2.43680350804128,
              -0.302089936305212,
              -1.84303907279999,
              1.6805053157347,
              -0.945718487078111,
              -1.59270815525366,
              -1.21551304073772,
              0.196007919501124,
              0.213976686223566,
              -0.664620135296073,
              1.2327368704145,
              0.498496558875468,
              0.425193083296679,
              -0.22459051745278,
              -0.517919405613641,
              0.897817742182631,
              -3.35122890097756,
              -0.41400260679718,
              -0.312730565862248,
              0.362442256629684,
              0.0570616262915615,
              -0.5408065295086,
              0.187799635739211,
              -0.574336807472028,
              2.44576669760033,
              0.589972500358108,
              0.485868880183127,
              -0.414246539349222,
              0.422200165301304,
              -0.493006433026094,
              0.06416281597439,
              0.282177981262464,
              0.867081758609729,
              0.342955537626554,
              0.0942366866674564,
              -0.311018439528566,
              0.24320149355189,
              -0.167200114871436,
              1.86186040668215,
              -3.98344445826677,
              -0.0377589295569621,
              -1.00769464397706,
              0.132980082606523,
              0.19232585307692,
              0.0501928673271849,
              0.566279996067507,
              -0.889375135285785,
              -0.0543507293128235,
              -0.235158053250687,
              1.18353598986363,
              -0.0340520433645055,
              -1.34834325338696,
              -0.139148714461988,
              -0.0996290010609555,
              -1.20945272504073,
              0.545724752285725,
              0.715327358331291,
              1.12153474837288,
              -0.766749975715376,
              0.272973129244384,
              -0.25917393587367,
              0.112964090654473,
              0.160485094985165,
              1.54303095937684,
              0.575175319570651,
              0.164791307825167,
              -0.106257130122476,
              -0.360155005996275,
              -3.12723450710587,
              1.15816682041917,
              0.254938470710326,
              0.328633168112764,
              -0.18562769768601,
              1.64355355597463,
              -0.90101961723027,
              1.01148193674063,
              1.96034469546374,
              0.426914743811668,
              -0.0868161773743664,
              0.745337607902971,
              0.153464633053653,
              -0.0786700691920876,
              0.976566714152362,
              -0.212216935773128,
              -0.481147421050406,
              -0.447739672004321,
              0.181411088570942,
              1.0246210748759,
              -0.0162417259069103,
              -1.37153288793127,
              -0.295419513849783,
              -1.25395242132427,
              -1.54358991248875,
              -0.398325311968664,
              2.11226194312209,
              -0.218804065422123,
              -0.508501771652001,
              0.339383786666108,
              0.285192562543049,
              0.572122115390172,
              0.214433418531621,
              -0.298252170106836,
              0.174884899533905,
              0.446480387939805,
              -0.730848921562483,
              -1.45512407376567,
              0.26755369192404,
              -0.502973139226643,
              0.00545967506492361,
              0.67481712601213,
              0.0593764863485393,
              -0.0309886695925739,
              -0.40891469205973,
              -0.852206994602835,
              -0.806545904649603,
              0.0278983857206734,
              -0.107657849761618,
              -0.188217931622271,
              -0.395753963636708,
              -0.985079978400868,
              -0.732448952106594,
              0.120854384503471,
              1.24690277980223,
              0.178260695402149,
              0.793159926281755,
              0.97511759410975,
              0.287811156699497,
              0.25090154704893,
              0.456805463211681,
              0.266694425181775,
              0.498628433760265,
              0.951298475098259,
              -0.518772310154947,
              -1.48449469087113,
              0.0241063566899218,
              -0.397716534884472,
              -0.743933195754226,
              -0.251854557312943,
              0.659401405478536,
              -0.0573394179099918,
              -1.57747854551151,
              -0.280363397371245,
              0.298735622971981,
              -1.19546075084437,
              -1.20430705365963,
              0.255345718207475,
              0.548859998801037,
              1.6593903894865,
              -1.16539928394287,
              0.179883950932841,
              0.259556583663066,
              -0.883325802190306,
              -1.13938426763399,
              -1.9734039405953,
              -0.0202506255030649,
              0.619400275019578,
              0.0462940321667564,
              -0.807045878402376,
              0.305368270649904,
              0.332565179382186,
              -0.0619943297938065,
              -1.85291748267623,
              0.648655488289662,
              0.402414356168397,
              1.77734036818097,
              -0.20805838569567,
              -0.403911801957153,
              0.312108555073062,
              -0.113520160312299,
              -0.17803815400785,
              -0.252990928909956,
              0.508351156497011,
              0.627792619048811,
              0.840663643648007,
              0.0358271298032351,
              -0.446446609313903,
              0.290749855203251,
              0.13863949363348,
              0.316631411825197,
              0.285830616820117,
              0.0483976063705858,
              0.226593158374692,
              0.132591083020422,
              0.530620484006256,
              -0.557336098325029,
              -2.05539674877892,
              -0.6783832353532,
              -0.365571013780076,
              -0.218160301891922,
              -0.00212607467141601,
              -0.061652773142401,
              0.468886450948659,
              -0.333255794147877,
              -0.805785764518407,
              0.195914007096635,
              0.854930968532136,
              -1.94848121952535,
              0.445412160698684,
              0.560890256462689,
              -2.042477239415,
              -0.233230104122266,
              -1.68025620781307,
              0.100439860246271,
              1.15815424593212,
              3.94850936427631,
              -0.741017105434694,
              0.33008944021499,
              0.514488996435269,
              0.229453267321394,
              0.344878906697668,
              0.852799340165132,
              -0.488322371455789,
              1.07626969887417,
              -1.39554415268349,
              -0.418887873300982,
              0.0933202481150503,
              0.697291058012235,
              0.926548210670084,
              -0.705000033319288,
              -0.2998887838532,
              0.409391912394734,
              0.882621475700541,
              -0.517462414712249,
              1.05914828503667,
              -0.254331733253897,
              0.518964317906336,
              -0.0631180216870107,
              -0.871548832171594,
              0.292295151508457,
              -0.58558129937721,
              -0.506270755086038,
              0.0103742492381634,
              0.585059570140583,
              -0.0682615124038836,
              0.0449573207679829,
              -0.249152682683973,
              0.637235701855856,
              -0.25770310990018,
              -1.89410524650349,
              0.248230465544581,
              -0.196841755160312,
              0.0666228725239234,
              -0.314795061905126,
              1.60949615806724,
              0.763295596658202,
              1.15870092545037,
              -0.0882789753735163,
              -0.628730514358689,
              0.103396722468273,
              0.929977791926898,
              -0.630007610030191,
              0.228463601566977,
              -0.402528361769523,
              1.25831694031448,
              -0.280711418181517,
              0.905063804627354,
              -0.29757453162692,
              0.603857763048724,
              -1.76347449474025,
              0.596136801480856,
              0.724269472378518,
              -0.594183099722563,
              0.942774993021578,
              -0.68210744648188,
              0.295401611959282,
              0.675369625823821,
              -0.353807918303096,
              -1.14184418453045,
              -0.546831971909506,
              -1.08387159077207,
              0.176753579421925,
              0.379913250848626,
              0.148504221019319,
              1.63208698845424,
              0.248715597979362,
              0.186706160254168,
              0.386536601556391,
              -0.9169566300913,
              0.272077672254851,
              2.11362297508392,
              -0.0450255870175573,
              0.488417597549458,
              0.329457843291655,
              -0.230007993325308,
              -0.0537686163713716,
              1.37422523411142,
              0.823302642122393,
              0.995181071813848,
              0.317112796800024,
              -0.522762230433575,
              0.122269076032408,
              -0.475054038739594,
              0.837039914065136,
              0.973681777119093,
              0.811226350573035,
              0.261355029664587,
              -0.65566788951431,
              0.113705796711133,
              0.0823329026394124,
              -1.12106949841445,
              0.0979271673543348,
              0.0357620096156103,
              -0.520487599239201,
              0.385370627057813,
              -0.694955139101207,
              -0.0317325721686911,
              0.616452524124522,
              -0.405179360276054,
              0.319878306721025,
              0.482817054325256,
              0.50270548234309,
              0.0511567585334808,
              0.506631917892454,
              0.486595209562485,
              -0.451593575213577,
              0.937750119875443,
              0.871452745952642,
              -0.267171218432928,
              -0.231399830226307,
              -0.835089919119854,
              -0.366936386004597,
              0.290995730884196,
              0.343622687631892,
              0.348523945938259,
              0.461743420024818,
              0.974483101575452,
              -0.12546246723681,
              -0.698759905171345,
              -0.195690967213177,
              -0.49321623209015,
              1.14559371793213,
              -0.0954628994863772,
              -0.061748640680499,
              1.70392016034154,
              1.18195009423012,
              1.19542768294966,
              0.366820830591731,
              0.365916801221569,
              0.608552043769965,
              0.450862192118702,
              0.193974521964547,
              0.0374375968798448,
              0.968284750806426,
              -0.160331998499197,
              -0.156878171600154,
              -0.784745386964035,
              -0.267561930630949,
              0.631589904818282,
              -1.24303480130167,
              0.334633446099653,
              -0.359690742186383,
              0.681956233232615,
              0.365159271017158,
              -0.733646771742774,
              -0.694844863961853,
              -0.701262421094911,
              0.0638211995693484,
              0.337812864762317,
              -0.151966141339879,
              -2.01667174471096,
              0.156423178921368,
              0.925873699087911,
              0.279371586827887,
              0.488920275117664,
              0.972620358000899,
              0.256608082831518,
              -0.373570402518091,
              -1.02535218357323,
              -1.28299657927131,
              0.445524233517591,
              -0.91079008107709,
              -0.0148153079137788,
              -2.03197834866855,
              0.920722674944951,
              0.854007646354647,
              -0.511543636134344,
              0.176746537036661,
              -0.923028189118242,
              -1.8841744201399,
              1.3068279906674,
              0.557299790228986,
              0.150444441110488,
              0.0799928065592103,
              -0.974369495574652,
              0.214738031447705,
              0.183558595972001,
              0.112120509319549,
              -0.45475163420784,
              -2.50822400109386,
              -1.28303339694369,
              -1.26081051222463,
              2.1548905521564,
              -0.0700441290875492,
              -0.327191856735784,
              -1.15164964484328,
              1.45226988759806,
              1.00454496555926,
              -1.41868452053102,
              0.940878554072824,
              2.16696878239668,
              1.54171989712185,
              0.77658460677432,
              0.306324151344025,
              0.0976459801759321,
              0.636707092359231,
              -2.08500131929138,
              0.345491994685992,
              0.409622152326473,
              0.410809190811333,
              0.532097193237089,
              0.239127252111056,
              -0.149770325451033,
              0.203465883014127,
              0.184360503246979,
              -0.660490976435306,
              -0.17842323593036,
              0.342554049976051,
              -0.499917170415379,
              -0.875688123282551,
              -0.00129584352176697,
              0.00243453443797682,
              0.100441587895752,
              0.0769323351158597,
              0.0605385720472799,
              -0.101823032959419,
              0.19441244324685,
              0.077579201751319,
              -0.498824294419579,
              -0.56608014605031,
              0.580460405726137,
              -0.104481866622915,
              0.771738114628458,
              0.405156902164978,
              -0.41116563272095,
              -0.606497069897241,
              -0.625676646852938,
              0.842284660820811,
              0.327007429072442,
              0.108615210515792,
              -1.06796976658387,
              0.7069311488708,
              0.168256555282607,
              0.0686999815808633,
              -0.184644662683612,
              2.74392077383516,
              0.0997787205454598,
              -0.549227856596529,
              -1.01677292056666,
              0.589491534339351,
              0.2895329997259,
              0.0721291480749132,
              -0.271266837778941,
              0.255381291896046,
              0.977124459949667,
              0.421433584570457,
              0.0252851841465844,
              -0.773632241364351,
              0.338587168519075,
              0.258322470274023,
              -0.457189659207853,
              0.348437570452614,
              -0.0235992411427233,
              -0.912696422547703,
              0.28746974184178,
              0.220218340442722,
              0.34976155715696,
              -1.34514529492574,
              -1.24773138874212,
              -0.0607359413554846,
              0.199489296017906,
              0.622765124509008,
              0.598152274137124,
              -0.524762599198251,
              -0.391483701649831,
              0.142699974565359,
              0.803926755050697,
              -1.8531728540614,
              0.358803065836615,
              -0.272054044497038,
              0.0203606558129431,
              -0.494036495628999,
              -0.394919821149871,
              -0.965616257863711,
              0.148805107531391,
              -1.75137488339354,
              -0.457115473397824,
              0.358289297528691,
              0.324487271831991,
              1.90132178361332,
              0.0480991110191673,
              0.192975111350737,
              -0.871243044103348,
              0.515944092367988,
              0.24792730186234,
              -1.07985363030437,
              -0.514775264747611,
              0.322151509419232,
              -0.827479807882569,
              -0.0853642526705071,
              0.653207336011501,
              -0.664583317516183,
              -0.808332678622678,
              0.00481145801683075,
              0.218745891373117,
              -2.14767674000723,
              -0.00880198410079634,
              -0.625382289780493,
              -0.375870577599815,
              0.227964258438637,
              0.273730144751565,
              -2.30164859433635,
              -0.344965187765402,
              0.0623089695488149,
              0.570125494444793,
              -0.660963160369811,
              -0.0354123062337607,
              0.593197367889491,
              3.40736222671631,
              -0.660353177289586,
              0.369222700564521,
              -0.853332595943775,
              0.638365160704338,
              0.149701966186102,
              0.425630647494263,
              0.396606857540012,
              -1.06662780156965,
              0.569389913685305,
              -0.465709810318765,
              -0.344104053257345,
              -1.57196084741383,
              0.146489670568744,
              0.172948610919702,
              0.255109766054993,
              -0.3739303047715,
              -0.0976947730825762,
              0.730048802248462,
              0.588054744146868,
              -0.749017051516066,
              -1.4026415932063,
              -1.72929383836399,
              -0.0000131936292612489,
              -0.521253320723786,
              0.0372560473601248,
              -0.844358822140805,
              -2.27376446503729,
              0.135045972468053,
              0.458949148368596,
              -0.123968992511581,
              0.261600447359905,
              -0.164313613271651,
              0.517149635220786,
              0.594833480489413,
              1.82238521470806,
              0.432948638699274,
              1.58825747312092,
              0.595482463813365,
              -0.0966720636316892,
              -0.926690288764236,
              0.781677036952941,
              0.362688608557606,
              0.380792146802474,
              0.0206374430702351,
              0.447230879490749,
              1.2307165070247,
              0.484436927951743,
              -0.849501544833878,
              0.191949840185145,
              1.00461517367898,
              -0.844868960479951,
              -1.39405050750238,
              -0.482107439519444,
              -0.564113983129032,
              0.0726485624383211,
              0.309498810019529,
              0.0520765906053552,
              0.00452718084375187,
              0.162359660771332,
              0.299190325734731,
              0.282461029630364,
              1.03249911622728,
              0.931206101341913,
              0.776525428267771,
              0.700466617003378,
              0.536885942303569,
              0.469769694159679,
              0.169145562460123,
              0.35519369817944,
              0.0930334288311631,
              0.487574463203306,
              -1.26298770637121,
              -0.486648487277034,
              -1.05380199599117,
              -0.721878393231463,
              0.498804365259941,
              0.522528772782197,
              -0.112658431337838,
              0.10530266760429,
              -0.840454561728094,
              0.462882076482917,
              0.563648003157701,
              0.536274968822137,
              0.461047368095966,
              0.167112317658613,
              -1.76311987779616,
              0.627699838468829,
              -1.03570679804354,
              0.462858442588154,
              0.154496874643213,
              -0.539934966731499,
              -1.92759476481296,
              0.818791343544912,
              1.07832683792277,
              0.258075221302404,
              -0.479330529367027,
              0.79241143687712,
              -0.390398190658804,
              0.542183495556005,
              0.358825817300128,
              0.616543922886803,
              -0.385854630200565,
              -0.405134603628931,
              0.214078615047312,
              -0.766984718039917,
              -0.30028600200549,
              0.671917544076404,
              0.546342633181134,
              -0.0654315876482177,
              0.536544054655743,
              0.7347903621084,
              0.0471731236302455,
              0.569049725334121,
              1.1270367614564,
              -0.664844922255706,
              -1.11634967976687,
              -1.12893411864834,
              0.599332038476724,
              -0.810373708200954,
              1.11900729824069,
              0.495369808623035,
              0.503187709237376,
              1.03622663630562,
              1.38406027740991,
              0.400076733262329,
              1.14703140910329,
              -0.695702805566799,
              -2.83144953041516,
              0.642162091394217,
              1.58402393982867,
              -0.116722451671543,
              1.96424194411664,
              1.88956261391155,
              -2.04164282662045,
              -2.7059582609603,
              -1.12514363951507,
              -0.664808497440272,
              0.282295363426027,
              0.455520803340163,
              0.778488814965874,
              0.115331981729188,
              0.368084057248147,
              -0.557671745975055,
              -0.122079131983779,
              0.207409611899991,
              -0.217106808431153,
              0.2378262304338,
              -0.00851293833814894,
              -0.29416719687503,
              0.476206751406242,
              0.665230598364972,
              0.255336192792096,
              0.16563258250162,
              -0.330754180072993,
              -0.51934970509307,
              -0.884467565001941,
              -0.813984997661512,
              0.34375468201717,
              -0.749872193185856,
              0.337665769350369,
              -1.52514896609812,
              1.33183838814726,
              0.116099425828347,
              -1.06349385794906,
              -0.297574062693644,
              0.377948851007508,
              0.140102106795235,
              -0.57439354340358,
              0.224378426950173,
              -0.0321268747310328,
              0.0905017190723955,
              -1.20795843628355,
              0.433208595079592,
              0.659769165861579,
              0.612397777195949,
              0.103665967898917,
              0.572176386513576,
              0.301442391418843,
              -1.88468610421663,
              1.33438746534999,
              -0.60776994433673,
              0.0784958847561982,
              0.546484491921592,
              0.2302138067154,
              0.246473183229811,
              -0.497087512180178,
              0.272353027391483,
              0.128900317781948,
              0.606294905111512,
              -0.63543983525239,
              0.679833042044366,
              -0.898496783233376,
              0.576332006434304,
              -0.215573067140632,
              -0.285709942231405,
              -0.846416927287351,
              0.792762400646642,
              -0.233629351868097,
              -0.074981630807263,
              -0.0540534366619155,
              0.755183788645449,
              0.244593785390895,
              0.016095651709095,
              0.326826836094324,
              0.43567970880174,
              1.3099328956003,
              0.406480556912307,
              0.455163928428161,
              0.11318098331493,
              0.262603315924076,
              0.00403179477888525,
              0.608448296240899,
              -0.403380170041995,
              -0.232322545222977,
              0.822015260852111,
              -0.308209133011871,
              -0.29230238119488,
              0.814621831231832,
              0.482263394254039,
              0.228581274099524,
              -1.16260827412813,
              -0.166622441994245,
              0.218781472092492,
              -0.410392275637267,
              0.0626176305456473,
              -0.0286395008139218,
              0.284430855892523,
              -0.549437088652402,
              0.240445671036952,
              0.860408109153494,
              -0.95337904507832,
              -0.19919584846228,
              0.13224479121817,
              0.198861308605378,
              -0.204419670979558,
              0.909563691998038,
              -0.614768039744033,
              -2.49757277274383,
              0.929096873054553,
              -0.0520631675757751,
              0.816375497151104,
              -0.309268977414799,
              -0.271548624719163,
              -1.87736401381842,
              -0.277187950792654,
              0.304052321431444,
              -1.54902348845139,
              -0.754039834762514,
              0.0692251313795845,
              0.330327707302767,
              -0.735700122367203,
              0.876609677186688,
              -0.0735303991781406,
              0.216072861128,
              0.9853132145433,
              0.394380099284031,
              -0.410395448028417,
              -0.0600364646209095,
              0.447782131141198,
              0.0196566033060597,
              0.28202822165063,
              -0.0257308752489793,
              0.586771603971672,
              1.88676203861176,
              -0.110132247702362,
              -0.349935785257342,
              -0.365009951888225,
              0.0695069811351369,
              1.00116573582747,
              -0.284650671800532,
              -0.344408803968544,
              -0.406800082071224,
              0.588954682127685,
              0.0140311345962136,
              0.212620130176821,
              0.778919153363682,
              -1.08367829236184,
              5.51589232613697,
              0.658523169229435,
              0.250069479707668,
              -0.782877601946062,
              -0.180613210395147,
              -0.142695261257867,
              2.44996804264778,
              2.01349756942026,
              0.359742867752543,
              -0.831642860300716,
              0.165286353865355,
              0.596153065890505,
              0.0368397846923764,
              -0.096100588198319,
              -2.06295053270607,
              0.344075666954067,
              -0.00854046427688565,
              0.980811342170716,
              -0.0852304826856969,
              0.830800389978621,
              0.407678075143458,
              0.488919719098248,
              0.684039425529166,
              0.862596177931459,
              -0.296633662578927,
              -1.36243040936438,
              -0.234977937790865,
              -0.694415262100506,
              0.161232147947013,
              -0.578527841768087,
              -0.769477772973968,
              -1.20677074994724,
              -1.46168982713941,
              0.68346099072879,
              0.845627475177918,
              -0.0436262104654073,
              0.372171425743041,
              0.497216533989575,
              0.0170060165667044,
              -0.740278499101196,
              -0.816811329794888,
              0.00717013034839635,
              -0.600898697899079,
              0.39192494351741,
              0.205913412617384,
              0.365425613100066,
              -0.21064082491812,
              0.886161652738146,
              0.0988644959370804,
              0.0769334576882481,
              0.21274504207191,
              0.627308865464575,
              0.0413645349287537,
              0.501488319974913,
              1.25583322667972,
              -0.00500557008073024,
              0.28111920237573,
              0.631739071921979,
              -0.151515326345238,
              -0.0185390199053477,
              -0.729537065430122,
              0.578033236858086,
              -1.18199919904443,
              0.357994748270092,
              -0.047223561681408,
              -0.752207882339519,
              0.189749986405239,
              -0.958036717266905,
              0.286938924060587,
              -0.022616193332332,
              0.182854749470213,
              0.233364429230584,
              0.229718597547491,
              0.755824869768514,
              3.44038663101103,
              0.23140060780731,
              0.501980664926027,
              -0.0679472831024817,
              0.29387290832399,
              0.665271234507448,
              0.136609397530373,
              0.089777462670365,
              -0.294064386849108,
              1.13890342506429,
              0.683678728093582,
              -0.961667931872025,
              0.99210201087445,
              0.47828208617577,
              -1.25451565616369,
              -0.412532058921109,
              0.152260382983947,
              -0.337493796938793,
              -0.151781732567285,
              -0.74657027383423,
              -1.51428434486058,
              0.765648325387714,
              -0.00581812382468205,
              0.937205160964945,
              -0.41423069241229,
              0.964646848230867,
              0.406946969432099,
              0.130542590549941,
              0.0202751964199758,
              1.74811693620029,
              0.288765110404616,
              0.410083259164426,
              2.47912084573275,
              -0.506643060758265,
              0.73725994722705,
              -0.908766032128571,
              0.28864687127292,
              0.328641950777089,
              -0.145205675822285,
              -0.134234072826592,
              -0.343239984188169,
              -1.06121417520362,
              -0.513962551338349,
              1.26146288420539,
              2.17099109597271,
              0.12123257396815,
              -0.762817469175781,
              -0.421394924846766,
              0.40095976669269,
              0.182743528583269,
              0.680468565439422,
              0.373375917841777,
              0.911970131299963,
              1.26207905857286,
              -0.690187102172708,
              0.367408122513236,
              -0.0771139174151364,
              -0.739330720068785,
              0.642727621935657,
              0.2679080563156,
              0.143306352813945,
              -0.523500510661513,
              0.883998069254229,
              0.612434074976136,
              0.707541041211187,
              -0.180525173590582,
              -0.261465040903621,
              0.144846348101687,
              1.45200587345817,
              0.470744978431628,
              -0.323935492505275,
              -0.395014175924656,
              -0.451043338380598,
              -0.173074120121331,
              -3.6893134604256,
              -3.80615051911861,
              -3.79444186820569,
              -0.091287014471717,
              -0.443864618428336,
              0.212708054427224,
              1.08415876499528,
              -0.331277445492027,
              1.01462649930462,
              -2.63816345913624,
              -0.213412808519431,
              1.01972051526892,
              -3.07051002840401,
              -1.07265023701978,
              0.931420871148266,
              -1.29857407555141,
              -0.250969768135581,
              1.05173370840324,
              0.965764696358926,
              0.717852715867277,
              -0.307600609237548,
              -1.01339968006205,
              0.710740723966065,
              0.181431486815867,
              0.276190461277413,
              -0.768083353783139,
              0.38758276350403,
              -0.362201972069634,
              -0.798631008202484,
              -0.738670536633967,
              -0.640514054490288,
              -0.712139367378086,
              0.293690858972292,
              -0.0644378645527288,
              -2.04523578959385,
              -0.175013094659013,
              0.497935605452909,
              0.572321437288183,
              0.550174096985461,
              1.33163712432276,
              -0.795856045521308,
              -0.930615615769059,
              0.435964857533596,
              -2.77129483929783,
              0.890378679505546,
              -0.835226744268587,
              0.0268186077166516,
              -1.47908248567191,
              -0.00711515060790517,
              0.283141833878509,
              -0.402349180164818,
              -0.945233466479569,
              0.572839088032066,
              -0.746632924275025,
              -0.823035988507786,
              -0.761314019081671,
              2.08259004969233,
              -1.15197812866831,
              0.199792576273921,
              0.403601439477114,
              -0.809563088178713,
              -0.341444934714647,
              1.05237989428793,
              1.36158747506518,
              1.05504882618073,
              0.39297485462072,
              0.842972970165298,
              -0.160384399836743,
              0.744647190791403,
              0.456039650732946,
              -0.238590969115365,
              0.186350149244948,
              -0.717784093712135,
              0.12381074241769,
              -0.367137603711299,
              -1.04230990731609,
              -0.371479408599023,
              0.570151083378101,
              0.987350029915047,
              -0.815349332190421,
              -0.546110520099591,
              -0.000847876868690894,
              1.04258068341846,
              -0.456783671326396,
              0.184268331684001,
              0.317938686530002,
              0.0187646442757612,
              0.244602819084404,
              0.451552584796988,
              -0.793295549699347,
              -0.670064400650138,
              0.625933106214694,
              0.620322464268832,
              0.183581273835324,
              -1.20825474079851,
              -1.28562124928538,
              -0.401578749509549,
              -0.198921013362243,
              -0.332880780682773,
              0.702534903585111,
              0.66058320999886,
              -0.229647914973262,
              -0.704566554561151,
              0.264441068069238,
              0.353624025432142,
              -0.59587874903648,
              -0.457130590041652,
              1.15437832045209,
              -0.306855324369856,
              0.24662297921095,
              -0.343731655372047,
              0.0525501942656331,
              -0.704471568583164,
              0.0529360956761881,
              -0.322280601286634,
              -0.0526295807288158,
              0.497368081660011,
              0.0757280238782599,
              0.806480475951097,
              0.617629073347294,
              -0.543462314177962,
              -0.776547603368968,
              0.988131395375436,
              -0.445291670322225,
              0.180093425005919,
              0.951817558572103,
              0.522770210066189,
              2.26263345181408,
              -1.64900983885217,
              0.748938185859376,
              0.652247048436739,
              3.73219689792807,
              -0.131513747947011,
              -1.18746417168243,
              0.803806680588811,
              -0.00213212242602156,
              -0.209765038672714,
              -0.317261532224858,
              -0.32299962233938,
              0.47658957584771,
              -1.11616891991077,
              -0.566711237280888,
              0.192008696709422,
              -1.13743483193037,
              0.238867546246613,
              -0.100097315386367,
              0.662829388329922,
              -0.0585120052357112,
              -1.71533084161112,
              0.315121466144508,
              -0.968095966533201,
              -0.788040627047734,
              -2.48949084862984,
              -2.91029839900725,
              1.18811023374854,
              -0.151210468876791,
              0.00964216397641472,
              -0.112664380158763,
              -0.0716970647808577,
              0.079453067081702,
              0.554660724190103,
              -1.02014230629359,
              0.231434810974479,
              0.980692919699942,
              1.48464320495852,
              -0.758008559903151,
              -0.981922134085097,
              0.675477411043918,
              0.378929051656989,
              0.062464564094553,
              -0.389280456722625,
              -0.793624461074448,
              -0.818514950383458,
              0.825034788363068,
              1.58531091741326,
              0.252194870784502,
              -1.54320099114149,
              -0.126473602419164,
              -0.469405532033477,
              0.888181736029532,
              -0.575606775020614,
              -1.19211386396373,
              -0.823331655602444,
              0.707499041640173,
              0.530086704131115,
              -0.695207056216812,
              0.0788219966928571,
              -0.125155327532788,
              -0.12378029518818,
              -0.726953315804257,
              1.82563551678302,
              -0.552715219086392,
              0.683349677740997,
              -0.771487757891225,
              0.695083862832658,
              -0.71114419727926,
              -0.422955481961528,
              -0.128228934530874,
              0.0976823973269263,
              -0.685703546129353,
              0.112280240291166,
              -0.455579472500018,
              0.0852498846325262,
              0.287467799268438,
              -0.95664875654925,
              0.581999645613779,
              -0.798821416830032,
              -0.0662105954486248,
              -0.528157637046419,
              -0.0355988959009733,
              1.83818681446862,
              1.24707240293213,
              0.207422568224665,
              0.324569356798993,
              0.03875550257968,
              -0.026074848151883,
              2.00216460398171,
              -0.380969560462585,
              1.48526305788525,
              -0.136192136625549,
              0.315885824162779,
              0.389059527984787,
              -0.638611288234653,
              0.103031327359367,
              0.511309727784498,
              0.115146507001143,
              -0.157928047554882,
              -1.04768194005564,
              0.293770877401149,
              -0.0414830446016951,
              0.773833719161937,
              -0.00469407341439058,
              -0.427882607968323,
              -0.649518882131692,
              -0.880559384223159,
              0.249907945480106,
              1.29244824881792,
              -0.40207094090333,
              -0.467246902900111,
              -0.641811931490306,
              1.4209978614367,
              -0.736572167079193,
              -0.599900651234743,
              2.92763767969567,
              0.372205047790835,
              1.48386139679876,
              2.52092058934196,
              -0.382758117073354,
              0.615641627598753,
              0.46717352780768,
              0.132107302629011,
              -0.167021643291132,
              -0.100150921722197,
              -1.38954085448025,
              -0.710502303351337,
              -0.495626125638513,
              1.03176407496424,
              -0.259401117118091,
              -0.292561455056815,
              0.710776365129539,
              -0.778029523357733,
              -2.48058163791639,
              0.478374096404786,
              -0.0992874556285653,
              0.371042326647955,
              0.2826692583055,
              0.0742711743822433,
              -1.3199615827357,
              -0.216096684122529,
              0.336080093097858,
              0.695557386024734,
              -1.06604006039416,
              0.724792598549525,
              1.18047516449941,
              -0.485322611180564,
              0.231928689355016,
              -0.0601684864438437,
              -0.293932305622763,
              0.523421816934887,
              3.50799206252878,
              1.01547439836657,
              1.22828244235002,
              1.97523089135048,
              1.17127532874164,
              -0.9677760365326,
              0.241292933005126,
              0.211775024287034,
              -1.53864087232203,
              0.398312830677176,
              -1.57123329220295,
              -0.398976477529886,
              0.74147252245375,
              -0.0933701272104212,
              -0.844740313543499,
              -0.0629134046481705,
              0.187459083091899,
              -0.829608766385384,
              0.128417387087155,
              -0.262040432265242,
              0.10910234774096,
              -0.285207406355525,
              0.940610996672781,
              -0.45187426959502,
              -0.775276386629245,
              0.083180650382858,
              0.516314324856622,
              -0.577155744820771,
              0.373645807918378,
              0.0106065290639214,
              0.612820897054471,
              -0.348353539881056,
              0.0175500224459147,
              -0.488405543040495,
              -0.047663222646064,
              -0.699613333300707,
              0.233040243995493,
              -1.44742082975127,
              -0.961146026135175,
              -0.885223980388605,
              -0.0913492795029848,
              -0.174790766857092,
              -0.567449761210461,
              -0.95431164058192,
              -0.627657452098645,
              0.287498985960595,
              -0.519100167952506,
              0.00968812716399049,
              -1.28800143368306,
              0.126919766223721,
              0.172376673324453,
              1.9618444806707,
              -2.9027385109357,
              0.2648033615714,
              -0.987380578024482,
              0.324233032213671,
              0.204932176603852,
              0.570558589190269,
              -0.0642003237363886,
              -0.61569618273837,
              0.603932447941084,
              -0.110882801033259,
              1.74261362845499,
              0.342459989675356,
              0.804959016280908,
              -1.30046855203824,
              0.378162393996983,
              0.20036011441235,
              -0.124191101738178,
              -0.792260764147394,
              0.140317101640481,
              -0.504786054832227,
              0.0296787413557681,
              -0.165116692192727,
              -0.485396351658678,
              0.787718122274695,
              0.568683716854368,
              -0.422470111264471,
              -1.3808182044836,
              0.332832714691392,
              0.933566682324427,
              1.55811214684432,
              0.789766989879742,
              -1.40830020945769,
              -0.939010824583754,
              -0.415379387315942,
              0.404431581133515,
              1.61747437602755,
              0.730843930874118,
              0.493417669778693,
              0.305716811075791,
              2.22906464278454,
              1.25227361661504,
              0.428821266494136,
              -0.219105360036562,
              0.073861925221204,
              0.434854463849057,
              0.235686261096067,
              0.40475786328558,
              -1.2840294525946,
              0.563767811369439,
              0.315265675385653,
              -0.521253656134137
          ],
          "z": [
              0.201435282720929,
              0.329768907686387,
              0.093902843144933,
              0.22464198944332,
              -0.988028651231165,
              0.069235909569869,
              -2.97106969956548,
              0.231801909252522,
              0.575335157107774,
              -2.24137325077847,
              -6.08439792252051,
              0.435630856597877,
              0.360143510495229,
              0.614737231948329,
              1.18966509137946,
              0.602096428929417,
              0.0217464566277283,
              1.34815981886397,
              -4.95127968532156,
              -1.07203527535065,
              1.32260942990256,
              0.866963310846321,
              -7.29586001064523,
              -1.18448467496028,
              -1.97929257559334,
              -3.84943347358822,
              -0.818912099541793,
              0.966385799124935,
              0.919940474237401,
              0.443362084498909,
              1.21777495305549,
              -0.373455052714888,
              -0.0914757076696811,
              -0.521955954642683,
              1.26908344278054,
              -1.33489404453911,
              -0.238896796125194,
              -0.428099137071566,
              0.420095085692551,
              -0.0250073997096215,
              -2.29721214455071,
              0.820241017150571,
              0.0695590530448773,
              0.436465157510775,
              0.469391875763944,
              0.0581541571510837,
              -3.64638543695082,
              0.0514946597432047,
              -0.1616355921716,
              0.19774392087412,
              -0.718922878788087,
              -2.60379877220889,
              -1.97235279165453,
              0.579514590104909,
              -0.35081529950437,
              0.75720748844966,
              1.48472388721961,
              1.0227125433678,
              -0.45438886942164,
              0.399726669908647,
              0.909397077189509,
              -2.92603598778514,
              -0.822434564810604,
              0.382785959079656,
              -0.673111286629802,
              -1.37510691208798,
              1.48679901006805,
              -2.08494451637625,
              -0.265810117450144,
              0.887360314979283,
              -0.251159383138168,
              -1.87968765761116,
              -0.520130125955135,
              -0.625095706302765,
              -0.850858696319319,
              0.254337365645582,
              -1.39972092422961,
              -1.18514264467012,
              0.125537954871331,
              1.1287755289296,
              0.14454429463339,
              0.267278062223429,
              0.409815365809074,
              -0.625364051110913,
              0.479524955217465,
              0.460634175322814,
              0.316945395539065,
              -0.378036798429535,
              0.244556877963394,
              0.392789915700996,
              0.45517310988052,
              0.301657370678075,
              -1.76821404511141,
              0.0925241171689499,
              0.683823311615076,
              2.46033405306559,
              0.564160807599312,
              -0.111909203627049,
              0.760814635815623,
              0.388991272550677,
              0.975361072753549,
              -0.0819164843198154,
              0.613478635616877,
              -1.43595309413178,
              -0.340901637796999,
              0.564294362804157,
              0.601025773391637,
              -0.194063192964131,
              0.661163667144902,
              -0.537851540929384,
              -1.29457491143452,
              0.209281147627875,
              -0.500391133157367,
              0.485138344634687,
              1.95570779786125,
              -0.295919011525778,
              0.474280392118237,
              -1.68312133531548,
              -0.389060194739038,
              -1.2629195805879,
              -3.89411467896226,
              1.1047246216818,
              -1.43462988809516,
              0.226446705888556,
              -0.674545373186389,
              -0.684147400083191,
              0.913066180731731,
              -0.416523924620181,
              0.0335882437469713,
              -0.356798574005519,
              -0.128188356607853,
              0.0857995118274772,
              0.216924378757859,
              0.345254123482773,
              -0.3776087056699,
              0.0183199094623133,
              -3.58033655626386,
              -0.638465637714718,
              -1.21380535616773,
              0.204430196791765,
              0.262936581432787,
              -0.458444177605979,
              0.10296659398774,
              0.731078935636378,
              0.85427574934739,
              0.433736016207214,
              0.198972204080811,
              -2.32221387885246,
              0.139385092018533,
              -0.955386851966025,
              0.644262451961307,
              0.119693532658142,
              -0.0713426617850664,
              0.117381749027406,
              0.0646569325654356,
              -5.55289891421013,
              0.581922864745088,
              0.511897897689287,
              -0.191142735831372,
              -6.8935779159372,
              0.601680103631857,
              -1.78527619036835,
              0.128130928812123,
              0.735092337622664,
              0.0840843852492471,
              0.0636063219753065,
              -0.92036618884045,
              0.559043480200678,
              0.219751107999207,
              -0.0920545392785709,
              0.1422208001426,
              -1.75832611905009,
              0.611194600858184,
              0.287922327120066,
              -1.17190708941481,
              0.223067051824703,
              -1.14066388583667,
              -0.151491017299948,
              -0.374123575666241,
              1.67595702083324,
              0.522681636385925,
              0.0981663195168752,
              0.0519989523775098,
              0.259642275492207,
              0.0520827967040611,
              0.0918585219110326,
              0.388692143131158,
              0.452490150058834,
              -4.4366444641562,
              0.072963688366289,
              0.0983229359828043,
              0.0474111415943476,
              0.786197892031262,
              -0.0808829842900052,
              -1.28045574786836,
              -1.22128062494545,
              -0.3258849733231,
              0.260263212246296,
              -1.33471484262465,
              -1.13441908123808,
              0.129260159123716,
              0.305887821842525,
              -0.135691137157392,
              0.310262330472663,
              0.387982995927783,
              0.326260246252182,
              0.184155066695482,
              1.00014533955884,
              0.336187620356077,
              -2.2510150320422,
              -0.624951358112126,
              -1.0518314692747,
              -0.915750261949487,
              -1.87066392102886,
              0.119769991585212,
              0.716553652560477,
              0.736352689480932,
              0.226339278826639,
              1.4222572068008,
              -3.58835110566922,
              -0.77821621495273,
              -0.979810375965438,
              -2.03107544379674,
              -1.80398781125976,
              -3.34352426312471,
              -2.0998305359256,
              0.163575787899497,
              -0.617479443315807,
              -0.356924985570485,
              0.137349640242777,
              0.897267499738498,
              0.154321913651882,
              -0.503014130778954,
              0.831053421421423,
              -0.488843686495411,
              0.66472682497978,
              0.281071084921098,
              0.0632248790761047,
              -0.151340171650605,
              -0.266805172841342,
              -0.249397812861632,
              0.264531988644407,
              -0.239640157225558,
              0.18141608155129,
              -0.108273234423785,
              0.501764283494912,
              0.0440426431474745,
              -0.263115739994546,
              -0.00809353834762257,
              -0.918226287793572,
              -1.84982309162079,
              -1.19077875856524,
              0.8041442734153,
              -2.45816545184397,
              -0.741264234595641,
              -0.750481855056847,
              -0.522684702143792,
              0.630374034984599,
              -1.99965494115806,
              0.496757806018483,
              -2.17067986824758,
              0.187019485378602,
              -1.88177640899705,
              -1.77685244528598,
              -1.32176973907868,
              0.208511824340334,
              -0.07651821824412,
              -0.210938858878613,
              0.90174131392254,
              0.621549436895915,
              -1.37164104858736,
              -0.682720485329491,
              -1.39613483535912,
              -2.86059280228357,
              0.500273700193716,
              0.0392888406517229,
              1.1376812754993,
              0.673233776910963,
              0.0666170426842229,
              1.36911568481306,
              -2.45146457633713,
              1.68201660252343,
              0.545829362567192,
              0.0992422503616995,
              -0.0517598955733725,
              0.184942355202663,
              0.490155181514731,
              -1.02908006438034,
              0.543185223305955,
              1.64824423477788,
              0.611802781198183,
              0.160453583989484,
              0.030048888576949,
              0.133593025902589,
              -0.180379309128775,
              0.555765090526691,
              -1.04288872051171,
              0.0451380874617328,
              0.0587377545343644,
              0.249634998763665,
              0.485272040007986,
              1.40513318722012,
              -1.66818625055177,
              -1.47028064602572,
              -0.330743238510071,
              0.404616581742008,
              -1.17634909459707,
              0.720143555993384,
              0.657328802043389,
              1.04848064473136,
              -1.22663441286723,
              -1.58265004626531,
              0.539161975754559,
              -0.313393819799657,
              0.605067818954292,
              0.132648811553307,
              -2.70825477535052,
              0.372271078046589,
              -0.593752121198804,
              -4.50945991000676,
              0.338009653522183,
              -3.02324514154651,
              0.454534439002359,
              -0.351704462135075,
              -7.1969046791121,
              -3.16777424972967,
              0.0137527308194705,
              0.132412541083231,
              0.295740048120441,
              0.245964227915253,
              -0.453670185747093,
              -0.989040698062325,
              -0.0340893337748556,
              -1.4882750738949,
              -0.563716962154728,
              0.109556938474678,
              -1.33150569806488,
              -0.0399068438000196,
              -1.20955404761503,
              0.794580527902131,
              0.0372807580485174,
              0.0962392235813986,
              0.592043714950028,
              0.0394404324510617,
              0.656739108973752,
              0.429628238553541,
              -0.0875122017834257,
              -1.80614645213255,
              0.0494521187101716,
              0.874812131286081,
              -2.04408796950931,
              0.151237182129809,
              0.0319618009512268,
              0.258350350249337,
              -0.868145759937639,
              0.24335929074493,
              -1.61506965706355,
              0.378493400087638,
              -3.23667456765387,
              0.225040409764339,
              0.143600339574886,
              0.0935130570300524,
              0.568750491875574,
              -0.287438168320356,
              -0.11785703817499,
              0.0229718877943081,
              0.408483683126699,
              -0.429542506010513,
              0.147090279765807,
              -0.100638354603314,
              -0.537428052837324,
              0.0910992007510667,
              -0.0236144042397153,
              0.630707185271891,
              0.561959068837475,
              0.0533685560992648,
              -3.50888727020853,
              0.0344532636325116,
              2.54347559328956,
              -0.826292781365443,
              0.00215521124956007,
              -0.701361118120506,
              -0.119620230131513,
              -3.07039347903198,
              0.418475670019897,
              0.00205197063201533,
              1.07459494866056,
              -1.6322653809072,
              1.02595987916888,
              1.53157736969924,
              0.0592078440408532,
              0.460139562780784,
              0.14746484850218,
              2.62613821659859,
              -3.09354303733116,
              -1.84224544742511,
              -1.11045780487569,
              -1.00207511467868,
              0.0995894842326051,
              -0.272194056790103,
              0.619256135019886,
              -0.00470902796948681,
              0.104618213108984,
              0.423070351511568,
              -0.237270362340998,
              -2.85965513730981,
              0.0689455901785611,
              -3.55143526111131,
              0.0674351870812182,
              -0.837030295028947,
              0.580999790503328,
              -0.445056228444484,
              -0.0258674937944121,
              0.248695195180769,
              -0.0129926124990086,
              0.0240812505027651,
              0.836786276800301,
              0.0724080872052626,
              0.569793024120605,
              0.0947990456346026,
              0.0212079605993768,
              0.584430789067772,
              0.653977645917662,
              -0.0528947525116797,
              0.894624685260529,
              0.716899836173961,
              -0.0327219751845249,
              0.278751546852453,
              0.00119949194465178,
              -0.113289518612589,
              -0.113986152531227,
              0.151037651980589,
              0.161527114152331,
              0.0321173797341634,
              0.393347786545859,
              -1.87274619470789,
              -1.65238611111895,
              0.520074623224423,
              -0.206097666734405,
              -0.411236753008206,
              0.485859645611812,
              -0.85964549538278,
              0.346675344170111,
              0.0300452704359991,
              -0.423763397555881,
              -0.0152522620658323,
              0.186626021675583,
              0.655904979836246,
              0.302620335072325,
              -3.12448193882679,
              -0.088922115937366,
              0.664028073470281,
              0.326924107671291,
              -0.0470206409027649,
              0.0143117998071442,
              -1.68372612389384,
              0.0323667299550089,
              0.0415359138512121,
              0.0375569352637335,
              0.0469816944972589,
              0.187703378699373,
              -5.31420879509299,
              -0.0725139622117533,
              0.37644436389219,
              0.19202098868823,
              -0.458698491808881,
              0.885900258484577,
              0.0276991690149805,
              1.17575956470279,
              0.0258085120882074,
              -0.669664883625841,
              0.0188104037429896,
              0.450450129237971,
              -0.676865679910868,
              -1.34949741785303,
              -1.83104637882284,
              0.27319891670183,
              -0.544049158891722,
              0.782051025160722,
              -1.55294875290435,
              0.16958109169016,
              -0.198134171804605,
              0.198073879365734,
              0.0245699728007103,
              -1.43092721050107,
              0.0802890132051873,
              0.292498713655298,
              -1.56563560572575,
              -1.60471483314779,
              0.164169679140727,
              -1.08910099199152,
              0.779958689049855,
              -2.77193260874233,
              0.0770158396135511,
              0.1701746191906,
              -0.839060554655484,
              -0.333652129321467,
              -1.35459696078161,
              -2.66023572040389,
              -3.72621265796508,
              0.000526180248069594,
              0.108619430277669,
              0.062297409310144,
              -1.56875138348828,
              -0.20841159067964,
              0.137088650298165,
              0.142521187817007,
              1.04234493705821,
              -2.15143467307565,
              0.970570787132514,
              -2.1843655440488,
              -0.00480085228526271,
              -2.24194211003628,
              -1.18481768563936,
              -1.16665265346029,
              -1.99669073803962,
              -2.3291072640413,
              -2.19996286008883,
              0.17857176168999,
              -1.56891533920987,
              0.127236183918666,
              -0.0670119906291482,
              0.00816167972228109,
              0.0882586543868099,
              1.99521082911364,
              -2.33341932270998,
              0.0263252126770561,
              0.0711700465189143,
              0.14256357394057,
              -1.17213148187719,
              0.0365398115129294,
              0.514076153912921,
              0.0975237113486845,
              0.224548879212178,
              -0.886311663581513,
              0.681722407989349,
              -0.493518177989226,
              0.51061171054333,
              -1.1389173060293,
              0.377293326066407,
              0.356036083745283,
              0.652896898394031,
              -0.765307867309984,
              0.275298523439435,
              1.19124143144739,
              -0.022189905006053,
              0.121694806219906,
              -0.837573569761749,
              0.543424982910464,
              0.18979901464302,
              -3.56550349295584,
              -0.0157420763504221,
              -0.512457007071173,
              0.36144926757398,
              -0.595829625777939,
              -0.4354798110641,
              0.317777919224763,
              -0.117226739612249,
              0.280515340874097,
              -0.818762938694842,
              0.213210754843899,
              -1.81247363463926,
              0.0896765137300259,
              0.128880049013161,
              -2.19384580202298,
              0.106029442540481,
              -0.798186827525241,
              -1.11669184376855,
              0.0200879371273319,
              0.109584123226776,
              0.287512760872306,
              0.376295403828007,
              0.140081814860865,
              -0.182000126673088,
              0.0979590959947257,
              0.212759017251337,
              -0.126086227039247,
              0.281770063215871,
              0.0620319413566109,
              -0.562506981299625,
              0.048309979069721,
              0.398343836994229,
              -0.616141429228007,
              -0.956187384023838,
              0.121852953338223,
              -0.625595894144844,
              -1.60170431362068,
              -0.214115080382863,
              0.255667050111464,
              -0.333834554682138,
              0.301245771111847,
              2.35917423769727,
              0.829771066177059,
              0.749500036371455,
              -0.597367628597697,
              0.180112356358765,
              -1.75010908909204,
              0.128712671893312,
              0.506139688104827,
              0.445951402640855,
              1.0344823316167,
              0.905649428274134,
              -1.00927047476914,
              -2.92769147230422,
              -2.30719117275504,
              0.68706840834152,
              -0.0763240366144424,
              -0.780985723092197,
              -0.115406811916378,
              0.654156467058692,
              -0.0129320642919497,
              -3.24391785098157,
              0.105091376339246,
              0.129910916988248,
              -0.614849542938968,
              0.451600492476619,
              -2.33325017845528,
              -0.673791976309609,
              0.779575955078375,
              -0.126776221459093,
              0.911588460210325,
              0.950308236851943,
              0.85001042613116,
              0.192347806749469,
              -0.283454573478784,
              1.00697310156632,
              2.3662272761381,
              1.12074492548176,
              2.94457826334648,
              0.120377891047738,
              -4.31435643202912,
              -1.38718825822165,
              -1.62371840395902,
              -2.30697841952415,
              -0.142454320935754,
              -1.49886569075242,
              2.56312577696992,
              0.404794500111747,
              -0.806402315841101,
              0.0288057041599678,
              -0.770813514194557,
              -0.135091332792428,
              0.256999692455624,
              0.373538322999267,
              -1.15763580352943,
              -1.3641841164833,
              -0.115084656630812,
              -0.0935911411134283,
              0.601551821297373,
              0.366186239628564,
              0.372422550315499,
              0.0678783620691453,
              0.0200642126911787,
              -0.453313700917959,
              0.629824456884568,
              0.129564109057972,
              0.0156299850599162,
              -0.96787809782156,
              -1.99830475489081,
              -3.17776819457878,
              -1.92196241988928,
              -0.266676618836066,
              0.230415886700703,
              -0.699608344545887,
              -2.02610738329313,
              0.07540810320955,
              0.000855397948504991,
              0.166570433376148,
              0.243898694525263,
              0.9094468725102,
              0.219960049790814,
              -3.15017574909945,
              0.199800118881778,
              -0.0173423262020871,
              0.569923464641658,
              0.48301062423049,
              0.225914700830922,
              -0.799198352177065,
              -0.120183214561493,
              0.563029887490992,
              -1.31605612379603,
              0.275592400182286,
              -0.0211778663678136,
              -0.246119772988733,
              1.61753068903214,
              -1.15645660150662,
              0.931615850508436,
              -1.25327681788859,
              -0.799031996736195,
              1.14074376513482,
              0.355433149692337,
              -0.690820999928717,
              0.276020854808502,
              0.275189780364792,
              0.3140616917245,
              0.466830530153564,
              0.137800563835295,
              0.18858790977888,
              0.216704521035688,
              -0.0432782944285155,
              0.263439822592142,
              0.75420538708724,
              -0.0535032144683402,
              0.0677501071635038,
              -0.93790318926309,
              0.548436079161045,
              1.00001321897493,
              0.623916259281142,
              0.449063338279003,
              1.82664025896787,
              -0.498405496453375,
              -1.57811397891205,
              -0.133048990218416,
              0.190214367190967,
              0.242778906504724,
              0.732315984444652,
              -0.686432612235966,
              -1.70365017976834,
              0.438524886054865,
              -0.0439223962351139,
              0.021343837766456,
              0.0556991031550056,
              -1.09029046708651,
              -3.32323635217336,
              -1.5605448091282,
              -0.797890589628444,
              -1.860400274184,
              0.35342685230491,
              0.722578143563161,
              -2.20871442933047,
              -4.99097737247449,
              -0.234308892870175,
              0.112548164322145,
              0.80790761198157,
              -5.36941472427141,
              -5.93024802121068,
              -0.0305638655506526,
              0.143572519629536,
              -0.0150362264726781,
              0.432864110887317,
              0.263468592392225,
              0.194123631870597,
              1.74683365617047,
              -0.549623940830478,
              0.470987688003252,
              0.261130192958413,
              0.864033178874537,
              -1.26556010358431,
              -1.75055013959594,
              0.707062179556742,
              0.0204381905978652,
              4.77324863625193,
              -1.03924847082782,
              -0.328807285037652,
              -1.66050145936156,
              0.0786773068559298,
              0.669455388094528,
              0.338729260988127,
              -0.049366505612301,
              0.269591755735994,
              -0.000315810024028251,
              -1.20743498638151,
              0.0183113243077317,
              -0.84826470450931,
              -0.863279143624488,
              0.529680060764749,
              1.15335727105136,
              0.247660708614553,
              1.39241896240673,
              0.633565479576951,
              -0.0149506950243461,
              -0.578411871710383,
              -0.311352905940913,
              1.30118201518842,
              0.771401594679105,
              0.0201160784033326,
              -0.0117893657532512,
              -0.11038198871329,
              0.186065503025048,
              0.135885643846546,
              -0.639388093788451,
              -0.443653039807009,
              -1.80034177426752,
              1.04222176652177,
              -0.384772070594481,
              0.265655226062016,
              0.780858400378483,
              -0.0370563272143619,
              0.0527073492025041,
              -0.000481611500759385,
              -1.07618734648571,
              0.476773152808276,
              0.782834498401576,
              -1.10587845271553,
              -0.467814157945432,
              0.690214160633646,
              0.762457290876196,
              -1.02742501613685,
              -0.686846438976701,
              1.84643558636128,
              0.326963334300782,
              -1.08363583017532,
              -1.96606562230174,
              0.300518619877536,
              0.277597486753096,
              0.662579366672698,
              0.0209537626617113,
              0.254319296937486,
              0.438812835613493,
              -1.04626748782004,
              0.0752149782757035,
              0.0486281731963457,
              0.173550446209641,
              -0.672636082289588,
              0.181521630634443,
              0.266066077773135,
              -3.26254489646069,
              1.93910460888094,
              -0.410114419939523,
              0.185203123743723,
              -0.0717305794497175,
              0.0680312988103592,
              0.288958690563819,
              0.539635486417125,
              0.0537864182871731,
              -0.350397363420889,
              0.171516242939545,
              1.29321803611032,
              -0.016876083626561,
              0.936909897771907,
              -0.126313586253189,
              0.237668201638247,
              0.313253343436089,
              1.08280202362872,
              0.0505812926930027,
              0.656685777814574,
              0.225726099170438,
              0.680912550477763,
              0.0766600053250677,
              0.133237594871513,
              -1.01509529090255,
              0.169378686825494,
              0.0135881300084492,
              -3.73302029087431,
              0.267109197975442,
              0.449674343819011,
              0.261888199325048,
              0.222658013390228,
              0.484535447257994,
              -0.0577138110599983,
              0.518730783206087,
              0.815001823101661,
              -0.830836577498071,
              0.413328826955777,
              -1.06322184992324,
              -0.157142294889985,
              -0.000807589506236425,
              1.3587359882984,
              -1.88579209480576,
              0.627725557864767,
              0.123305517216282,
              -0.188918867623365,
              -0.473725133187876,
              0.575758291120433,
              -0.339690849914096,
              -0.174317018679743,
              0.0249872845314335,
              -3.94225135603574,
              -1.47893870651877,
              0.145754628365991,
              0.0235361649037374,
              0.105134257332068,
              -0.945161803132605,
              -0.0584764159359753,
              -2.64249978333383,
              -1.53512064584769,
              0.334992309271676,
              1.27913477233017,
              0.0880126733175439,
              0.374905920428746,
              -1.00097900890805,
              -2.29688896449009,
              -0.874639444526266,
              0.00833190210172062,
              -2.58806837595964,
              -0.671511708929246,
              0.153135260558687,
              0.0400880302589775,
              -1.14987070795904,
              0.434707113339209,
              0.554970336086407,
              0.0635648091419332,
              -1.23482323256628,
              -0.080476921297847,
              0.4067768242966,
              0.271271112585804,
              0.0400628421160103,
              0.761355782754328,
              -0.0299398940393913,
              0.177776466198269,
              -1.00868921444903,
              -0.284505027324104,
              0.374554910796853,
              0.532035566549224,
              -0.80646024301548,
              -0.333237423263164,
              0.424712651818345,
              0.553170038028111,
              -0.488659607328918,
              0.300423239978439,
              0.266800832905318,
              0.397536026089433,
              0.312344399483165,
              -0.022168059448657,
              1.15057686722741,
              -0.646619641290186,
              -0.825175041752325,
              -0.0144224201553895,
              0.63504400722545,
              0.250788689583603,
              0.402539806690356,
              1.80388250254246,
              -1.76913426934027,
              0.00241216770364545,
              -0.355260853693555,
              0.396482918375194,
              0.15868027018582,
              0.793413030329964,
              -4.5459078811711,
              -1.96005007965839,
              0.323429923780063,
              -0.706145842613805,
              0.270054742381299,
              -0.962939211003922,
              0.00239041240072087,
              0.355377239928287,
              0.0417043137704091,
              0.462949546923248,
              0.19626191644891,
              0.283628229823178,
              -0.878830460462333,
              0.470626362799907,
              0.644297053227211,
              0.145334929329441,
              0.714756735165543,
              -0.319365847817606,
              1.23261441921106,
              -0.256958274380368,
              -0.0383358194964691,
              -2.08090778621257,
              0.202956040570613,
              0.236625542023082,
              -0.874426732593924,
              0.0777197401783311,
              -0.300204309012016,
              1.10730909957241,
              0.825409741801164,
              0.669261904824014,
              -0.994107050456728,
              0.196885626723832,
              0.0459513170658258,
              0.617365009421032,
              -0.15363586804811,
              0.268805334470302,
              0.190937921736173,
              0.977499091154549,
              0.0693198989632788,
              -1.1531118124012,
              0.0395879370895699,
              -0.21806412708114,
              -1.6765583738856,
              0.00873260831276519,
              -0.440759469184986,
              -0.824825698569709,
              0.228259263649597,
              -1.08386973836612,
              0.464745737309687,
              -1.50389860129237,
              0.0825566305182464,
              0.241570419574859,
              -0.602296550063063,
              0.504762182096921,
              -0.0354795176537561,
              0.284403906912075,
              0.360737539978092,
              0.10580619508073,
              0.0582437506962831,
              0.473626057503257,
              0.311487499883721,
              -0.153697407529554,
              0.162512599293491,
              -0.00211331054327925,
              -0.885803706170668,
              0.0786741326808752,
              -0.0263432806240451,
              0.3078762353796,
              0.211132054571361,
              1.20972705881375,
              0.145151154167082,
              -2.12187860363487,
              -0.0239406248388519,
              2.95395500209722,
              -0.00307145112349762,
              -3.63603849723378,
              0.427910562503992,
              0.0793993901397694,
              1.05564421006315,
              0.350354673184895,
              -0.654331376410231,
              -1.15485390183089,
              -1.5565633333093,
              0.151473173960423,
              -0.924156741963,
              0.649108749322011,
              -0.175048380603691,
              -1.28464553150983,
              -0.93244545285393,
              -1.17812817968612,
              -0.0605748095689137,
              0.0285469664108156,
              0.196875933120605,
              -0.375060583095478,
              -0.246935895624134,
              0.0633540097597771,
              -1.08274439808768,
              0.310804115811128,
              -0.497390248829602,
              0.587846849837282,
              -0.772612495333765,
              0.488623796467802,
              0.171258938892608,
              -0.792835913980862,
              -0.220986166599445,
              -0.267876522469103,
              0.124477619676802,
              -0.749445536746051,
              0.902284494612122,
              -0.00763377256276944,
              0.0367163679814548,
              0.618836444279845,
              0.688257527118951,
              -1.1317167455996,
              0.517196644119127,
              -0.741563734168152,
              0.0710256069142671,
              0.27253837878832,
              0.659006905625495,
              -1.1338071432556,
              -0.0184606936538446,
              0.137351403668896,
              0.36141013887272,
              -0.663340501526959,
              0.147976158091713,
              0.265935281548811,
              -0.735792746608604,
              0.712687654437566,
              0.259947309592841,
              0.323483596957288,
              0.0419597975993537,
              0.282127744241919,
              0.639309500171828,
              -0.683694800268629,
              -0.936720739302269,
              -0.0376289703189331,
              -0.145312933707847,
              -0.00503814021467743,
              0.517217851494227,
              -0.563631606335842,
              0.105333860726423,
              -0.0802837510118038,
              -0.122660671925034,
              1.08156486228778,
              -0.0971364268284961,
              -1.22791355306383,
              0.444905451454032,
              -4.29436612476007,
              -0.304092105023748,
              -0.0774055143339369,
              -0.0288364910272663,
              0.482897074460814,
              -1.28855913334552,
              0.126952178659444,
              0.356127528242023,
              0.490142942614144,
              0.00173858796285496,
              -0.741286316039748,
              -1.09698025947217,
              -0.945067879021056,
              -0.308144645671483,
              -0.769679079629866,
              -0.397061552483639,
              -0.47754813923761,
              -0.291762840213537,
              -0.390695014562958,
              -0.687298558516404,
              -1.2548949575022,
              -1.65728836769051,
              0.144040197950486,
              -0.209650965652329,
              0.495309819410042,
              0.17859055666506,
              0.0267854927587341,
              -1.03290789478098,
              0.558433891911889,
              -0.627632060017161,
              -0.681548619727586,
              -2.12966738249115,
              0.132840252089134,
              -0.22027791976573,
              0.189470975349154,
              -0.933077121160419,
              0.43915517069287,
              0.108536540999273,
              0.344010986103331,
              -0.414524270437723,
              -0.711937954583684,
              -0.199148561080372,
              -0.667758772617096,
              -0.30527227868935,
              -1.01518937256627,
              -0.471639625807022,
              -0.711887385724221,
              0.104494249466904,
              0.0831941703557162,
              -0.102725151611912,
              -1.0435661930929,
              -1.22853082757275,
              -0.124329014917568,
              0.279966843182925,
              -0.0385733312523065,
              0.18478059637032,
              0.0710197806247863,
              1.67575446274096,
              0.603734668047825,
              0.0822242790483166,
              0.602378597990761,
              -1.53937708704371,
              2.29318944681488,
              -0.997050680975961,
              0.464623358824963,
              -2.32562411184392,
              -0.868608570722855,
              -0.677373917807514,
              -0.921027816808551,
              0.681837809917625,
              -1.75116547467387,
              0.586550159713259,
              0.147893858301868,
              -1.79435682813842,
              -1.21862876767976,
              -0.689455781017328,
              -0.463434539722022,
              -0.670158066060087,
              0.0300335301515722,
              -0.025591162860816,
              0.0432810741549666,
              0.122831583006351,
              -1.93641840997623,
              -1.14289562734621,
              0.54607525969265,
              0.915887446561737,
              0.499265777289227,
              -0.620635066833952,
              0.124537206605066,
              -0.983022997678468,
              -0.399594299660427,
              -1.5075004381065,
              0.045142653952438,
              -0.417434410886356,
              0.533094522390881,
              0.0952316812488323,
              -1.81360521344802,
              0.232873151627376,
              1.54461778105453,
              0.315238628147857,
              -0.140138779343334,
              0.189029569058112,
              -1.27094866498482,
              -0.93666285592659,
              -0.816430149736072,
              0.471931404597186,
              0.813662197617444,
              0.0133396006920097,
              -0.477341068700562,
              -0.782284150477913,
              -0.0100204213101296,
              0.286318923462362,
              0.151803754888808,
              0.0188808666779572,
              0.160957171215222,
              -0.0277210638257505,
              -1.24861715219712,
              0.413885641249625,
              0.203968780388296,
              -0.515790101235995,
              -2.50423379427962,
              -1.58005502647478,
              0.657564095543935,
              0.324293592262935,
              0.815240793813968,
              0.2077912338511,
              0.646144608705515,
              -0.0841404151341285,
              -0.786965886954045,
              0.689528098541406,
              0.430883582271515,
              -0.121889926728947,
              0.2974704037652,
              0.398690210503794,
              -0.0264125594164891,
              0.543239496775179,
              -1.69935973156252,
              -0.48572963635272,
              -0.314699436679991,
              -0.708184101269676,
              -0.989825087221664,
              -5.19076582982733,
              1.21749446322987,
              0.320549016206214,
              0.174744514552949,
              -0.506897055644051,
              0.275649497065348,
              -1.6324852416658,
              -1.5517772649111,
              -0.878199104196153,
              0.299220469114478,
              0.222276677466418,
              -0.0219563823758066,
              -1.33976822174443,
              -1.48497882710557,
              1.46370504194792,
              0.1299811724002,
              0.263346892172945,
              0.638104352713343,
              1.15360168273349,
              -0.468837581135563,
              0.0401941970540898,
              -0.153111219154928,
              0.223402441823262,
              0.482027333916087,
              0.437836468434647,
              0.39746745561212,
              -0.0196871921449227,
              -0.67758505527722,
              -1.1184371707713,
              -1.22112241485821,
              0.0315323250180424,
              0.160884754206719,
              0.85590652264223,
              1.66272788915888,
              0.214367518902495,
              0.484442662268426,
              -0.377404706630656,
              2.75910218247209,
              -0.262001267313402,
              0.0792249199121136,
              -0.762997190858696,
              -0.915830344617389,
              -0.586100342904004,
              0.640817973241934,
              0.53416999591684,
              0.306775364660919,
              -0.212486722671298,
              0.144946977072661,
              -0.64553979149751,
              -1.13518926136245,
              0.0726305182162064,
              -0.1561122241775,
              0.00869549569869239,
              0.578626752239608,
              0.184332855466415,
              0.511676499723752,
              0.251183319656597,
              -0.143344946134044,
              -0.286383838323596,
              0.264972997358432,
              0.554669374299871,
              0.151769186735788,
              0.646550761557722,
              -0.331668085453978,
              -0.624479048812596,
              -0.108108709882785,
              0.365054513175981,
              0.00519533472872395,
              0.156073888315936,
              0.835823632327505,
              0.33707698051764,
              0.0246355168030926,
              -2.96327361172512,
              0.523274079966885,
              -1.77292400377501,
              -1.32476114744006,
              0.188595895001369,
              -2.38626870932639,
              0.612032227352184,
              0.520303526260806,
              -0.127637788840415,
              -0.477472380923026,
              0.205498898667131,
              1.26494888021247,
              -0.403384597364363,
              -0.382373519306708,
              0.830437884381207,
              2.03694177323554,
              -0.585701915121424,
              0.539711022384663,
              0.161984583647865,
              1.38730856346021,
              -0.195400496429837,
              -0.247897195880014,
              0.30481632981319,
              -0.046320049982809,
              0.11438860703239,
              -9.33345353064982,
              0.0579699301371457,
              0.267186284765361,
              -2.24476275568573,
              -0.197962663730499,
              1.19833786444468,
              -1.23538548285478,
              -0.255373637704608,
              0.667418671737577,
              -0.0669217996951513,
              -1.05312709033287,
              -3.1119033828674,
              0.0899905306510694,
              0.520028952218291,
              0.12994133948372,
              0.164879855025449,
              0.772665628253494,
              -3.06226155788337,
              0.247240135142442,
              0.109997355084786,
              0.0226047741753301,
              -0.905862238797552,
              -0.0918303576836181,
              -0.156100624666097,
              -0.370227447467026,
              0.590692691970053,
              0.186336218244972,
              0.227139065177038,
              0.0368765488915991,
              -0.114569623947706,
              -1.06340569694066,
              -0.419996513552912,
              -0.00590308919382204,
              -1.34677983214869,
              0.817363387019003,
              0.340604930456656,
              -0.481401238170515,
              -0.422485169839871,
              0.31337082736105,
              -1.7634930917449,
              1.18358083298412,
              -0.173905334072758,
              0.388701176823508,
              0.920311144650929,
              -1.18290937376296,
              0.129173289800365,
              0.0265378432945605,
              -0.860440132151409,
              0.209083687030687,
              -0.733928622869432,
              1.47191486596371,
              0.487752537271892,
              -0.571795609840717,
              -0.66720520193808,
              -0.721094241070373,
              -0.0477801399749262,
              1.11629630323079,
              -0.00489165798906517,
              0.474840278785689,
              -0.762893201160789,
              0.642008317256303,
              0.446576657796006,
              1.24387613464874,
              -0.333576885670089,
              0.0550482899924014,
              0.103876210329595,
              -2.10491377648628,
              -1.24589648211258,
              -0.220442117675885,
              1.50962937820831,
              -0.623029599272283,
              1.11078755073469,
              1.12403186616635,
              0.908243192202142,
              0.115239012888345,
              -3.38254477912597,
              0.322654571713596,
              -0.589148214551562,
              0.18169720927297,
              0.339110930641593,
              -0.210779656523968,
              -5.62495713050087,
              -0.0225512324070686,
              -2.42467257426969,
              0.0021170484156514,
              0.205893569913861,
              0.370434408411279,
              0.570483441097427,
              -0.471451446401507,
              0.04768170191749,
              1.19282803523924,
              -0.144828396992933,
              0.251377272360025,
              -1.4369007304792,
              -1.53231154924227,
              0.0988195858031498,
              0.264749389770932,
              -1.54721058295121,
              -0.388393448408577,
              -0.549458013355723,
              -0.731681692992894,
              0.0886864438545585,
              0.600661419644756,
              0.425243131865364,
              -0.0572043259134494,
              -0.12793419156486,
              -0.281839583762381,
              -12.4854571362502,
              0.111976357275464,
              -0.0514533129097393,
              -0.161498048574933,
              -0.0085102348118441,
              -1.86927834551668,
              -0.743222546829823,
              0.458186092343577,
              -0.728257704623913,
              -1.66124676121107,
              -0.860236469894299,
              0.230634872778352,
              0.118314834637993,
              0.348536026992159,
              1.32136150498439,
              0.288656734946902,
              -0.764680249891349,
              -3.41516767315211,
              -1.29811584863534,
              0.169910624106906,
              0.0751129337215151,
              1.7817911612731,
              1.48847880224328,
              0.114438839147462,
              -1.77582690653253
          ],
          "text": [
              "AAMP",
              "AAR2",
              "AATF",
              "ABCB9",
              "ABCD4",
              "ABCF3",
              "ABHD17C",
              "ABHD4",
              "AC002094.2",
              "AC002347.2",
              "AC002985.1",
              "AC004079.1",
              "AC004477.2",
              "AC005253.2",
              "AC005306.1",
              "AC005606.1",
              "AC005841.1",
              "AC005943.2",
              "AC006001.4",
              "AC006441.3",
              "AC007620.2",
              "AC008264.2",
              "AC008878.1",
              "AC009119.1",
              "AC009511.1",
              "AC010776.2",
              "AC010883.3",
              "AC010978.1",
              "AC012615.3",
              "AC012640.6",
              "AC013489.3",
              "AC015674.1",
              "AC016596.3",
              "AC016739.1",
              "AC017083.2",
              "AC020909.3",
              "AC022149.1",
              "AC022167.1",
              "AC022400.9",
              "AC022966.1",
              "AC025370.1",
              "AC025423.4",
              "AC025682.2",
              "AC027290.2",
              "AC027319.1",
              "AC034102.1",
              "AC060766.5",
              "AC067852.2",
              "AC067930.5",
              "AC068631.4",
              "AC068888.1",
              "AC073641.1",
              "AC079250.1",
              "AC079328.2",
              "AC084024.3",
              "AC087393.2",
              "AC087521.4",
              "AC090971.2",
              "AC092069.1",
              "AC093110.1",
              "AC098614.3",
              "AC104411.1",
              "AC104758.1",
              "AC114947.2",
              "AC115223.1",
              "AC116533.1",
              "AC125257.2",
              "AC125611.3",
              "AC130304.1",
              "AC139530.1",
              "AC140479.5",
              "AC243964.4",
              "ACAP3",
              "ACLY",
              "ACOT9",
              "ACSF2",
              "ACSL3",
              "ACTR1A",
              "ADAM10",
              "ADAM9",
              "ADPGK",
              "ADPRHL2",
              "ADRM1",
              "AFAP1",
              "AFAP1-AS1",
              "AGPAT2",
              "AGR2",
              "AHCY",
              "AHSA1",
              "AKAP11",
              "AKR1A1",
              "AKR1B1",
              "AKR1C1",
              "AKT1",
              "AL031600.3",
              "AL034430.2",
              "AL109628.2",
              "AL110504.1",
              "AL117190.2",
              "AL139317.3",
              "AL162151.2",
              "AL353644.2",
              "AL353689.2",
              "AL354811.1",
              "AL451085.3",
              "AL512791.1",
              "AL590714.1",
              "AL662797.2",
              "ALAS1",
              "ALCAM",
              "ALKBH4",
              "ALKBH5",
              "ALYREF",
              "ANAPC11",
              "ANG",
              "ANKRD17",
              "ANLN",
              "ANTXR1",
              "ANXA1",
              "ANXA2P2",
              "AP000926.2",
              "AP000942.2",
              "AP001107.6",
              "AP001267.5",
              "AP002383.2",
              "AP002490.1",
              "AP003392.3",
              "AP3B1",
              "AP3D1",
              "AP3M1",
              "AP3S1",
              "AP5Z1",
              "APH1A",
              "APLP2",
              "APMAP",
              "APOBEC3C",
              "APOLD1",
              "ARF3",
              "ARF5",
              "ARFGAP1",
              "ARFGEF1",
              "ARHGEF11",
              "ARHGEF12",
              "ARHGEF28",
              "ARHGEF9",
              "ARID5B",
              "ARPC3",
              "ARPC4",
              "ARRDC1",
              "ARRDC3",
              "ASB6",
              "ASCC1",
              "ASH2L",
              "ASMTL",
              "ASPH",
              "ASS1",
              "ATAD3B",
              "ATF4",
              "ATF5",
              "ATG10",
              "ATG101",
              "ATG13",
              "ATP1A1",
              "ATP2A1-AS1",
              "ATP5IF1",
              "ATP5MC2",
              "ATP5MC3",
              "ATP5MPL",
              "ATP6AP1",
              "ATP6V0B",
              "ATP6V1G1",
              "ATPAF2",
              "ATRX",
              "AUP1",
              "AVPI1",
              "B2M",
              "B3GAT3",
              "B4GALT2",
              "BAD",
              "BANF1",
              "BAP1",
              "BAZ1A",
              "BBS2",
              "BBX",
              "BCAR1",
              "BCAR3",
              "BCCIP",
              "BCL2L1",
              "BCL2L2-PABPN1",
              "BCL3",
              "BCL6",
              "BCL7B",
              "BCL9L",
              "BET1L",
              "BICC1",
              "BID",
              "BIK",
              "BLVRB",
              "BOD1L1",
              "BOP1",
              "BRD4",
              "BRD7",
              "BRD9",
              "BRI3",
              "BRK1",
              "BRMS1",
              "BSG",
              "BST2",
              "BTBD10",
              "BTBD6",
              "BUD23",
              "BUD31",
              "BX322234.1",
              "C12orf65",
              "C15orf48",
              "C16orf58",
              "C19orf47",
              "C1orf56",
              "C1R",
              "C4orf48",
              "C5orf15",
              "C8orf33",
              "C8orf58",
              "C9orf16",
              "CA9",
              "CALM2P2",
              "CAMTA2",
              "CAP1",
              "CAPN2",
              "CAPZA2",
              "CARHSP1",
              "CARS1",
              "CASC3",
              "CASK-AS1",
              "CASP3",
              "CASP7",
              "CBX5",
              "CBX6",
              "CCAR1",
              "CCDC12",
              "CCDC124",
              "CCDC34",
              "CCDC58",
              "CCDC86",
              "CCN2",
              "CCNA2",
              "CCT3",
              "CCT5",
              "CCT7",
              "CD109",
              "CD151",
              "CD320",
              "CD47",
              "CD55",
              "CD81",
              "CDC123",
              "CDC26",
              "CDC42BPB",
              "CDC42EP1",
              "CDC42EP3",
              "CDC42SE1",
              "CDC5L",
              "CDCP1",
              "CDH6",
              "CDK2AP2",
              "CDK4",
              "CEACAM19",
              "CEBPB",
              "CENPBD1",
              "CENPF",
              "CENPT",
              "CENPU",
              "CEP164",
              "CEP290",
              "CEP55",
              "CEP63",
              "CERS2",
              "CFAP298",
              "CFAP36",
              "CFAP97",
              "CHD2",
              "CHFR",
              "CHKA",
              "CHMP1A",
              "CHMP1B-AS1",
              "CHMP4B",
              "CHMP5",
              "CHPF2",
              "CHST3",
              "CHTF8",
              "CHTOP",
              "CIAO2B",
              "CIDECP1",
              "CKAP2",
              "CKAP5",
              "CKS1BP3",
              "CLIC1",
              "CLIP1",
              "CLPP",
              "CLPTM1L",
              "CMTR1",
              "CNBP",
              "CNN3",
              "CNOT4",
              "CNOT7",
              "COL4A2-AS1",
              "COL6A3",
              "COPS3",
              "COQ4",
              "COQ5",
              "CORO1B",
              "COTL1",
              "COX16",
              "COX6A1",
              "COX6B1",
              "COX7A2",
              "COX7A2L",
              "COX7C",
              "CPD",
              "CRAMP1",
              "CRIM1",
              "CRLF1",
              "CRTAP",
              "CRTC1",
              "CSF3",
              "CSGALNACT1",
              "CSK",
              "CSNK1E",
              "CSNK1G2",
              "CSRNP1",
              "CSTB",
              "CTDNEP1",
              "CTF1",
              "CTNNAL1",
              "CTNNB1",
              "CTNNBL1",
              "CTPS1",
              "CTSD",
              "CUEDC1",
              "CUL5",
              "CWC27",
              "CXorf40B",
              "CXXC1",
              "CYB561D2",
              "CYB5R1",
              "CYC1",
              "CYFIP1",
              "CYP51A1",
              "CYTH2",
              "CYTOR",
              "DAD1",
              "DAP3",
              "DAXX",
              "DAZAP1",
              "DBN1",
              "DCAF7",
              "DCTN3",
              "DCTN6",
              "DCTPP1",
              "DDB2",
              "DDX1",
              "DDX23",
              "DDX27",
              "DDX28",
              "DDX39A",
              "DDX39B",
              "DDX41",
              "DDX42",
              "DDX46",
              "DDX49",
              "DDX50",
              "DDX56",
              "DDX6",
              "DDX60",
              "DEDD2",
              "DEK",
              "DGAT1",
              "DGCR2",
              "DGLUCY",
              "DHCR7",
              "DHRS1",
              "DHX32",
              "DHX37",
              "DKK1",
              "DLGAP5",
              "DMAC2",
              "DMPK",
              "DMTF1",
              "DMWD",
              "DMXL1",
              "DNAJA3",
              "DNAJB12",
              "DNAJC11",
              "DNAJC13",
              "DNAJC16",
              "DNMBP",
              "DOK4",
              "DPAGT1",
              "DPP9",
              "DPY19L4",
              "DPYSL2",
              "DPYSL3",
              "DRAP1",
              "DRG2",
              "DST",
              "DTX2",
              "DUS1L",
              "DUSP10",
              "DVL2",
              "DYNC1H1",
              "DYNLT3",
              "E2F1",
              "E2F4",
              "E4F1",
              "EBAG9",
              "EBNA1BP2",
              "ECSIT",
              "EDF1",
              "EEA1",
              "EEF1D",
              "EEF2",
              "EFR3A",
              "EGR1",
              "EHD4",
              "EIF1AD",
              "EIF2AK1",
              "EIF2B4",
              "EIF2S3",
              "EIF3B",
              "EIF3C",
              "EIF3CL",
              "EIF3D",
              "EIF3G",
              "EIF3I",
              "EIF4A2",
              "EIF4BP6",
              "EIF4BP7",
              "EIF4E2",
              "EIF4G3",
              "EIF5A",
              "EIF5AP4",
              "EIF5B",
              "EIF6",
              "EIPR1",
              "ELOF1",
              "ELOVL1",
              "EMC3",
              "EMD",
              "EML2",
              "ENC1",
              "ENDOD1",
              "ENO1",
              "ENTR1",
              "EPB41L1",
              "EPB41L3",
              "EPHA2",
              "EPHB4",
              "EPHX1",
              "ERBIN",
              "ERCC1",
              "ERCC3",
              "EREG",
              "ERF",
              "ERGIC2",
              "ERGIC3",
              "ERH",
              "ESF1",
              "ESS2",
              "EXO1",
              "EXOC1",
              "EXT1",
              "F2R",
              "F3",
              "FADD",
              "FADS1",
              "FADS2",
              "FADS3",
              "FAF2",
              "FAM102A",
              "FAM13A",
              "FAM160B2",
              "FAM168B",
              "FAM174C",
              "FAM210B",
              "FAM3C",
              "FAM50A",
              "FAM53C",
              "FAP",
              "FARP1-AS1",
              "FARSA",
              "FASTK",
              "FAU",
              "FBLIM1",
              "FBXO44",
              "FBXO5",
              "FDFT1",
              "FDPS",
              "FDX2",
              "FGF5",
              "FGF7P4",
              "FHL3",
              "FHOD1",
              "FIP1L1",
              "FJX1",
              "FKBP15",
              "FKBP4",
              "FKBP8",
              "FLAD1",
              "FMR1",
              "FN1",
              "FNTA",
              "FOSL1",
              "FOXO3",
              "FP236383.4",
              "FP236383.5",
              "FP671120.7",
              "FP671120.8",
              "FRMD8",
              "FST",
              "FTH1P5",
              "FTH1P7",
              "FTSJ1",
              "FUBP1",
              "FXR2",
              "G2E3",
              "GADD45B",
              "GAK",
              "GALE",
              "GALNT1",
              "GALNT18",
              "GALNT2",
              "GALNT5",
              "GALNT6",
              "GART",
              "GATAD1",
              "GBP3",
              "GCN1",
              "GET3",
              "GFM1",
              "GGA3",
              "GLA",
              "GLB1",
              "GLG1",
              "GLMP",
              "GLOD4",
              "GLUD1",
              "GLUL",
              "GLYR1",
              "GMFB",
              "GMPPA",
              "GMPPB",
              "GNA12",
              "GNB2",
              "GNG12",
              "GNG5",
              "GNL1",
              "GNPDA1",
              "GNS",
              "GOLGB1",
              "GOPC",
              "GOSR2",
              "GPCPD1",
              "GPI",
              "GPKOW",
              "GPNMB",
              "GPR108",
              "GPR137",
              "GPR89A",
              "GPSM2",
              "GRAMD1A",
              "GRK2",
              "GRK6",
              "GRPEL1",
              "GSR",
              "GSTP1",
              "GTF2F1",
              "GTF2F2",
              "GTF2IRD1P1",
              "GTF3C5",
              "GTPBP2",
              "GTPBP6",
              "GUCD1",
              "H2AX",
              "H2AZ1",
              "HAGH",
              "HARS1",
              "HAS2",
              "HAT1",
              "HDAC3",
              "HDAC5",
              "HDGF",
              "HELZ2",
              "HERC2P2",
              "HEXA",
              "HEXIM1",
              "HGH1",
              "HIF1A-AS1",
              "HIPK2",
              "HLA-A",
              "HLA-B",
              "HLA-C",
              "HLA-E",
              "HMBOX1",
              "HMGB1",
              "HMMR",
              "HNRNPA1L2",
              "HNRNPA3",
              "HNRNPC",
              "HNRNPCP2",
              "HNRNPH1",
              "HNRNPK",
              "HNRNPKP4",
              "HPCAL1",
              "HRAS",
              "HS1BP3",
              "HSCB",
              "HSD11B1",
              "HSD17B10",
              "HSF1",
              "HSP90AB1",
              "HSPA1A",
              "HSPA1B",
              "IDH1",
              "IDH3B",
              "IER2",
              "IFI27L1",
              "IFI35",
              "IFI44",
              "IFIT3",
              "IFNGR2",
              "IFT22",
              "IGF1R",
              "IGF2R",
              "IGFBP6",
              "IKBIP",
              "IKBKB",
              "IL4R",
              "IL6",
              "INPP5K",
              "IQGAP1",
              "IRF3",
              "IRS1",
              "ISG20L2",
              "ITFG1",
              "ITGB1BP1",
              "ITPA",
              "ITPR3",
              "JAGN1",
              "JMJD1C",
              "JSRP1",
              "KARS1",
              "KAT2A",
              "KDM5C",
              "KIAA0232",
              "KIAA1109",
              "KIAA1191",
              "KIFC3",
              "KIRREL3",
              "KISS1",
              "KLC4",
              "KLF9",
              "KLHDC3",
              "KLHL9",
              "KRT10",
              "KSR1",
              "LAMC1",
              "LAMP1",
              "LAPTM4A",
              "LAPTM4B",
              "LGALS1",
              "LHFPL5",
              "LIAS",
              "LIF",
              "LIMK2",
              "LINC00106",
              "LLGL2",
              "LMAN1",
              "LMAN2",
              "LPAR2",
              "LPCAT3",
              "LRP1",
              "LRPAP1",
              "LRRC59",
              "LRWD1",
              "LSM6",
              "LSM7",
              "LTA4H",
              "LTO1",
              "LURAP1L",
              "LY6E",
              "MACROH2A1",
              "MAD2L2",
              "MAF1",
              "MAN1A2",
              "MAN1B1",
              "MANBAL",
              "MAP11",
              "MAP2K1",
              "MAP2K2",
              "MAP2K3",
              "MAP2K7",
              "MAP3K9",
              "MAP7D1",
              "MAP7D3",
              "MAPK3",
              "MAPK6",
              "MAPK8IP3",
              "MAPRE3",
              "MARCKSL1",
              "MATR3",
              "MAVS",
              "MBIP",
              "MBNL1",
              "MBNL2",
              "MDH2",
              "MDK",
              "MEG3",
              "MEIS1",
              "MEN1",
              "MFSD1",
              "MFSD12",
              "MGAT4B",
              "MGST1",
              "MICAL3",
              "MICB",
              "MICU2",
              "MID1",
              "MID1IP1",
              "MIR210HG",
              "MIR570",
              "MITF",
              "MLEC",
              "MLF2",
              "MLLT6",
              "MME",
              "MMP10",
              "MORF4L2",
              "MPDU1",
              "MPG",
              "MPHOSPH10",
              "MPRIP",
              "MRI1",
              "MRM2",
              "MRPL14",
              "MRPL15",
              "MRPL18",
              "MRPL2",
              "MRPL4",
              "MRPL41",
              "MRPL51",
              "MRPL52",
              "MRPL53",
              "MRPS22",
              "MRPS24",
              "MRPS28",
              "MRPS7",
              "MT-ATP6",
              "MT-ATP8",
              "MT-CO3",
              "MT-ND1",
              "MT-ND2",
              "MT-ND4L",
              "MT-ND5",
              "MT-ND6",
              "MT-TE",
              "MT-TG",
              "MT-TH",
              "MT-TI",
              "MT-TL2",
              "MT-TM",
              "MT-TP",
              "MT-TQ",
              "MT-TR",
              "MT-TT",
              "MT1X",
              "MTHFD1L",
              "MTIF2",
              "MTND2P28",
              "MTREX",
              "MTSS2",
              "MTX1P1",
              "MVD",
              "MYL12B",
              "MYOF",
              "NAA20",
              "NABP2",
              "NACC2",
              "NAXD",
              "NBL1",
              "NCL",
              "NCOR1",
              "NDRG1",
              "NDUFA2",
              "NDUFAB1",
              "NDUFB2",
              "NDUFB3",
              "NDUFB4",
              "NDUFB8",
              "NDUFB9",
              "NDUFC2-KCTD14",
              "NDUFS2",
              "NDUFS3",
              "NDUFS6",
              "NDUFS7",
              "NEDD8",
              "NEK7",
              "NELFE",
              "NEMF",
              "NEXN",
              "NF1",
              "NFE2L3",
              "NFIL3",
              "NHP2",
              "NIFK",
              "NIN",
              "NIPBL",
              "NKAPD1",
              "NKIRAS2",
              "NLE1",
              "NMT1",
              "NOLC1",
              "NOP14",
              "NOP16",
              "NOP53",
              "NOP56",
              "NORAD",
              "NOSIP",
              "NPC2",
              "NPEPPS",
              "NPIPB4",
              "NPLOC4",
              "NPM1",
              "NPRL3",
              "NPTX1",
              "NR1D2",
              "NSD3",
              "NSFL1C",
              "NSMCE1",
              "NSUN5",
              "NT5C3B",
              "NUCB2",
              "NUCKS1",
              "NUDC",
              "NUP155",
              "NUPR1",
              "OAF",
              "OAZ1",
              "OBI1",
              "OCRL",
              "OGFOD1",
              "OGFR",
              "OPA1",
              "ORAI1",
              "OSBPL2",
              "OSBPL8",
              "OSBPL9",
              "OSER1",
              "OSGIN1",
              "OST4",
              "OTUB1",
              "OXCT1",
              "P3H1",
              "P3H3",
              "P4HA2-AS1",
              "PA2G4",
              "PABPC1",
              "PABPC4",
              "PACRGL",
              "PACS1",
              "PACSIN2",
              "PAF1",
              "PAIP2",
              "PAM",
              "PANK4",
              "PAPPA",
              "PAPPA-AS1",
              "PARP12",
              "PARP14",
              "PBX2",
              "PCBP1",
              "PCCB",
              "PCDHGA12",
              "PCM1",
              "PDAP1",
              "PDCD1LG2",
              "PDCD2",
              "PDCD5",
              "PDE4DIP",
              "PDE6D",
              "PDIA5",
              "PDRG1",
              "PDS5A",
              "PEAR1",
              "PELO",
              "PEMT",
              "PES1",
              "PFDN2",
              "PFDN6",
              "PFKM",
              "PFKP",
              "PFN1",
              "PFN1P1",
              "PGAM1",
              "PGK1",
              "PGM1",
              "PGM2",
              "PGM3",
              "PHAX",
              "PHB",
              "PHB2",
              "PHF3",
              "PHKB",
              "PHLDA1",
              "PHLDA2",
              "PHLDB2",
              "PI3",
              "PI4K2B",
              "PICALM",
              "PIH1D1",
              "PIM1",
              "PITPNA",
              "PKP3",
              "PLAT",
              "PLBD2",
              "PLCB3",
              "PLCB4",
              "PLD2",
              "PLD3",
              "PLEKHA5",
              "PLEKHG5",
              "PLEKHM1",
              "PLIN2",
              "PLIN3",
              "PLK2",
              "PLK3",
              "PMM1",
              "PNN",
              "PNRC2",
              "POGZ",
              "POLE3",
              "POLR2E",
              "POLR2G",
              "POLR2I",
              "POLR2J",
              "POMT2",
              "POP7",
              "PORCN",
              "POSTN",
              "PPAN",
              "PPDPF",
              "PPIB",
              "PPIG",
              "PPM1F",
              "PPM1G",
              "PPP1R12A",
              "PPP1R15A",
              "PPP1R16A",
              "PPP1R18",
              "PPP4R1",
              "PPP5C",
              "PPP6R1",
              "PQBP1",
              "PRAG1",
              "PRCC",
              "PRDX2",
              "PREB",
              "PRELID1",
              "PRELID3B",
              "PRKACB",
              "PRKAR1B",
              "PRKG1-AS1",
              "PRKRIP1",
              "PRMT1",
              "PROCR",
              "PRPF40A",
              "PRPSAP1",
              "PRR11",
              "PRRC2B",
              "PRRC2C",
              "PSAP",
              "PSMA2",
              "PSMA5",
              "PSMA6",
              "PSMA7",
              "PSMB3",
              "PSMB4",
              "PSMB5",
              "PSMB7",
              "PSMB8",
              "PSMB9",
              "PSMC1",
              "PSMC3",
              "PSMC3IP",
              "PSMC4",
              "PSMD6",
              "PSMD8",
              "PSMD9",
              "PSME2",
              "PSMG3",
              "PSMG4",
              "PTAR1",
              "PTBP2",
              "PTEN",
              "PTGES",
              "PTGES2",
              "PTGR1",
              "PTGS2",
              "PTOV1",
              "PTPN23",
              "PTPRU",
              "PTS",
              "PTTG1IP",
              "PUF60",
              "PUM3",
              "PUS1",
              "PVR",
              "PXDN",
              "PXK",
              "PYCR1",
              "QARS1",
              "QTRT1",
              "R3HDM4",
              "RAB11B",
              "RAB34",
              "RABAC1",
              "RABGGTA",
              "RAC1",
              "RAD51C",
              "RALY",
              "RAMAC",
              "RANBP2",
              "RANBP3",
              "RANGAP1",
              "RAPGEF2",
              "RB1",
              "RBCK1",
              "RBM4",
              "RBM42",
              "RBM5",
              "RBM6",
              "RBMX",
              "RBX1",
              "RCC2-AS1",
              "RCN2",
              "RDX",
              "RECQL",
              "REV3L",
              "REX1BD",
              "REXO4",
              "RFC1",
              "RFNG",
              "RFTN1",
              "RFXANK",
              "RGCC",
              "RHBDD3",
              "RHEB",
              "RHOC",
              "RHOF",
              "RHOG",
              "RHOT2",
              "RIC8A",
              "RING1",
              "RN7SL2",
              "RNA5-8SN2",
              "RNA5-8SN3",
              "RNA5-8SN4",
              "RNF10",
              "RNF123",
              "RNF141",
              "RNF167",
              "RNF181",
              "RNF185",
              "RNF185-AS1",
              "RNF25",
              "RNU6-2",
              "RNU6-26P",
              "ROCK2",
              "RPF2",
              "RPL12P4",
              "RPL13A",
              "RPL13AP5",
              "RPL14P1",
              "RPL15P3",
              "RPL17",
              "RPL18A",
              "RPL18AP3",
              "RPL22",
              "RPL23",
              "RPL23A",
              "RPL23AP42",
              "RPL24",
              "RPL27",
              "RPL27A",
              "RPL3",
              "RPL34",
              "RPL35",
              "RPL39",
              "RPL39P3",
              "RPL5",
              "RPL7",
              "RPL7P9",
              "RPL8",
              "RPL9",
              "RPLP0",
              "RPLP1",
              "RPLP2",
              "RPPH1",
              "RPS10P3",
              "RPS11",
              "RPS14",
              "RPS15",
              "RPS16",
              "RPS18",
              "RPS19",
              "RPS21",
              "RPS25",
              "RPS28",
              "RPS28P7",
              "RPS29",
              "RPS2P46",
              "RPS2P5",
              "RPS4X",
              "RPS5",
              "RPS9",
              "RPSA",
              "RPSAP19",
              "RPSAP58",
              "RPTOR",
              "RRAS",
              "RRP1",
              "RSPRY1",
              "RSRC2",
              "RSRP1",
              "RTF2",
              "RXRB",
              "S100A2",
              "S100A6",
              "SAMHD1",
              "SBDS",
              "SBDSP1",
              "SCAND1",
              "SCARA3",
              "SCARF2",
              "SCCPDH",
              "SCD",
              "SCD5",
              "SCOC",
              "SCRN1",
              "SDC4",
              "SDF4",
              "SDHB",
              "SEC24D",
              "SEC61B",
              "SEC62",
              "SEL1L",
              "SELENOO",
              "SELENOS",
              "SELPLG",
              "SEMA3A",
              "SENP6",
              "SEPTIN11",
              "SERF2",
              "SERINC1",
              "SERPINB8",
              "SERPINE1",
              "SF3B1",
              "SFT2D1",
              "SGCB",
              "SGSM3",
              "SH3D19",
              "SH3GL1",
              "SH3GLB2",
              "SHARPIN",
              "SHFL",
              "SHISA5",
              "SHLD2",
              "SHMT2",
              "SIN3B",
              "SIRT2",
              "SKAP2",
              "SKI",
              "SKP2",
              "SLC16A3",
              "SLC20A1",
              "SLC25A11",
              "SLC25A25",
              "SLC25A6",
              "SLC2A1",
              "SLC35A2",
              "SLC39A10",
              "SLC39A4",
              "SLC3A2",
              "SLC41A3",
              "SLC4A2",
              "SLC6A14",
              "SLC6A15",
              "SLC6A9",
              "SLC9A3R1",
              "SMAD3",
              "SMARCA1",
              "SMARCA5",
              "SMARCD1",
              "SMARCD2",
              "SMARCD3",
              "SMC2",
              "SMC3",
              "SMC5",
              "SMC6",
              "SMCHD1",
              "SMNDC1",
              "SNAPC1",
              "SNAPIN",
              "SND1",
              "SNHG5",
              "SNHG6",
              "SNORA4",
              "SNORD14C",
              "SNORD58B",
              "SNRPA1",
              "SNRPB",
              "SNRPB2",
              "SNRPC",
              "SNRPD1",
              "SNRPF",
              "SNRPG",
              "SNX1",
              "SNX11",
              "SOCS5",
              "SOD2",
              "SOX9",
              "SP110",
              "SP3",
              "SPAG7",
              "SPG7",
              "SQSTM1",
              "SRA1",
              "SREK1",
              "SRGAP1",
              "SRI",
              "SRRD",
              "SRSF1",
              "SRSF4",
              "SRSF9",
              "SRXN1",
              "SSR2",
              "SSR3",
              "ST3GAL1",
              "ST7",
              "STARD3",
              "STAT2",
              "STAT3",
              "STAU1",
              "STC2",
              "STIM1",
              "STK17A",
              "STK25",
              "STK39",
              "STK40",
              "STOML2",
              "STRN4",
              "STX10",
              "STX1A",
              "STXBP3",
              "SUGP1",
              "SUMO2",
              "SURF2",
              "SUZ12",
              "TAF6",
              "TAF6L",
              "TAF9B",
              "TALDO1",
              "TARBP2",
              "TBCA",
              "TBCAP1",
              "TBL3",
              "TBRG4",
              "TCEAL4",
              "TCERG1",
              "TCTEX1D2",
              "TENT4B",
              "TFE3",
              "TFPI2",
              "TGFBR2",
              "THAP12",
              "THAP3",
              "THBS1",
              "THOC2",
              "THOC7",
              "THSD1",
              "TIGD2",
              "TIMM13",
              "TIMM22",
              "TIMM44",
              "TIMP3",
              "TLE5",
              "TMA7",
              "TMED9",
              "TMEM123",
              "TMEM132A",
              "TMEM164",
              "TMEM183A",
              "TMEM50A",
              "TMEM51",
              "TMEM59L",
              "TMEM87A",
              "TMPO",
              "TMSB4XP4",
              "TMSB4XP6",
              "TNFAIP2",
              "TNIP1",
              "TNKS1BP1",
              "TNKS2",
              "TOMM40",
              "TOMM6",
              "TOP2A",
              "TOP2B",
              "TOP3B",
              "TOPBP1",
              "TP53I3",
              "TP53INP1",
              "TPD52L2",
              "TPI1",
              "TPP2",
              "TPR",
              "TRABD2A",
              "TRAF2",
              "TRAF5",
              "TRAP1",
              "TRIM11",
              "TRIM21",
              "TRIM56",
              "TRIP10",
              "TRMT1",
              "TRMT10C",
              "TRNP1",
              "TSPAN1",
              "TSPAN13",
              "TSPAN9",
              "TSPYL1",
              "TSR1",
              "TSR3",
              "TSTA3",
              "TTC5",
              "TUBA1C",
              "TUBB",
              "TUBB3",
              "TUBB4B",
              "TUBB6",
              "TUBG1",
              "TUFM",
              "TWF1P1",
              "TWF2",
              "TXNRD1",
              "TYMS",
              "U2AF2",
              "U2SURP",
              "UACA",
              "UAP1",
              "UBA5",
              "UBA52",
              "UBAP2L",
              "UBE2D3",
              "UBE2H",
              "UBE2L6",
              "UBFD1",
              "UBL4A",
              "UBL5",
              "UBR2",
              "UBR5",
              "UBXN11",
              "UBXN4",
              "UFL1",
              "UNC119B",
              "UNC50",
              "UPF2",
              "UPP1",
              "UQCRC1",
              "UQCRH",
              "USB1",
              "USP10",
              "USP11",
              "USP16",
              "USP18",
              "USP19",
              "USP20",
              "USP25",
              "USP32P1",
              "USP34",
              "USP41",
              "USP47",
              "USP53",
              "USP9X",
              "UTRN",
              "VAV3",
              "VDR",
              "VIRMA",
              "VKORC1",
              "VPS11",
              "VPS28",
              "VPS35L",
              "VRK3",
              "WBP4",
              "WDFY1",
              "WDR13",
              "WDR25",
              "WDR74",
              "WLS",
              "WNT5A-AS1",
              "WWTR1",
              "XPC",
              "XPNPEP1",
              "XRCC1",
              "XRCC6",
              "YARS2",
              "YBX1",
              "YBX3",
              "YEATS2",
              "YKT6",
              "YME1L1",
              "YWHAQ",
              "ZBTB38",
              "ZC3H18",
              "ZCRB1",
              "ZDHHC20",
              "ZDHHC3",
              "ZEB2",
              "ZFAND6",
              "ZFP36L1",
              "ZFP36L2",
              "ZFYVE26",
              "ZKSCAN1",
              "ZMAT2",
              "ZNF106",
              "ZNF184",
              "ZNF274",
              "ZNF395",
              "ZNF512B",
              "ZNF584",
              "ZNF593",
              "ZNF598",
              "ZNF622",
              "ZNF7",
              "ZNF706",
              "ZRANB2",
              "ZXDC"
          ],
          "type": "scatter3d",
          "mode": "markers",
          "opacity": 0.7,
          "name": "common",
          "marker": {
              color: "#8d99ae"
          }
      },
      {
          "x": [
              1.12960272043083,
              0.976527122717007,
              1.333801965387,
              0.767652659019849,
              1.48502230165899,
              2.21652069621139,
              1.40186724593029,
              0.931990405448231,
              1.03197718858175,
              1.21921512672999,
              2.01448612188787,
              0.930356977026282,
              -1.13671091728005,
              1.61431596340891,
              0.577537972384724,
              1.5977184823982,
              -1.43360879342723,
              0.526126412781948,
              0.308202924020685,
              0.534842199523585,
              2.25583179251479,
              1.22482579257731,
              1.97437786129154,
              0.765929420613699,
              0.817894907412479,
              1.92460405012915,
              1.24347240004262,
              0.790160901332478,
              0.781896782454423,
              1.44183625658695,
              1.06973799189063,
              -0.151306754873339,
              1.56720130954834,
              -0.0255692717838085,
              0.590204395965511,
              2.29342157441554,
              1.50053988300861,
              0.523105085785869,
              0.783699169095866,
              1.50292573870764,
              1.14804538293917,
              0.510982384323054,
              1.28229674546054,
              1.04149985901681,
              0.866622529255401,
              1.81961741160487,
              1.76813297927968,
              0.215337227316208,
              0.48567951951578,
              0.72426782595142,
              1.01866810409822,
              0.476900899601867,
              1.22975066157473,
              0.132437268318361,
              1.75487312613906,
              0.681880186939646,
              1.85078204017324,
              1.34521494810942,
              0.952401314781663,
              -0.131193246125162,
              0.482065520158003,
              0.35884964257978,
              0.680980586627626,
              1.74142170431999,
              1.02988467582661,
              1.71570973264057,
              1.69571261694091,
              -1.34416152926225,
              1.86905555198814,
              1.2526547822783,
              1.12051952918034,
              1.86852253464468,
              0.501449867097852,
              1.46615663302961,
              0.763612229367488,
              0.965010814811365,
              0.697348209942734,
              0.877629529520354,
              0.694968822493599,
              0.55890282437313,
              1.04747965589817,
              -0.0248387344372822,
              -0.00779064760731063,
              1.46901053224489,
              0.997404061010149,
              1.88188125789045,
              -0.92921847950163,
              1.1936421235302,
              0.957196880442435,
              0.922904100344808,
              0.281544046176669,
              0.378369644624875,
              0.929336597292022,
              1.43662560430272,
              0.946333754808687,
              0.089115149453138,
              1.29870329067475,
              1.17501512421035,
              0.491436839539508,
              1.0061296883918,
              1.71589979813174,
              0.412857290144295,
              1.2200249428409,
              0.239181776398477,
              1.57211448540528,
              1.35518401885444,
              0.864353793847546,
              1.31783964056768,
              1.181135949159,
              0.177724102884634,
              0.270147630204845,
              0.761047977705585,
              -0.179825009274218,
              1.53756436446588,
              1.94904767843597,
              0.200155153116505,
              0.415160712811392,
              0.658515517576676,
              0.371486221859678,
              1.35793702805752,
              0.432456813757002,
              0.846276177497104,
              0.88170836443654,
              1.03342168426821,
              3.18977449905596,
              0.493641462479309,
              1.04950888747201,
              0.345541269664539,
              -0.138814986024166,
              1.25813091136636,
              0.284861104326453,
              1.15040228147278,
              1.15399488646845,
              0.58842955986983,
              0.868496216226035,
              0.595922482021218,
              0.838061285011728,
              0.947130354613732,
              0.388580507179094,
              1.46264332630106,
              2.16076121988517,
              0.756063135972712,
              -0.305434103186559,
              1.20015022505233,
              0.934688131989155,
              -0.0848784733013311,
              0.729672479086333,
              0.811169224152206,
              1.08055418025331,
              0.983860799066895,
              0.797314338397588,
              0.504308499287539,
              0.96098324260933,
              1.1366660235739,
              2.55048002778599,
              0.449827100150564,
              -1.14766561549876,
              1.61965147979133,
              1.05499983618935,
              0.381481407391321,
              1.178382795246,
              0.40618027013376,
              0.242462417675229,
              0.908536127020888,
              -0.142032311720066,
              0.774216470734099,
              1.30684209548328,
              1.78815731966159,
              0.306359621080029,
              0.847016484027588,
              1.09135931291758,
              1.04408298604768,
              1.25966595585472,
              0.413608855665988,
              1.09490581050969,
              1.47058609264874,
              0.854814601623351,
              0.679681230158783,
              0.212747439004483,
              1.53182235702757,
              0.422591565644118,
              1.46493664937511,
              0.361988691585504,
              1.40264504013292,
              1.79087119670091,
              0.490422846499157,
              0.429792659959363,
              0.891012559770325,
              0.860587027494998,
              0.485860807873377,
              0.653530383732158,
              1.40186463524068,
              3.08830188345784,
              0.812927804778915,
              0.354817706124962,
              0.607792982047995,
              0.737228745992259,
              1.45725013918736,
              0.555365924471524,
              0.481349088943724,
              1.20043905623649,
              0.505942864791887,
              1.04984522363656,
              0.622353055062602,
              0.43971289997225,
              1.03687231018565,
              0.257113363774674,
              -0.40903387764796,
              2.11526403961683,
              -0.496373440147768,
              0.927790625062183,
              2.17399063323447,
              2.02970989523894,
              1.2607667436736,
              1.52312273839384,
              -0.129271617105165,
              0.406082693883731,
              1.94016679892974,
              0.316032746461935,
              0.821940535096653,
              0.426964252608362,
              1.94130912653966,
              1.4956127753819,
              0.341345226401098,
              1.74049495005662,
              -0.157171366606951,
              0.696813348739128,
              1.0962010307223,
              1.58342048693759,
              1.23938698805811,
              0.698831063965995,
              0.476733911041161,
              1.03745489341248,
              0.280007833815533,
              0.939461556497681,
              0.381512948087978,
              3.96151553365072,
              0.700417130404004,
              0.913501586794939,
              0.918266811648272,
              0.243768641150885,
              1.10906074752173,
              0.759548343877434,
              2.28959211858589,
              0.866299998474072,
              1.23306992719468,
              -0.23321177169868,
              2.25588308564422,
              1.32415000489231,
              1.15152435321204,
              0.287320733714963,
              1.24722643927527,
              1.04098806686698,
              1.60670710551579,
              0.508254727735557,
              1.20343398906275,
              2.53589498777569,
              1.80926608343328,
              1.27599551022777,
              2.2610876766879,
              0.478232501264729,
              0.122453849278191,
              -0.343801153806877,
              1.72854650457845,
              0.827253774005078,
              2.74964793631165,
              0.866941347903512,
              2.18748357629248,
              0.80452000542989,
              0.83060035953088,
              1.23679841879547,
              0.476600430573649,
              0.227206353903629,
              0.160578421285191,
              1.57520209247046,
              2.24787379036271,
              0.862293217421953,
              0.407522937624752,
              0.796175467269483,
              0.963345294740626,
              0.302999692195133,
              0.799041373175361,
              0.948272295004247,
              1.08549965362742,
              1.16618681796949,
              0.38292053054634,
              1.11744871612534,
              1.4081610918012,
              -0.00604764121629675,
              1.07519476550043,
              1.29185251942082,
              0.761983760548908,
              0.455584118118221,
              1.16221481458466,
              0.892167663260175,
              -0.254146314455231,
              1.68541012011088,
              -0.187777751964849,
              1.31026759036524,
              1.26132469727826,
              2.00139128632232,
              0.239675126122566,
              1.32767441470447,
              0.665456237896896,
              1.27108822716971,
              1.0276656220613,
              0.323266718965138,
              0.786860399377461,
              0.124328133254548,
              0.1837306201446,
              2.20687114862353,
              0.790039485299665,
              1.12187992316964,
              1.05536399667806,
              0.26071428864979,
              0.883905353835726,
              0.933555654977889,
              1.14322414283257,
              0.66172639095005,
              0.902547056272643,
              0.302382581877495,
              0.580036868045237,
              0.918861912791148,
              2.9207776138477,
              2.72725729671753,
              0.139303592795702,
              1.45758265326215,
              1.33051911347576,
              0.80194301926303,
              0.587955251066434,
              0.609946273224852,
              0.886153884631835,
              0.234787080613027,
              0.631665373729712,
              1.45813978679037,
              1.05283345195957,
              0.0778977503982237,
              0.946512631192415,
              1.2602769194909,
              1.16833951094366,
              1.66768769162747,
              0.267694838097044,
              1.90144936718032,
              0.35856502949678,
              1.28936912589055,
              0.451501897890104,
              0.539614734852447,
              0.842026695279477,
              0.108475651077603,
              0.316325442339122,
              1.4187327984838,
              0.532826376551794,
              -0.190196356021622,
              0.146935091980904,
              0.635251982690579,
              1.71460096364183,
              1.88100044672699,
              0.845997563384721,
              0.765089080660107,
              1.36976173880876,
              1.79929988539481,
              0.67239268060568,
              0.441298444745047,
              1.55973375995755,
              1.29835354663885,
              1.94154864201079,
              0.205787107767094,
              2.23187876438868,
              0.714703017113428,
              0.571186045269925,
              -0.0322943956893181,
              0.442078466578996,
              2.46202981023438,
              0.181570276708274,
              0.919339998451439,
              0.718147475765303,
              2.63888980870684,
              2.49000794859243,
              1.05984563972239,
              1.77606933332727,
              1.79340201828467,
              1.34853735841277,
              0.435675822269357,
              0.83470391454208,
              -0.286917581923326,
              1.44071987187764,
              0.727654014513374,
              0.799550158198344,
              0.944399315975541,
              1.06986010419656,
              0.390997247361414,
              1.25993650215168,
              0.915227270327318,
              0.489687986529238,
              0.0484528108703126,
              0.386504025868107,
              1.65237424602963,
              1.01630486441795,
              1.12095375918094,
              0.251558319875625,
              1.81548602905558,
              0.193010038245506,
              0.272634350992565,
              0.842807178369431,
              2.37740158395095,
              0.450528363972609,
              0.689763855859321,
              1.57971879501472,
              4.56996818627277,
              0.835239156284164,
              0.394949594478359,
              0.56606133056192,
              1.25564284530716,
              1.169324060999,
              1.89869205303587,
              2.36824315944409,
              1.59118630302496,
              0.532048391888434,
              0.154890327990767,
              0.765243404570415,
              0.485636955510116,
              1.35482230046357,
              1.03758139430054,
              1.19594132894363,
              0.195345887393063,
              0.690555897261428,
              1.23240870950681,
              -0.0445554620877877,
              0.773688738024236,
              1.07096298988796,
              -0.11337437157101,
              1.3476455571984,
              0.505998909806056,
              0.748088448432239,
              2.70730379976499,
              0.416906538944066,
              0.452774636416033,
              0.117193964859845,
              -0.250116962801602,
              0.5851204604558,
              1.76342076309332,
              1.03792162423399,
              1.67838079955129,
              0.567348202121665,
              1.71743781610123,
              1.34261207627944,
              0.72694293943361,
              0.0479595779166165,
              2.08013738280743,
              1.38727727484954,
              1.25237877502631,
              0.390344277436381,
              1.05548256708625,
              0.210560316459399,
              0.31470629353517,
              0.857078382331289,
              1.25032747285592,
              1.42680214160075,
              -0.284040583858885,
              0.481270214100234,
              1.50734055830982,
              1.77074087818591,
              0.668662340636038,
              0.130625978580314,
              0.619806131889013,
              0.708262394845694,
              0.448298798059815,
              0.551846106378702,
              0.508941160830073,
              1.42243942206529,
              -0.0142878204483164,
              1.22029600802468,
              1.64351358353826,
              1.92912960015803,
              0.496945479730746,
              1.15330896878707,
              0.215846338076935,
              0.57123158840277,
              2.83384381609685,
              1.05005387885316,
              0.392024791767368,
              0.518174377463453,
              0.702855338980976
          ],
          "y": [
              0.750268407330178,
              0.00511960155336429,
              -0.0672492891450435,
              1.65780954934078,
              -1.93805234431821,
              0.309381091143376,
              -1.42495527749762,
              -0.413838067588464,
              -0.46291218582042,
              0.987418983128149,
              -0.158554505794614,
              0.662403213420237,
              -1.79264801397862,
              -0.806917662318658,
              1.35180242673793,
              -0.721060654826063,
              9.79147273801659,
              -0.83878692083264,
              0.507762692474892,
              3.0321739714103,
              -0.689461760537292,
              -0.38071720299003,
              -0.712453088170631,
              -0.430558909338667,
              -0.251550421171778,
              -0.141735769472917,
              -0.0618288565313018,
              -0.405104590075597,
              -0.729973325258994,
              0.817733714367472,
              -0.444606934014708,
              -0.592221897429978,
              1.45132828739635,
              -1.03166023167544,
              -0.0124221025761103,
              -0.230447714506798,
              0.594298071926535,
              0.167217321219778,
              0.680130584805726,
              -0.0323697852441004,
              0.595951906490954,
              -0.94747407900938,
              -0.595264918378709,
              0.929007774456816,
              0.847958811106532,
              0.778588664137916,
              -0.77725042122744,
              -1.17533330232189,
              0.647357337521483,
              -0.335422984332239,
              0.0720675828543045,
              -0.548939848121539,
              -0.392367231914114,
              -0.714169616297516,
              0.3314973865474,
              -0.546879672614553,
              -0.528442865435581,
              -0.483565956933668,
              0.588149601158825,
              -1.49716838643707,
              -0.917605881583738,
              -0.560033832499726,
              -0.640288864311451,
              0.746226109672722,
              -0.485434113249338,
              0.926269344688464,
              0.466853349005989,
              -1.95943113917223,
              -0.0614341965522048,
              -0.54476040926301,
              0.495029151620231,
              -0.111893335752562,
              -0.398887829459747,
              0.113589392388145,
              0.828981260147345,
              -0.60881593549211,
              -1.0656577718635,
              0.861853320867518,
              0.674772457346415,
              0.226611577294097,
              -0.885521695259709,
              -0.914557329356502,
              -0.650132326604828,
              -0.407177750599364,
              -0.47466484475489,
              -0.109391780034465,
              -1.05860682831571,
              -0.72060960526058,
              -0.550328003189911,
              1.32445933399692,
              -0.95378025015472,
              -0.679148483113965,
              0.627211109121304,
              -0.399623021458169,
              0.791135352680241,
              -0.878979730021821,
              -0.482453965351339,
              -0.476082862514973,
              -1.28028522237238,
              -0.451275350856002,
              0.146170043090802,
              -0.752277374992409,
              0.684810091538703,
              0.392321068652307,
              1.01650373705076,
              0.251240724254615,
              0.299908567365924,
              1.38122799970493,
              -0.565356626351956,
              1.80384618175068,
              -0.448186160386491,
              0.353473955196055,
              -1.26688497833179,
              0.365799376444898,
              0.582448418246784,
              -0.968744423493238,
              -0.356722583174912,
              -0.39199064769121,
              -0.722046782132712,
              1.19476656315667,
              1.03049388951134,
              -0.792849867434668,
              0.382285606856036,
              0.358811546391976,
              -0.0254747471314463,
              0.437769550811804,
              -0.0402554371188472,
              1.44751923667595,
              -1.24883375875953,
              0.273740658591893,
              -0.31623371992331,
              -0.0320078387820785,
              0.267471158784149,
              0.678300343528001,
              -0.566454570439508,
              0.00235903486380327,
              0.548344137977482,
              -0.395145921465231,
              -0.773274673362442,
              -0.527900617602107,
              -0.114571736620304,
              0.0168829649480281,
              -1.14830016311263,
              -0.401098717252742,
              -0.531973456069084,
              -1.13926916309954,
              -0.233274750957838,
              1.27055843924768,
              0.702949800470391,
              -0.718872442863983,
              1.82283042586052,
              -0.851416880608205,
              0.0609313877384356,
              -0.686350128219249,
              -0.214938509804731,
              -0.873414529052032,
              -1.89332017679964,
              -0.912306920539541,
              0.198180172219761,
              -0.580533147228553,
              -0.0640965237804625,
              -0.5427520689886,
              -0.409997778956165,
              -0.0317209802359968,
              0.876152687138336,
              -0.701309254585501,
              -0.885528578668778,
              0.619822316687955,
              -0.551910330039083,
              0.368468583155664,
              0.478806511560682,
              -0.336540239538798,
              -0.475962554967189,
              0.176783212953473,
              0.386394514059368,
              0.202017222671739,
              0.211421733309863,
              -0.486062330938398,
              -0.480784335779365,
              0.950454281063258,
              -0.380013483560093,
              0.179655840055148,
              0.724538473618882,
              -1.39084431681643,
              1.20597899868174,
              -0.389685378983028,
              1.44785303479584,
              -0.345102175272354,
              0.0507591815582405,
              -0.406506813426308,
              -0.493330236901172,
              0.809943990435492,
              0.77793782462434,
              0.775644231885296,
              -0.717157332946538,
              0.407307352293173,
              0.596526581960786,
              -0.815715339012896,
              1.17042350635128,
              1.87108587967328,
              0.0383666857052936,
              1.5722287209443,
              0.839928835141944,
              -0.926873362687378,
              -1.25598871733103,
              0.470670135626386,
              -0.721039147650298,
              -1.22674750478316,
              0.0849440653480661,
              -1.1669022684923,
              -0.925250101409093,
              -0.216893012014303,
              -0.830394728267178,
              1.10653591282435,
              1.75468945173797,
              -0.502858824662042,
              -0.511100601362439,
              0.568384472065363,
              -0.47807141381334,
              0.195366217765993,
              0.298811960863977,
              -1.10820730408149,
              -0.0237506674891842,
              -0.533359072388298,
              0.418316612793474,
              -0.998378818556808,
              -1.38352830535668,
              0.85285139579519,
              -1.47644986038685,
              0.143679338816375,
              -0.317035351331304,
              -0.746545815962673,
              0.894276873962957,
              -0.757281925429773,
              0.586218050539767,
              3.06283963908194,
              0.630744023378133,
              -0.321361253144379,
              -0.382891044808909,
              -0.530926357651592,
              -0.71881722783855,
              0.790318232213704,
              -0.409527343360207,
              -1.30590588457353,
              -1.84162866371228,
              0.385028259827433,
              -0.981932150111469,
              -0.135923236990948,
              -0.746563186367156,
              -0.697184501675791,
              -0.499302781453594,
              -0.726713601730491,
              -0.585923998333314,
              -0.0808512543832193,
              -0.408845709692835,
              0.4737892305509,
              -0.577487636576341,
              -0.54297050424085,
              -0.818047908929675,
              0.626276450462576,
              1.88550917354461,
              -1.57452502101505,
              -0.628999941163197,
              -2.53731313198784,
              0.51954411567745,
              -0.490359846461736,
              -0.677604202488148,
              -0.172013688594848,
              -0.742483646932633,
              0.572095671021657,
              -0.308215573177388,
              -0.656192894870918,
              -0.746181709728415,
              -0.942408820160784,
              -0.467758349968175,
              -0.455595534665168,
              0.684987995810325,
              -1.43224547278464,
              -1.05724238134712,
              2.01590749906241,
              -0.468232979606032,
              -0.658901585488398,
              -0.595590558594523,
              -0.859045221040188,
              -0.621824978284342,
              -0.751716625832295,
              -0.701894625999115,
              0.858116785962083,
              -0.735073821283592,
              -0.433607001296796,
              -0.292030906614407,
              -1.01274094262466,
              -0.583270275523462,
              0.437752806791617,
              -0.509782341154958,
              -0.775551750574427,
              -0.571470576997861,
              -0.673397195013519,
              -0.41316395433282,
              0.384550164807301,
              -0.665671551057337,
              -0.463152631837973,
              -0.935576282745776,
              1.60781768950765,
              -0.711874588212636,
              -0.594357776285545,
              -0.627748621900684,
              -0.800995524857535,
              -0.632451744574064,
              -0.604236020804214,
              0.907958221545201,
              -1.1699423085302,
              -0.608470293841719,
              0.971452853259221,
              -0.672589213768381,
              0.823937159683433,
              0.453383422320392,
              0.401904183921866,
              -0.544995356634659,
              -0.332512345693228,
              -0.456642074490469,
              -0.521317982302155,
              -1.01651388339286,
              -1.08655749710421,
              0.991181136504636,
              -0.467177878546012,
              -0.129761716658165,
              0.473263004000771,
              0.616153568685934,
              -0.737387973399614,
              0.480366203513087,
              -0.571890352859894,
              -0.62019719335573,
              -0.402767535699585,
              0.436368995727926,
              0.45747724098997,
              -0.835334040584128,
              -1.22094704595422,
              0.516700732010802,
              -0.407757433704213,
              -0.493394576682856,
              -0.571224606868844,
              -0.773889126786399,
              -0.667779657059574,
              -0.640874165414336,
              -0.602480022049091,
              -0.327246919308563,
              -0.647900109785929,
              -0.878515552262193,
              1.01173123956381,
              0.00252061942285957,
              -0.477222838666182,
              -0.813545253019535,
              -0.464591221006982,
              -0.494500686373648,
              0.869964920259536,
              -0.606444850628984,
              -0.361991123480504,
              1.52158301701303,
              -0.480237736517917,
              0.54821975570022,
              -0.295525821155177,
              -0.288626210493186,
              -0.654194715893577,
              0.027070438975204,
              0.95986033448598,
              -0.545982806744676,
              -0.854745456492768,
              -0.531988020246192,
              0.551325427431956,
              -0.924648885393929,
              -0.781585823866905,
              -1.7758680249377,
              -0.630683049440575,
              0.479847681453005,
              -0.596158324998064,
              0.963522809664514,
              -0.264079232468338,
              0.954680834778477,
              1.04920321826929,
              -0.498055200662386,
              0.521685838918978,
              -0.235258668238832,
              -0.37667560470602,
              -1.02238218774268,
              -0.879358320781106,
              -0.636661559587756,
              0.246426649581317,
              -0.793535977410217,
              0.452427067644426,
              0.611661852320939,
              0.456202390954057,
              -0.458166739396069,
              -0.53833730325765,
              1.86109332429695,
              -0.354595034488729,
              -0.901814316608556,
              0.0866384992870563,
              -0.378215039726905,
              -0.923818683112749,
              0.467785640781664,
              -1.04598120749909,
              -0.700087511491985,
              0.425197407862542,
              -0.249770242154762,
              0.72082345312309,
              -0.671263466593225,
              1.79145271413686,
              -0.281340034516509,
              0.584999221829226,
              -0.737168493278118,
              0.318405697975856,
              0.275703539959563,
              -0.476630799726848,
              -0.797011951086048,
              -0.703736937541926,
              1.02643113612709,
              -0.607434423816812,
              -0.57306029039793,
              1.08477259112692,
              1.16400283127279,
              -0.461252583268148,
              -1.13663423502163,
              -0.786254621504916,
              -0.907102072138265,
              1.48562397552192,
              0.932368869144406,
              -0.477427796806405,
              -0.29734644257339,
              -0.518907461317653,
              0.813775615436389,
              -0.741230563054501,
              -1.06501920843179,
              0.182297366347286,
              -0.176793198783596,
              -0.42522608291081,
              -0.365667250615511,
              -0.583450306886752,
              -1.08734361141349,
              -0.585037793477071,
              0.705451579018855,
              -0.375572223768782,
              -0.69068339862456,
              0.494836494142468,
              -0.511136337815108,
              -1.42392368675555,
              0.429471033386378,
              -0.942214078092985,
              2.73103271958559,
              0.388809142953526,
              0.564119289956756,
              -0.664490838971498,
              -0.40236243399737,
              -0.434055265690223,
              -0.619319141244368,
              -0.355148547116259,
              -0.710050851894206,
              0.070492513331177,
              -0.959693561632717,
              -0.556942505826367,
              0.132028349008953,
              0.147681749339173,
              -0.31482210891491,
              -0.517533401209316,
              0.352036703629306,
              -0.461368026140065,
              -1.2435176060059,
              -0.514794172025318,
              0.0923416360578347,
              -0.886105350766682,
              -0.702993212322529,
              1.15656511603941,
              -1.18196881248591,
              0.656257799887267,
              -0.511699012243618,
              2.13689858090033,
              -0.840557618869797,
              0.333522943234844,
              -1.24231196050971,
              -0.0717324188748151,
              1.08218440326221,
              1.24744808055151,
              -0.904569798648334
          ],
          "z": [
              0.107103384287452,
              0.349958339970351,
              0.333014471072359,
              -0.104898910743449,
              -5.06783773437466,
              2.31816317856317,
              1.55728418387691,
              -0.755396604680226,
              0.505894484533505,
              0.109191381983958,
              0.548991111188275,
              0.0545077897938441,
              1.41555254339385,
              0.973136623154839,
              -0.130839258360781,
              0.882634996718364,
              -1.67952100507511,
              0.784763501568635,
              0.747768780536312,
              -0.327540651318751,
              -0.682086648503977,
              0.461591221014988,
              0.950296879790997,
              0.419097255469055,
              -0.334726429807333,
              0.523283377304958,
              0.300400557423819,
              0.398178851574455,
              0.726207734554098,
              0.19718843589216,
              -0.754209897285051,
              0.397124484463876,
              0.16717148969484,
              0.868608038774273,
              0.0705599301255,
              0.617142399131179,
              0.239892871234248,
              0.359035054325689,
              0.00680163915542115,
              0.420658869057698,
              0.129699601613522,
              0.891997042517397,
              0.690989728334205,
              0.0601011394276701,
              0.0143670315700219,
              0.319364970722061,
              0.974226334073774,
              1.06328290293801,
              -0.0826331748299618,
              0.314094836485593,
              0.468668616712335,
              0.480617065211393,
              0.474413593273746,
              0.578439278133777,
              0.347948738222159,
              0.520102043143853,
              0.738478413310037,
              0.590389553626429,
              0.0694909534215499,
              1.31962261476964,
              0.855819004319687,
              0.467931942605994,
              0.614719361617456,
              0.298491926902053,
              0.528327275109355,
              0.270819458114438,
              0.343121125278225,
              1.54274150522372,
              0.548663985589785,
              0.633721092180721,
              0.132122371969908,
              0.626381571372006,
              0.333310458915997,
              0.753442252498111,
              -0.0157112772379301,
              0.640387569564027,
              -2.92801268657188,
              0.0162860085395033,
              -0.0203061912508986,
              0.264776677209009,
              0.937939780779698,
              0.74990998805566,
              0.485006316360622,
              -0.360514746116736,
              0.510809660179569,
              0.525438316478052,
              0.712669176029809,
              0.800218671602204,
              0.579444025923174,
              -0.0200673129085467,
              0.85186025647717,
              0.592779095241088,
              0.0580297868347303,
              0.523737718601902,
              0.0454457856600398,
              0.736915937946869,
              0.579827076681849,
              -0.777837455176606,
              1.22579836840025,
              0.488841778166059,
              0.610495942095946,
              0.673991772434315,
              0.142467325410183,
              0.544897312301679,
              0.216156556440633,
              0.231964886645856,
              0.723470795302323,
              0.0969961661510473,
              0.640117806073236,
              -0.304951101000757,
              0.336427807879146,
              0.0353797410369389,
              1.07604700332005,
              0.276383813692083,
              0.381164340334866,
              0.85053914358876,
              0.273015517923774,
              0.358168127922287,
              0.634919865180397,
              0.129858700432279,
              1.57203966208027,
              0.803078359543076,
              0.0698934257534678,
              0.119804517539615,
              1.0935289640284,
              -0.057276305092819,
              0.320386130902109,
              -0.213690354741241,
              1.06604509133554,
              0.199219436507841,
              0.205495302942269,
              0.281104464467396,
              0.821330717768258,
              -0.0539418625426468,
              0.577819569550852,
              0.0815527754671757,
              0.0381495750103184,
              0.419909945453504,
              0.690377614684615,
              -0.737047120946367,
              0.768924012495942,
              0.153619055900088,
              0.930219588175863,
              0.477271226688839,
              -1.117634707277,
              0.965789306259443,
              -0.339896180342783,
              -0.0490574175474007,
              0.0969592387469749,
              0.755905830156564,
              -0.113650015095996,
              0.793156170792826,
              0.260868626477674,
              0.753892742727495,
              0.728216167962633,
              0.804430871605925,
              1.51550148822444,
              1.08117702152951,
              0.144068446043645,
              0.493326819737424,
              0.273255238437737,
              0.459992945958613,
              0.292055537397334,
              0.185379006314831,
              1.05916238133948,
              0.695559146009989,
              0.990553091653733,
              0.32687224802675,
              0.449040985779127,
              0.0605739917611843,
              0.124791879565718,
              -0.439009048755545,
              0.565321109263949,
              0.3181087860061,
              0.135983500493222,
              0.273353308573625,
              0.0801460275028751,
              0.457933294444243,
              0.357868829957431,
              0.21078933473453,
              0.298160347652215,
              0.849138409079353,
              1.09072405133575,
              -3.43864959138099,
              0.263752946316155,
              0.32173440677731,
              -0.187432100498248,
              -0.57210320056191,
              0.215058700814258,
              0.337880948125464,
              0.460005238277438,
              0.18556345676869,
              0.715389741468097,
              0.00550059031737715,
              0.626576761414069,
              -0.0183255680810102,
              0.00142188300459953,
              0.950207706695792,
              -0.117965529906689,
              -0.217528139365526,
              0.342487161315775,
              -0.177238692632232,
              0.0724267455673751,
              0.893678886261796,
              -3.69424953150112,
              0.108674510103357,
              0.610699053087572,
              0.98882170452703,
              0.487331932616691,
              0.910370516060012,
              0.953983174840062,
              0.577792309018772,
              1.08121729170881,
              0.109160522884936,
              0.120309364885876,
              0.310900428039551,
              0.427850488376625,
              0.379927411479143,
              0.376064816186274,
              0.549821367172508,
              0.5026872915358,
              -2.19200221771322,
              0.422847556072335,
              0.437309662594339,
              0.333986903061649,
              0.808138389463147,
              -3.90813087283044,
              1.64569954465431,
              1.64636970470306,
              0.420098384749869,
              -0.619563717414846,
              0.681130943049677,
              0.0626288392039994,
              0.652125052149769,
              0.0656632690585055,
              -0.378740879997574,
              1.78689339101057,
              0.294986144881832,
              -0.672899664135017,
              -1.12585452320216,
              0.605737353401167,
              0.0963217075888442,
              -0.862318294677035,
              1.61651918348034,
              1.87153185202242,
              0.179253326709232,
              0.776023648931026,
              0.658059798121817,
              0.853029460072134,
              0.767902114518928,
              0.391788617375899,
              -1.49999723771209,
              0.632565257368996,
              0.433185924660962,
              0.344796808848287,
              0.16031767689647,
              -0.141728040213796,
              0.744801670441208,
              0.915811236284947,
              0.473768485381571,
              -0.220074809705563,
              1.44957795067754,
              0.395406525479728,
              -6.74512916514646,
              0.0379194718367855,
              0.275824371257206,
              0.690308524510157,
              0.609635575552514,
              0.743492953141041,
              0.0332290708944495,
              -0.217365628516253,
              0.589405855050571,
              0.630149894529518,
              0.815784155133564,
              -0.473211716281258,
              0.0331918764393522,
              0.0308005946135916,
              1.36300066114704,
              1.06124501534599,
              -0.0829022817117869,
              0.363436429780394,
              0.657555369399384,
              0.623570241397593,
              0.918780721475588,
              0.694394684980486,
              0.667350620704832,
              0.765770818314039,
              0.182271551075001,
              0.571565876648804,
              0.484918825434741,
              -0.129103140996364,
              1.00914599620738,
              0.511134903434618,
              0.151385854118251,
              0.525104920136579,
              0.562324702846764,
              -0.716049783760111,
              0.472110856942716,
              -0.489624212724956,
              0.188123754520841,
              -0.786128972602698,
              0.345436367351073,
              -2.08767715945308,
              -0.131338670122394,
              0.807061961299087,
              0.638422406501518,
              0.529437546345092,
              0.799294016261871,
              0.493860093219337,
              0.477272889178186,
              0.426108161497818,
              -3.18482555250097,
              0.671854447615882,
              0.0597961471649062,
              0.5622582134916,
              0.0223824072290209,
              0.0783160701654716,
              0.149371005724246,
              0.514101893045706,
              -0.52525801406703,
              0.351547801570649,
              0.47350299525993,
              1.04479460479954,
              1.52192830217018,
              0.579437602557216,
              0.329163241601239,
              0.345187940727621,
              0.200038102195956,
              0.0194772109033221,
              0.694395723123571,
              -0.025626320523974,
              -1.27450008322557,
              0.503827427982251,
              0.363659454306393,
              0.243894426287544,
              0.115095667256249,
              0.690345272492236,
              1.25787956299109,
              0.173375375212967,
              -0.571897318871527,
              0.665771442378065,
              0.460800441932256,
              0.997855481119296,
              0.577224062340804,
              0.738712451476342,
              0.529802633182661,
              -0.762026660471527,
              0.655108800198664,
              0.740371728628927,
              -0.175251738516953,
              0.407874999028413,
              0.419175727611184,
              0.613854749391666,
              0.328085968539964,
              0.457485715446601,
              0.276617821189156,
              -0.68750323783332,
              0.365748866421188,
              -0.0908328248186638,
              0.591990596198461,
              0.338163686832359,
              -0.571696749688012,
              0.209206887782884,
              0.807069199716904,
              0.543230764317884,
              0.337637576568867,
              0.422626157477704,
              -1.2082240456284,
              0.511646131798007,
              -0.0454669671166218,
              0.758639550904674,
              0.709663452518675,
              -3.88688503978998,
              0.503675456287652,
              0.0709913934934532,
              0.577470383859132,
              0.554876602961281,
              0.675231039713586,
              0.0630251607860625,
              0.276241994348171,
              -0.414487338635214,
              0.200377255532125,
              0.153904424409495,
              0.378361273128083,
              0.806182753754875,
              1.01144532401231,
              0.620504799670489,
              0.61303377523043,
              -1.91705703860859,
              0.120960766438601,
              -0.108287923596686,
              0.179871214316368,
              0.477398077651058,
              -1.44745623594438,
              2.59040297789493,
              0.265043877917612,
              -1.75726932370904,
              0.297978149282384,
              0.437983506788287,
              0.815370662006824,
              0.35199298835246,
              0.927476520191455,
              0.592583620130745,
              0.053069554719922,
              0.639032027981535,
              -0.101621010431723,
              0.647936591086851,
              0.133960961439834,
              1.73312307588412,
              0.0332686866808942,
              0.655025756298632,
              -0.0216482397799905,
              0.50448130411782,
              -0.783493519612573,
              -1.26253931355368,
              1.02133842846961,
              0.221025470028134,
              0.551167987748684,
              0.439783383677279,
              -0.0431162704486325,
              -0.139027116417379,
              0.569692651894785,
              1.19078300017048,
              0.867307298322194,
              0.787003655840834,
              -0.11017032405895,
              0.1193165980602,
              0.302273731788559,
              0.285475458737656,
              -0.982366161390623,
              0.982594092316549,
              0.85238303795668,
              1.01028128317432,
              0.493761609747326,
              0.952105258645928,
              0.342892941089364,
              0.28972255465974,
              0.442682147122438,
              0.879575511829873,
              0.539202511698055,
              0.309807442950237,
              0.418459989812072,
              -1.08838942993175,
              -0.0405002071804891,
              0.693868114235734,
              -3.58245592170388,
              0.0164421967189378,
              0.792744102799738,
              0.187605754025401,
              1.11511223250841,
              1.30306792128433,
              0.580332048705537,
              -0.633940630484689,
              0.310000486710741,
              0.519146269296776,
              -0.626723579103146,
              0.80100018373233,
              0.670896981447182,
              0.743144415436097,
              0.489625084684528,
              0.800959520911375,
              0.372960522774891,
              -0.633772454332362,
              0.378508336879113,
              -0.00854469605207818,
              0.438668463166105,
              1.17973372621185,
              0.461164149407628,
              0.242788150339926,
              1.01458498526616,
              0.537336329878424,
              0.0910700885571837,
              -2.6269424350715,
              0.366893255945609,
              0.446887451141846,
              -0.0368185741422857,
              0.723626642387647,
              -0.0216843328778972,
              -1.98316132659327,
              0.217867849231563,
              -0.159314567105839,
              -0.13797849600491,
              0.887371515802268
          ],
          "text": [
              "AAK1",
              "ABHD15",
              "AC004556.3",
              "AC004918.5",
              "AC008750.8",
              "AC016876.3",
              "AC044849.1",
              "AC243919.1",
              "ACO2",
              "ACTB",
              "AGAP1",
              "AKAP17A",
              "AL022312.1",
              "AL031284.1",
              "AL049840.6",
              "AL365203.2",
              "AL662884.1",
              "ALDOA",
              "AMD1",
              "ANKRD12",
              "ANXA2",
              "ANXA4",
              "ANXA5",
              "ANXA7",
              "AP2A1",
              "AP2S1",
              "APPL2",
              "ARGLU1",
              "ARHGAP5",
              "ARID4B",
              "ARPC1A",
              "ARPP19",
              "ASL",
              "ASXL1",
              "ATF6B",
              "ATOX1",
              "ATP10D",
              "ATP13A1",
              "ATP5F1A",
              "ATP5F1B",
              "ATP5F1C",
              "ATP5MC1",
              "ATP5MF",
              "ATP5PD",
              "ATP5PF",
              "ATP6V0A1",
              "ATP6V1B2",
              "ATP6V1F",
              "ATRN",
              "ATXN10",
              "BABAM2",
              "BAG6",
              "BAK1",
              "BAX",
              "BCKDK",
              "BECN1",
              "BLVRA",
              "BRD8",
              "BTG1",
              "C11orf98",
              "C1orf43",
              "CALCOCO2",
              "CAMK2G",
              "CAMK2N1",
              "CAPRIN1",
              "CAT",
              "CBR1",
              "CBR4",
              "CBWD6",
              "CBX4",
              "CCT8",
              "CDCA5",
              "CDK11B",
              "CDK5",
              "CDK9",
              "CFAP410",
              "CFL2",
              "CHCHD1",
              "CHD6",
              "CHID1",
              "CKS2",
              "CLCN7",
              "CLP1",
              "CLSTN3",
              "CMAS",
              "CNNM3",
              "CNOT6",
              "CNP",
              "CNPY4",
              "COA4",
              "COA6-AS1",
              "COASY",
              "COMMD1",
              "COPB2",
              "COPG1",
              "COPS2",
              "COX5A",
              "COX8A",
              "CPED1",
              "CPSF3",
              "CPSF4",
              "CRTC2",
              "CTSC",
              "CWC15",
              "CYBRD1",
              "CYTH1",
              "CZIB",
              "DBNDD2",
              "DCUN1D4",
              "DDI2",
              "DDX21",
              "DESI1",
              "DGKZ",
              "DHCR24",
              "DHRS3",
              "DHRS4",
              "DHX9",
              "DIP2A",
              "DNAJB14",
              "DNAJC25-GNG10",
              "DOK1",
              "DPM2",
              "DPP3",
              "DUSP7",
              "ECHDC3",
              "EDC4",
              "EDEM2",
              "EHD1",
              "EIF1",
              "EIF4G1",
              "EIF4H",
              "ELK4",
              "ELOC",
              "EMB",
              "EMC8",
              "EPC2",
              "ERLIN2",
              "ETFA",
              "ETHE1",
              "EXOSC4",
              "FABP5",
              "FAM13B",
              "FAM214A",
              "FAM234A",
              "FAM76B",
              "FBXL17",
              "FBXL3",
              "FBXO32",
              "FIBP",
              "FUT11",
              "FYB1",
              "FYN",
              "G3BP2",
              "G6PC3",
              "GAA",
              "GABARAP",
              "GABARAPL1",
              "GAPDH",
              "GARS1",
              "GDE1",
              "GIGYF1",
              "GNPTAB",
              "GNPTG",
              "GPS2",
              "GRAMD4",
              "GRINA",
              "GSTO1",
              "GTF2H1",
              "GUSB",
              "GYS1",
              "HAUS1",
              "HCFC1",
              "HDLBP",
              "HERC2",
              "HM13",
              "HMGB3",
              "HNRNPA0",
              "HPRT1",
              "HTATIP2",
              "ICAM3",
              "IDH3G",
              "IDS",
              "IFIT5",
              "IFNAR2",
              "IFNGR1",
              "IK",
              "IKBKE",
              "IMMT",
              "INTS4",
              "IP6K2",
              "KANSL2",
              "KBTBD4",
              "KCTD12",
              "KCTD5",
              "KDM2B",
              "KDM5A",
              "KIAA0100",
              "KIAA0930",
              "KIF2A",
              "KIZ",
              "KLHL18",
              "KMT2A",
              "KMT2E",
              "KRR1",
              "L3MBTL3",
              "LAMTOR2",
              "LANCL1",
              "LEMD3",
              "LGALS3",
              "LHPP",
              "LINC00623",
              "LIPA",
              "LTBP4",
              "LUC7L3",
              "MAF",
              "MAN2A1",
              "MAP1S",
              "MARCHF9",
              "MAU2",
              "MCFD2",
              "MEPCE",
              "MFSD11",
              "MGST3",
              "MICOS10",
              "MICU1",
              "MIEN1",
              "MIR4690",
              "MIR4767",
              "MKI67",
              "MON1B",
              "MORF4L1P1",
              "MPV17",
              "MPV17L2",
              "MRPL21",
              "MRPL28",
              "MRPL36",
              "MRPL49",
              "MRPS10",
              "MRPS12",
              "MRPS15",
              "MRPS18A",
              "MTHFD2",
              "MXD4",
              "MYBL1",
              "MYD88",
              "MYDGF",
              "N4BP2L2",
              "NAGA",
              "NANS",
              "NARF",
              "NDUFA6",
              "NDUFAF3",
              "NDUFB5",
              "NDUFS4",
              "NDUFV2",
              "NECTIN1",
              "NECTIN2",
              "NETO2",
              "NEU1",
              "NIBAN2",
              "NOC4L",
              "NOL3",
              "NR1H2",
              "NRG1",
              "NSUN2",
              "NT5DC2",
              "NUBP1",
              "NUDT16",
              "NUP62",
              "OGDH",
              "OLA1",
              "OS9",
              "OTUD5",
              "OXR1",
              "PAPSS1",
              "PBXIP1",
              "PCF11",
              "PCTP",
              "PDGFD",
              "PDSS1",
              "PEAK1",
              "PEPD",
              "PEX10",
              "PHF1",
              "PIGT",
              "PIN1",
              "PKM",
              "PLD4",
              "PLEKHM2",
              "PLOD1",
              "PNMA1",
              "PNRC1",
              "POFUT2",
              "POLDIP2",
              "POLR1D",
              "POLR2F",
              "POMP",
              "PPP1CA",
              "PPP1R2",
              "PPP2R5C",
              "PPT1",
              "PPWD1",
              "PRAF2",
              "PRDM1",
              "PRDX1",
              "PRDX5",
              "PRKAA1",
              "PRMT5",
              "PRPF38B",
              "PRPF39",
              "PRR5L",
              "PRXL2C",
              "PSMB6",
              "PSMC1P1",
              "PSMD13",
              "PSMD14",
              "PSMD2",
              "PSMD3",
              "PSMD4",
              "PSMG2",
              "PTDSS1",
              "PTPA",
              "QTRT2",
              "RAB13",
              "RAB20",
              "RAD21",
              "RAD23B",
              "RASSF1",
              "RBBP6",
              "RBBP8",
              "RBM25",
              "RC3H2",
              "RELA",
              "RHOA",
              "RNF216",
              "RPN1",
              "RPRD2",
              "RPS17",
              "RSF1",
              "RTL6",
              "S100A10",
              "SCAMP2",
              "SCPEP1",
              "SDE2",
              "SEC11A",
              "SEC13",
              "SECISBP2",
              "SEM1",
              "SEPTIN7",
              "SERPINB6",
              "SETD1B",
              "SF1",
              "SFSWAP",
              "SH3BP5",
              "SIL1",
              "SLC16A1",
              "SLC1A5",
              "SLC25A5",
              "SLC2A6",
              "SLC35B1",
              "SLC39A11",
              "SLC39A6",
              "SLC39A7",
              "SLC43A3",
              "SLFN11",
              "SLIRP",
              "SLK",
              "SMCO4",
              "SMIM15",
              "SMU1",
              "SMURF2",
              "SNF8",
              "SNORD36B",
              "SNTB2",
              "SNX19",
              "SNX3",
              "SORT1",
              "SPTLC2",
              "SQLE",
              "SQOR",
              "SRP19",
              "SRP54",
              "SRPRA",
              "SRRT",
              "SSNA1",
              "ST6GALNAC4",
              "STAG1",
              "STAG3L5P",
              "STING1",
              "STK10",
              "STK38",
              "STT3A",
              "STYXL1",
              "SUB1",
              "SULT1A1",
              "SURF1",
              "SYNE1",
              "SYS1",
              "TAGLN2",
              "TARDBP",
              "TAX1BP3",
              "TBC1D10A",
              "TBC1D17",
              "TBC1D22B",
              "TBC1D4",
              "TBCB",
              "TCEA2",
              "TCN1",
              "TCN2",
              "THBS3",
              "THOC6",
              "THRAP3",
              "TIMM10B",
              "TIMM23",
              "TK1",
              "TMED7-TICAM2",
              "TMEM106C",
              "TMEM11",
              "TMEM115",
              "TMEM131",
              "TMEM147",
              "TMEM181",
              "TMEM205",
              "TMEM208",
              "TMEM258",
              "TMEM60",
              "TNFSF10",
              "TNPO1",
              "TOB2",
              "TOMM22",
              "TOMM5",
              "TOP1MT",
              "TPP1",
              "TPRG1L",
              "TPX2",
              "TRAF7",
              "TRAK2",
              "TRIM26",
              "TRIM59",
              "TSC22D4",
              "TSEN54",
              "TSG101",
              "TSPO",
              "TTC17",
              "TTC27",
              "TTC39B",
              "TUBGCP2",
              "TWF1",
              "TXNDC5",
              "TXNRD2",
              "UAP1L1",
              "UBAP1",
              "UBE2L3",
              "UBE3C",
              "UBL3",
              "UQCRC2",
              "URM1",
              "UROD",
              "USP3",
              "VAC14",
              "VAMP2",
              "VDAC1",
              "VGLL4",
              "WAC",
              "WASHC3",
              "WASHC5",
              "WHRN",
              "WWP1",
              "YARS1",
              "YIF1B",
              "YIPF3",
              "YRDC",
              "YTHDF2",
              "YWHAG",
              "YY1AP1",
              "ZFP90",
              "ZMAT5",
              "ZNF207",
              "ZNF266",
              "ZNF324",
              "ZNF451",
              "ZNF767P",
              "ZNF83"
          ],
          "type": "scatter3d",
          "mode": "markers",
          "opacity": 0.7,
          "name": "PBMC common",
          "marker": {
            color: "#45364B"
        }
      },
      {
          "x": [
              1.59573595910442,
              1.51772217945655,
              1.57805907850436,
              1.44882424096921,
              1.01505522053505,
              1.75550767754001,
              1.8000386492362,
              1.39445783559912,
              1.22655904758068,
              1.72846961016537,
              1.59470902532674,
              1.63777437423734,
              3.00982371010658,
              2.44322052908513,
              2.74861259002996,
              1.90194512729043,
              1.13702452535938,
              1.83652498634912,
              1.92685246021314,
              1.56093119581079,
              1.89999133517128,
              2.02143589291656,
              1.42337380316509,
              2.61733816690453,
              1.93766630565456,
              1.35465333885501,
              1.09417696268055,
              3.23501090530799,
              3.73419685938271,
              2.20035407778056,
              2.2897322053946,
              2.11543892158904,
              2.03038102595328,
              1.79340604934723,
              1.74567878053255,
              1.04123340503296,
              1.44652587039535,
              1.30250069757404,
              1.55680219914518,
              1.75537046167266,
              1.91191622455239,
              0.704832160156219,
              1.51337064347036,
              1.1954409644243,
              1.67243376308974,
              1.53718552950611,
              3.48413458825903,
              1.19989212202145,
              1.83009989093245,
              1.37974611975147,
              0.892859578725468,
              1.61344126809986,
              1.76460730205887,
              1.34740787823014,
              1.84597187725321,
              2.0932229522365,
              1.22921986157733,
              1.8276680764751,
              2.52043116045864,
              1.53880564996533,
              1.56790836921223,
              1.9725922427329,
              2.60491668117052,
              1.24103150674506,
              1.13241857561143,
              0.706118694142293,
              2.5822281177856,
              3.17902491695806,
              0.891280161872479,
              1.15490710678564,
              1.29425093360813,
              0.90991203636144,
              1.87789211532449,
              1.69262417638434,
              2.39510250154742,
              3.29111825553469,
              1.61206945939443,
              1.40513171194386,
              1.64601054725991,
              1.71803575998303,
              1.06113443873123,
              1.86240078339345,
              1.82371341300957,
              1.96504176181579,
              1.03100669083151,
              1.87023535391954,
              1.39840084820158,
              1.07666543864816,
              0.98135655147546,
              2.81131364669878,
              1.66496396071706,
              1.34885606698578,
              1.33570162739897,
              2.95878959442693,
              2.64093191400365,
              2.12923956801086,
              0.789530717227997,
              2.72597821767039,
              2.74689720645561,
              0.865882484674031,
              1.07536016717111,
              1.51802982975646,
              2.44164982880283,
              1.47670923905924,
              1.39697159167399,
              1.17399828130695,
              2.4327988382687,
              1.36057215458169,
              2.17982360218414,
              1.48523365558028,
              2.07830655462339,
              1.51901505817331,
              1.58187252945431,
              1.08904259951673,
              0.832432732691197,
              2.2369457529725,
              2.19708484300512,
              1.56617289918546,
              1.07147228576007,
              1.33035265443277,
              1.28137107828191,
              0.721733097524245,
              1.41861580408615,
              1.59215597073765,
              1.17536008938858,
              1.47504649404292,
              2.52523708239168,
              1.43671622471185,
              0.865781491353817,
              0.95864991842496,
              0.90660273345141,
              2.42922171973488,
              4.09586129590358,
              0.964604575673893,
              1.58566148967869,
              1.01475319499457,
              2.28390011259203,
              0.688110868993863,
              1.05045473463368,
              0.826069668063639,
              1.31717165326123,
              1.25838811360704,
              1.20833351242783,
              1.63347679836289,
              1.36654860686846,
              0.665729068304465,
              1.32755101240508,
              1.13022845164686,
              2.97259805232037,
              1.21238398517693,
              2.12723574313052,
              1.14860474943639,
              1.15905860193509,
              0.698021856950788,
              0.753024588832772,
              1.90503275912808,
              1.3337127386355,
              1.12672052562548,
              2.95992004250716,
              1.10745039708496,
              1.33977844499237,
              2.24536065259582,
              1.42649519563568,
              1.06391249896094,
              1.87238354373595,
              3.80190604106811,
              4.19998283073229,
              3.82126709873398,
              3.06533870674748,
              1.88818213283535,
              1.00252014975313,
              0.728058106252632,
              0.822518181900914,
              2.22061166615785,
              3.35232006242021,
              1.4843240705771,
              2.35012680671694,
              2.52371304501256,
              1.55540095873421,
              1.34488827003033,
              1.3755789334748,
              2.67875211300423,
              1.74783624046457,
              1.85019798394712,
              1.02484359131882,
              0.999197219961543,
              1.01340038008767,
              2.17978815299697,
              0.825965809829806,
              1.21333580597728,
              2.94925119151025,
              2.70600072469754,
              2.50793243267531,
              0.9917255238751,
              0.806624758054757,
              1.18287510104496,
              3.3544650490588,
              2.50548091464662,
              1.37098631019252,
              2.54035728138515,
              1.67246292243961,
              2.58658224509438,
              1.05322639325989,
              2.58704863207067,
              0.826838672539116,
              1.41187591064501,
              1.20725566276412,
              2.93378575356334,
              2.09393922177989,
              1.64879961191581,
              0.710227870599896,
              1.46828773319179,
              0.75090164111083,
              1.54530807401708,
              7.65074364067993,
              4.84568219143911,
              2.31247892294201,
              1.00392174574815,
              2.51772138905155,
              1.57116873303533,
              1.14976772676313,
              1.56379261381197,
              0.811961158956572,
              0.753687440477681,
              6.73601882610969,
              1.52866328371787,
              2.24884294395746,
              4.00558045742817,
              2.82579034099097,
              1.82676330542038,
              1.86649212794419,
              1.08155783797909,
              0.809530057281866,
              1.76105658570239,
              1.67135042064895,
              1.39121100190769,
              2.78640848983439,
              2.71595344297735,
              1.78781871869961,
              1.35005016828119,
              1.7003529673761,
              1.30852051055183,
              1.13633410499138,
              1.38480221161654,
              1.13735476751354,
              1.54426125200326,
              3.40882441125024,
              1.19037822636112,
              0.96660571309497,
              1.55583986176191,
              2.59601679184329,
              3.23328144210129,
              0.98397598415589,
              3.49945667435209,
              1.76463788139255,
              0.879738192633139,
              2.90396166528438,
              3.03877650954461,
              2.72946477318962,
              2.72325752315503,
              0.803903581567008,
              1.38465217323002,
              0.778617265533721,
              0.797724740401513,
              0.823840289566051,
              1.32096397799235,
              1.52094369747754,
              1.12743092713792,
              0.523239849783155,
              1.37776474729657,
              4.64440785729551,
              3.72693681825647,
              1.76441626610888,
              1.45357404777312,
              1.50795515076603,
              0.986670656490093,
              0.827950747216883,
              1.96082797951311,
              2.05008160952619,
              1.5741875924688,
              0.750947004518499,
              1.47142572466343,
              1.15261263080572,
              0.882651478116054,
              1.0821576353515,
              2.55125575472347,
              1.55343660147986,
              0.555886349119982,
              2.70160622970303,
              1.60230306041393,
              0.879646035237374,
              2.04442190090952,
              0.873655662399987,
              1.25185951540738,
              2.36278126955847,
              1.11172493908303,
              2.17913797014136,
              1.41167556576616,
              1.70523776382167,
              1.3055496532686,
              0.566191759442106,
              1.29996333220908,
              0.747851395661467,
              1.8409875879998,
              1.35427808611145,
              1.68275711511155,
              1.81404195398481,
              0.647140808479131,
              2.23152490259159,
              1.21952130526749,
              1.2598247177576,
              1.19684979423795,
              0.957708937871244,
              0.492310756803789,
              0.513714506053496,
              1.21998251671055,
              1.54346651879354,
              0.841700706201418,
              2.67253478427172,
              1.10359197707321,
              2.98508340081731,
              1.30830512529161,
              1.93237599410877,
              1.3206633264464,
              1.61313642527618,
              1.32344673112361,
              0.794979968870839,
              2.10718287168688,
              3.02584255218373,
              1.09854724194341,
              2.77424205212913,
              2.59376804800953,
              1.42495423063357,
              1.54078911033678,
              3.50418855791196,
              1.50216864364195,
              1.99056147157372,
              1.07658417245307,
              3.23336391624031,
              1.68512467680581,
              0.908360433778544,
              1.44759888104909,
              1.67948723278811,
              1.42900573439696,
              2.18250774197038,
              2.67725277740826,
              1.55435191121555,
              1.20383129297271,
              3.63303923716632,
              2.12810312007437,
              3.29938257017915,
              0.78814555800282,
              0.892650653483094,
              1.15585204078933,
              1.68786539329395,
              1.05811404306909,
              1.20619328962916,
              1.69895184527852,
              1.39745043283484,
              0.567429312677555,
              0.654063112715259,
              0.814488636655767,
              0.706527771642753,
              1.03830806804569,
              1.10679319824466,
              2.69584306625021,
              0.618939080211221,
              0.550606875256149,
              2.5609343748744,
              1.83548714119735,
              1.64174759921854,
              2.07369918510884,
              4.52298922261751,
              0.795159570598164,
              1.11666233317961,
              0.962770389227668,
              2.60502483837665,
              1.03722446828185,
              1.3365549252576,
              1.74296780371152,
              1.67617909775976,
              1.41908724327512,
              2.83076431852643,
              3.79914858631656,
              0.953898789679217,
              0.759661056766186,
              2.14269840225099,
              1.40196203434305,
              2.33173569463982,
              1.97376633040642,
              1.95643529393206,
              2.17139207320247,
              1.32215384481685,
              1.42592036694741,
              1.87517094551443,
              2.05926887213281,
              1.06098536843217,
              1.66722402448557,
              0.864357957048268,
              1.50695873690341,
              1.48522007304081,
              3.08496125248121,
              2.99433336285162,
              1.56098932091595,
              7.42167259232425,
              5.98373266747159,
              5.54560640447963,
              4.06087408347676,
              7.05867724768448,
              6.1415516564299,
              4.46342459247204,
              6.21938483473559,
              5.47816085796923,
              5.82516562286302,
              5.37330645703748,
              4.96618382222865,
              3.74737453969176,
              6.95655017084081,
              4.03083760435998,
              3.98057055524046,
              4.13343387794894,
              4.47571285517433,
              4.38538979342665,
              3.55856286211662,
              5.62910031093191,
              4.40889012604122,
              3.62067234937326,
              3.72657237032498,
              2.8918556096148,
              5.7464583362622,
              4.23383620959258,
              4.71817296108885,
              4.13040080950973,
              3.95585649565399,
              5.76748588059598,
              3.22922433805477,
              5.69055562664126,
              4.78051278310447,
              4.31782125467461,
              3.81978309267505,
              3.2892054014421,
              4.78697455339616,
              1.12667758358117,
              3.45115064058099,
              1.38321773930845,
              2.75922017400153,
              2.5552155103448,
              2.38854911155339,
              0.783444010500308,
              0.60135418840707,
              1.34758958189726,
              0.767729536753012,
              1.56919801042234,
              2.15011719285255,
              1.22431834081624,
              2.91503010263161,
              1.72327502348771,
              1.89269263661144,
              1.1518035789202,
              2.12935138106586,
              1.58669886247202,
              1.37262228936233,
              2.74260725105313,
              0.815674124789495,
              1.66915510515856,
              1.24840588863094,
              1.85297739248588,
              1.11200184635853,
              1.76585984414476,
              0.944158744459612,
              2.07884680370655,
              1.91881095763948,
              1.61041431496464,
              1.84881275718517,
              2.34448711616875,
              2.17308045994089,
              2.50364256285373,
              2.50922191891954,
              2.18254783314447,
              0.861781347931805,
              2.38933477647992,
              1.10957613842943,
              3.56526459290862,
              1.96558860482445,
              3.15385718807937,
              2.52490301368543,
              0.538248281267988,
              0.690410926848891,
              2.84998997665053,
              1.02924108691873,
              2.4325415668711,
              3.17932490292958,
              3.23364495718013,
              0.620910245057637,
              2.48004162605209,
              1.97482907603708,
              2.60015380553661,
              1.24260349936228,
              1.53092546502404,
              2.39004717429872,
              2.16021443128424,
              1.07593122570284,
              2.10297388041974,
              1.56852316975889,
              1.79157463218403,
              2.88742537570222,
              1.57523928628211,
              2.02533556982345,
              2.87788365228708,
              1.26211083124448,
              2.37083752117419,
              1.90259325429259,
              0.388854889048794,
              1.0725355111241,
              1.42714449544012,
              2.32767913511771,
              0.716257134693432,
              0.543576802600428,
              2.06088911156018,
              0.745334192683383,
              0.545676141175539,
              1.61054371609431,
              0.83066196841645,
              3.12877869878869,
              0.927414523455213,
              1.94569115030809,
              0.939668654463919,
              1.2992273589349,
              0.962896396830933,
              1.77238191376517,
              1.36640741735992,
              1.80928524292794,
              1.38081847868399,
              1.64529193903644,
              1.96096911434729,
              1.67041282185111,
              2.62542422455292,
              0.84341037839992,
              1.7700154941424,
              1.63502215533135,
              1.24172110812828,
              1.37913895462084,
              1.28068086251648,
              1.57148738485294,
              1.57522456276014,
              2.4877127974796,
              1.17309612428845,
              1.67774727489985,
              1.44948800724325,
              0.695068763666857,
              2.44972065078213,
              1.67477181457348,
              0.599611979709939,
              1.57895560961195,
              1.25912416586062,
              2.08988865083173,
              1.73818010300791,
              1.23154534758127,
              0.926228436955828,
              1.25675214080585,
              1.1939446381256,
              1.03838829561385,
              1.55782673667418,
              2.29369199017803,
              2.61130585962133,
              1.38587329435483,
              2.21086320839211,
              1.32321082917061,
              1.69273007471036,
              2.22099199373064,
              3.64016591840144,
              1.39034555086452,
              0.979858788058897,
              1.69694698066108,
              1.79389439288856,
              2.9845876487571,
              3.63179223738514,
              1.43118457390412,
              1.64767989754659,
              1.9926189114371,
              1.19872802733362,
              2.05176435529355,
              1.65638032183438,
              1.37284179857529,
              1.71065918835079,
              1.61948257882749,
              1.14739022569423,
              1.31337380680152,
              1.8326407810668,
              2.40285600564706,
              1.64842192183817,
              1.0879198865717,
              2.67996587163398,
              2.24300733678601,
              1.68919822266241,
              0.673069726682618,
              1.03534780288053,
              0.907099638966229,
              1.84123994871084,
              1.34527151395909,
              2.66559862948228,
              3.19480496330694,
              1.81603220544504,
              1.75993555594176,
              1.08501427591719,
              1.33652870016838,
              1.60204018068871,
              0.91771805155395,
              1.57274976374608,
              2.33402127463635,
              0.881415273967727,
              1.082339981296,
              1.3561661507476,
              0.924901327274528,
              1.63098704191228,
              1.54886083346371,
              0.649651365621671,
              0.948675590393918,
              0.99498287632988,
              2.12424761838375,
              1.22577980272191,
              0.778249389065079,
              1.23118632708904,
              1.77862885125819,
              1.75672693828021,
              1.65311073735766,
              1.23594509652165,
              1.25321490287704,
              1.82829157885816,
              0.977130118605498,
              3.21599682324122,
              2.60802932705385,
              0.956065723658719,
              0.52250707731406,
              0.957525897326337,
              1.95778441356562,
              1.15245355120954,
              0.978223278959881,
              0.648826131408533,
              0.927164481425817,
              2.0872345217623,
              1.3593082327249,
              1.63789468184233,
              0.70646278056617,
              2.45973520911745,
              2.23161454164337,
              1.57018660377602,
              1.61982428364796,
              2.33630825400652,
              0.959812288221653,
              1.08131503727772,
              0.819167504962093,
              0.902466273749347,
              1.75238429772129,
              0.673592650398109,
              1.7416320283622,
              0.698586903583625,
              1.50183170939339,
              1.5002685597836,
              1.90887699602343,
              0.987982481517339,
              1.46401451195842,
              0.546660777341556,
              0.76772254183523,
              3.0969049542213,
              0.608729177989853,
              0.808349414627889,
              0.513792131432804,
              2.43890232941734,
              1.0405091339786,
              1.47392052556909,
              0.919866787585518,
              1.09576682077806,
              1.70515182873306,
              2.49051172605402,
              2.87708400237129,
              1.36268418271366,
              1.65676809049459,
              0.863068212112519,
              1.25414009593537,
              2.00691619630175,
              1.6335748631274,
              2.1839563019975,
              1.61192080419054,
              0.610707493907133,
              1.23673967300539,
              1.13195969490813,
              0.694522823894351,
              0.774482154968238,
              0.728729972475134,
              2.56116145579182,
              1.18792104036066,
              1.91271028697806,
              0.769632006380602,
              1.64419067626367,
              1.41154904830273,
              0.774639140451541,
              1.63572459275284,
              1.86190255992122,
              1.94684217221988,
              1.70666016274315,
              0.981244345742936,
              0.92087339581036,
              1.00808438883851,
              0.907720576024861,
              1.09127014866447,
              1.53782838724469,
              1.81030482639412,
              1.26953012675442,
              1.25341019936571,
              1.31683727244945,
              1.5927097578622,
              0.717614308667245,
              0.820004593874034,
              1.9659407522534,
              2.92377041682319,
              1.30501032797851,
              1.63749156412665,
              1.23643408964008,
              1.50471747592343,
              1.85450642126703,
              0.952584773576921,
              0.803477907160939,
              0.657851805736836,
              1.81977077404471,
              2.28166724538899,
              1.55988613472111,
              1.82697101640013,
              2.08986976169084,
              1.78857224097553,
              2.01421033196273,
              1.95548675944433,
              1.02727448349368,
              2.55818401701031,
              0.950214379441015,
              2.67247441836389,
              1.97184275353206,
              2.1241428134714,
              1.02548409291621,
              1.65143614093919,
              1.14415383149832,
              1.96763723806261,
              0.741710862029872,
              1.64936300541938,
              0.67913390245549,
              1.91236340425786,
              1.26047674650119,
              1.12058378266812,
              1.26275688269185,
              1.00533815717801,
              2.71763901657115,
              1.97773818263623,
              1.14628747785177,
              1.62725263792384,
              1.10140589466567,
              2.15197249809412,
              1.06538548250846,
              2.67933410441221,
              2.06092096299086,
              2.24595324865382,
              0.499791831895633,
              0.560142647220207,
              1.52338299630055,
              2.33909526441307,
              1.41979994694768,
              0.81099227508146,
              1.90073839785055,
              1.09296281049978,
              0.88831449669586,
              1.74131472732848,
              1.93521690874005,
              0.952730228481798,
              1.03967445796292,
              1.09763648740871,
              2.69939901982207,
              2.35408046200899,
              1.37204322340994,
              2.19793622375841,
              2.19763713322755,
              3.1875338877556,
              3.0821057582201,
              1.27145233467141,
              1.26635439301283,
              2.83982550867788,
              2.13963655953695,
              2.07045913472099,
              1.12514169250122,
              1.2100012057551,
              1.9118741227335,
              1.51803643578879,
              1.23538840078834,
              1.96717459896659,
              3.91527130920705,
              1.08097561782059,
              2.4928169781842,
              1.18905268123484,
              0.887360474392944,
              2.0540877899204,
              0.710467034301623,
              1.05722403410728,
              1.83085255811632,
              2.53031445564527,
              1.6853392959658,
              1.65006945504342,
              2.08745017559315,
              1.85477812824174,
              1.31011331465312,
              1.56981280798515,
              1.69555912786131,
              3.11739428461572,
              1.5966479364689,
              2.71860237174588,
              1.96455117222385,
              1.37674532136548,
              0.923635387344679,
              0.963377011577143,
              0.879153372365592,
              1.13599533685482,
              0.875323082098996,
              2.67261625245057,
              2.23591895571933,
              2.7101560804991,
              1.46570377993291,
              1.59910591209966,
              0.774030910056993,
              1.08198395437257,
              1.27888306081382,
              1.26075035988298,
              3.39627799092542,
              0.739560145331064,
              2.39838898060177,
              0.512978568434314,
              1.02134858344259,
              1.12623170588089,
              2.8213565231982,
              3.02808600985046,
              1.32521055179855,
              0.919549703584377,
              1.65310438181877,
              1.17940336943553,
              1.07893445920483,
              2.26451190534428,
              1.92458771423379,
              1.42164985023272,
              0.660050419270318,
              2.91173264544306,
              1.74019406123341,
              1.36704073335416,
              2.07683004324056,
              1.13833555438266,
              0.692249140510111,
              1.15096198863515,
              2.15776268796577,
              2.02858639876555,
              2.88715323344928,
              1.60259952606346,
              1.08792615943357,
              1.25081652322856,
              1.22010395403035,
              2.1089024679541,
              2.89687122642115,
              2.81362805413593,
              1.67564563902979,
              1.94458094520189,
              1.49226594961312,
              0.976687969086678,
              2.59211831962107,
              3.26251372435569,
              1.27773538446754,
              1.07037529174919,
              1.79518609737369,
              0.961225718612383,
              1.31271507870897,
              1.19906044998042,
              0.687704158400987,
              2.99244141025603,
              2.420950874915,
              1.64934542579247,
              1.58571703064434,
              1.4385702537339,
              1.13290624467072,
              1.29271706238181,
              2.74051569958299,
              2.2545413513023,
              1.12145500450393,
              1.99332135317474,
              1.04053012969761,
              1.41513535523062,
              1.49772582517544,
              1.61436045261462,
              2.67168592247423,
              0.826940529120475,
              0.636347065085861,
              1.73546259725908,
              0.955379236267804,
              1.81797508508595,
              1.73818636707908,
              1.72170630795456,
              1.67660983318495,
              2.29618694380667,
              2.86834796197182,
              1.54636530171009,
              3.47967444767962,
              3.33313079475459,
              2.1862253658126,
              1.42109858204907,
              1.45963288808435,
              1.20390245368438,
              2.66787310547146,
              1.3055728822333,
              1.66524607906104,
              1.05223837547814,
              1.01945404535707,
              1.85142314867013,
              2.91649192349891,
              1.64563092454639,
              1.79318821731087,
              1.62425172442417,
              2.01221328280346,
              2.19783244656479,
              1.77281129594952,
              0.92355609327117,
              1.57556568200692,
              1.92904715876068,
              0.700723381705724,
              1.2957971541939,
              2.45218424908976,
              1.23478354005168,
              2.20344819975865,
              1.07008817584666,
              0.918461848508169,
              0.6345158598811,
              0.87146889445552,
              0.967409981956476,
              0.519399986788916,
              1.12556053864217,
              2.03899396471707,
              1.46061164704172,
              1.10351728190978,
              1.24007816717636,
              1.20254595478757,
              1.98502109306999,
              0.98278298452052,
              1.7481603397004,
              0.793746032703658,
              0.53213662209812,
              0.958746703882072,
              6.32066537466761,
              0.687320818151031,
              1.34290185303076,
              1.11582688592283,
              2.02197231401384,
              1.80158137430745,
              1.34414333439694,
              1.1325150856689,
              2.03137593976696,
              0.805342454582803,
              2.02080757336153,
              2.11936765310711,
              1.60660290474949,
              1.2400867251593,
              1.29929961557684,
              0.368421844399499,
              1.70298230667237,
              0.703403038169161,
              0.978664441749605,
              1.51243957550986,
              0.916366526038749,
              1.97573435040097,
              0.821130859048672,
              2.46933280153814,
              1.49875948501165,
              1.27314707473241,
              2.06078482545396,
              1.11666622150429,
              1.1796482493645,
              0.663605365087143,
              2.14658757604717,
              1.74994399787873,
              1.93819877619339,
              1.1477649036621,
              2.68294538736228,
              1.63697856877796,
              2.1189073734413,
              1.49022982133558,
              2.17726296496775,
              1.35561663110152,
              1.1498698089067,
              1.61801994400936
          ],
          "y": [
              -0.203167111579235,
              -0.193755721964644,
              -0.201034616380968,
              -0.185444044903575,
              -0.133115222066483,
              -0.222441576915708,
              -0.227813683310769,
              -0.178885416092201,
              -0.158630521162209,
              -0.219179771275256,
              -0.203043224825718,
              -0.208238522109293,
              -0.373759163829141,
              -0.305405556075115,
              -0.342247299722556,
              -0.240107429025283,
              -0.147829297629849,
              -0.232215304866971,
              -0.243112188126227,
              -0.198968350933635,
              -0.239871728371601,
              -0.254522499743934,
              -0.182373766971681,
              -0.326410677679109,
              -0.244416743720643,
              -0.174083499956841,
              -0.142660273539154,
              -0.400925190649318,
              -0.461145750723884,
              -0.276106747481847,
              -0.286889103955218,
              -0.265862792853453,
              -0.255601618491197,
              -0.227013542848474,
              -0.221255843066683,
              -0.136273293561346,
              -0.185166775156526,
              -0.167791934175249,
              -0.198470238978121,
              -0.222425023532514,
              -0.241310317561653,
              -0.0956906785841099,
              -0.193230763415363,
              -0.15487651249905,
              -0.212419745141505,
              -0.19610373242316,
              -0.430978856207593,
              -0.155413489153325,
              -0.231440197231499,
              -0.17711063104312,
              -0.118373841768465,
              -0.205303036308878,
              -0.223539333133647,
              -0.173209425489669,
              -0.233354954443575,
              -0.263182713203598,
              -0.158951515188232,
              -0.231146829144068,
              -0.314720055866364,
              -0.196299179752249,
              -0.199810059893077,
              -0.248630122472225,
              -0.324912180332068,
              -0.160376442876194,
              -0.147273647232973,
              -0.095845882865328,
              -0.322175088105867,
              -0.39417117934904,
              -0.118183304821859,
              -0.149986608067529,
              -0.16679670303452,
              -0.120431008123215,
              -0.237205733093646,
              -0.214855466713421,
              -0.299600716126492,
              -0.407693842746541,
              -0.20513754469622,
              -0.180173086160639,
              -0.209232113672199,
              -0.217921057369977,
              -0.138674105093782,
              -0.235336897086596,
              -0.230669748315057,
              -0.247719251110664,
              -0.135039568028993,
              -0.236282040316637,
              -0.17936109138988,
              -0.140547726548634,
              -0.129049897896259,
              -0.349811400272745,
              -0.211518606640196,
              -0.173384131402859,
              -0.171797212314053,
              -0.367602534212358,
              -0.329256969031997,
              -0.267527668738139,
              -0.105908503229886,
              -0.339516744967753,
              -0.342040360086641,
              -0.115119391799069,
              -0.140390261822804,
              -0.19379283613666,
              -0.30521607067406,
              -0.188808022172873,
              -0.179188669413902,
              -0.152289720189915,
              -0.304148309045693,
              -0.174797531261467,
              -0.273630001634089,
              -0.189836386719221,
              -0.261383235852073,
              -0.193911691658495,
              -0.201494661681017,
              -0.142040876653428,
              -0.111084096369943,
              -0.280521076763626,
              -0.2757123550764,
              -0.199600697077173,
              -0.139921237415836,
              -0.171151925432043,
              -0.165242909112449,
              -0.0977295659081216,
              -0.181799773719209,
              -0.202735230628364,
              -0.152454005352028,
              -0.188607432722535,
              -0.315299830413545,
              -0.183983363739656,
              -0.11510720821446,
              -0.12631062579025,
              -0.120031781997015,
              -0.303716774304378,
              -0.504776054718934,
              -0.12702898092756,
              -0.201951752480448,
              -0.133078786451546,
              -0.286185534689875,
              -0.0936734633344672,
              -0.137385731979644,
              -0.110316471975597,
              -0.169561802019286,
              -0.162470301042055,
              -0.156431837634348,
              -0.207720073174563,
              -0.17551851569829,
              -0.0909733782018812,
              -0.170813942260324,
              -0.147009436089405,
              -0.369268352453679,
              -0.156920476658597,
              -0.267285932255771,
              -0.149226307249239,
              -0.150487434184542,
              -0.0948691004327998,
              -0.101504494102287,
              -0.240479913301031,
              -0.17155727768792,
              -0.146586248561825,
              -0.367738908675563,
              -0.144261547868733,
              -0.172289029515223,
              -0.281536229462037,
              -0.182750324046769,
              -0.139009243415661,
              -0.236541192628185,
              -0.469314019101634,
              -0.517337019409599,
              -0.471649689259734,
              -0.380456355853403,
              -0.238447095380831,
              -0.131603022099918,
              -0.0984925993328221,
              -0.109888029460197,
              -0.278550572889758,
              -0.415077077507328,
              -0.189726656631906,
              -0.294174959431365,
              -0.315115974309831,
              -0.198301196797229,
              -0.172905466182075,
              -0.176607911987289,
              -0.333819504390526,
              -0.221516113702072,
              -0.233864781512956,
              -0.134296066932018,
              -0.131202152060397,
              -0.132915586203811,
              -0.273625725131739,
              -0.110303942774888,
              -0.157035301968124,
              -0.366451844852669,
              -0.337106709577352,
              -0.313212240229351,
              -0.13030078510614,
              -0.107970686078026,
              -0.153360597789616,
              -0.415335843395419,
              -0.312916495151758,
              -0.176053869262303,
              -0.317123893860028,
              -0.212423262853424,
              -0.322700359265903,
              -0.137720098027894,
              -0.32275662303834,
              -0.110409242775407,
              -0.180986689627889,
              -0.156301808514149,
              -0.364586132631885,
              -0.263269122191501,
              -0.209568579540863,
              -0.0963416037599207,
              -0.187792072513494,
              -0.101248386934646,
              -0.197083616123189,
              -0.933628277130574,
              -0.595232594844267,
              -0.289633211755891,
              -0.131772107177591,
              -0.314393155739314,
              -0.200203382128752,
              -0.149366605960368,
              -0.199313545331098,
              -0.108614456297253,
              -0.101584458886907,
              -0.823278135669506,
              -0.195075629748653,
              -0.281956324487606,
              -0.493884797437732,
              -0.351557832902085,
              -0.231037679799601,
              -0.235830466784006,
              -0.141137933515422,
              -0.108321174198159,
              -0.22311098348577,
              -0.212289053386249,
              -0.17849372609818,
              -0.346806903686101,
              -0.338307380918728,
              -0.226339501084728,
              -0.173528184832665,
              -0.215787848961808,
              -0.168518149538697,
              -0.147746007022595,
              -0.177720585472761,
              -0.14786913722734,
              -0.196957330102006,
              -0.421893622535123,
              -0.154265756288489,
              -0.127270393201483,
              -0.198354144974017,
              -0.323838519674126,
              -0.400716552481346,
              -0.129365899782541,
              -0.432827274814934,
              -0.223543022148906,
              -0.116790910171563,
              -0.36098822831344,
              -0.377251958014659,
              -0.339937354410758,
              -0.33918852710391,
              -0.107642410070225,
              -0.177702485212538,
              -0.10459193138324,
              -0.10689700993915,
              -0.110047525262159,
              -0.170019298704496,
              -0.194144357938735,
              -0.146671949644974,
              -0.0737838309522082,
              -0.176871603165879,
              -0.570951356496466,
              -0.460269917301053,
              -0.223516287028667,
              -0.18601704986023,
              -0.192577451756505,
              -0.129690978394747,
              -0.110543400716737,
              -0.247210910825388,
              -0.257978248215797,
              -0.200567569871587,
              -0.10125385946406,
              -0.188170632051054,
              -0.14970980815467,
              -0.117142361733864,
              -0.141210291588406,
              -0.318438658754822,
              -0.198064221591741,
              -0.077722223966855,
              -0.336576568559453,
              -0.203959350454742,
              -0.116779792531047,
              -0.257295474952703,
              -0.116057128753394,
              -0.161682707086584,
              -0.295701562560999,
              -0.14477721805353,
              -0.273547288678557,
              -0.180962520516731,
              -0.216377138735291,
              -0.168159752656659,
              -0.0789654432047578,
              -0.167485832687128,
              -0.100880412860403,
              -0.232753662103589,
              -0.17403823039306,
              -0.213665128821726,
              -0.229503007395255,
              -0.088730936465779,
              -0.279867118767905,
              -0.157781505318912,
              -0.162643609417113,
              -0.155046470246729,
              -0.126197108221293,
              -0.0700526215970328,
              -0.072634717020575,
              -0.157837144727808,
              -0.196861455451271,
              -0.112202161794232,
              -0.333069461214464,
              -0.14379607761218,
              -0.370774554046641,
              -0.168492165993094,
              -0.243778533607446,
              -0.169983028844864,
              -0.205266260823857,
              -0.170318811907684,
              -0.106565887483671,
              -0.264866803392906,
              -0.375691637356807,
              -0.143187493231021,
              -0.345339174703058,
              -0.323567236774382,
              -0.182564425836443,
              -0.196538459510583,
              -0.433398117555715,
              -0.191879381834779,
              -0.250797885839903,
              -0.140537922795657,
              -0.400726501957693,
              -0.213950745614578,
              -0.120243826621427,
              -0.18529622051052,
              -0.213270658297689,
              -0.183053189239709,
              -0.273953809625733,
              -0.333638628248896,
              -0.198174642296641,
              -0.155888701003694,
              -0.448942345127319,
              -0.2673905704671,
              -0.408690829245178,
              -0.105741401043513,
              -0.118348637543453,
              -0.150100602570922,
              -0.214281378879744,
              -0.138309732024114,
              -0.156173646444136,
              -0.21561882105395,
              -0.179246435628391,
              -0.0791147385692457,
              -0.0895660261446921,
              -0.108919364961808,
              -0.095895232964205,
              -0.135920388135337,
              -0.144182265024494,
              -0.335881314760549,
              -0.0853287496504224,
              -0.0770853212848307,
              -0.31960626357519,
              -0.232090101792246,
              -0.208717842153692,
              -0.260827414178063,
              -0.556303712418917,
              -0.106587554192282,
              -0.14537285307767,
              -0.126807709206729,
              -0.324925228150173,
              -0.135789665337265,
              -0.171900152059327,
              -0.220928797521472,
              -0.212871573061851,
              -0.1818566469781,
              -0.352157881261897,
              -0.468981366573727,
              -0.125737461357798,
              -0.102305101195906,
              -0.269151309245801,
              -0.179790704086748,
              -0.29195630111248,
              -0.248771761508137,
              -0.246680988090658,
              -0.272612842810976,
              -0.170162841298194,
              -0.182680978134145,
              -0.236877457891425,
              -0.259086576876102,
              -0.138656121621237,
              -0.211791255148899,
              -0.11493547655321,
              -0.192457246850131,
              -0.189834748155221,
              -0.382823571285905,
              -0.371890446610981,
              -0.198975363002702,
              -0.905993711862374,
              -0.732524192294832,
              -0.679669722481758,
              -0.500555283860715,
              -0.862202850400365,
              -0.751563085172111,
              -0.549117982614792,
              -0.760952687487025,
              -0.671533258400111,
              -0.713395055832255,
              -0.658883882553595,
              -0.609769613838513,
              -0.462735473515996,
              -0.849882492192963,
              -0.496931757236387,
              -0.490867664634094,
              -0.509308718179814,
              -0.550600408264462,
              -0.539704057272021,
              -0.439957699262974,
              -0.689742221053337,
              -0.54253907933231,
              -0.447450434340971,
              -0.460225951203102,
              -0.359527783669987,
              -0.703900003252428,
              -0.521421007387911,
              -0.579850196353903,
              -0.508942816297634,
              -0.48788622155088,
              -0.706436714244467,
              -0.400227113473761,
              -0.697156038492244,
              -0.587370718448096,
              -0.531552755710241,
              -0.471470662435574,
              -0.40746308075523,
              -0.588150250449873,
              -0.146581068139703,
              -0.426999754258855,
              -0.177529438648544,
              -0.343526972442895,
              -0.318916353888926,
              -0.298810131350206,
              -0.105174217969736,
              -0.0832073517532008,
              -0.173231345771104,
              -0.103278462685328,
              -0.199965639022125,
              -0.270046293813085,
              -0.158360207834648,
              -0.362323497246309,
              -0.218553109173627,
              -0.238991231411497,
              -0.149612206134265,
              -0.267541157588819,
              -0.202076898571019,
              -0.176251229747053,
              -0.341522830466819,
              -0.10906237932107,
              -0.212024215949834,
              -0.161266070085747,
              -0.234200082491508,
              -0.144810623463044,
              -0.223690436716017,
              -0.124562446368918,
              -0.26144841016658,
              -0.242142081125271,
              -0.204937872161861,
              -0.233697671179114,
              -0.29349460109859,
              -0.27281652561531,
              -0.312694720933798,
              -0.313367800663698,
              -0.273958646125915,
              -0.114624640795874,
              -0.298904912025664,
              -0.144517992052093,
              -0.440766179506596,
              -0.247785220900049,
              -0.391135006723371,
              -0.315259529190263,
              -0.075594411042613,
              -0.0939509366309473,
              -0.354477217153832,
              -0.134826569935538,
              -0.304117272459973,
              -0.394207368915416,
              -0.400760406042257,
              -0.0855665461069963,
              -0.309847562232962,
              -0.248899968515111,
              -0.324337598784054,
              -0.160566084181341,
              -0.195348533711867,
              -0.29899085393828,
              -0.271264399708492,
              -0.140459152913058,
              -0.264359041086321,
              -0.199884227911932,
              -0.226792605207104,
              -0.358993331197317,
              -0.200694443614624,
              -0.254992947130376,
              -0.357842241260899,
              -0.162919400499474,
              -0.296673448849947,
              -0.240185617465385,
              -0.0575719613373623,
              -0.140049502296657,
              -0.18282865397084,
              -0.291466927794976,
              -0.0970689592826201,
              -0.0762372306900599,
              -0.259282038557215,
              -0.100576743712815,
              -0.0764904897085628,
              -0.204953482794411,
              -0.11087047574317,
              -0.388109599741102,
              -0.122542464919788,
              -0.245384841151274,
              -0.124020773006279,
              -0.167397046689826,
              -0.126822910452638,
              -0.224477243079819,
              -0.17550148294484,
              -0.228929169526582,
              -0.177239997775076,
              -0.20914542255171,
              -0.247227936983058,
              -0.212175943783965,
              -0.32738615969419,
              -0.112408412423876,
              -0.22419176406365,
              -0.207906501220858,
              -0.160459634683148,
              -0.177037384141988,
              -0.165159643187942,
              -0.20024182349668,
              -0.200692667405313,
              -0.310772993399487,
              -0.152180886196319,
              -0.213060754077265,
              -0.185524120026793,
              -0.0945128465557442,
              -0.306189714695667,
              -0.212701801895475,
              -0.082997176000755,
              -0.201142771678573,
              -0.162559096567235,
              -0.26278047132076,
              -0.220351221138389,
              -0.159232056073768,
              -0.122399378375171,
              -0.1622729413256,
              -0.154695999391606,
              -0.135930066590927,
              -0.198593836654119,
              -0.287366802607366,
              -0.325682955033527,
              -0.177849798247799,
              -0.277374543032099,
              -0.170290353278958,
              -0.214868242025812,
              -0.278596454668398,
              -0.449802090342401,
              -0.178389320222752,
              -0.128869211418468,
              -0.215376959140268,
              -0.227072455406665,
              -0.370714747743038,
              -0.448791910154894,
              -0.183316039054217,
              -0.209433499966032,
              -0.251046090301349,
              -0.155273055646516,
              -0.258181250507321,
              -0.21048309765447,
              -0.176277710796125,
              -0.217031165994833,
              -0.206031845107749,
              -0.149079790105919,
              -0.169103639206382,
              -0.23174672393909,
              -0.30053607970315,
              -0.209523015943122,
              -0.141905435337821,
              -0.333965929232575,
              -0.281252331257485,
              -0.214442168121504,
              -0.0918589370907883,
              -0.135563269060252,
              -0.120091727450533,
              -0.232784106276217,
              -0.172951699782693,
              -0.332232700639022,
              -0.39607484515008,
              -0.229743106413759,
              -0.222975745225371,
              -0.141554909647855,
              -0.171896988329364,
              -0.203927637294234,
              -0.121372706508369,
              -0.20039411376717,
              -0.292232027835885,
              -0.116993229119913,
              -0.141232289352597,
              -0.174266001845597,
              -0.122239279142338,
              -0.207419715108233,
              -0.197512212244414,
              -0.0890338038761877,
              -0.125107347501881,
              -0.130693744057781,
              -0.266925452269597,
              -0.158536514987862,
              -0.104547551675039,
              -0.159188744728678,
              -0.225230858183589,
              -0.222588665518768,
              -0.210088663061926,
              -0.159762830914715,
              -0.161846217681933,
              -0.231222046930966,
              -0.128540031477805,
              -0.398631378770162,
              -0.325287682240481,
              -0.125998874918867,
              -0.0736954310921242,
              -0.126175026662225,
              -0.246843742549748,
              -0.149690617185252,
              -0.128671907641898,
              -0.0889342496597635,
              -0.122512300467184,
              -0.26246028374784,
              -0.174645054851654,
              -0.208253035721495,
              -0.0958873926013107,
              -0.307397846268541,
              -0.279877932601625,
              -0.200084900481625,
              -0.206073067532981,
              -0.292507923376267,
              -0.126450851210455,
              -0.141108642638738,
              -0.109483812073394,
              -0.119532769719224,
              -0.222064780091852,
              -0.0919220213157472,
              -0.220767652883861,
              -0.0949372662624269,
              -0.191838734919555,
              -0.191650160412974,
              -0.240943672541467,
              -0.129849233724681,
              -0.187276561662486,
              -0.0766092737827203,
              -0.103277618835731,
              -0.384264429952462,
              -0.0840970522738064,
              -0.108178744385601,
              -0.0726440815545324,
              -0.304884619136916,
              -0.136185919290929,
              -0.188471598667977,
              -0.121631924713963,
              -0.1428520700917,
              -0.216366771738536,
              -0.311110649226908,
              -0.357745773470892,
              -0.175052321116755,
              -0.21052987710751,
              -0.114779884910957,
              -0.161957830686456,
              -0.252770879420647,
              -0.207731903465448,
              -0.274128560328197,
              -0.205119611299731,
              -0.0843357114179001,
              -0.159858686658415,
              -0.147218288998762,
              -0.094446985730537,
              -0.104093081861952,
              -0.0985736516138088,
              -0.319633658055979,
              -0.153969327440788,
              -0.241406111290658,
              -0.10350797192044,
              -0.209012568931883,
              -0.180947257762552,
              -0.104112020202767,
              -0.207991241535752,
              -0.235276792637953,
              -0.245523697590684,
              -0.216548733426612,
              -0.129036361673934,
              -0.121753359443007,
              -0.132274278154651,
              -0.12016663576303,
              -0.142309602678622,
              -0.196181285192323,
              -0.229052169556681,
              -0.163814445977658,
              -0.161869777767774,
              -0.169521463144365,
              -0.202802038138732,
              -0.0972326853974166,
              -0.109584796411391,
              -0.247827703095765,
              -0.363377907154177,
              -0.168094689786267,
              -0.208204404596327,
              -0.159821821836282,
              -0.192186866663378,
              -0.23438454074563,
              -0.125578941701984,
              -0.107591057761664,
              -0.0900230847094365,
              -0.230194118092096,
              -0.285916167107632,
              -0.198842277345989,
              -0.231062737538971,
              -0.262778192581477,
              -0.226430404150237,
              -0.253650825923906,
              -0.246566559233766,
              -0.134589323757567,
              -0.31927446719825,
              -0.12529298321037,
              -0.3330621788205,
              -0.248539705946928,
              -0.266912808863931,
              -0.134373335462129,
              -0.209886643887716,
              -0.148689359506842,
              -0.248032362951988,
              -0.100139634055565,
              -0.20963654594106,
              -0.0925905042722206,
              -0.241364264216396,
              -0.162722268553659,
              -0.14584592705456,
              -0.162997338549773,
              -0.131942979552718,
              -0.338510724352245,
              -0.2492509159472,
              -0.148946757330954,
              -0.206969205838304,
              -0.143532354032066,
              -0.270270113253205,
              -0.139186940511278,
              -0.333889714395958,
              -0.259285881035112,
              -0.281607718786244,
              -0.0709551200113277,
              -0.0782356932528948,
              -0.194438628921546,
              -0.292844141425365,
              -0.181942625788157,
              -0.108497572540548,
              -0.239961852167332,
              -0.142513801220081,
              -0.117825534302733,
              -0.220729374471164,
              -0.244121254529025,
              -0.125596489022308,
              -0.136085226038776,
              -0.143077622054313,
              -0.336310296213148,
              -0.294651918636819,
              -0.176181372661355,
              -0.275815063546824,
              -0.275778982004195,
              -0.395197680561471,
              -0.382479091513808,
              -0.164046336391231,
              -0.163431333305907,
              -0.353251000852719,
              -0.268781936106203,
              -0.260436542505024,
              -0.14639578203481,
              -0.156633024036692,
              -0.241305238502251,
              -0.193793633072079,
              -0.159695672516973,
              -0.247976551314566,
              -0.482990124938755,
              -0.141067695914092,
              -0.311388749147909,
              -0.154105845799708,
              -0.117710443409377,
              -0.258461543919792,
              -0.096370455877954,
              -0.138202363542061,
              -0.231530997140816,
              -0.315912352177314,
              -0.213976636739742,
              -0.209721770278157,
              -0.262486299693141,
              -0.234417318803706,
              -0.16871030148986,
              -0.200039806681016,
              -0.215209532007712,
              -0.386736212144715,
              -0.203277130275106,
              -0.338626941140197,
              -0.247660067594476,
              -0.176748622140425,
              -0.122086559277178,
              -0.126880890628083,
              -0.116720358899503,
              -0.147705138871653,
              -0.116258282145901,
              -0.333079289334263,
              -0.280397206480089,
              -0.337608001433897,
              -0.187480350776962,
              -0.203573654381856,
              -0.104038644790829,
              -0.141189339144252,
              -0.164942760832673,
              -0.162755276595974,
              -0.420380053387745,
              -0.0998801769071684,
              -0.299997188839138,
              -0.0725459353246052,
              -0.133874437817549,
              -0.146527278555648,
              -0.351022948078964,
              -0.375962282546423,
              -0.170531594875732,
              -0.12159367248354,
              -0.210087896345417,
              -0.152941776666462,
              -0.140821455582131,
              -0.283846589273301,
              -0.242838974767177,
              -0.182165793549588,
              -0.0902883200136214,
              -0.36192570015868,
              -0.220594180082478,
              -0.175577884621542,
              -0.261205113167121,
              -0.147987456931832,
              -0.0941726941850446,
              -0.149510678761739,
              -0.270968627452497,
              -0.255385119101566,
              -0.358960500628351,
              -0.203995115338173,
              -0.141906192080378,
              -0.161556883087232,
              -0.157851794626013,
              -0.26507425123768,
              -0.360132855288552,
              -0.350090604667357,
              -0.212807217918776,
              -0.245250908750438,
              -0.190684745295439,
              -0.12848669165235,
              -0.323368217617867,
              -0.404243062783264,
              -0.16480430799402,
              -0.139788898768896,
              -0.227228283444113,
              -0.126621363960386,
              -0.16902417187693,
              -0.155313158293252,
              -0.0936243987734727,
              -0.371662206124623,
              -0.302719000021514,
              -0.209634425178307,
              -0.201958452805309,
              -0.184207029219807,
              -0.147332478423317,
              -0.166611660599777,
              -0.34127051086542,
              -0.282643766269647,
              -0.145951029104154,
              -0.251130831136933,
              -0.136188452162593,
              -0.181379900969024,
              -0.191343411192619,
              -0.205413924457551,
              -0.332967056624645,
              -0.110421530501707,
              -0.0874288059327822,
              -0.22002338795946,
              -0.12591605877625,
              -0.22997749061303,
              -0.220351976820457,
              -0.218363863207804,
              -0.212923535919252,
              -0.287667787648412,
              -0.356691879142745,
              -0.197211157459799,
              -0.430440795868534,
              -0.412762131670387,
              -0.274402294580283,
              -0.182099289918026,
              -0.186747973384753,
              -0.155897285656122,
              -0.332507087802417,
              -0.168162554941564,
              -0.211552640700136,
              -0.13760090600397,
              -0.133645885424075,
              -0.234012582357915,
              -0.362499847703766,
              -0.209186316926041,
              -0.226987264129842,
              -0.20660718304858,
              -0.253409906847787,
              -0.275802544122606,
              -0.224529042685591,
              -0.122076993436075,
              -0.200733819188382,
              -0.243376951136181,
              -0.0951950057041112,
              -0.166983235265472,
              -0.306486917108261,
              -0.159622703612236,
              -0.276480014712101,
              -0.139754261815841,
              -0.121462436335098,
              -0.0872078938615549,
              -0.115793322471799,
              -0.127367418209689,
              -0.0733205993683963,
              -0.146446310598338,
              -0.256640662142186,
              -0.186866048446982,
              -0.143787066572226,
              -0.160261434346206,
              -0.155733640980946,
              -0.250129508266783,
              -0.129221979254281,
              -0.221555212233075,
              -0.106417028473362,
              -0.0748571155814926,
              -0.126322301748651,
              -0.773170921573089,
              -0.093578153552903,
              -0.172665829743431,
              -0.145272066784896,
              -0.254587212259682,
              -0.227999793851486,
              -0.172815598987904,
              -0.147285289967841,
              -0.255721642435374,
              -0.107815992155578,
              -0.254446700825313,
              -0.266336745316397,
              -0.204478073051015,
              -0.160262466760123,
              -0.167405763552574,
              -0.0551069693183261,
              -0.216105045957747,
              -0.0955182728387698,
              -0.128725128430793,
              -0.193118441677158,
              -0.121209661809662,
              -0.249009178577553,
              -0.109720666259201,
              -0.308555676103742,
              -0.191468109361218,
              -0.164250785644704,
              -0.259269457739038,
              -0.145373322155551,
              -0.152971318376025,
              -0.0907171798931441,
              -0.269620489562918,
              -0.221770388348516,
              -0.24448097965078,
              -0.14912499033018,
              -0.334325370648033,
              -0.208142518105008,
              -0.266281218314806,
              -0.190439111811051,
              -0.273321092687313,
              -0.174199709153288,
              -0.149378920897936,
              -0.205855396457275
          ],
          "z": [
              0.356629405518354,
              0.33125442037575,
              0.350879772766057,
              0.308844479806744,
              0.167755527335522,
              0.408597211716323,
              0.423081482960159,
              0.291161107269871,
              0.236549867170246,
              0.399802732574136,
              0.356295382100073,
              0.370302940683954,
              0.816579632695921,
              0.63228466115285,
              0.731617356532082,
              0.456227875536354,
              0.207427612340772,
              0.434949133346118,
              0.464329305895303,
              0.345308708643339,
              0.455592379522458,
              0.49509378379163,
              0.300566397600405,
              0.688918662129028,
              0.467846648198793,
              0.278214182789994,
              0.193490891529659,
              0.88982466400106,
              1.0521913154467,
              0.553289224432478,
              0.582360609904596,
              0.52566947781249,
              0.498003303352532,
              0.420924144546366,
              0.405400236558111,
              0.176270318513352,
              0.308096905218934,
              0.261250865493674,
              0.343965699376045,
              0.408552580490775,
              0.459471103156139,
              0.066851487260328,
              0.329839027332427,
              0.226428310423174,
              0.381576352652341,
              0.337585125291754,
              0.970855345786852,
              0.227876106676666,
              0.432859288430598,
              0.2863759324874,
              0.128009823314966,
              0.362388284971862,
              0.411556981618658,
              0.275857503540033,
              0.438021856106342,
              0.518443448067568,
              0.237415331142598,
              0.432068309503497,
              0.657398411990166,
              0.338112090307007,
              0.347578124023521,
              0.479206758405663,
              0.684878414144986,
              0.241257220639474,
              0.205929467949494,
              0.0672699489850314,
              0.677498667113142,
              0.871614501271018,
              0.127496097671118,
              0.213244151932252,
              0.25856752366599,
              0.133556354467677,
              0.448404324055763,
              0.388143544239339,
              0.616633653864497,
              0.908074301242324,
              0.361942086547996,
              0.294632922824562,
              0.372981861882528,
              0.396408988615673,
              0.182743385665019,
              0.443365569115756,
              0.430782004351577,
              0.476750867382874,
              0.172943948196584,
              0.445913863937462,
              0.292443622828741,
              0.187795043127593,
              0.15679460183528,
              0.75201168159335,
              0.37914670336371,
              0.276328545557531,
              0.272049894906565,
              0.799980130236455,
              0.696592831805213,
              0.530158315547216,
              0.0944007822310023,
              0.724255235828167,
              0.731059405963484,
              0.119235176530312,
              0.187370486792975,
              0.331354487592396,
              0.631773770685722,
              0.317914434056236,
              0.291978738761895,
              0.219453801971252,
              0.628894872184524,
              0.280139353725237,
              0.546611423208371,
              0.320687110159701,
              0.513591697908528,
              0.331674945805708,
              0.35212014673119,
              0.191820873879099,
              0.108355214510534,
              0.565191137383362,
              0.552225863777103,
              0.347013640077948,
              0.18610590336314,
              0.270310072657751,
              0.254378185077128,
              0.0723487344972324,
              0.299018797208763,
              0.355464968260893,
              0.219896747563613,
              0.317373604855605,
              0.658961599906429,
              0.304906191801424,
              0.119202327154067,
              0.149408977412316,
              0.132479961136225,
              0.627731368377136,
              1.16982732468441,
              0.151345806263616,
              0.353352554772866,
              0.16765728964422,
              0.580463646715739,
              0.061412672262194,
              0.179269674558776,
              0.106285545906929,
              0.266022782509753,
              0.246902680239518,
              0.230621777468565,
              0.368905098860939,
              0.282083271692893,
              0.0541327037422516,
              0.269398802557156,
              0.205217101963481,
              0.804471508752788,
              0.231939245822142,
              0.529506545734286,
              0.211194229151656,
              0.214594479120762,
              0.0646363485574672,
              0.0825266944759409,
              0.457232167500669,
              0.271402983257738,
              0.20407610391063,
              0.800347823012907,
              0.197808246775405,
              0.273375932259564,
              0.567928191707382,
              0.301581670644769,
              0.183646985482543,
              0.446612590302483,
              1.07421459757763,
              1.2036941929637,
              1.08051203058029,
              0.834636599315318,
              0.45175128458804,
              0.163678334353868,
              0.0744060249302059,
              0.10513037935789,
              0.559878265579042,
              0.927980976030167,
              0.320391255939513,
              0.602004730701781,
              0.658465887148676,
              0.343509927911441,
              0.27503796856911,
              0.285020501557962,
              0.708894337924541,
              0.406101978147453,
              0.439396451659245,
              0.170939320818285,
              0.162597508703936,
              0.167217269197597,
              0.546599892904343,
              0.106251764680685,
              0.232248837778544,
              0.796877642017226,
              0.717757299314122,
              0.653333040036201,
              0.160167243460548,
              0.0999608388513068,
              0.222341101753193,
              0.928678660520407,
              0.652535652269119,
              0.283526691771033,
              0.663879639085459,
              0.381585837105897,
              0.678914903017466,
              0.180171192172431,
              0.679066601379568,
              0.106535674502517,
              0.296826560187255,
              0.230271193003541,
              0.791847309428573,
              0.518676423948287,
              0.373889041031194,
              0.068606511474769,
              0.315175230966354,
              0.0818361784267769,
              0.34022708735559,
              2.3260985256128,
              1.41371621418199,
              0.589759272325693,
              0.164134221476758,
              0.656517023990443,
              0.34863859928756,
              0.211572502483884,
              0.346239421648074,
              0.101696571874495,
              0.0827422954981864,
              2.02857251566867,
              0.334813155247051,
              0.569060851757473,
              1.14046232089514,
              0.756720412592369,
              0.431774021081958,
              0.444696331548458,
              0.18938635892968,
              0.100905824789118,
              0.410402065459001,
              0.381223981590928,
              0.290105032855166,
              0.743910959025357,
              0.720994548933596,
              0.419106793396221,
              0.276716942360847,
              0.390657432907104,
              0.263208887083734,
              0.207203044236789,
              0.288020491391413,
              0.207535027848558,
              0.339886595032726,
              0.946359742172842,
              0.224781589757748,
              0.151996701945858,
              0.343652686765801,
              0.681983610682463,
              0.889262133850968,
              0.157646606002338,
              0.975839051341436,
              0.411566927940212,
              0.123741923738172,
              0.782146641157068,
              0.825996903066525,
              0.725389282850356,
              0.723370294946999,
              0.0990757412024208,
              0.2879716894766,
              0.0908510417127662,
              0.0970659936490957,
              0.105560411879212,
              0.267256284900515,
              0.332302260543067,
              0.204307171138816,
              0.00778625290652139,
              0.285731465614597,
              1.34824914847214,
              1.04982989370115,
              0.41149484471907,
              0.310389415555576,
              0.328077568683292,
              0.158523082834421,
              0.106897391093524,
              0.47538028049672,
              0.504411171522998,
              0.349620522142953,
              0.0818509334585267,
              0.316195903049282,
              0.212497844111206,
              0.124689507308393,
              0.189581450738873,
              0.667424507700789,
              0.342870995451445,
              0.0184049466727915,
              0.716327933300857,
              0.358765439676819,
              0.12371194835999,
              0.502570278507589,
              0.121763502554218,
              0.244779169712709,
              0.606120757486291,
              0.199198596533895,
              0.546388412568744,
              0.296761395438834,
              0.392246275772948,
              0.262242577545046,
              0.0217569139148951,
              0.260425554776417,
              0.0808440468660673,
              0.436400651925202,
              0.278092127009139,
              0.384934155663011,
              0.427636237922001,
              0.0480866331759529,
              0.563427936081019,
              0.234260750972558,
              0.24736995421523,
              0.226886550438606,
              0.149102911385547,
              -0.00227383235492975,
              0.00468801235582255,
              0.234410765925919,
              0.339628097835438,
              0.111369742087398,
              0.706872071795067,
              0.196553246044584,
              0.80853252892179,
              0.263138830257841,
              0.466125906331393,
              0.267158494118603,
              0.362289130922966,
              0.26806383228641,
              0.0961732214090497,
              0.522984091403198,
              0.821789967095101,
              0.194912381064772,
              0.739953668692766,
              0.681252177830104,
              0.301080451959938,
              0.338757236301519,
              0.977378157324639,
              0.326195432822629,
              0.485051481183076,
              0.187768610252501,
              0.889288959625357,
              0.38570423555258,
              0.133051675772889,
              0.308445915733734,
              0.383870584384322,
              0.302398255664172,
              0.547484474193773,
              0.708406659739441,
              0.343168711714507,
              0.229157372689075,
              1.01928849786258,
              0.529788671240353,
              0.91076237586534,
              0.0939502413788908,
              0.127941867692958,
              0.213551503869466,
              0.386595688837889,
              0.181760963131492,
              0.229925642478527,
              0.390201699925449,
              0.292134488007697,
              0.0221594440205309,
              0.0503382016544598,
              0.102518666501301,
              0.0674030067030806,
              0.175318815036349,
              0.197594484400556,
              0.714453390269489,
              0.0389136583627334,
              0.0166877299008288,
              0.670572603378747,
              0.434611560863087,
              0.371595283207561,
              0.512093091719906,
              1.30875617601399,
              0.0962316391806669,
              0.200804547462175,
              0.150749213533052,
              0.684913593667258,
              0.174966360277303,
              0.272327441009095,
              0.404518456482,
              0.382794570921407,
              0.299172138868015,
              0.75833826275463,
              1.07331769995688,
              0.147863611684902,
              0.0846852910209342,
              0.534535974473903,
              0.293601944420613,
              0.596022784976047,
              0.47958864552107,
              0.473951503018455,
              0.543868959971684,
              0.267643304387709,
              0.301394700221208,
              0.447519228578881,
              0.507399446840465,
              0.182694898633101,
              0.379881818170428,
              0.118739304313534,
              0.327753472259893,
              0.320682692264059,
              0.841019084674968,
              0.811541198034473,
              0.345327614581323,
              2.25159022112015,
              1.78388176764196,
              1.64137556599161,
              1.1584472838824,
              2.13352131690036,
              1.83521442346397,
              1.28938201401609,
              1.86053066569737,
              1.61943803459188,
              1.73230579709919,
              1.58533279218741,
              1.45291091933211,
              1.05647752544147,
              2.10030317173084,
              1.1486775327594,
              1.13232752856363,
              1.18204829020452,
              1.29337892949572,
              1.26400019204412,
              0.995064099059039,
              1.66853303285564,
              1.27164397745783,
              1.015266008561,
              1.04971135232438,
              0.778208990858139,
              1.70670523990115,
              1.21470543981629,
              1.37224219715209,
              1.18106174568727,
              1.12428896284292,
              1.71354471912473,
              0.887942508582621,
              1.68852216464873,
              1.39251902599668,
              1.24202265583603,
              1.08002933852425,
              0.907452120848058,
              1.39462079988696,
              0.204062136458452,
              0.960126892607781,
              0.28750512139578,
              0.735067609639834,
              0.668712469141871,
              0.614502079487728,
              0.0924210025884876,
              0.0331939461493433,
              0.275916604994601,
              0.0873096679029828,
              0.347997596412803,
              0.536949031527932,
              0.235821048478043,
              0.785746792752153,
              0.398113126451187,
              0.453218383949467,
              0.212234689580464,
              0.53019468418135,
              0.353689973615242,
              0.284058815035857,
              0.729664042796979,
              0.102904261763008,
              0.380509926994375,
              0.2436558331876,
              0.440300490031629,
              0.199288664186475,
              0.411964387040667,
              0.144695536713386,
              0.513767420870811,
              0.461713703763836,
              0.361403729535882,
              0.438945888839928,
              0.600170348820592,
              0.544418129472197,
              0.651937704705985,
              0.653752462020837,
              0.547497514363746,
              0.117901229061397,
              0.614757627109287,
              0.198499671486222,
              0.997243923188113,
              0.476928735104227,
              0.863428373778508,
              0.65885293976336,
              0.0126679382659593,
              0.0621607956599053,
              0.764591655314993,
              0.172369662817043,
              0.628811191353765,
              0.871712075566283,
              0.889380371805418,
              0.0395548050795978,
              0.644261196486587,
              0.479934317205101,
              0.683329227591124,
              0.241768531455157,
              0.335548958810126,
              0.61498934366179,
              0.540233288185434,
              0.187556230924634,
              0.521615062862969,
              0.34777809580809,
              0.420328452560721,
              0.776768000302144,
              0.349962599081255,
              0.496362203858189,
              0.773664432048088,
              0.248113542027867,
              0.608741156933373,
              0.456438687179178,
              -0.035924183857543,
              0.186451731086617,
              0.301792863756616,
              0.59470333682127,
              0.0705676071617729,
              0.0144011083578713,
              0.507926450551638,
              0.080025294224443,
              0.0150839452283986,
              0.361445818917497,
              0.107779250656897,
              0.855271272609685,
              0.139249263489234,
              0.470456832127505,
              0.143235077196569,
              0.260186170003852,
              0.150790199126561,
              0.414085774063113,
              0.282037347989442,
              0.426089056476101,
              0.286724731021492,
              0.372748125316039,
              0.475426186416631,
              0.380919015523749,
              0.69154875637156,
              0.111925834957549,
              0.413316065646986,
              0.36940774608931,
              0.241481522358126,
              0.28617844422009,
              0.25415368352276,
              0.348742244889324,
              0.349957810066379,
              0.646756343650049,
              0.219160363798612,
              0.383304640704083,
              0.309060378323876,
              0.0636758169880096,
              0.63439890933094,
              0.382336833966416,
              0.0326272703645708,
              0.35117138103882,
              0.247142090701145,
              0.517358923654201,
              0.402961195254949,
              0.238171725372767,
              0.138863473601402,
              0.246370559046169,
              0.22594161105071,
              0.175344910084674,
              0.344298943383629,
              0.583648580831026,
              0.686956576605447,
              0.28836887482692,
              0.556707454318704,
              0.267987102142333,
              0.388177989031806,
              0.560001972013369,
              1.02160654258844,
              0.289823533773067,
              0.15630743502175,
              0.389549591924656,
              0.421082984563626,
              0.808371279188487,
              1.01888289514645,
              0.303106951235287,
              0.373524839532291,
              0.485720689958766,
              0.227497469908374,
              0.504958506225126,
              0.376354764425479,
              0.284130213230416,
              0.39400966382438,
              0.364353298981533,
              0.210799189684888,
              0.264787484105751,
              0.433685745624429,
              0.619155580788426,
              0.373766192476085,
              0.19145569705485,
              0.709289128528658,
              0.567162745474942,
              0.387029208731107,
              0.0565203472857812,
              0.174355950720287,
              0.132641586045474,
              0.436482735492004,
              0.275162623585724,
              0.704615998245967,
              0.876747164288495,
              0.428283592805476,
              0.410037436112126,
              0.190510609821272,
              0.272318910961556,
              0.358679934665375,
              0.136095361299893,
              0.349152849859398,
              0.596766199264087,
              0.124287416010694,
              0.189640761102418,
              0.278706244313886,
              0.138431814109994,
              0.368095273555356,
              0.341382668056593,
              0.0489032241740966,
              0.146164698943338,
              0.161226739238311,
              0.528534619731012,
              0.236296407758292,
              0.0907313851601901,
              0.238054949340411,
              0.416117670822732,
              0.408993791952626,
              0.375291290025268,
              0.239602800299494,
              0.245220026918453,
              0.432271111672268,
              0.155419900189422,
              0.883640089274362,
              0.685890842249356,
              0.148568434830032,
              0.00754790923697828,
              0.149043375094286,
              0.474390321529898,
              0.212446101426672,
              0.155775464653497,
              0.0486348061331804,
              0.139167934103457,
              0.516495634040402,
              0.279728246886391,
              0.370342072279719,
              0.067381867519591,
              0.637656273223777,
              0.56345709233543,
              0.348319149115096,
              0.364464442868955,
              0.597510068716402,
              0.149787053137584,
              0.189307384878972,
              0.104040528591474,
              0.131134524420344,
              0.407581292261421,
              0.0566904349494119,
              0.404083978370622,
              0.0648201372416949,
              0.326085840625075,
              0.325577406111286,
              0.458482554990476,
              0.158949770795526,
              0.313785310803567,
              0.01540421080451,
              0.0873073927160148,
              0.844903927270346,
              0.035592756358702,
              0.100521805582016,
              0.0047132610087598,
              0.630880111175814,
              0.176034740038284,
              0.317007369128745,
              0.136794265328418,
              0.194008013322569,
              0.392218324280193,
              0.647666731165071,
              0.773404335628917,
              0.280826318037327,
              0.376480891169188,
              0.118319798186154,
              0.245520957859309,
              0.490371065734141,
              0.368936995686778,
              0.547955636972095,
              0.36189373453112,
              0.0362362290533331,
              0.239861246519642,
              0.205780211099217,
              0.0634982430558324,
              0.0895060438209097,
              0.0746245580597475,
              0.670646464367558,
              0.223982358409955,
              0.459729382172288,
              0.0879284706164554,
              0.37238992543618,
              0.29672024400675,
              0.0895571053682979,
              0.369636222894488,
              0.443203515523909,
              0.470831216807267,
              0.392708929315212,
              0.156758105477732,
              0.137121677599239,
              0.16548817467642,
              0.132843553809482,
              0.192545412887254,
              0.337794223038831,
              0.426420689111036,
              0.250526763309838,
              0.245283549613045,
              0.265914020850347,
              0.355645094645243,
              0.0710090454509685,
              0.104312802525636,
              0.477043275584355,
              0.788589692349559,
              0.262067155058342,
              0.370210953058315,
              0.239761851600058,
              0.327024473301961,
              0.440797826307084,
              0.147436211048458,
              0.0989372851273743,
              0.0515705227849875,
              0.429499610323145,
              0.579737377941707,
              0.3449687890837,
              0.43184158174943,
              0.517352779718201,
              0.419351886207291,
              0.492743577165596,
              0.473642979977497,
              0.171729999761142,
              0.669678014111913,
              0.146665209870817,
              0.706852437007197,
              0.478962977404132,
              0.528500530585405,
              0.171147652200136,
              0.374746606003668,
              0.209746510850358,
              0.477595079411804,
              0.0788467593308053,
              0.374072292013868,
              0.0584927984454781,
              0.459616554106387,
              0.247582034949631,
              0.202080049340913,
              0.248323678569798,
              0.16459492751037,
              0.72154280342264,
              0.480880541539633,
              0.210440506767013,
              0.36688061063105,
              0.195842194626972,
              0.537552493418284,
              0.184126092324979,
              0.709083638114806,
              0.5079368106391,
              0.568120941196447,
              0.000159483530585376,
              0.01978936236888,
              0.333095673856353,
              0.598416579694048,
              0.299403954903385,
              0.101381429933586,
              0.455835371266644,
              0.193095972918011,
              0.126531476931881,
              0.403980772128691,
              0.46704995035138,
              0.147483522126922,
              0.175763250929664,
              0.194616146439415,
              0.715610009900801,
              0.603290707932312,
              0.283870466387646,
              0.552502786316468,
              0.55240550327479,
              0.874382153454273,
              0.840090298442876,
              0.251151986155785,
              0.249493815068215,
              0.761285531384673,
              0.53354007075371,
              0.511039223661926,
              0.203562568132059,
              0.231164216170971,
              0.459457408998087,
              0.331356636289371,
              0.239421727852736,
              0.477444600095957,
              1.11108810899698,
              0.189196984335367,
              0.648416544067579,
              0.22435043915798,
              0.126221168908459,
              0.505714233218515,
              0.0686843025445694,
              0.181471476270523,
              0.433104103111981,
              0.660613080855752,
              0.385774043194519,
              0.374302073839527,
              0.516565778222346,
              0.440886202494951,
              0.26372696710226,
              0.348197567226838,
              0.389098174952768,
              0.851568345488346,
              0.356926037884823,
              0.721856147082648,
              0.476591296808768,
              0.285399884219975,
              0.138020050866932,
              0.15094652525381,
              0.123551703424952,
              0.207092855543575,
              0.122305852255512,
              0.706898570367977,
              0.564857158371433,
              0.719108882229381,
              0.314334766937444,
              0.357725526070025,
              0.0893592706102001,
              0.189524958766817,
              0.253568925397975,
              0.247671031220917,
              0.942278857606395,
              0.0781472110647869,
              0.61770262344336,
              0.00444863918050779,
              0.169802524558278,
              0.203917109002135,
              0.75527825633325,
              0.822519680553652,
              0.268637537644909,
              0.136691129679124,
              0.375289222804504,
              0.221211876398313,
              0.188533071244855,
              0.574157382962414,
              0.463592668139291,
              0.300005659737902,
              0.0522856501124708,
              0.784674252393955,
              0.403616261068713,
              0.282243342161459,
              0.513111443592288,
              0.20785404139135,
              0.0627586982939389,
              0.211960951516807,
              0.539435827139954,
              0.497419577779555,
              0.776679482534434,
              0.358861868942086,
              0.191457737383848,
              0.244439923092934,
              0.234450264975954,
              0.52354341220433,
              0.779840384728765,
              0.752764472377194,
              0.38262105660883,
              0.470095723638695,
              0.322974454234136,
              0.155276085372072,
              0.680715582455088,
              0.898770309601941,
              0.253195628906422,
              0.185749091952985,
              0.421503128059642,
              0.150246789549879,
              0.264573224321944,
              0.227605594649435,
              0.0612803844112765,
              0.810925816120914,
              0.625041169730583,
              0.374066574014129,
              0.35337062018624,
              0.305509238584966,
              0.206088088582796,
              0.258068612322965,
              0.728983738782494,
              0.570914332031912,
              0.202363425447537,
              0.485949168167827,
              0.176041569165912,
              0.297886736457478,
              0.324750348978624,
              0.362687261556649,
              0.706595968578475,
              0.106568804665551,
              0.0445758293221522,
              0.402077291561103,
              0.148345145977426,
              0.428915539395482,
              0.402963232724658,
              0.397602881549242,
              0.382934673158009,
              0.584460096585601,
              0.77056282613736,
              0.340570964259436,
              0.969404627702853,
              0.92173941993443,
              0.548693679159716,
              0.299826352671473,
              0.312360131287755,
              0.229180518625725,
              0.705355800812812,
              0.262250133064555,
              0.37923846598333,
              0.179849826682313,
              0.169186301680869,
              0.439794952241886,
              0.786222268789286,
              0.372858384712743,
              0.420853291875066,
              0.365904524921422,
              0.492094011243087,
              0.552469031449594,
              0.414225436140733,
              0.137994259449745,
              0.350068763488428,
              0.465043159823259,
              0.0655150542275206,
              0.259070451796996,
              0.635200226364106,
              0.239224989119202,
              0.554295627398438,
              0.185655703813175,
              0.136337290825005,
              0.0439802062787153,
              0.121052228156905,
              0.152258300736526,
              0.00653728808430338,
              0.203698803226058,
              0.500804772453913,
              0.31267848522617,
              0.196528950482046,
              0.240947134684135,
              0.228739299914005,
              0.483249401821568,
              0.157258567528118,
              0.406207395592052,
              0.0957718678013861,
              0.0106800425207195,
              0.149440458126971,
              1.89347346384931,
              0.0611556980649527,
              0.274391860893277,
              0.200532807497467,
              0.495268261652274,
              0.423583274130111,
              0.274795668673953,
              0.205960859086873,
              0.498326911865723,
              0.0995437531557282,
              0.494889414775726,
              0.526947348264995,
              0.360164019345985,
              0.240949918278149,
              0.260209672405917,
              -0.0425702944130668,
              0.391512659328371,
              0.0663866469545221,
              0.155918958524519,
              0.329536185504084,
              0.135655760244504,
              0.480228769334421,
              0.10467913475825,
              0.640778013590402,
              0.325086560133947,
              0.251703222156176,
              0.507892530154397,
              0.200805812189782,
              0.221291526744537,
              0.0534419419584991,
              0.535800978268624,
              0.406787553353655,
              0.468019841089492,
              0.210921058512558,
              0.710258254337959,
              0.370044094723673,
              0.52679763638417,
              0.322312177325823,
              0.545778543022143,
              0.278527505981791,
              0.211605706013927,
              0.363877558196424
          ],
          "text": [
              "ABCA2",
              "ABCB1",
              "ABCD1",
              "ABHD17AP6",
              "ABRACL",
              "AC004687.1",
              "AC004918.1",
              "AC005332.3",
              "AC005332.5",
              "AC005632.3",
              "AC005674.2",
              "AC005831.1",
              "AC008033.3",
              "AC008750.1",
              "AC008750.2",
              "AC010175.1",
              "AC010186.3",
              "AC010894.5",
              "AC011195.1",
              "AC011477.1",
              "AC012085.1",
              "AC016957.2",
              "AC018521.5",
              "AC020659.1",
              "AC020910.5",
              "AC021188.1",
              "AC022167.3",
              "AC022413.1",
              "AC024051.10",
              "AC025857.2",
              "AC025884.1",
              "AC026124.2",
              "AC026979.2",
              "AC027559.1",
              "AC037459.2",
              "AC055811.4",
              "AC067852.3",
              "AC069281.2",
              "AC078819.1",
              "AC079781.4",
              "AC090181.1",
              "AC090589.3",
              "AC092652.2",
              "AC092747.4",
              "AC093010.3",
              "AC099804.1",
              "AC104809.2",
              "AC108693.1",
              "AC116348.6",
              "AC116366.1",
              "AC125232.2",
              "AC130689.1",
              "AC133644.2",
              "AC135048.1",
              "AC138207.4",
              "AC138207.9",
              "AC139256.3",
              "AC139495.1",
              "AC139495.2",
              "AC146949.1",
              "AC242842.2",
              "AC243829.1",
              "AC245014.3",
              "ACAA2",
              "ACAD11",
              "ACBD5",
              "ACCS",
              "ACER3",
              "ACIN1",
              "ACP5",
              "ACSS2",
              "ACTR5",
              "ACVR1B",
              "ADA2",
              "ADAM15",
              "ADAP2",
              "ADGRG5",
              "AGAP2",
              "AGAP9",
              "AGFG2",
              "AHCYL1",
              "AHDC1",
              "AIMP2",
              "AJM1",
              "AKNA",
              "AKR1C3",
              "AL021707.8",
              "AL031432.2",
              "AL121753.2",
              "AL121933.2",
              "AL139246.5",
              "AL356273.6",
              "AL356356.2",
              "AL359962.1",
              "AL359962.2",
              "AL365361.1",
              "AL445363.3",
              "AL451085.1",
              "AL499604.2",
              "AL590064.1",
              "AL606834.2",
              "AL645933.3",
              "AL645933.5",
              "AL662844.4",
              "AL691432.2",
              "ALAD",
              "ALDH1A1",
              "ALDH9A1",
              "AMDHD2",
              "ANKRD36",
              "ANKRD36C",
              "ANKRD44",
              "ANKRD49",
              "ANKRD54",
              "AP000347.1",
              "AP002358.2",
              "AP003733.3",
              "AP1B1",
              "AP1S1",
              "AP1S2",
              "APOBEC3D",
              "ARFGAP3",
              "ARHGAP12",
              "ARHGAP25",
              "ARHGAP4",
              "ARID4A",
              "ARMC10",
              "ARMCX6",
              "ARMH3",
              "ARSD",
              "ASB8",
              "ASGR1",
              "ASGR2",
              "ASH1L-AS1",
              "ASMTL-AS1",
              "ASPSCR1",
              "ASXL2",
              "ATF2",
              "ATG16L1",
              "ATP11B",
              "ATP1B3",
              "ATP2A3",
              "ATP5F1E",
              "ATP5MC2P4",
              "ATP5PB",
              "ATP6V0A2",
              "ATP6V1D",
              "ATXN7L3B",
              "AUTS2",
              "AXIN1",
              "B3GAT1",
              "BAG5",
              "BCAS2",
              "BDP1",
              "BLOC1S1",
              "BMF",
              "BMI1",
              "BNIP1",
              "BTG1P1",
              "BUB3",
              "C14orf119",
              "C16orf54",
              "C16orf70",
              "C16orf91",
              "C1orf21",
              "C1QA",
              "C1QB",
              "C1QC",
              "C2",
              "C2CD4D-AS1",
              "C2orf49",
              "C2orf69",
              "C6orf47",
              "CA11",
              "CACNA2D2",
              "CAMK1D",
              "CAMP",
              "CARNS1",
              "CASP1",
              "CBFB",
              "CBLB",
              "CBWD1",
              "CBWD2",
              "CBX7",
              "CCDC144B",
              "CCDC159",
              "CCDC186",
              "CCDC65",
              "CCDC88B",
              "CCDC88C",
              "CCL4",
              "CCL5",
              "CCNB2",
              "CCNJ",
              "CCNT1",
              "CCSER2",
              "CD1D",
              "CD226",
              "CD244",
              "CD247",
              "CD300LB",
              "CD86",
              "CD99L2",
              "CDC20",
              "CDK13",
              "CDK17",
              "CDKN1B",
              "CDKN1C",
              "CEBPA",
              "CENPW",
              "CEP104",
              "CEP85L",
              "CEPT1",
              "CERS5",
              "CES1",
              "CES1P1",
              "CFP",
              "CHST12",
              "CHST13",
              "CHST2",
              "CHST7",
              "CIAO2A",
              "CIC",
              "CLASRP",
              "CLC",
              "CLCF1",
              "CLDND2",
              "CLEC12A",
              "CLEC12B",
              "CLTA",
              "CMC1",
              "CMTM7",
              "CNN2",
              "CNOT6L",
              "COA8",
              "COG5",
              "COL18A1",
              "COL6A2",
              "COMMD3",
              "COMMD5",
              "COMMD9",
              "COMT",
              "COPG2",
              "COQ10A",
              "COX15",
              "COX7B",
              "CPA3",
              "CRBN",
              "CREBRF",
              "CREBZF",
              "CREG1",
              "CRIP2",
              "CRIPT",
              "CRLS1",
              "CRY1",
              "CS",
              "CST7",
              "CTNND1",
              "CTSB",
              "CTSZ",
              "CWF19L1",
              "DBI",
              "DCAF1",
              "DCAF15",
              "DCAF16",
              "DCAF6",
              "DCP2",
              "DDB1",
              "DDOST",
              "DECR1",
              "DEFA1B",
              "DEFA3",
              "DENND11",
              "DENND1A",
              "DFFB",
              "DFFBP1",
              "DGKZP1",
              "DHRS13",
              "DHX35",
              "DNAAF2",
              "DNAJA2",
              "DNAJB9",
              "DNASE1",
              "DOK2",
              "DOP1B",
              "DPYD",
              "DROSHA",
              "DSTYK",
              "DUSP2",
              "DUSP3",
              "DYM",
              "DYNLL1",
              "DYNLL2",
              "DYRK1B",
              "E2F2",
              "ECH1",
              "EDRF1",
              "EGLN1",
              "EIF4EBP1",
              "EIF4HP1",
              "ELMSAN1",
              "ELOB",
              "EMC7",
              "ENO2",
              "ENO3",
              "EOMES",
              "EPHA4",
              "EPM2AIP1",
              "ERLIN1",
              "ERN1",
              "ERO1B",
              "ERP44",
              "ESCO1",
              "EWSR1",
              "EXOC2",
              "EXOC8",
              "EZH2",
              "FAM172A",
              "FAM198B-AS1",
              "FAM199X",
              "FAM20C",
              "FAM229A",
              "FAM89A",
              "FBP1",
              "FBXL14",
              "FBXO33",
              "FBXO34",
              "FCGR3A",
              "FCN1",
              "FCRL3",
              "FCRL6",
              "FGD2",
              "FGD3",
              "FGD6",
              "FGFBP2",
              "FH",
              "FHL1",
              "FKBP1C",
              "FLVCR2",
              "FLYWCH1",
              "FOXN2",
              "FOXO1",
              "FOXP1",
              "FP565260.6",
              "FUCA2",
              "FXYD6",
              "GALK1",
              "GANC",
              "GASK1B",
              "GATA1",
              "GATA3",
              "GATAD2B",
              "GCC1",
              "GDI2",
              "GFI1",
              "GHITM",
              "GIMAP8",
              "GK5",
              "GLCCI1",
              "GLE1",
              "GLRX3",
              "GLUD1P3",
              "GMCL1",
              "GMDS",
              "GNL2",
              "GNLY",
              "GNPAT",
              "GOLGA2",
              "GOLGA7B",
              "GPBAR1",
              "GPR183",
              "GPX1",
              "GSTM1",
              "GTF3C1",
              "GTF3C6",
              "GXYLT1",
              "GZMB",
              "H3P47",
              "HADHA",
              "HADHB",
              "HAVCR2",
              "HCCS",
              "HDAC9",
              "HDC",
              "HECA",
              "HECTD3",
              "HEXB",
              "HIGD2A",
              "HIVEP1",
              "HIVEP2",
              "HK1",
              "HLA-DQA1",
              "HLA-F",
              "HOXB-AS1",
              "HPS4",
              "HSD17B4",
              "HUS1",
              "HVCN1",
              "IAH1",
              "ID2",
              "IFI27L2",
              "IFNG",
              "IGHA1",
              "IGHA2",
              "IGHG1",
              "IGHG3",
              "IGHG4",
              "IGHV1-18",
              "IGHV1-2",
              "IGHV3-20",
              "IGHV3-21",
              "IGHV3-33",
              "IGHV3-48",
              "IGHV3-53",
              "IGHV3-66",
              "IGHV3-72",
              "IGHV3-74",
              "IGHV4-39",
              "IGHV4-61",
              "IGHV6-1",
              "IGKC",
              "IGKV1-12",
              "IGKV1-16",
              "IGKV1-27",
              "IGKV1-39",
              "IGKV1-5",
              "IGKV1-6",
              "IGKV1D-12",
              "IGKV2-26",
              "IGKV2-28",
              "IGKV2-29",
              "IGKV2-30",
              "IGKV2D-30",
              "IGKV3-15",
              "IGKV3-20",
              "IGKV3D-11",
              "IGKV3D-20",
              "IGLV1-47",
              "IGLV2-11",
              "IGLV3-19",
              "IGLV7-43",
              "IGLV7-46",
              "IKZF1",
              "IKZF2",
              "IKZF3",
              "IL18",
              "IL2RB",
              "IL7R",
              "IMPAD1",
              "INAFM1",
              "ING3",
              "IPO7",
              "IQCN",
              "IRF8",
              "ISOC2",
              "ITM2A",
              "ITPRIPL1",
              "JADE2",
              "JAK1",
              "JAK2",
              "KAT6A",
              "KCNA3",
              "KCNE3",
              "KCNK6",
              "KCNQ1",
              "KCTD10",
              "KCTD3",
              "KDELR1",
              "KDM2B-DT",
              "KIAA1143",
              "KIF21A",
              "KIF21B",
              "KIF22",
              "KIFC1",
              "KIR2DL1",
              "KIR2DL3",
              "KIR2DS4",
              "KIR3DL1",
              "KLF12",
              "KLF16",
              "KLF2",
              "KLHL28",
              "KLRB1",
              "KLRC4",
              "KLRG1",
              "KLRK1",
              "KPNA4",
              "KRAS",
              "KRT17P8",
              "LAIR1",
              "LGR6",
              "LHFPL2",
              "LILRB4",
              "LIMD1",
              "LINC002481",
              "LINC00299",
              "LINC00402",
              "LINC00653",
              "LINC00852",
              "LINC00869",
              "LINC00987",
              "LINC01578",
              "LINC01619",
              "LINC01637",
              "LINC02084",
              "LINC02384",
              "LINC02705",
              "LINC02723",
              "LMO2",
              "LNPEP",
              "LONRF3",
              "LRIG1",
              "LSM14A",
              "LTB4R",
              "LTN1",
              "LYPD2",
              "M6PR",
              "MADD",
              "MAGEE1",
              "MAGT1",
              "MAML1",
              "MAN2B1",
              "MARCHF7",
              "MATK",
              "MBTD1",
              "ME1",
              "ME2",
              "MECP2",
              "MED30",
              "MEF2C",
              "MFSD14A",
              "MFSD2B",
              "MGAT1",
              "MGME1",
              "MGST2",
              "MIF4GD",
              "MILR1",
              "MINK1",
              "MIR103A2",
              "MIR4518",
              "MIR4639",
              "MIR5010",
              "MIR573",
              "MIR6731",
              "MIR6752",
              "MIR6774",
              "MIR6802",
              "MIR6812",
              "MIR6819",
              "MKRN2",
              "MLST8",
              "MMP23A",
              "MMP24OS",
              "MOAP1",
              "MPND",
              "MPP1",
              "MRPL27",
              "MRPL30",
              "MRPL33",
              "MRPL37",
              "MRPL40",
              "MRPL47",
              "MRPL55",
              "MS4A2",
              "MSR1",
              "MSRB2",
              "MT1E",
              "MT1XP1",
              "MTCH2",
              "MTERF2",
              "MYBL2",
              "N4BP2L2-IT2",
              "NAA38",
              "NAA80",
              "NADK2",
              "NAIPP1",
              "NAIPP3",
              "NAP1L5",
              "NAPSB",
              "NBR2",
              "NCBP2",
              "NCEH1",
              "NCR1",
              "NDOR1",
              "NDUFA7",
              "NDUFB1",
              "NDUFB10",
              "NDUFV3",
              "NFAT5",
              "NFATC2",
              "NFE2",
              "NIPAL2",
              "NKG7",
              "NMUR1",
              "NOL4L",
              "NOP9",
              "NPIPB14P",
              "NR2C2",
              "NRM",
              "NRROS",
              "NSG1",
              "NTSR1",
              "NUDCD3",
              "NUDT4",
              "ORC2",
              "ORMDL2",
              "OSBPL7",
              "OTUD3",
              "OTULINL",
              "P2RX4",
              "PACC1",
              "PAFAH2",
              "PALM2AKAP2",
              "PAPOLG",
              "PARL",
              "PARP15",
              "PARVG",
              "PCBD2",
              "PCBP2-OT1",
              "PCK2",
              "PCNX2",
              "PCNX3",
              "PCSK7",
              "PDCD4-AS1",
              "PDCL3P4",
              "PDHB",
              "PDIA6",
              "PDK2",
              "PDLIM5",
              "PDXDC2P",
              "PDZD4",
              "PGGHG",
              "PHC3",
              "PHF2",
              "PHF20",
              "PHTF2",
              "PIGF",
              "PIGS",
              "PIK3CA",
              "PKD1",
              "PLA2G4A",
              "PLCD1",
              "PLEKHA1",
              "PLEKHF2",
              "PLEKHG3",
              "PLK1",
              "PLP2",
              "PLXNA3",
              "PMAIP1",
              "PMS2",
              "PMVK",
              "PNKP",
              "POLK",
              "POLL",
              "POM121C",
              "PPARGC1B",
              "PPFIA1",
              "PPFIBP2",
              "PPIP5K2",
              "PPP1R16B",
              "PPP2CB",
              "PPP2R2B",
              "PPP6R3",
              "PRDM4",
              "PRDX3",
              "PRKCB",
              "PRPF38A",
              "PRRC2A",
              "PRSS57",
              "PSMA1",
              "PSMA4",
              "PSMB1",
              "PSMD11",
              "PTCH1",
              "PTGDR",
              "PTGDS",
              "PTOV1-AS2",
              "PTPN4",
              "PTRHD1",
              "PUM2",
              "PVRIG2P",
              "PYCARD",
              "PYHIN1",
              "RAB11FIP4",
              "RAB14",
              "RABGAP1L",
              "RALA",
              "RALBP1",
              "RALGAPA1",
              "RAN",
              "RARG",
              "RASA2",
              "RASGEF1B",
              "RBM39",
              "RBM48",
              "RCBTB2",
              "RCC2",
              "RCE1",
              "RCHY1",
              "RENBP",
              "RESF1",
              "REST",
              "RETREG3",
              "RETSAT",
              "RFFL",
              "RFX5",
              "RGS1",
              "RGS6",
              "RHBDF2",
              "RIC1",
              "RIOK3",
              "RIOX1",
              "RIPOR2",
              "RMDN1",
              "RN7SKP80",
              "RN7SL138P",
              "RN7SL809P",
              "RNA5SP450",
              "RNF139",
              "RNF14",
              "RNF144A",
              "RNF166",
              "RNF38",
              "RNF7",
              "RNU5D-1",
              "RNU5E-4P",
              "RNU6-48P",
              "RNU6ATAC24P",
              "RNU7-181P",
              "RNVU1-15",
              "RNVU1-6",
              "ROGDI",
              "RPAP1",
              "RPE",
              "RPF1",
              "RPL10P19",
              "RPL26L1",
              "RPL34P20",
              "RPN2",
              "RPP30",
              "RPS19BP1",
              "RPS27L",
              "RPS6KA3",
              "RPUSD2",
              "RRAGA",
              "RRAS2",
              "RSBN1",
              "RSBN1L",
              "RUBCNL",
              "RUFY3",
              "RUNX3",
              "RUSC2",
              "S100A4",
              "S100B",
              "S100Z",
              "S1PR3",
              "S1PR4",
              "S1PR5",
              "SAMD3",
              "SAPCD2",
              "SCAF11",
              "SCAF8",
              "SCARB1",
              "SCIMP",
              "SCML4",
              "SDHC",
              "SDHD",
              "SEC61A1",
              "SELENON",
              "SEMA4C",
              "SENP3-EIF4A1",
              "SERPINB9",
              "SETBP1",
              "SFMBT2",
              "SH2D1B",
              "SH2D2A",
              "SIDT1",
              "SIGIRR",
              "SIGLEC11",
              "SIGLEC16",
              "SIGLEC17P",
              "SIVA1",
              "SLAMF6",
              "SLC1A7",
              "SLC24A4",
              "SLC25A29",
              "SLC25A42",
              "SLC27A3",
              "SLC37A2",
              "SLC43A1",
              "SLC44A2",
              "SLC46A2",
              "SLC50A1",
              "SLC9A9",
              "SLITRK4",
              "SLX1A",
              "SMAD4",
              "SMAD7",
              "SMARCC2",
              "SMS",
              "SNORA12",
              "SNORA2B",
              "SNORA33",
              "SNORA3B",
              "SNORA75",
              "SNORA77",
              "SNORD100",
              "SNORD15B",
              "SNORD20",
              "SNORD3C",
              "SNORD63",
              "SNORD98",
              "SNPH",
              "SNX10",
              "SNX12",
              "SNX17",
              "SNX20",
              "SNX29",
              "SOAT1",
              "SOX13",
              "SPINT1",
              "SPON2",
              "SPTSSA",
              "SRD5A1",
              "SRP72",
              "SRPK2",
              "SRSF8",
              "SSBP3",
              "ST14",
              "STAG3L2",
              "STAT4",
              "STK11IP",
              "STX12",
              "SUCLG1",
              "SULT1A3",
              "SULT1A4",
              "SUMF1",
              "SUMO3",
              "SYNE2",
              "SYNE3",
              "SYNRG",
              "SYTL2",
              "SYTL3",
              "TAF7",
              "TANGO2",
              "TBC1D2",
              "TBCC",
              "TBCCD1",
              "TBX21",
              "TCP11L2",
              "TFAM",
              "TFCP2",
              "TFDP2",
              "TFEC",
              "TGFBR3",
              "THAP1",
              "THG1L",
              "THUMPD1",
              "TIMMDC1",
              "TIMP1",
              "TIRAP",
              "TKTL1",
              "TM9SF4",
              "TMEM106A",
              "TMEM121B",
              "TMEM126A",
              "TMEM144",
              "TMEM150B",
              "TMEM165",
              "TMEM179B",
              "TMEM191A",
              "TMEM222",
              "TMEM256",
              "TMEM69",
              "TMF1",
              "TMOD1",
              "TMTC2",
              "TMUB1",
              "TNFAIP8L2",
              "TNFRSF18",
              "TNFSF8",
              "TNRC6B",
              "TNS3",
              "TOB1",
              "TOM1L2",
              "TOPORS",
              "TOR3A",
              "TOX",
              "TPI1P1",
              "TPK1",
              "TPM2",
              "TPMT",
              "TRA2A",
              "TRAF1",
              "TRAFD1",
              "TRAJ19",
              "TRAJ21",
              "TRAJ31",
              "TRAJ37",
              "TRAV10",
              "TRAV14DV4",
              "TRBJ1-5",
              "TRBV29-1",
              "TRDC",
              "TRDJ1",
              "TRDJ2",
              "TRERF1",
              "TRG-AS1",
              "TRGC1",
              "TRGV7",
              "TRGV9",
              "TRIM33",
              "TRIM62",
              "TRIM7",
              "TRPM2",
              "TSHZ1",
              "TSHZ2",
              "TSPAN4",
              "TSPOAP1",
              "TTC16",
              "TTC22",
              "TTC3",
              "TTC38",
              "TUBE1",
              "UBA1",
              "UBAP1L",
              "UBE2C",
              "UBE2E1",
              "UBE2E2",
              "UBE2N",
              "UBE2S",
              "UBE4A",
              "UBL7",
              "UBQLN1",
              "UBR1",
              "UCHL3",
              "UNG",
              "UQCR10",
              "UQCRFS1P1",
              "USP32P2",
              "VAMP8",
              "VDAC2P2",
              "VPS13A",
              "VPS25",
              "VPS26B",
              "VPS29",
              "VPS33A",
              "VSIG4",
              "WBP11",
              "WDR61",
              "WIPF1",
              "WNT10B",
              "XCL2",
              "XXYLT1",
              "YIF1A",
              "YPEL1",
              "YY1",
              "Z93241.1",
              "Z94721.1",
              "Z94721.3",
              "ZBTB1",
              "ZBTB10",
              "ZBTB2",
              "ZBTB25",
              "ZBTB39",
              "ZBTB40",
              "ZC3HAV1",
              "ZDHHC5",
              "ZFPM1",
              "ZFR",
              "ZFYVE28",
              "ZHX2",
              "ZNF148",
              "ZNF264",
              "ZNF292",
              "ZNF330",
              "ZNF335",
              "ZNF365",
              "ZNF574",
              "ZNF600",
              "ZNF770",
              "ZNF808",
              "ZNF830",
              "ZNF831",
              "ZNF839",
              "ZNF91",
              "ZSCAN25",
              "ZXDA",
              "ZXDB"
          ],
          "type": "scatter3d",
          "mode": "markers",
          "opacity": 0.7,
          "name": "PBMC-PRJCA002326",
          "marker": {
              color: "#62466B"
          }
      },
      {
          "x": [
              -0.0359521815729441,
              0.0961833055079976,
              0.0514242930795488,
              0.109936941079998,
              0.120672559194709,
              0.0153823805815016,
              0.00638454265189731,
              -0.0821726941324947,
              -0.257512315578203,
              -0.115547839415674,
              -0.0817547609068319,
              0.071055076732999,
              -0.291390673613391,
              -0.17938478022809,
              -0.566584118902496,
              -0.557923048181648,
              -1.09249250276168,
              -0.431820766189934,
              -0.128874188380733,
              -0.29221857083704,
              -0.398620338845174,
              -0.174141763341503,
              -0.198828653376516,
              -0.368157528187745,
              -0.292036177789799,
              -0.153242468847953,
              0.148961620896315,
              -0.225484214536455,
              -0.29624260900605,
              -0.339970743110018,
              -0.157737302873305,
              -0.33186627417131,
              -0.66676961081757,
              -0.308285829853004,
              -0.521859137021983,
              -0.176418479282084,
              -0.472061432989464,
              -0.325704080272036,
              -0.182204348124419,
              -0.428645663094228,
              -0.371646389774531,
              -0.202121836613528,
              -0.367436287571762,
              -0.769123030542622,
              -0.553820217222224,
              -0.0549322577280477,
              -0.0643997103905763,
              -0.0776834215789261,
              0.0104328877762583,
              -0.118123810372538,
              -0.305845041061417,
              -0.501342702699554,
              0.0731797599883539,
              -0.213918192507907,
              -0.138510147087534,
              -0.182813934340028,
              0.121181981871569,
              0.0685787779878027,
              -0.254405053920692,
              0.0162970601574754,
              -0.0465082568992484,
              0.05382437449327,
              -0.0698185329414293,
              -0.366475445771077,
              0.000482737182928628,
              -0.190101249484587,
              0.0129690593291776,
              -0.169529535157719,
              -0.349069969279313,
              0.165897985447575,
              0.0373774376212271,
              -0.334895871149515,
              -0.178985735543135,
              -0.548281523307525,
              0.0189975307308893,
              -0.548244161973795,
              -0.490544552182482,
              -0.386414232018088,
              -0.0959166675545737,
              -0.482656255029553,
              -0.107858233721582,
              -0.382603357610242,
              -0.0778951643193445,
              0.0254563870214708,
              -0.191142871907209,
              -0.367100627602057,
              -0.809423403729553,
              0.0506048740501452,
              -0.158282117571266,
              -0.433717395792355,
              -0.512686101320314,
              -0.0105276657754532,
              -0.240212227021595,
              -0.472315641153676,
              -0.381147506683681,
              -0.0998597823935384,
              0.15510471893098,
              0.0218181463682366,
              0.0819001590276083,
              0.0770603027952814,
              -0.137445838470402,
              -0.389547158353401,
              -0.281930886306677,
              -0.23394964870924,
              0.164872060861259,
              -0.0273786516743935,
              0.112984171585465,
              -0.0040636512458006,
              -0.0628858929028581,
              0.00516576423775722,
              0.18890356437084,
              -0.541473500460093,
              -0.981210623071486,
              -0.374135119914953,
              -0.249049942685517,
              -0.395525146820667,
              -0.25365704444849,
              0.0824036043939433,
              -0.0945140949736718,
              -0.0921731487062374,
              -0.1428198769722,
              -0.255285949278411,
              -0.027807266743579,
              -0.0120851448959093,
              0.130280262153532,
              0.0461451109332859,
              -0.0238262420275094,
              0.0828477113355633,
              -0.178819793677776,
              0.0761052909112233,
              0.0653321985645705,
              -0.19715120493717,
              -0.085296102576951,
              0.0146359463045893,
              0.169276955834967,
              0.0423711606137646,
              -0.076792899584838,
              0.111204988839413,
              0.0315335743392655,
              0.0282729683755762,
              -0.10797224201171,
              -0.0385638011218213,
              0.0932946628370749,
              0.0643756228243161,
              -0.148162944557874,
              -0.0525433331802468,
              0.120475632251109,
              0.0265429568648216,
              -0.0841547785258306,
              0.0718478976035032,
              0.141814024663343,
              0.0948163156623268,
              0.152776654892597,
              0.0213014639148574,
              0.110083679640028,
              -1.02353760827879,
              -0.442847371823661,
              0.205421527284489,
              -0.0751674315437428,
              -0.382389005533501,
              -0.196146346811665,
              -0.0506070063307577,
              -0.970070277036035,
              -0.00201317632820064,
              -0.242136063622213,
              0.0844829709336633,
              0.00906745029698719,
              0.0783574102147387,
              -0.243232171179679,
              -0.378716227568376,
              -0.0926366537843537,
              -0.0866437595616848,
              0.0117955785555829,
              -0.076669199180911,
              -0.185620037802286,
              0.112800167702733,
              0.0859202071832977,
              0.0261741212912408,
              -0.0368878857570712,
              0.0884907206675762,
              -0.185186678559015,
              -0.00668867525846267,
              0.086293536640048,
              -0.0378538075590538,
              -0.724498861734812,
              0.154998102943536,
              0.0719974283664147,
              -0.37932947578348,
              0.0732837430329331,
              0.0145766266390872,
              -0.0293380407940123,
              0.03441937193633,
              0.0697413207258936,
              0.124472343018379,
              0.0497981251777946,
              0.0398424144535599,
              -0.28260221407575,
              0.109866017251502,
              -0.0273902112059616,
              0.0293989106081111,
              -0.0260524794341248,
              0.0925487026820454,
              -0.063748542214268,
              0.147819011985632,
              -0.157817721445993,
              0.0955075698901988,
              -0.273187971402021,
              0.0356239159115875,
              -0.0185026173250861,
              -0.283224736584524,
              0.0493858392534147,
              0.105620649865373,
              0.0959106537584379,
              0.0539845628227489,
              0.154669250209179,
              0.0334574285061555,
              -0.320593680961336,
              -0.409277238557997,
              -0.165985333000259,
              0.100427921557059,
              -0.0570443560097455,
              0.0412799548520826,
              0.0826131850464371,
              0.0964203096952131,
              -0.146338061320595,
              0.0186460081426184,
              -0.184464995520173,
              0.0265389774422995,
              0.0827484648051953,
              -0.0695022326892239,
              0.0281003546364487,
              0.00698203066106218,
              -1.34549253678839,
              0.038603183556474,
              -0.0233612905854215,
              0.0426713981401457,
              0.119195073634903,
              0.0498640581034206,
              0.14883647917694,
              -0.229319689792276,
              0.00260716615646278,
              -0.126929123335069,
              -0.0975668278980476,
              -0.36323999169133,
              -0.067531883051937,
              0.101580289752374,
              -0.00236502751262901,
              -0.00730497367605554,
              0.155648995719152,
              -0.148516840947724,
              0.120844456224572,
              -0.11261661679295,
              -0.0637351333897256,
              0.0670393600045266,
              0.00512553641390523,
              -0.197017122126584,
              0.0427294441657355,
              -0.213360442062654,
              -0.0590559205768726,
              -0.0272484776441215,
              -0.267216474695735,
              0.0948649831358783,
              0.024176390505682,
              -0.575260736528475,
              -0.167049091419941,
              0.0514143113891439,
              0.128839927613708,
              0.0186147196263907,
              -1.39173534312039,
              -0.0702390431938251,
              0.0856792035558301,
              -0.19187510922347,
              -0.0717409037197393,
              0.0659144360522014,
              -0.227337525997891,
              -0.19597319314228,
              0.0568852837197191,
              -0.205978916854816,
              -0.584145764718237,
              -0.674164511687433,
              0.0185098637064753,
              -0.00884205856811682,
              -0.408746563088751,
              -0.413961430371818,
              -0.0614905972595188,
              -0.96039597409233,
              -0.0513515295824966,
              0.029188453037947,
              -0.0213460472032722,
              -0.214515869520301,
              0.125815376971228,
              0.188820065632029,
              -0.156923006643844,
              -0.25404129998419,
              0.0714504518034456,
              -0.0214582163445923,
              -0.155738648137883,
              0.0136548533020027,
              0.00957590874182646,
              -0.024009493501542,
              0.0727966583583256,
              0.0827218517260221,
              -0.090496768792595,
              0.0650396038250175,
              0.139920536059467,
              0.176432110579326,
              0.0540955187352799,
              0.151947949886501,
              -0.122031010356235,
              0.0849968239391616,
              -0.259441914963914,
              0.0177961288162416,
              -0.0264821978154161,
              -0.0209359091298557,
              -0.00177449915423,
              0.0915637854756016,
              -0.0202351044882015,
              0.012856620449733,
              -0.178906589730009,
              0.159714876323324,
              0.109522070204563,
              0.175242068237485,
              0.081111355339798,
              0.0184934910575462,
              -0.105039969158096,
              -0.317577829923825,
              -0.273565807815554,
              -0.297068793627651,
              0.0382312485923365,
              -0.382439686686819,
              -0.251458804232462,
              -0.019236266842284,
              -0.215301022252856,
              0.104449142465404,
              -0.0780768625098238,
              -0.318021091919791,
              0.0942244812558362,
              -0.407031507331497,
              -0.0206589973437785,
              0.200853804177493,
              0.148277931965206,
              0.0433797628649446,
              0.0511735816782574,
              0.126750977652598,
              -0.207458998852071,
              -0.0521040844667517,
              0.000389031599733192,
              -0.0813015497212262,
              0.0446485598100416,
              -0.23284646118531,
              0.0766931852856119,
              0.137442441566311,
              -0.327431976255669,
              -0.0535812303659848,
              -0.137551043058302,
              0.0800723482605182,
              -0.00327344587844486,
              0.123514526173119,
              0.043253561905003,
              0.0715095991803151,
              0.0761845729045164,
              0.0306598900453533,
              0.00329451753896953,
              -0.177684392705785,
              -0.109602212924148,
              -0.294587432020104,
              -0.0509261350048991,
              0.115296474991335,
              0.0480835096093228,
              -0.0283617521787996,
              0.199218564742339,
              0.00553497208303022,
              -0.495727537504417,
              0.0964167048807888,
              -0.00402731395531764,
              0.0535641313743891,
              -0.204146804550871,
              -0.0360387936860027,
              -0.0833860364793547,
              0.113381266097005,
              -0.123144947356409,
              -0.0601228640910715,
              0.0300586797137466,
              0.00433706883779739,
              -0.168558748719949,
              -0.0772933372925929,
              -0.177745408172959,
              0.084539266678179,
              0.000130749066981906,
              -0.0897364840072296,
              0.0363964749907814,
              -0.506339358995345,
              -0.324526397712548,
              -0.279996514947392,
              -0.422390001828165,
              -0.0759929674580979,
              0.0829819561772615,
              0.0494652804386727,
              -0.282843396007634,
              -0.0322258255541654,
              0.0559263206368698,
              0.0775049953458921,
              -0.0454249370173864,
              -0.058474543563466,
              0.058825432102283,
              -0.108305641198416,
              -0.0239848385493734,
              0.00809136755539935,
              -0.0581339967343446,
              0.0419208648719855,
              -0.204185067443278,
              -0.122291993671525,
              0.0402038664599827,
              0.0809516001809329,
              -0.0205122353650687,
              0.0535387590589336,
              -0.462087129318905,
              -0.0364644642034129,
              0.0536644889912605,
              -0.107017818554472,
              -0.144729293078676,
              -0.0235393667290105,
              -0.0201310624509397,
              0.0987953661361885,
              0.0745789576825562,
              -0.101826155232309,
              -0.0463765887922569,
              0.16277755865,
              -0.0772214968075898,
              -0.0120660591467157,
              0.141680150575474,
              0.0390851634427627,
              -0.0649507656807791,
              0.0312720034902716,
              0.0992531178518578,
              0.0979752486422967,
              0.0598132890405708,
              0.112405916065406,
              -0.0460556248972705,
              0.0409368399023462,
              -0.796689438647386,
              0.0768882635006141,
              0.0501734322044162,
              0.101426974382255,
              0.179585617485134,
              0.157023413663254,
              -0.109478228879624,
              -0.269732925117795,
              -0.0357386424307942,
              -0.046474112053451,
              0.0607952937442397,
              -0.490425039958664,
              -0.307440470746092,
              -0.595346530023158,
              -0.0595653494269448,
              0.0879316923245186,
              -0.403563651494732,
              -0.0976506658670432,
              -0.00489636656765929,
              -0.514683892940851,
              0.0880048437545157,
              0.0856718889763662,
              0.0423931583006215,
              -0.0550148479251517,
              -0.503105165798855,
              -0.0662737070019165,
              0.0690100743504656,
              -0.483632429873572,
              0.0805552067872126,
              0.0263926395175733,
              -0.282237637983613,
              0.136563244780831,
              -0.116371835577197,
              -0.130849405105683,
              0.101817455485575,
              -0.0571726366934598,
              -0.337201448915545,
              -0.483751017524079,
              -0.0331307448454805,
              -0.255087323681201,
              0.0532311711655116,
              0.134967774032549,
              0.125330784248008,
              0.038780350969626,
              -0.338421149843348,
              0.0813467670464715,
              -0.112010188731696,
              -0.217119034804756,
              0.089461738427985,
              -0.220110519101664,
              0.0941392863307063,
              -0.187587219889659,
              0.119277404577449,
              -0.254349286279625,
              0.0818993236372117,
              -0.671220027948448,
              -0.556863575412795,
              0.0699780285831872,
              0.0873296346281132,
              -0.383403807592495,
              -1.63146887141454,
              -0.80785200512105,
              0.0547558661926106,
              0.117631001835816,
              0.0368180689367372,
              -0.796293305152858,
              -0.0735129534385544,
              -0.651701078202731,
              -0.113205648016837,
              0.0902534623414172,
              0.0587310524941398,
              -0.187023691471036,
              -0.0146421079002554,
              -0.0669623925245981,
              0.172969698033826,
              0.0116715933664244,
              -0.510472545371926,
              0.139795894120009,
              -0.0462128593431401,
              0.0992073130290577,
              0.103651861941176,
              -0.2883863629731,
              0.116896168252159,
              -0.479672908022147,
              -0.00267085283566221,
              -0.0131694533454396,
              0.0199383997907588,
              0.0997148008494869,
              -0.607702691260711,
              0.100751744472202,
              0.0933062313594814,
              -0.0817009834443782,
              -0.0567108485155939,
              0.139927747596879,
              0.0983200928573115,
              -0.0650863768743152,
              -0.0980321469692854,
              -0.0527084599011714,
              -0.0244595555646103,
              -0.012188390907546,
              -0.280932640751364,
              0.0494318386381404,
              -0.048905466162445,
              0.108200187982879,
              0.09625722116753,
              0.0454922724339368,
              -0.0632342228756888,
              -0.502008375511277,
              -0.227307131323764,
              -0.230449289045457,
              0.114943578364322,
              -0.161501167908325,
              -0.554677122908181,
              0.12536481015958,
              0.0741459701751768,
              -0.799491761906741,
              0.0584374805267472,
              0.130690519193817,
              -0.31454139460856,
              -0.372090343556062,
              -0.0841175365836755,
              -0.138918521633264,
              -0.3153567004545,
              -0.0194636196191428,
              -0.120996624852019,
              0.191420469950792,
              0.0917516389729857,
              -0.149259585366666,
              0.0898136055214873,
              -0.0980913179901354,
              0.153721987158782,
              0.00269845519291551,
              -0.063613238379499,
              -0.143248949989022,
              -0.0516324451803626,
              0.00641228932835269,
              -0.28008869337268,
              0.0893698404358475,
              -0.320603191100488,
              0.0397317288160102,
              -0.0326640844893772,
              -0.0244814956007227,
              0.0973871948706413,
              0.0226977495181703,
              -0.105388787980698,
              0.0542384966714475,
              -0.0500168083220854,
              0.114279985642238,
              0.160602810498318,
              -0.0790799783507934,
              0.143152991614682,
              0.166267813664202,
              0.047452516712404,
              -0.162967990415962,
              0.0295015227644691,
              0.0312824177836527,
              -0.063717489692958,
              -0.29965437090506,
              -0.300224074082378,
              -0.0644591088342516,
              0.00351863819777659,
              0.0631721371644866,
              -0.00244280418356002,
              -0.147670014119422,
              0.171647718812978,
              -0.228657089581688,
              0.0261623348398468,
              0.1853732219498,
              0.0938991600132583,
              -0.350768752765576,
              -0.293761161791828,
              -0.0952491430157984,
              0.0823714066216227,
              -0.125823183769287,
              -0.153661918123065,
              -0.0502006082754605,
              -0.204278602228871,
              0.0269037539737604,
              0.0272314733034402,
              -0.00204403360450506,
              0.00720388775283642,
              -0.119087953618924,
              0.0528398601557214,
              0.0730609670448956,
              0.0733259451202035,
              -0.131581150815171,
              -0.155162088867694,
              0.0754357033692464,
              -0.542863458117193,
              -0.290552730706275,
              -0.662924698736856,
              -0.0262144657860161,
              0.0663253351270352,
              0.0910122855969605,
              -0.204485425768349,
              -0.0228273896505578,
              0.0548667353825859,
              -0.450635436786697,
              -1.23251127593523,
              -0.0643691854113108,
              0.129428489433473,
              -0.0309554957089281,
              -0.13894126029668,
              0.0340683436789908,
              0.00356237769474305,
              0.129788950966868,
              -0.148280150196033,
              0.0239466811845555,
              -0.356544351439685,
              -0.0922406174501694,
              -0.141170071431947,
              -0.026591725395221,
              0.057809428337191,
              -0.184946569532788,
              0.0398222343357643,
              0.16814626428631,
              -0.079396002720893,
              0.0754734762292485,
              0.0675904261271068,
              0.0616889365483378,
              -0.75708258112009,
              -0.780065740340559,
              -0.213501570280075,
              -1.10472291099752,
              0.0488225230744939,
              -0.404651852858411,
              0.0350913357219845,
              -0.0732262484461425,
              -1.00778086191453,
              -0.120222780080462,
              -0.531934114517731,
              0.114363396522713,
              -0.369748804668673,
              -0.485263177375031,
              -0.330626832489701,
              -0.167255807233482,
              0.104364149493589,
              -0.127249483968573,
              -0.00513617066616151,
              -0.224957621922949,
              -0.213611968270944,
              -0.483899482550857,
              0.110322473750957,
              0.143691607763879,
              0.139865023462711,
              0.158301598910067,
              -0.0115698768679667,
              0.0831884721187166,
              0.137644387249197,
              0.00524018096292872,
              0.0417042975706579,
              0.00855650634726191,
              0.147275767712762,
              -0.00458900481154872,
              0.0127245502672239,
              -0.224439789059877,
              0.0308681105810452,
              -0.0688243732470246,
              0.0471443036627176,
              -0.0640776117842605,
              0.163288087839336,
              -0.0472639749272853,
              -0.00693174174075839,
              0.0959515882209217,
              0.11953227990119,
              0.00454363373881034,
              0.0522506674132698,
              0.0179672617703845,
              0.158530869242373,
              -0.036301012030397,
              -0.323884077337239,
              0.132117390322742,
              0.0994736897616754,
              -0.164914268066874,
              -0.00598783733315655,
              -0.106911699983857,
              -0.422396342155525,
              -0.281041081487983,
              -0.15812888768978,
              -0.14361155474701,
              0.0181889909014455,
              0.0541521452689269,
              0.0962639852104739,
              0.117268659252422,
              -0.281389289875459,
              -0.205795544768091,
              0.061215881859875,
              0.0771183767184438,
              0.213661459746854,
              -0.0220878147846997,
              0.123487028989816,
              -0.184195846620379,
              0.0012441293777718,
              -0.125888310422143,
              0.0749124794737444,
              0.171117248858011,
              -0.329906050980561,
              0.045491273644958,
              -0.0232659604130937,
              0.132591106287862,
              0.0637698697783889,
              0.0805076993743523,
              -0.726836728955354,
              0.0270070701307734,
              0.0731903698069645,
              -0.116244521130293,
              0.130899285156557,
              -0.00871363935864716,
              -0.112700657810465,
              -0.0977131800078034,
              0.0873472944932682,
              -0.0282970303542416,
              -0.00488487446119285,
              -0.376608854704637,
              0.108789910000272,
              0.0438929599538525,
              0.133424441792529,
              -0.0683629425699232,
              0.10947707502278,
              0.037073310974731,
              0.125985824415773,
              0.076557622426925,
              0.10511741686348,
              0.0883436242772307,
              0.0267436514680092,
              0.151590081577293,
              0.116631907593757,
              0.0808276956879209,
              -0.411688065623037,
              -0.0881837520595795,
              -0.142614116778514,
              -0.33221771719638,
              -0.00486084465479597,
              -0.211447665801981,
              -0.992117625497274,
              0.0819668503840388,
              -0.0719380942368982,
              -0.0647513517958578,
              0.00341432487477572,
              -0.818501044684649,
              0.11155632606385,
              0.117055782789415,
              0.0491330492547466,
              -0.0164475498563639,
              0.050758716766473,
              0.0184410771085818,
              0.00556749175031507,
              -0.122820052909338,
              -0.234273305587329,
              0.0205921662053742,
              -0.00855319362167078,
              0.069216058791579,
              0.0420042334746152,
              0.141201917599935,
              0.0715352292193118,
              0.0680511548525856,
              0.0575096815375544,
              -0.213894027462855,
              0.144479700027214,
              0.0299576394826532,
              0.0262701920508586,
              0.0689423526045151,
              0.02308159142602,
              -0.229226043174916,
              -0.231223426900139,
              0.114486180452697,
              -0.0212479574812243,
              0.048762073989259,
              0.0271194529772372,
              -0.203275498977548,
              0.0766726039061469,
              0.13949836183308,
              0.0843735649653101,
              0.0236513949373676,
              -0.718670285120163,
              0.0701944689027993,
              -0.00976437852678802,
              -0.114464199136782,
              0.0913433434175506,
              -0.426927070918309,
              0.0104007839341267,
              0.0688011990404983,
              0.0650495238404718,
              0.115750809947828,
              0.11842518474372,
              -0.269241735046619,
              0.193710700050511,
              -0.455143017176449,
              0.129175561565924,
              -0.23543197022741,
              -0.391153956271581,
              -0.13658243442503,
              0.130988195700573,
              0.0950245371513343,
              0.116279355302246,
              0.0943815062066575,
              -0.522888401739454,
              -0.305288831052751,
              0.0990755429866294,
              0.147731465478117,
              0.110605837454376,
              -0.122061507762914,
              0.00658547186935277,
              0.0400322557271737,
              -0.0692025845233332,
              0.0501552012329343,
              -0.0530573024637112,
              0.0862703035852673,
              0.0742357036567023,
              0.0778230495905488,
              0.0252455016251674,
              0.00509804405246733,
              -0.172094365639489,
              0.11802220423805,
              0.099367746163583,
              0.0635837479217684,
              0.105835888061748,
              -0.0561979326907904,
              0.127695661618899,
              0.08658561339728,
              -0.108626357887419,
              0.0493531563837791,
              -0.307017855534715,
              -0.0442198316629801,
              -0.46745735985836,
              0.0559830330279977,
              -1.20410857555536,
              -0.614376833969671,
              0.0266010632503814,
              0.000846183187204308,
              0.101919491758902,
              -0.114614000675137,
              0.0844938224005864,
              0.0300702769118227,
              -0.0504746966184818,
              -0.743419442201898,
              -0.00946811974603157,
              -0.203251454889411,
              -0.436108631859434,
              -0.0591657057517255,
              0.0564298215710015,
              -0.270756734071972,
              -0.47183141784896,
              -0.460920530957398,
              0.0433539526702152,
              -0.00463219915980922,
              -0.0448079170449907,
              0.125929000125448,
              -0.317444035965446,
              -0.222602864536331,
              -0.345559783230584,
              -0.335588513712046,
              -0.29338655023107,
              -0.393837770396382,
              -0.32388245030206,
              -0.334900472339167,
              -0.674272314332305,
              -0.487649002222282,
              -0.439095636739155,
              -0.176000857006718,
              -0.510788028755909,
              -0.366765736553827,
              0.114088267533538,
              -0.196008113463457,
              -0.303795787524595,
              -0.317223647741845,
              -0.391933199937471,
              -0.19209613988428,
              -0.437055897100665,
              -0.0179985643825053,
              0.166819153088181,
              0.208132150625781,
              0.102040721817552,
              -0.338825244298176,
              -0.478557735613403,
              -0.0720326908593685,
              0.0371342339939522,
              -0.333160516628854,
              -0.327146947073861,
              -0.304857231403978,
              -0.232424686099113,
              -0.187672776485894,
              -0.273940668644808,
              0.135332442069477,
              0.057309444142984,
              0.0191617636070992,
              -0.136550344186556,
              -0.0795267079711062,
              0.168851756977731,
              0.134995497116663,
              -0.0915222910911602,
              0.0710765276550741,
              0.032914216035612,
              -0.0775399092427052,
              -0.0454032791692334,
              -1.10725317468123,
              -0.902430133516571,
              -1.32969334681816,
              -0.686019302447292,
              -0.315519767116153,
              -1.14783243048189,
              -1.24273676805897,
              -1.54279444300543,
              -0.000997544289147556,
              -0.12576692129639,
              -0.0330718642398916,
              -0.179881846354097,
              0.0875163546602332,
              0.0658887071162241,
              -0.0609585773403435,
              0.0533084961415224,
              -0.125598243500176,
              -0.0157899481904274,
              -0.0692352005198537,
              0.117715565859663,
              -0.0725443656393809,
              0.158946083794221,
              0.0211569617094611,
              -0.0878254881916997,
              -0.193345844768407,
              0.105363057394257,
              0.0330407365738157,
              0.0995840682768654,
              -0.375140115024731,
              -0.167805733438845,
              -0.231826368725456,
              -0.11309594706568,
              -0.239465804333214,
              0.114712137723983,
              0.100157568671505,
              0.18542402671304,
              0.0635904099290686,
              0.173400404957357,
              -0.135784332117934,
              0.0586020186365667,
              -0.110764627422008,
              0.105317277135969,
              0.118687584212976,
              0.0614878135690113,
              0.0574489506867878,
              0.047495952689954,
              -0.0162770848260037,
              -0.178032524850653,
              -0.345152362218924,
              0.106173029722195,
              0.111274061825369,
              -0.248433796904808,
              -0.073499281308356,
              -0.0457813531221762,
              0.0823188090929515,
              0.0162674035866248,
              -0.428011906204711,
              -0.268109454417981,
              0.00610081396661505,
              -0.172829918108492,
              -0.020986614558907,
              -0.0585454584254297,
              -0.146195795933632,
              0.0464490869683432,
              0.141249568056559,
              -0.409397572414413,
              -0.0873113995570846,
              0.112903793763467,
              0.0998517717319325,
              -0.0958599438931619,
              -0.0702489713522585,
              -0.249197998947785,
              -0.0971429047670154,
              0.147213031673685,
              0.121311911210588,
              -0.0816748680610422,
              -0.274536940125999,
              0.0542919998788296,
              0.0203859276276162,
              0.0598149248064608,
              0.0968948230355697,
              -0.892641196055533,
              -0.26408358768242,
              -0.100216419606522,
              -0.447634609531049,
              -0.370111016264208,
              -0.589927129807094,
              -0.119037721426144,
              0.0618850746986557,
              -0.317004988919924,
              0.0272269868794811,
              -0.0876561807725204,
              -0.0295547218940782,
              0.0983486454849654,
              -0.499040118178711,
              -0.0739038395161903,
              0.0852619065729778,
              -0.101907414953366,
              0.0732541693040706,
              -0.683838644147805,
              -0.279278316515065,
              -1.02193775653253,
              -1.09909783960024,
              -1.84015308024312,
              -1.66542449284681,
              -0.0458049579971214,
              0.130888343384606,
              0.0686055865935984,
              -0.0985326480252034,
              -0.200454049199962,
              -0.0649291629678827,
              -0.121203982530609,
              -0.178994843333575,
              -0.18597627523341,
              -0.184414106239091,
              0.104601023405818,
              -0.0719816421114522,
              0.0525840407155397,
              -0.0136584375740352,
              0.0375591321827342,
              -0.0389806530180896,
              -0.00435973539790369,
              0.12515675109485,
              0.0825306315091708,
              0.0791783707788667,
              0.0653858378187678,
              0.0281373052574598,
              0.100045862710119,
              -0.0317196316209583,
              -0.199064509766988,
              -0.246133138317353,
              0.070440050738736,
              0.0287724927222737,
              0.122579053546922,
              0.0912090525667934,
              0.0654839400646187,
              0.0658438867863423,
              0.142636877802884,
              0.076144277672173,
              -0.355654268273466,
              -0.141762075938184,
              0.0347106062755552,
              -0.0676009445502654,
              -0.0448967784538825,
              0.0791296067441233,
              0.130127749280783,
              -0.164112391256114,
              -0.385706734524644,
              0.0220260403800998,
              0.0230856464252938,
              -0.360479014994971,
              -0.326850514247528,
              0.0576938570125348,
              0.0812583705972514,
              -0.317292995718944,
              0.101940357008685,
              -0.187354112458278,
              -0.0971934465831855,
              0.100933953415264,
              -0.0443470473994083,
              -0.178401606862832,
              0.0534978387497507,
              0.110983200159615,
              0.0752669395940116,
              0.0894562785045518,
              0.0677457815411195,
              0.0368683784645636,
              0.00442646948716019,
              0.0943359411380219,
              0.140984983394096,
              -0.0723675149492812,
              0.102388147944164,
              0.0752344137099127,
              -0.0523040541456091,
              -0.00932749143990386,
              0.0784137817909466,
              -0.732000206158488,
              0.0196826689547644,
              0.176268101964084,
              -0.119453311934505,
              0.142547811870237,
              0.150368244351962,
              -0.0147435900098138,
              -0.665338471828914,
              -0.209318507765454,
              0.133610558868476,
              0.120731348341274,
              0.121825386067951,
              -0.252088920130517,
              0.0700916749391781,
              0.0761259141839618,
              -0.322603084864769,
              0.0902737036597457,
              0.0262289244955853,
              0.0691173306612154,
              0.0159193888296332,
              -0.0771999238332783,
              -0.0102339537712279,
              0.132796447225673,
              0.126566366323735,
              0.0838170734423775,
              -0.18066510242538,
              -0.290263128125883,
              0.0364849270783151,
              -0.396641462270474,
              -0.547786755493806,
              -0.0154260019690567,
              0.0977817630360235,
              -0.0861445825832156,
              0.0866430014812485,
              0.115496398385603,
              -0.00078391128962485,
              -0.245395145419546,
              -0.211348210233402,
              -0.0324402359429563,
              0.0551912247365129,
              0.0853626608666474,
              -0.0832937634187945,
              0.0967404557036313,
              0.0763917070127665,
              0.0256768519578315,
              0.106842882829101,
              0.152249948576936,
              0.076388021489545,
              -0.209380864397752,
              -0.23772404669419,
              -0.0952249657451729,
              0.115975307321999,
              0.0675359363546782,
              0.0172391245329434,
              -0.00181215220111591,
              0.0818487611405855,
              -0.0121891202528859,
              -0.260477777151576,
              0.119200854185218,
              0.00593027338857927,
              -0.0696725610919665,
              -0.116625086771326,
              -0.219415073592237,
              -0.0317515955976645,
              0.149513954279054,
              0.157260589461521,
              -0.0796921854722563,
              0.107884079557561,
              0.0790973121252431,
              -0.0496881213271883,
              0.138969024047416,
              -0.107072029453256,
              -0.0292746450037113,
              0.11981727135903,
              0.13749358320682,
              0.0632466631126684,
              0.119611711347166,
              0.152847898587091,
              0.136451713608467,
              0.120655017991618,
              0.118812419742063,
              0.138556655695128,
              0.059924080057391,
              -0.0856080791757833,
              -0.507767012184125,
              0.155574035489674,
              0.0495835135846412,
              0.0378927795717769,
              0.0326852665292303,
              0.0496311737443075,
              0.162700533983527,
              0.0936873608308971,
              -0.051268827903766,
              -0.566703460791083,
              -0.0450226798562628,
              -0.149134858534091,
              0.151169762809559,
              0.0684843604293217,
              0.00688233629029661,
              -0.179669694046942,
              0.143124821340158,
              0.0884641014560033,
              0.0547492303094925,
              0.0870881721784172,
              0.014914532206597,
              -0.223448534223535,
              -0.235688651416629,
              0.00503733982501059,
              0.0299329324105495,
              -0.243736262456138,
              -0.797842085702282,
              0.000774905701877882,
              0.145224162059258,
              0.147155324145194,
              0.0836916064375109,
              0.110015077473746,
              0.0643076542661828,
              -0.0227468871660647,
              -0.271991218018014,
              0.132875994589776,
              0.101449382762238,
              0.0348643598677976,
              0.0347034568389089,
              0.000516702885913323,
              0.0538386954316044,
              -0.693421619575435,
              -0.29413000808553,
              0.0752967304701914,
              -0.0296639629452536,
              -0.22543127267439,
              -0.0219989773243321,
              -0.38808967022346,
              -0.302506191445292,
              -0.0449006095725315,
              -0.111692594653505,
              -0.103110240016699,
              -0.11508769664476,
              0.0180554955941067
          ],
          "y": [
              1.11528682525086,
              0.618170768415195,
              0.786561745417909,
              0.566427264578717,
              0.526038052999169,
              0.922157517739617,
              0.956008906268357,
              1.28917621300067,
              1.94883353251209,
              1.4147391559013,
              1.28760387750056,
              0.71270741621398,
              2.07628964691838,
              1.65490452705312,
              3.11161394481377,
              3.07902953149803,
              5.09017025709912,
              2.60461141289451,
              1.46487513523491,
              2.07940433633586,
              2.47970578843666,
              1.63517941052188,
              1.72805566731597,
              2.36509954110148,
              2.07871814283522,
              1.55655272893318,
              0.419609816986621,
              1.82833839793817,
              2.09454344870701,
              2.25905608705094,
              1.57346305496426,
              2.22856570380446,
              3.48852871459439,
              2.13985208298307,
              2.94335099648962,
              1.64374480106094,
              2.75600360923588,
              2.20538248784683,
              1.66551221848839,
              2.59266613789039,
              2.37822522863012,
              1.74044517978825,
              2.362386111886,
              3.87359959556217,
              3.06359398731932,
              1.18669308276052,
              1.22231124136307,
              1.27228681016732,
              0.940778347018975,
              1.42443039443902,
              2.13066942262098,
              2.86616469963625,
              0.704713998357354,
              1.78482506634857,
              1.50112724208356,
              1.66780558496017,
              0.524121518705636,
              0.722023671029048,
              1.93714348847575,
              0.918716338431005,
              1.15500056648571,
              0.777532233098158,
              1.24269776854575,
              2.35877126247839,
              0.978212496899144,
              1.6952216973885,
              0.931236840572083,
              1.61782742780626,
              2.29328891529007,
              0.355892348281972,
              0.839408392073125,
              2.23996356017808,
              1.65340325343867,
              3.04275648378624,
              0.908556711273209,
              3.04261592412803,
              2.82554023057991,
              2.4337843495466,
              1.34088336619452,
              2.79586312216307,
              1.38580955836687,
              2.4194471953076,
              1.27308342217902,
              0.884257401210687,
              1.69914045716215,
              2.36112330229364,
              4.02521641743395,
              0.789644538434319,
              1.57551274002873,
              2.6117468543271,
              2.90884048430274,
              1.01963549554817,
              1.88374767256516,
              2.75695998335611,
              2.41397003782372,
              1.35571803130757,
              0.396498442902256,
              0.897945078058974,
              0.671906381870708,
              0.690114739814642,
              1.49712313300814,
              2.44557094844273,
              2.04070032668121,
              1.86018679346267,
              0.359752050139715,
              1.08303175531859,
              0.554963067892332,
              0.995316779317604,
              1.21661600386944,
              0.960594156853029,
              0.269341468331381,
              3.0171435500655,
              4.67150899924215,
              2.38758825245715,
              1.91699665404121,
              2.46806115240161,
              1.93432935029447,
              0.670012335230601,
              1.33560665086053,
              1.32679961496549,
              1.51734117502179,
              1.94045756583974,
              1.08464427772117,
              1.02549499549076,
              0.489892249054672,
              0.806422921774415,
              1.06966698923693,
              0.668341529783036,
              1.65277895206746,
              0.693707656089612,
              0.734237852069546,
              1.72174482249953,
              1.30092700398117,
              0.924965729769731,
              0.343180090036647,
              0.820621161346385,
              1.2689365157687,
              0.561656654381826,
              0.861393994393839,
              0.873660945652521,
              1.38623847684204,
              1.1251121798227,
              0.629038330838427,
              0.737836651836096,
              1.53744269920939,
              1.17770554445786,
              0.526778925476727,
              0.880169541636126,
              1.29663314981377,
              0.709724689971176,
              0.446500283232168,
              0.623313615479421,
              0.405257013672221,
              0.899888924859968,
              0.565875209290926,
              4.83075027839307,
              2.64609536874932,
              0.207198097371836,
              1.26282123000442,
              2.41864076653122,
              1.71796437623134,
              1.17042075526589,
              4.62959713275366,
              0.987602545782041,
              1.8909854713278,
              0.662189406524791,
              0.945915353818179,
              0.685234802260411,
              1.89510921339643,
              2.40482315447264,
              1.32854339948429,
              1.30599711755186,
              0.935651673769652,
              1.26847113392172,
              1.67836262091658,
              0.555655321628606,
              0.656782280604697,
              0.881557163462857,
              1.11880710269225,
              0.647111574002128,
              1.67673225012848,
              1.00519256374994,
              0.655377752029216,
              1.12244106392417,
              3.70571592307289,
              0.396899550284115,
              0.709162129943765,
              2.40713029800606,
              0.704322796551988,
              0.925188900386941,
              1.09040330867243,
              0.850537135619786,
              0.717649988571521,
              0.511742623414128,
              0.792679664176384,
              0.83013473220967,
              2.04322597532245,
              0.566694092020282,
              1.08307524423197,
              0.869424960488902,
              1.07804247099134,
              0.631844759141807,
              1.21986143652038,
              0.423908505013075,
              1.57376560323978,
              0.620713000129056,
              2.00780800169973,
              0.846005437402347,
              1.04963861246544,
              2.04556801031766,
              0.794230753573671,
              0.582665882350298,
              0.619196530423757,
              0.776929577502293,
              0.398136749905464,
              0.854156129543912,
              2.18615630107208,
              2.51979884807087,
              1.60449353968833,
              0.602201804742338,
              1.19463915381715,
              0.824726462030004,
              0.669223857359452,
              0.61727911856696,
              1.53057717974037,
              0.909879198720225,
              1.67401715644335,
              0.880184512896885,
              0.668714912020624,
              1.24150779348587,
              0.874310347741592,
              0.953761055295963,
              6.04199918718514,
              0.834796928495298,
              1.06791776325217,
              0.81949161697851,
              0.531596603633433,
              0.792431613355768,
              0.420080621306158,
              1.84276810472917,
              0.970220035693747,
              1.45755747147062,
              1.34709154857774,
              2.34659893686225,
              1.23409500481029,
              0.597866400636045,
              0.988926269463393,
              1.00751118266115,
              0.394450781545413,
              1.53877411729954,
              0.525391347291605,
              1.4037114004958,
              1.21981099025397,
              0.727815221918018,
              0.960745500732029,
              1.72124038028222,
              0.819273238010122,
              1.78272671481434,
              1.20220700003145,
              1.08254201859411,
              1.98534222084392,
              0.623130520210447,
              0.889072964650526,
              3.14425684821682,
              1.60849557882786,
              0.786599298225895,
              0.495311031266622,
              0.909996911411607,
              6.21597244787851,
              1.24427979925641,
              0.657688977023778,
              1.70189525782448,
              1.24993005263689,
              0.732047376139218,
              1.8353108691959,
              1.7173129428333,
              0.766016574749298,
              1.75495616818968,
              3.17768382741933,
              3.51634958272246,
              0.910391397121659,
              1.01329395606627,
              2.51780235717688,
              2.53742157013737,
              1.21136666560566,
              4.59320076839878,
              1.173221777696,
              0.870216737472681,
              1.06033607671338,
              1.78707362838309,
              0.506689902471512,
              0.269655604712952,
              1.5703995347879,
              1.93577498462741,
              0.711219948310137,
              1.06075807599959,
              1.56594377772089,
              0.92865676762496,
              0.944002447128635,
              1.07035641228438,
              0.706155291501945,
              0.668815034926825,
              1.32049279012351,
              0.735338642980381,
              0.453623907696847,
              0.316261187392529,
              0.776512142588035,
              0.408374742103931,
              1.43912994179056,
              0.660256204585406,
              1.95609301184718,
              0.913076588527066,
              1.07965914424072,
              1.05879306789478,
              0.986704601874601,
              0.635550184298919,
              1.05615652227205,
              0.931659854658755,
              1.65310549349995,
              0.379154250854364,
              0.567988078999189,
              0.320738328011697,
              0.674873994792598,
              0.910452993796825,
              1.37520677029025,
              2.17481015925287,
              2.00922948620911,
              2.09765169502586,
              0.836196210753651,
              2.41883143760414,
              1.92605919870756,
              1.0523987260666,
              1.79002750579365,
              0.587073291382435,
              1.27376700151097,
              2.17647778587194,
              0.625540196642088,
              2.51135002726813,
              1.05775127890814,
              0.2243826444593,
              0.422181970410682,
              0.816826629043983,
              0.787504964124457,
              0.503170014425005,
              1.76052448706088,
              1.17605301648641,
              0.978565033156063,
              1.28589882034688,
              0.812053200283809,
              1.85603641536242,
              0.69149589799428,
              0.46294691841954,
              2.21188312485951,
              1.18161028926013,
              1.49751893046614,
              0.678782915202144,
              0.99234389304013,
              0.515346092427678,
              0.817301418405729,
              0.71099742587191,
              0.693409383818062,
              0.864680942515829,
              0.967634103507922,
              1.64850738152579,
              1.3923707031701,
              2.0883163928661,
              1.17162137132761,
              0.546263791288238,
              0.799130338020463,
              1.08673034573529,
              0.230534691861128,
              0.959205134477212,
              2.84503949820889,
              0.617292680488681,
              0.995180072283332,
              0.778511311738836,
              1.74806345174887,
              1.11561267467307,
              1.29374101218057,
              0.553469131160203,
              1.44332076123901,
              1.2062210220354,
              0.866942797494985,
              0.963711849144832,
              1.61417516499152,
              1.2708192470884,
              1.64873693203578,
              0.661977612409913,
              0.979536735740034,
              1.31763247013739,
              0.843098939446304,
              2.88496296594608,
              2.20095184681989,
              2.03342289437421,
              2.56913128188627,
              1.26592703577687,
              0.667836477977273,
              0.793931882395018,
              2.04413334255291,
              1.1012676434902,
              0.769624356102576,
              0.688441731206982,
              1.15092493381609,
              1.20001976135073,
              0.758717408303379,
              1.38749278098629,
              1.07026365618325,
              0.949587542223904,
              1.19873856656649,
              0.822315250107158,
              1.74820740322335,
              1.44011180517535,
              0.828774888611726,
              0.675475020727331,
              1.05719913551531,
              0.778606766682022,
              2.718478591393,
              1.11721411917371,
              0.77813374940585,
              1.38264777432832,
              1.52452472144584,
              1.06858771583094,
              1.05576509852623,
              0.608343754428358,
              0.699449979918088,
              1.36311585859435,
              1.15450520879184,
              0.36763192180248,
              1.27054897102998,
              1.02542319167341,
              0.447003940199301,
              0.832983638622614,
              1.22438440459133,
              0.862378068179827,
              0.606621615032422,
              0.611429175186339,
              0.755000923377733,
              0.557138562986995,
              1.15329768831882,
              0.826017318518464,
              3.9773090864862,
              0.69076198074647,
              0.791267695648485,
              0.598443198996043,
              0.304397160908418,
              0.389279988718216,
              1.3919042542192,
              1.99480953306014,
              1.11448345487194,
              1.15487210779926,
              0.751306455548791,
              2.82509060537505,
              2.13667169900657,
              3.21982300142119,
              1.20412355754965,
              0.649214733204091,
              2.49830336692479,
              1.34740696120065,
              0.998449595235674,
              2.91635651436189,
              0.648939525148818,
              0.657716495709188,
              0.820538402326901,
              1.18700380105448,
              2.87279538398607,
              1.22936153365421,
              0.720401061146789,
              2.79953565707373,
              0.676966319735608,
              0.880735060926885,
              2.04185437838552,
              0.466254605467399,
              1.4178391688631,
              1.47230623471768,
              0.596974143024483,
              1.19512176745157,
              2.24863753378726,
              2.79998180387737,
              1.1046721029567,
              1.93971030273992,
              0.779763964374226,
              0.472257036341227,
              0.508513022278765,
              0.834130394714165,
              2.25322625502441,
              0.673988336125576,
              1.40142991553498,
              1.79686717658189,
              0.643458440912482,
              1.80812164660064,
              0.625860714363547,
              1.6857634927335,
              0.531286860698979,
              1.93693368117539,
              0.67190952475071,
              3.50527193675409,
              3.07504361570196,
              0.716759453566585,
              0.651479776112975,
              2.42245862355949,
              7.11789053899576,
              4.01930455002246,
              0.774027803737196,
              0.537480906348371,
              0.841512831697135,
              3.97581876526265,
              1.25659680347116,
              3.43183834563091,
              1.40592743561127,
              0.640479841607763,
              0.759072480356181,
              1.68364340348595,
              1.03511472289538,
              1.23195248510109,
              0.329287369153246,
              0.936118127026851,
              2.9005127123396,
              0.454092831759778,
              1.15388923090482,
              0.606793940524971,
              0.590072795597022,
              2.06498692202589,
              0.540245474607875,
              2.78463926600409,
              0.990076836067606,
              1.02957434731919,
              0.905017002695493,
              0.604884685488666,
              3.26630897038935,
              0.600983528151809,
              0.628994808099993,
              1.28740155758883,
              1.19338444220197,
              0.453596776673066,
              0.610131812909347,
              1.22489459684387,
              1.34884215764556,
              1.17832677911781,
              1.07204962190631,
              1.02588342445351,
              2.03694475802079,
              0.794057696106242,
              1.16401927328928,
              0.572961223550752,
              0.61789268519912,
              0.808879010654975,
              1.21792648015705,
              2.86866907337125,
              1.83519651928971,
              1.84701784822315,
              0.547591448101459,
              1.58762335198973,
              3.06681781147961,
              0.50838501104299,
              0.701078952172875,
              3.98785190067975,
              0.760176947763475,
              0.488348792662594,
              2.16338657589834,
              2.37989545786352,
              1.29649303932686,
              1.50266361621264,
              2.1664538944227,
              1.05325406567627,
              1.43523840852827,
              0.259872443734174,
              0.634843447661053,
              1.54156844745973,
              0.642134657378503,
              1.34906476903644,
              0.401700513757269,
              0.969876590894501,
              1.21935240060352,
              1.51895542030086,
              1.17427862969995,
              0.955904518577401,
              2.03376968520472,
              0.643804176706035,
              2.18619207982448,
              0.830551150303723,
              1.10291644774831,
              1.07213216403394,
              0.613641532961155,
              0.894635862199291,
              1.3765190857134,
              0.77597423540343,
              1.16820033050866,
              0.550087996187329,
              0.375813692268974,
              1.27754089300998,
              0.441462863037279,
              0.354500991964169,
              0.801504240048883,
              1.59314178641777,
              0.869038916196948,
              0.862338887846256,
              1.2197446116818,
              2.10737907416665,
              2.10952239390105,
              1.2225347083571,
              0.966790923673171,
              0.742364368491851,
              0.989218878457549,
              1.53558821150687,
              0.334260878632076,
              1.84027529063946,
              0.881601506087011,
              0.282623213776133,
              0.626764110193912,
              2.29968002616244,
              2.08520782448046,
              1.33837202594908,
              0.67013346869723,
              1.45339673972334,
              1.55813076806781,
              1.16889181702819,
              1.74855929691079,
              0.878812161873311,
              0.877579226312106,
              0.987718636075876,
              0.952926391383336,
              1.4280576644439,
              0.781236142594329,
              0.705160917507815,
              0.704164025160006,
              1.47505918587216,
              1.56377466420521,
              0.69622675770211,
              3.02237280592197,
              2.07313716394018,
              3.47406350487164,
              1.0786518910517,
              0.730501504304548,
              0.637625020144096,
              1.74933740205633,
              1.06590913761084,
              0.773610695087865,
              2.67539538671068,
              5.61694456989494,
              1.22219640122692,
              0.493096762128867,
              1.09648844770037,
              1.5027491629113,
              0.851857763310207,
              0.966626368285816,
              0.49174064485802,
              1.53788364664877,
              0.889937169978402,
              2.32140880547953,
              1.3270534437944,
              1.51113432746832,
              1.08007120552562,
              0.762539786353292,
              1.67582891935061,
              0.830210653226852,
              0.347433942930999,
              1.27872983015471,
              0.69608464981244,
              0.725742017936524,
              0.747944420134939,
              3.82830138785365,
              3.9147679210894,
              1.78325766304409,
              5.13618312200018,
              0.796350044339559,
              2.50239736455484,
              0.848009094176564,
              1.25551817078549,
              4.77147073287352,
              1.43232707358005,
              2.98125476629467,
              0.549774190343684,
              2.37108619243195,
              2.80567080506106,
              2.2239027145118,
              1.6092732786902,
              0.587393049321355,
              1.45876272237188,
              0.999351778823853,
              1.8263572674382,
              1.78367299896266,
              2.80054035442515,
              0.564976825446866,
              0.439436497961916,
              0.453832755477359,
              0.384471239578692,
              1.02355646999755,
              0.667059530067534,
              0.462187164595725,
              0.96031418854325,
              0.823130012933208,
              0.947837611397597,
              0.425952281872671,
              0.997293248310293,
              0.932156725028743,
              1.82440909260131,
              0.863897581634191,
              1.23895757158531,
              0.802663789684716,
              1.22109945191407,
              0.365711224621813,
              1.15784370555816,
              1.00610702097788,
              0.619042528050677,
              0.530327976611728,
              0.962934717040953,
              0.783452785369969,
              0.912432757401623,
              0.383608685801027,
              1.11659918444629,
              2.1985353289014,
              0.48298066208016,
              0.605791786191741,
              1.60046401220815,
              1.00255589290848,
              1.38224853831272,
              2.56915513527044,
              2.03735273041775,
              1.57493626329143,
              1.52031960074521,
              0.911598574898848,
              0.776299103988483,
              0.617867237725237,
              0.538844100447546,
              2.03866274928069,
              1.75426629137687,
              0.749724131903452,
              0.689896255890867,
              0.176198077431894,
              1.06312673184557,
              0.515449541483186,
              1.67300457274822,
              0.975348010651222,
              1.45364175720939,
              0.698195214515039,
              0.336256596346585,
              2.22119101253394,
              0.808882768268087,
              1.06755911501609,
              0.481198462476989,
              0.740115597275053,
              0.677145050660005,
              3.71451137507262,
              0.878423469011792,
              0.704674082424792,
              1.41736019037502,
              0.487563379792125,
              1.01281082127452,
              1.40402757702159,
              1.34764214997422,
              0.651413336712598,
              1.08648685128179,
              0.998406359986934,
              2.39689486123781,
              0.57074258955324,
              0.814895894773778,
              0.478063313326271,
              1.23722159131406,
              0.568157358485258,
              0.840552567968826,
              0.506048650349151,
              0.692005908402933,
              0.584559130039444,
              0.647664975508102,
              0.879414494585793,
              0.409721103226671,
              0.541239667911913,
              0.675941170391975,
              2.52886878734882,
              1.31179082986202,
              1.51656707036302,
              2.22988789192126,
              0.99831595578995,
              1.77553052692174,
              4.71254298759445,
              0.671655477705096,
              1.25067191672277,
              1.22363417581979,
              0.967183368041835,
              4.05936803844552,
              0.560334864304911,
              0.539644977715423,
              0.795181792315204,
              1.04190710097559,
              0.789065756108668,
              0.910650183940123,
              0.959082789987269,
              1.44209845336409,
              1.86140444539371,
              0.902557422840718,
              1.0122071972681,
              0.719626112831254,
              0.822001603319919,
              0.448803133559848,
              0.710901001329162,
              0.72400867852604,
              0.763667484524134,
              1.78473415336089,
              0.436471561539257,
              0.867322927938158,
              0.881195729012101,
              0.720655841812095,
              0.893191784004297,
              1.8424157903117,
              1.84993028579967,
              0.549312256426727,
              1.05996704658439,
              0.796577464024878,
              0.878000665730673,
              1.74478545277616,
              0.691573328625747,
              0.455212198559167,
              0.662601010286835,
              0.891048086796303,
              3.68378783178078,
              0.715945168467231,
              1.01676387978717,
              1.41066231784385,
              0.636379524615286,
              2.58620050337634,
              0.940899127104343,
              0.721186885400025,
              0.735301322203992,
              0.544554506318366,
              0.534493055890441,
              1.99296159291375,
              0.251256210642143,
              2.69235366672103,
              0.494048319556456,
              1.86576353779044,
              2.45161599404602,
              1.49387486092036,
              0.487228883283815,
              0.622530251011249,
              0.54256602927672,
              0.624949442211908,
              2.94722326448585,
              2.1285768664698,
              0.607289681717198,
              0.424237869785299,
              0.563910763255655,
              1.43924467819398,
              0.955252976559457,
              0.82942051722134,
              1.24038046639186,
              0.791336283647482,
              1.17963918385463,
              0.655465158711826,
              0.700741359634432,
              0.687245157330755,
              0.885050787748781,
              0.960848931646865,
              1.62747675399195,
              0.536009136728268,
              0.606190363931106,
              0.740815819187411,
              0.581856119841935,
              1.19145476609491,
              0.499615953523895,
              0.654278909855504,
              1.38869937142857,
              0.794353712058467,
              2.13508174908411,
              1.14639112359532,
              2.73868230720809,
              0.769410994492656,
              5.5100888059496,
              3.29141822437957,
              0.879950935583319,
              0.976845151543937,
              0.596590265301919,
              1.41122589657429,
              0.662148581470395,
              0.86689916687383,
              1.1699229837444,
              3.77689834773886,
              1.01564930413345,
              1.74469499484886,
              2.62074308895634,
              1.2026200304325,
              0.767730100407017,
              1.99866127555185,
              2.75513825336376,
              2.71408965099405,
              0.816923731363076,
              0.997455752755989,
              1.14860360029364,
              0.506262432942781,
              2.17430680374643,
              1.81749827177624,
              2.28008300152797,
              2.24256939867831,
              2.0837984724128,
              2.46171295682623,
              2.1985292077198,
              2.23998087063198,
              3.51675515451032,
              2.81464668176585,
              2.63198070664981,
              1.64217363540845,
              2.90169961420304,
              2.35986338551395,
              0.550809272146774,
              1.71744431898932,
              2.12295978412654,
              2.17347766596438,
              2.4545476405481,
              1.70272681256401,
              2.62430686105043,
              1.0477422800207,
              0.352426759776575,
              0.197000273783658,
              0.5961341773118,
              2.25474652672742,
              2.78044379873959,
              1.25102780522018,
              0.840323365263673,
              2.23343486288729,
              2.21081079685684,
              2.12695311557389,
              1.85444962613302,
              1.68608537112284,
              2.01063977606702,
              0.470885093492439,
              0.7644208114783,
              0.907938839408293,
              1.49375413201425,
              1.27922156541848,
              0.344779760071924,
              0.472152737408649,
              1.32435097850668,
              0.712626714216107,
              0.856199786757777,
              1.27174689247931,
              1.1508434533273,
              5.14570240204361,
              4.37512346959914,
              5.9825599616394,
              3.56094931113261,
              2.16706737879115,
              5.2983684274891,
              5.65541460119427,
              6.78428233754501,
              0.983781566228375,
              1.45318507078192,
              1.10445058415716,
              1.65677457391188,
              0.65077730376319,
              0.732144172749138,
              1.20936511666358,
              0.779473054732777,
              1.45255047637596,
              1.03943309225651,
              1.24050317328869,
              0.537162762184272,
              1.25295281230678,
              0.382046578411745,
              0.900432566603285,
              1.31044298058064,
              1.70742841376085,
              0.583634988805651,
              0.855723795088544,
              0.605376523543963,
              2.39136921408334,
              1.61134219411027,
              1.8521986549511,
              1.40551472207402,
              1.88093950413306,
              0.548462166945113,
              0.603218918035592,
              0.282432077661767,
              0.740790755588882,
              0.327666976840723,
              1.49087226501959,
              0.759557927558081,
              1.39674390316618,
              0.583807221882353,
              0.533505864694844,
              0.748701078808778,
              0.763895964259051,
              0.801340826552921,
              1.04126578269242,
              1.64981711355114,
              2.27855021475538,
              0.58058773587833,
              0.561396790123018,
              1.91467860937579,
              1.25654536660433,
              1.15226583150013,
              0.670331349498444,
              0.918827911467789,
              2.59028183725421,
              1.98870176163167,
              0.957076341583083,
              1.63024402681975,
              1.05898383029713,
              1.20028655505868,
              1.53004195328643,
              0.805279312504426,
              0.448623864480611,
              2.52025156439657,
              1.30850889216465,
              0.555265462856861,
              0.604369377856425,
              1.34066996218388,
              1.24431715066807,
              1.91755366674775,
              1.34549667804027,
              0.426188305465247,
              0.523632702551043,
              1.28730330709857,
              2.01288305025537,
              0.775772947285685,
              0.903333327261304,
              0.754994769349718,
              0.615493919103251,
              4.33829583079639,
              1.9735557698838,
              1.35705976083804,
              2.66410576690053,
              2.37244889373264,
              3.19943430096425,
              1.42786868243647,
              0.747206515231153,
              2.17265503448402,
              0.877596104998045,
              1.30980601742657,
              1.09121849962858,
              0.610024393093632,
              2.85750198712185,
              1.25806738302461,
              0.6592589188708,
              1.36342157141233,
              0.704434057923198,
              3.55274530569021,
              2.03072091036832,
              4.82473136546368,
              5.11502065176445,
              7.90299583741714,
              7.24563733137314,
              1.1523546370331,
              0.487604544589314,
              0.721922812518614,
              1.35072512729176,
              1.73417068138523,
              1.22430313153071,
              1.43601852319551,
              1.65343751848715,
              1.67970284640006,
              1.67382570235857,
              0.586501889589661,
              1.25083575119419,
              0.782198578607352,
              1.03141398871262,
              0.838724826393986,
              1.1266804471787,
              0.996430697988785,
              0.509167764443552,
              0.669534437732902,
              0.682146209729573,
              0.734036052120666,
              0.874171333254111,
              0.603639174760534,
              1.09936325627653,
              1.72894299895867,
              1.90602314254862,
              0.715021248053357,
              0.871781650551641,
              0.518865498708957,
              0.636884749514912,
              0.733666974875018,
              0.732312794412774,
              0.44340457051244,
              0.693560981299211,
              2.3180601620256,
              1.51336154857501,
              0.849441462765134,
              1.2343548258507,
              1.1489379119473,
              0.682329668278087,
              0.490466028283797,
              1.59744721598604,
              2.43112262428315,
              0.897162945615221,
              0.893176528411011,
              2.33621167543362,
              2.20969556641422,
              0.762974585228792,
              0.67432089852229,
              2.17373856478639,
              0.596511766702292,
              1.68488650313996,
              1.34568682490327,
              0.60029802728224,
              1.14686973071789,
              1.65120566252157,
              0.77876071580799,
              0.562491060917023,
              0.696861675575687,
              0.643478982068137,
              0.725157544586267,
              0.841323558742179,
              0.963375508777292,
              0.625120865708729,
              0.449619276742739,
              1.25228747009135,
              0.594827101446577,
              0.696984043454336,
              1.17680533624877,
              1.01512023665456,
              0.685022722853878,
              3.73393724985833,
              0.905979105364574,
              0.316878215549742,
              1.42943220423776,
              0.443739651619071,
              0.414317861576526,
              1.0354965157601,
              3.48314452760163,
              1.76752027418131,
              0.477363109399618,
              0.525816878283951,
              0.521700923268916,
              1.92842980131788,
              0.716331896748867,
              0.693630067848563,
              2.19371601850403,
              0.640403690343823,
              0.881350984536608,
              0.719997544760324,
              0.920137201860084,
              1.27046780985094,
              1.01853050129862,
              0.480425935129743,
              0.503864553476392,
              0.664694625542313,
              1.65972131576186,
              2.07204763003831,
              0.842766167728842,
              2.47226091997996,
              3.04089508356713,
              1.03806386499996,
              0.612157100770675,
              1.30411912930902,
              0.654063006174805,
              0.545511645656334,
              0.982977842742135,
              1.90324668841479,
              1.77515635824704,
              1.10207429164639,
              0.772389911241883,
              0.65887986417259,
              1.29339386531616,
              0.616074675121582,
              0.692630110260261,
              0.883427974822248,
              0.578067635165641,
              0.407238571938934,
              0.69264397582213,
              1.76775487038139,
              1.87438671722772,
              1.33828106696672,
              0.543709909216682,
              0.725947017678879,
              0.915172132873787,
              0.986846259007059,
              0.672099749417087,
              1.02588616837407,
              1.95999010064241,
              0.531574856225205,
              0.957717944089393,
              1.24214859775283,
              1.41879194269998,
              1.80550526293999,
              1.0994835101645,
              0.41753184535802,
              0.388387693240175,
              1.27984411977299,
              0.574150476925438,
              0.682451166097858,
              1.1669637544272,
              0.457203656861224,
              1.38285172490084,
              1.09016480298413,
              0.529255790533008,
              0.462754514915897,
              0.742083989266629,
              0.530029142073901,
              0.404988982840657,
              0.466674204606472,
              0.526104045972785,
              0.533036212314973,
              0.458755056366244,
              0.754584108829036,
              1.3021007127256,
              2.89033403877,
              0.394732794610341,
              0.793487069297419,
              0.837469588470559,
              0.857061133534039,
              0.793307763713697,
              0.367921701628643,
              0.627560934549749,
              1.1729106399893,
              3.11206292918868,
              1.14941157432282,
              1.54109920401452,
              0.411302413539637,
              0.722378885857441,
              0.954136122384893,
              1.65597642104083,
              0.441568844375832,
              0.647211719979454,
              0.774052769052133,
              0.652388198698901,
              0.92391764247573,
              1.82067982420834,
              1.86672921584913,
              0.961077311220386,
              0.867415880123309,
              1.8970056900597,
              3.98164553970941,
              0.977113309502328,
              0.433670769427999,
              0.426405410950283,
              0.665166653640897,
              0.566133302246467,
              0.738092361050589,
              1.06560627364491,
              2.00330561300457,
              0.480126664488313,
              0.59835889487954,
              0.84886301573937,
              0.849468360155326,
              0.978084712178261,
              0.777478355305354,
              3.588798080479,
              2.0865954866381,
              0.696749597259533,
              1.0916294829443,
              1.82813922169647,
              1.06279251029031,
              2.44008763152275,
              2.11810810550473,
              1.1489523252638,
              1.40023507288285,
              1.36794680279231,
              1.41300802095102,
              0.912100806829546
          ],
          "z": [
              -0.296497688980893,
              -0.201009039666614,
              -0.233354458265748,
              -0.191069877122591,
              -0.183311706354282,
              -0.259400402615533,
              -0.265902754176249,
              -0.329899271042051,
              -0.456609695266479,
              -0.354018057101441,
              -0.329597248624729,
              -0.219168132870054,
              -0.481092131599301,
              -0.400150276304592,
              -0.679962631654314,
              -0.673703647311655,
              -1.06001406482462,
              -0.582574936555392,
              -0.363648437940653,
              -0.481690417414896,
              -0.558582411656566,
              -0.396361372870003,
              -0.414201529494767,
              -0.536568244923199,
              -0.481558609782366,
              -0.381258349095716,
              -0.162868414760707,
              -0.43346436030658,
              -0.484598417211443,
              -0.516198864259129,
              -0.384506572865533,
              -0.510342112152159,
              -0.752362389775286,
              -0.493301536392172,
              -0.647641805472626,
              -0.398006657833498,
              -0.611655140557208,
              -0.505888958913363,
              -0.402187857093964,
              -0.580280425726088,
              -0.539089495557123,
              -0.416581371777817,
              -0.536047035263536,
              -0.826328816343614,
              -0.670738707344845,
              -0.310213775975924,
              -0.317055497962675,
              -0.326655066309363,
              -0.26297718878558,
              -0.355879600830365,
              -0.491537683016225,
              -0.632815458323402,
              -0.217632715407596,
              -0.425106092245187,
              -0.370611932018492,
              -0.402628378907256,
              -0.182943568434499,
              -0.220957647766477,
              -0.454364210534887,
              -0.258739402915948,
              -0.304126111876486,
              -0.231620022365874,
              -0.320971448610647,
              -0.535352676104017,
              -0.270167735864342,
              -0.407894609014352,
              -0.261144406378918,
              -0.39302831337684,
              -0.522774484752198,
              -0.150629230488405,
              -0.243505518245619,
              -0.512531471951001,
              -0.399861903825524,
              -0.666736130803421,
              -0.256787888653846,
              -0.666709131369936,
              -0.625012098069878,
              -0.549761581764062,
              -0.339831451164728,
              -0.619311564041033,
              -0.34846110886816,
              -0.547007626275263,
              -0.326808083706365,
              -0.252120350228496,
              -0.408647344864719,
              -0.535804468199653,
              -0.855452167590838,
              -0.233946617253986,
              -0.384900287081027,
              -0.583945549423937,
              -0.64101284599615,
              -0.278124481853841,
              -0.444107663255381,
              -0.611838845894672,
              -0.545955545251071,
              -0.342680971141396,
              -0.158429061284256,
              -0.254749550706978,
              -0.211330857033775,
              -0.214828413554811,
              -0.369842801828348,
              -0.552025613257561,
              -0.474255949036436,
              -0.43958196650667,
              -0.151370622185744,
              -0.290301966635943,
              -0.188867774329886,
              -0.273453215790348,
              -0.31596152699088,
              -0.26678351306359,
              -0.134004085293837,
              -0.661816264682946,
              -0.979595423174923,
              -0.540887994089702,
              -0.450494301322221,
              -0.556345649131087,
              -0.453823656170932,
              -0.210967038659946,
              -0.338817872115873,
              -0.337126170649955,
              -0.373726388964824,
              -0.455000795828921,
              -0.290611708363441,
              -0.279250005214999,
              -0.176368631493636,
              -0.237169496782403,
              -0.287734792544518,
              -0.210646101620675,
              -0.399741984756561,
              -0.215518559683624,
              -0.223303811472114,
              -0.412989309452248,
              -0.332156424364044,
              -0.259939818653411,
              -0.148187393511127,
              -0.239896768816217,
              -0.326011524258105,
              -0.190153513392548,
              -0.247728627600262,
              -0.250084927685099,
              -0.348543497769699,
              -0.298384994418321,
              -0.203096537833015,
              -0.223995087732728,
              -0.377587594748539,
              -0.30848740266454,
              -0.183454017010362,
              -0.251335132804931,
              -0.331331638422894,
              -0.218595195230476,
              -0.168033676002847,
              -0.201996904598837,
              -0.160111453315749,
              -0.255122934955884,
              -0.190963835458772,
              -1.0101833200093,
              -0.590543391523442,
              -0.122067261940081,
              -0.324836868219999,
              -0.546852723222814,
              -0.412263141582612,
              -0.307088102298126,
              -0.971544772896795,
              -0.271971425510841,
              -0.445497937454635,
              -0.209464369644275,
              -0.263963931889185,
              -0.213891049654804,
              -0.446290047375125,
              -0.54419856411031,
              -0.337461125890499,
              -0.33313031826684,
              -0.261992430604221,
              -0.325922131281611,
              -0.404656229527604,
              -0.189000746044138,
              -0.208425740648727,
              -0.251601674454857,
              -0.29717388226306,
              -0.206568140801174,
              -0.404343059388969,
              -0.275350208058845,
              -0.208155951462174,
              -0.297871912521639,
              -0.794080843445766,
              -0.158506108085696,
              -0.218487135761391,
              -0.544641732293576,
              -0.217557571321039,
              -0.25998268643149,
              -0.291717933115855,
              -0.245643185446715,
              -0.220117527990308,
              -0.180565765555,
              -0.234529620063136,
              -0.241724185210034,
              -0.474741088822364,
              -0.191121130731571,
              -0.290310320213627,
              -0.249271257524525,
              -0.289343598836506,
              -0.203635611243343,
              -0.316584926649807,
              -0.163694129214757,
              -0.384564687918918,
              -0.201497364815767,
              -0.467937819412379,
              -0.244772713177849,
              -0.283887637298637,
              -0.475190959139898,
              -0.234827561418029,
              -0.194189075660673,
              -0.201206073392177,
              -0.231504261130526,
              -0.158743755852551,
              -0.246338340706617,
              -0.502195892512992,
              -0.566283696012008,
              -0.390467070486009,
              -0.197941637696587,
              -0.311740098817681,
              -0.240685336419129,
              -0.210815583711158,
              -0.200837766905458,
              -0.37626882990093,
              -0.25704191895183,
              -0.403821530009281,
              -0.251338008562913,
              -0.210717822831558,
              -0.320742871984276,
              -0.250209668231083,
              -0.265470975217871,
              -1.24284633842027,
              -0.242619724229606,
              -0.287398792078765,
              -0.23967980003288,
              -0.184379421800026,
              -0.234481973165604,
              -0.162958849314059,
              -0.436236093773097,
              -0.26863250216045,
              -0.362242822854638,
              -0.341023951270728,
              -0.53301455220696,
              -0.319318984808333,
              -0.197108870626103,
              -0.272225693271175,
              -0.275795580492629,
              -0.158035735793097,
              -0.377843340491114,
              -0.183187483743344,
              -0.351899788230098,
              -0.316575236667405,
              -0.222070119118424,
              -0.266812583986544,
              -0.412892413555756,
              -0.23963785265974,
              -0.424703029919931,
              -0.313193770255739,
              -0.290207895447339,
              -0.463622474856086,
              -0.201961734703015,
              -0.253045348812296,
              -0.686232851078515,
              -0.391235803072055,
              -0.233361671605296,
              -0.177409499490621,
              -0.257064529820565,
              -1.27626403123461,
              -0.321275333334661,
              -0.20859990363382,
              -0.409176501368032,
              -0.322360663522986,
              -0.222883053411564,
              -0.434803669012521,
              -0.412138010852187,
              -0.229408034548187,
              -0.419368718240708,
              -0.692653679878578,
              -0.757706367471782,
              -0.257140304696691,
              -0.27690636581962,
              -0.565900199610686,
              -0.569668760534129,
              -0.314953206672698,
              -0.964553569083503,
              -0.307626137320073,
              -0.249423346184104,
              -0.285942462118873,
              -0.425538007788093,
              -0.179595212519068,
              -0.134064426251174,
              -0.3839181159051,
              -0.45410134116613,
              -0.218882412264004,
              -0.286023521946448,
              -0.383062230809155,
              -0.260648812487984,
              -0.263596490778529,
              -0.287867220525274,
              -0.217909566524655,
              -0.21073705496246,
              -0.335914722785134,
              -0.223515257141204,
              -0.169402019006459,
              -0.143016670056987,
              -0.231424078051362,
              -0.160710322881073,
              -0.358703166681493,
              -0.209093030115999,
              -0.458004133983357,
              -0.25765609029027,
              -0.289654137880342,
              -0.285646072923751,
              -0.27179894375391,
              -0.204347368666026,
              -0.285139631466251,
              -0.261225661134668,
              -0.399804708540887,
              -0.155097498263253,
              -0.191369686510744,
              -0.143876662617348,
              -0.211900891627714,
              -0.25715213650786,
              -0.346424469941535,
              -0.500016466315936,
              -0.468210865583299,
              -0.48519546540299,
              -0.242888505676157,
              -0.546889348318638,
              -0.452235082247802,
              -0.284417814338999,
              -0.426105403993257,
              -0.195035673813493,
              -0.326939389195715,
              -0.500336792749222,
              -0.202424597941042,
              -0.564660802372467,
              -0.285445960652507,
              -0.125368159523041,
              -0.163362487428277,
              -0.239167895227538,
              -0.233535636642624,
              -0.178919094033904,
              -0.420438310020437,
              -0.308169976458369,
              -0.27023545287035,
              -0.329269732338805,
              -0.238250990093135,
              -0.438784740198071,
              -0.215093713633634,
              -0.171192831612914,
              -0.507137635232479,
              -0.309237446445985,
              -0.369918828671871,
              -0.212651737481619,
              -0.272882168262718,
              -0.181257938708972,
              -0.239259095248617,
              -0.21883966899153,
              -0.215461265987421,
              -0.248360001767761,
              -0.268135782796335,
              -0.398921479170661,
              -0.3497214078398,
              -0.483402291793089,
              -0.307318722903721,
              -0.187196771831549,
              -0.235768699195802,
              -0.291012411205981,
              -0.126549876928545,
              -0.266516702388879,
              -0.628757619267406,
              -0.200840371950234,
              -0.273426956388997,
              -0.231808088906243,
              -0.418044729256669,
              -0.296560279840267,
              -0.330776101516717,
              -0.188580811157504,
              -0.359508161175536,
              -0.313964804572985,
              -0.24879447068892,
              -0.267382375686972,
              -0.392326767654619,
              -0.326373169126074,
              -0.398965572431876,
              -0.209423687124199,
              -0.270422102579211,
              -0.335365297578836,
              -0.244214417865837,
              -0.636426327525258,
              -0.505037898237608,
              -0.472858061818923,
              -0.575759727630064,
              -0.325433447618642,
              -0.210549088631248,
              -0.23477015268062,
              -0.474915380660411,
              -0.293804811306939,
              -0.230101036038903,
              -0.214507053321039,
              -0.3033432430607,
              -0.312773634023005,
              -0.228005972523722,
              -0.348784431062672,
              -0.287849403448775,
              -0.264669305023021,
              -0.312527535435416,
              -0.24022217823593,
              -0.418072380207943,
              -0.35889176813006,
              -0.241462979347417,
              -0.212016339829238,
              -0.285339902065013,
              -0.231826424390422,
              -0.60444713908544,
              -0.296867893666487,
              -0.231735564760799,
              -0.347853776871711,
              -0.375106242091446,
              -0.287527480070175,
              -0.285064444748213,
              -0.199121415480084,
              -0.216621575244612,
              -0.344101984455612,
              -0.304030960982716,
              -0.152884229102078,
              -0.326321253088751,
              -0.279236212762631,
              -0.168130421064383,
              -0.242271418037568,
              -0.317453721986526,
              -0.247917653634238,
              -0.198790617947822,
              -0.19971407921865,
              -0.227292090682919,
              -0.189285654793256,
              -0.303799014141728,
              -0.240933290877342,
              -0.84624987717686,
              -0.214952738974421,
              -0.234258401771654,
              -0.197219665068498,
              -0.140737765867878,
              -0.157042502892724,
              -0.349631809888411,
              -0.465441005647301,
              -0.296343373401406,
              -0.304101436860877,
              -0.226582438001076,
              -0.624925731711521,
              -0.492690631622471,
              -0.700747992571412,
              -0.313561912636637,
              -0.206972126608365,
              -0.562154731693161,
              -0.341084537375169,
              -0.274054983438874,
              -0.642456564316419,
              -0.20691926320732,
              -0.208605189566681,
              -0.239880872031391,
              -0.310273460369135,
              -0.634089114814451,
              -0.318409754939279,
              -0.220645968383182,
              -0.620017003733346,
              -0.212302796333843,
              -0.251443760704781,
              -0.474477625316992,
              -0.171828189421641,
              -0.354613523786752,
              -0.365075842352103,
              -0.196937481122592,
              -0.311832801765932,
              -0.514197614117885,
              -0.620102701942225,
              -0.294458757667413,
              -0.454857257628731,
              -0.232048704968767,
              -0.172981167702795,
              -0.179945406896295,
              -0.242491692938709,
              -0.515079039666284,
              -0.211730769683946,
              -0.351461548679507,
              -0.427419203691221,
              -0.205866427912003,
              -0.429581021089916,
              -0.202486164659482,
              -0.406077827651077,
              -0.184319924758965,
              -0.454323909652523,
              -0.211331460734585,
              -0.755578515360477,
              -0.672938011781655,
              -0.219946469374077,
              -0.207407207883722,
              -0.547586077146695,
              -1.44950917012854,
              -0.854316585212667,
              -0.230946873265792,
              -0.185509709407275,
              -0.243909750002966,
              -0.845963608490255,
              -0.323641247852794,
              -0.741473007533423,
              -0.352325455832462,
              -0.205294282996253,
              -0.228074176618652,
              -0.405670589832281,
              -0.281097812711876,
              -0.318907438429278,
              -0.145518807103155,
              -0.262082029382788,
              -0.639413204050124,
              -0.169492092390298,
              -0.303912640732082,
              -0.198823719128723,
              -0.195611834253546,
              -0.478921045152356,
              -0.186040742121682,
              -0.617155627112459,
              -0.272446700115496,
              -0.28003358842624,
              -0.256107962937498,
              -0.198456979446698,
              -0.709677260350632,
              -0.197707624764352,
              -0.203088177758038,
              -0.329558385959092,
              -0.311499087255562,
              -0.169396807537669,
              -0.199464875094588,
              -0.317551722379825,
              -0.3413602174063,
              -0.308606732663582,
              -0.288192461075404,
              -0.279324616679459,
              -0.473534559787669,
              -0.234794319635569,
              -0.30585847219636,
              -0.192324954097746,
              -0.200955623989661,
              -0.237641275166094,
              -0.316213250122614,
              -0.63329651151419,
              -0.434781704085136,
              -0.437052406705644,
              -0.1874517950884,
              -0.38722655669679,
              -0.671357956331997,
              -0.179920817829349,
              -0.216934476745662,
              -0.848274996006701,
              -0.228286328488389,
              -0.176072156326262,
              -0.497822164744192,
              -0.539410321914166,
              -0.331304725268579,
              -0.370907046787792,
              -0.498411351311152,
              -0.284582112439832,
              -0.357955660641671,
              -0.132185225579535,
              -0.204211615000372,
              -0.378380090026892,
              -0.205612148654864,
              -0.341402977765264,
              -0.15942830223162,
              -0.268566531489129,
              -0.316487148371506,
              -0.374036461631438,
              -0.307829142974376,
              -0.265882702843211,
              -0.472924675213409,
              -0.20593283864948,
              -0.502202765082674,
              -0.241804172973061,
              -0.294121522242795,
              -0.28820831619851,
              -0.200139040458209,
              -0.254113899236088,
              -0.346676546344033,
              -0.231320754029118,
              -0.30666159151044,
              -0.18793134508762,
              -0.154455826317863,
              -0.327664297991043,
              -0.167066062014475,
              -0.150361971497924,
              -0.236224690699559,
              -0.388286566412062,
              -0.249197104120089,
              -0.247910127671073,
              -0.316562486324477,
              -0.487063951207763,
              -0.487475651259838,
              -0.317098422670361,
              -0.267973820408594,
              -0.224864795202424,
              -0.272281899135469,
              -0.377231375062113,
              -0.146474144787293,
              -0.435757261019367,
              -0.251610192017766,
              -0.136555312347593,
              -0.202659693650251,
              -0.524002122718078,
              -0.482805181737269,
              -0.339349059810218,
              -0.210990306609062,
              -0.361443607763426,
              -0.381561467096952,
              -0.306794415853692,
              -0.418139973785849,
              -0.251074400208638,
              -0.250837571504732,
              -0.271993724740979,
              -0.265310648612942,
              -0.356576345803094,
              -0.232331488652486,
              -0.217718561972887,
              -0.217527073682587,
              -0.365604643592286,
              -0.382645576152816,
              -0.216002441882067,
              -0.662820727467415,
              -0.480486586199117,
              -0.749583836720158,
              -0.289460659425536,
              -0.222586114273357,
              -0.204745913974874,
              -0.418289436287312,
              -0.287012964771779,
              -0.230866752857299,
              -0.59617149204754,
              -1.16119962688937,
              -0.317033438869355,
              -0.176984171106484,
              -0.292886798411349,
              -0.370923479044597,
              -0.245896858512936,
              -0.267942211750093,
              -0.176723681016244,
              -0.377672294236368,
              -0.253211349886601,
              -0.528175900168448,
              -0.337174927417507,
              -0.372534145259895,
              -0.289733288764706,
              -0.22874019486906,
              -0.404169542893824,
              -0.241738768515653,
              -0.149004495798767,
              -0.327892675249249,
              -0.215975145056195,
              -0.221671887266478,
              -0.225936640674272,
              -0.817627699952449,
              -0.834236643389372,
              -0.424805017229771,
              -1.06885245630296,
              -0.235234645860296,
              -0.562941128146492,
              -0.245157586038881,
              -0.323434058451355,
              -0.998796595207732,
              -0.357396436214931,
              -0.654922559600028,
              -0.187871067621735,
              -0.537718192187225,
              -0.621195475011024,
              -0.509446420807652,
              -0.391385187724603,
              -0.195097094588934,
              -0.362474333744427,
              -0.274228279575831,
              -0.433083814409991,
              -0.424884797122879,
              -0.620209991249516,
              -0.190791269196517,
              -0.166676827224322,
              -0.169442135579237,
              -0.156118813235328,
              -0.278877643110692,
              -0.210399848417683,
              -0.171046894129202,
              -0.26672973528799,
              -0.240378682136178,
              -0.264333169167621,
              -0.164086708551391,
              -0.273832866280265,
              -0.261321102591169,
              -0.432709598809339,
              -0.24820952971705,
              -0.320253012038318,
              -0.236447423051524,
              -0.316822731114475,
              -0.152515291553187,
              -0.304672236883127,
              -0.275525861780648,
              -0.20117649181179,
              -0.184135737293922,
              -0.267233100092435,
              -0.232757272977389,
              -0.257532419844084,
              -0.155953129399416,
              -0.296749773791398,
              -0.504573720851046,
              -0.175041017758898,
              -0.198631220088773,
              -0.389693057795881,
              -0.274843742548677,
              -0.34777708953208,
              -0.575764309512715,
              -0.473612925257076,
              -0.384789554417599,
              -0.37429850053817,
              -0.257372185710874,
              -0.231383156484168,
              -0.200950735905931,
              -0.185771558851672,
              -0.473864560524289,
              -0.419236203098333,
              -0.226278497008638,
              -0.214786446021292,
              -0.116112616154501,
              -0.286478505736075,
              -0.181277809744009,
              -0.403627027643009,
              -0.269617510380711,
              -0.361490672002209,
              -0.216380553350638,
              -0.14685749267226,
              -0.508925542924815,
              -0.237641996948051,
              -0.287329901051869,
              -0.174698683548254,
              -0.224432839478693,
              -0.212337127903557,
              -0.795770319816552,
              -0.250999738053123,
              -0.217625048146734,
              -0.354521519096402,
              -0.175921290118816,
              -0.276813562764747,
              -0.351960521068995,
              -0.341129713663508,
              -0.207394445856593,
              -0.290965639519247,
              -0.274046678586419,
              -0.542675656125442,
              -0.191898787288544,
              -0.238797029702051,
              -0.17409646772021,
              -0.319919555878418,
              -0.191402202598807,
              -0.243725297529261,
              -0.179472037461268,
              -0.215191679097411,
              -0.194552740567827,
              -0.206674441053615,
              -0.251190099422859,
              -0.160968938959415,
              -0.186231711965554,
              -0.212105880292161,
              -0.568025897333217,
              -0.334243204795862,
              -0.373577694897759,
              -0.510596084953231,
              -0.274029313275958,
              -0.423320748553986,
              -0.987477446034295,
              -0.211282662050829,
              -0.322503164652373,
              -0.317309614124616,
              -0.268049203173201,
              -0.862012189375381,
              -0.189899617049057,
              -0.185925395541364,
              -0.235010241908079,
              -0.282402528179406,
              -0.233835441721103,
              -0.257190013820779,
              -0.266493201820078,
              -0.359273373893135,
              -0.439815859451046,
              -0.255635513989242,
              -0.27669761551204,
              -0.220497112262118,
              -0.240161931322431,
              -0.168476019524725,
              -0.218821147261602,
              -0.221338938376909,
              -0.228956809025225,
              -0.425088629203551,
              -0.166107306746338,
              -0.248867488130386,
              -0.251532248237289,
              -0.220694907984441,
              -0.253836513151997,
              -0.436168419379169,
              -0.437611842930989,
              -0.187782336941654,
              -0.285871576883749,
              -0.235278329821576,
              -0.250918523790005,
              -0.417415074088518,
              -0.215108586913853,
              -0.169707106213109,
              -0.209543432645258,
              -0.253424740592822,
              -0.789868781109955,
              -0.219790057238068,
              -0.27757288689609,
              -0.353234956748463,
              -0.204506672686773,
              -0.579038472869775,
              -0.263000388855377,
              -0.220796913611178,
              -0.223508088371498,
              -0.186868443444602,
              -0.184935787481685,
              -0.465086043649662,
              -0.130530174512845,
              -0.599428927068226,
              -0.177166951228461,
              -0.440653176692113,
              -0.553186777198585,
              -0.369218856755556,
              -0.175857038281967,
              -0.201846431859206,
              -0.186486486385906,
              -0.202311122743774,
              -0.648385610939495,
              -0.491135733898423,
              -0.19891894368686,
              -0.163757395320929,
              -0.190586494401328,
              -0.358725205849288,
              -0.265757551248509,
              -0.241586995063753,
              -0.320526329106488,
              -0.23427157651283,
              -0.308858826221915,
              -0.208172740994415,
              -0.21686963020717,
              -0.214277209159551,
              -0.252272748059676,
              -0.266832451537027,
              -0.39488180636222,
              -0.185227004209579,
              -0.198707780983267,
              -0.224567341761836,
              -0.194033532247569,
              -0.311128424987579,
              -0.178236411448297,
              -0.207944880116692,
              -0.349016199258499,
              -0.234851179926169,
              -0.492385225734881,
              -0.302472365107201,
              -0.608327974370853,
              -0.230060052426189,
              -1.1406742134969,
              -0.71450037703706,
              -0.251293141812229,
              -0.269905089024998,
              -0.196863743884123,
              -0.353343211895349,
              -0.209456527754542,
              -0.248786089891266,
              -0.306992487743735,
              -0.807753935458795,
              -0.27735879338157,
              -0.417397698457256,
              -0.585673593171164,
              -0.313273107292995,
              -0.22973717750861,
              -0.46618086846803,
              -0.611488918480354,
              -0.603604088484171,
              -0.239186547148288,
              -0.273864080983177,
              -0.302897349190207,
              -0.179513101938731,
              -0.499919779160545,
              -0.431382132240588,
              -0.52023782384422,
              -0.513032015023985,
              -0.482534466029139,
              -0.555126254559658,
              -0.504572545062504,
              -0.512534797033422,
              -0.757784271819651,
              -0.622919608301765,
              -0.587832173487177,
              -0.39770486012662,
              -0.639641190360866,
              -0.535562456802341,
              -0.188069891542121,
              -0.412163246270594,
              -0.490056775376223,
              -0.499760514043646,
              -0.553749903174705,
              -0.409336230746748,
              -0.586358141133455,
              -0.283523379855514,
              -0.149963542142779,
              -0.120108410708079,
              -0.19677613612021,
              -0.515371061397458,
              -0.616349739841628,
              -0.322571525574249,
              -0.243681271076216,
              -0.511277405667068,
              -0.506931656867489,
              -0.490823835343264,
              -0.438479941432917,
              -0.406139655733713,
              -0.46848176142708,
              -0.172717637752865,
              -0.229101512002239,
              -0.256669204598043,
              -0.369195666516539,
              -0.327987130327721,
              -0.148494666488768,
              -0.172961133418929,
              -0.336655823766369,
              -0.219152631208686,
              -0.246730897061074,
              -0.326551356099121,
              -0.30332759186273,
              -1.07068096934593,
              -0.922664142213978,
              -1.23142894144505,
              -0.766273316310204,
              -0.498529192593713,
              -1.10000585709701,
              -1.16858915148295,
              -1.38542796390183,
              -0.271237471795969,
              -0.361402949287322,
              -0.294416207179102,
              -0.400509484675037,
              -0.207272273324801,
              -0.222901646610099,
              -0.314568738695074,
              -0.231992825525019,
              -0.361281053078471,
              -0.281927307659511,
              -0.320549899288296,
              -0.185448598614132,
              -0.322941290992388,
              -0.155653071651059,
              -0.255227360502125,
              -0.333984302864233,
              -0.410239338867534,
              -0.194375226691586,
              -0.246639466094492,
              -0.198551454269903,
              -0.541614260951997,
              -0.391782595807267,
              -0.43804756312839,
              -0.352246179660058,
              -0.443568255592038,
              -0.187619047312845,
              -0.198137010131729,
              -0.13651859792418,
              -0.224562527414889,
              -0.145207553682239,
              -0.368642102448271,
              -0.228167423853347,
              -0.350561434942254,
              -0.194408310120768,
              -0.184746162639384,
              -0.226081983625407,
              -0.22900069660637,
              -0.236193301381522,
              -0.282279340413091,
              -0.399173059340611,
              -0.519943398153096,
              -0.193789894429336,
              -0.19010359730809,
              -0.450049039192567,
              -0.323631367590688,
              -0.303600809693193,
              -0.211028316587162,
              -0.258760834447752,
              -0.579822436803426,
              -0.464267793002074,
              -0.266107792728177,
              -0.395413358584235,
              -0.285682715562606,
              -0.312824881152257,
              -0.376166020807435,
              -0.236949826339188,
              -0.168441584583418,
              -0.566370656129005,
              -0.333612793056901,
              -0.188925859934496,
              -0.19835799646454,
              -0.339790459407464,
              -0.321282507988949,
              -0.450601295232932,
              -0.340717600205699,
              -0.164132045196127,
              -0.182849674073769,
              -0.329539513491626,
              -0.468912661252868,
              -0.231282089555858,
              -0.255784553763958,
              -0.227290908585067,
              -0.200494856465929,
              -0.915590096951604,
              -0.461358471778908,
              -0.342938697559297,
              -0.594002922893276,
              -0.537979946972314,
              -0.696831624469568,
              -0.356540045151796,
              -0.225794900045266,
              -0.499602498691169,
              -0.250840813650908,
              -0.33386195165387,
              -0.291874519253571,
              -0.199444241335185,
              -0.631151479246437,
              -0.323923724456269,
              -0.20890146626575,
              -0.344160707370847,
              -0.217578942986491,
              -0.764697448084082,
              -0.472339050614911,
              -1.0090271757688,
              -1.06478745845955,
              -1.60031629752842,
              -1.47404744140466,
              -0.303617867923919,
              -0.17592919726812,
              -0.220938274336871,
              -0.34172190805327,
              -0.415376133344276,
              -0.317438110632441,
              -0.358105509142561,
              -0.399868485635048,
              -0.404913667040302,
              -0.403784754508449,
              -0.194925915971924,
              -0.322534634833575,
              -0.232516358389987,
              -0.280386956356052,
              -0.243374215378771,
              -0.298686235405266,
              -0.273667183108229,
              -0.180071173191921,
              -0.210875241611876,
              -0.213297776665536,
              -0.223265048683656,
              -0.250182965602065,
              -0.198217735239032,
              -0.293439006661715,
              -0.414371972792444,
              -0.448386451905059,
              -0.219612585778071,
              -0.249723942863992,
              -0.181933964654154,
              -0.204603718924974,
              -0.223194154398117,
              -0.222934036340192,
              -0.167439035330498,
              -0.215490385623601,
              -0.527532675239269,
              -0.372961961525891,
              -0.245432722880595,
              -0.319368892591176,
              -0.302961565519209,
              -0.21333301634199,
              -0.176478846005601,
              -0.389113575816684,
              -0.549250303669625,
              -0.254599314621034,
              -0.253833582777938,
              -0.53101931276487,
              -0.506717437577696,
              -0.228823713308615,
              -0.211794650006535,
              -0.49981062885241,
              -0.196848665463001,
              -0.405909370908234,
              -0.340754124608542,
              -0.197575950176017,
              -0.302564298463723,
              -0.399439779081142,
              -0.231855995742825,
              -0.190313790559076,
              -0.216124400224269,
              -0.205870373564496,
              -0.221559618571857,
              -0.243873393464947,
              -0.267317769672009,
              -0.202344050664623,
              -0.168632788571128,
              -0.322813488583656,
              -0.196525066159372,
              -0.216147905285694,
              -0.308314485968719,
              -0.277257167336182,
              -0.213850312334416,
              -0.799501743333312,
              -0.256292768644553,
              -0.143135192049007,
              -0.356840374587801,
              -0.167503399460047,
              -0.161851908318413,
              -0.281171149479956,
              -0.75132816700874,
              -0.421782097359096,
              -0.173961968891856,
              -0.183269221959484,
              -0.182478607816932,
              -0.452690439982094,
              -0.219864342026816,
              -0.215503656128934,
              -0.503648002532068,
              -0.205279655463633,
              -0.251562070529548,
              -0.220568458847551,
              -0.259012329786519,
              -0.326305663225466,
              -0.277912228785491,
              -0.174550292459427,
              -0.179052504723422,
              -0.209945585201347,
              -0.401075510244446,
              -0.480277302835121,
              -0.244150497335825,
              -0.55715236242867,
              -0.666378583324693,
              -0.281664299334727,
              -0.199853902967841,
              -0.332769584473854,
              -0.207903408209743,
              -0.187052295769087,
              -0.271083088389785,
              -0.447853136089816,
              -0.423248876280154,
              -0.293959756499005,
              -0.230632258318339,
              -0.208828655458997,
              -0.330709419733378,
              -0.200606411116014,
              -0.215311579051226,
              -0.251961029674576,
              -0.193305820318508,
              -0.160492081380009,
              -0.215314242420789,
              -0.421827159822825,
              -0.442309562049089,
              -0.339331587933684,
              -0.186706208820824,
              -0.221711264687984,
              -0.258058613396283,
              -0.271826153995982,
              -0.211368000082307,
              -0.279325143746055,
              -0.458752707158972,
              -0.184375244444237,
              -0.266231035089557,
              -0.320865961015671,
              -0.354796537562981,
              -0.429078452447427,
              -0.293462105656768,
              -0.162469267114197,
              -0.156871106115622,
              -0.328106713820587,
              -0.192553392099053,
              -0.213356354277961,
              -0.306424063516385,
              -0.17008963592788,
              -0.347892952763195,
              -0.291672119697206,
              -0.183929786190427,
              -0.171155873742747,
              -0.224810938496039,
              -0.184078335594675,
              -0.16005996855333,
              -0.171908788216415,
              -0.183324382629425,
              -0.184655949356622,
              -0.170387636849886,
              -0.227212026766812,
              -0.332381876471561,
              -0.637458031253737,
              -0.158089906335949,
              -0.234684710656966,
              -0.243133102720614,
              -0.246896349049851,
              -0.234650268703686,
              -0.152939891525004,
              -0.202812751835424,
              -0.307566372363872,
              -0.680048874918705,
              -0.303052549062886,
              -0.378289955294437,
              -0.161272685305677,
              -0.221025879286488,
              -0.265543020063801,
              -0.400356171301721,
              -0.16708641946367,
              -0.206587377363699,
              -0.230951668733913,
              -0.20758170243996,
              -0.259738496570386,
              -0.431993261453346,
              -0.440838669178684,
              -0.266876319878648,
              -0.248885342871726,
              -0.446654332520498,
              -0.847082845767203,
              -0.269956598206602,
              -0.165569315965239,
              -0.164173747951932,
              -0.210036254824572,
              -0.191013411302045,
              -0.224044205694567,
              -0.286954789078931,
              -0.467072977069677,
              -0.174492806991122,
              -0.197203471493365,
              -0.245321611753866,
              -0.245437889471825,
              -0.27014319030756,
              -0.231609673237955,
              -0.77162265341848,
              -0.483071731134167,
              -0.216102871635763,
              -0.291953463075983,
              -0.433426101493506,
              -0.286414306713644,
              -0.550972349096705,
              -0.48912483959959,
              -0.302964334104343,
              -0.351232037060588,
              -0.345029937455788,
              -0.353685531656105,
              -0.257468657043967
          ],
          "text": [
              "ABAT",
              "ABCB10",
              "ABCB6",
              "ABCF2",
              "ABCG1",
              "ABHD10",
              "ABHD8",
              "ABI2",
              "AC004585.1",
              "AC005261.1",
              "AC005324.5",
              "AC006058.1",
              "AC007283.1",
              "AC008026.1",
              "AC008760.2",
              "AC009163.5",
              "AC010323.1",
              "AC011479.5",
              "AC011483.2",
              "AC011611.3",
              "AC011933.1",
              "AC012321.1",
              "AC013451.2",
              "AC013489.1",
              "AC015712.2",
              "AC015813.5",
              "AC018629.1",
              "AC018868.1",
              "AC019349.1",
              "AC021097.1",
              "AC024909.1",
              "AC025259.1",
              "AC034236.1",
              "AC060780.2",
              "AC064799.1",
              "AC078816.1",
              "AC079922.1",
              "AC090114.1",
              "AC090114.3",
              "AC091042.1",
              "AC091551.1",
              "AC093591.1",
              "AC097523.1",
              "AC099329.1",
              "AC099336.2",
              "AC099518.5",
              "AC105250.1",
              "AC114546.3",
              "AC118549.1",
              "AC132872.1",
              "AC133528.1",
              "AC135050.3",
              "AC139769.2",
              "AC159540.2",
              "AC243960.2",
              "AC246787.1",
              "ACAA1",
              "ACAT2",
              "ACER2",
              "ACOT7",
              "ACP2",
              "ACSL1",
              "ACTN1",
              "ADAM8",
              "ADAMTSL4",
              "ADD3",
              "ADGRL2",
              "ADRB2",
              "AEBP2",
              "AFAP1L2",
              "AKAP9",
              "AL009174.1",
              "AL031847.2",
              "AL033519.3",
              "AL035071.1",
              "AL049650.2",
              "AL049844.1",
              "AL110114.1",
              "AL118558.1",
              "AL122020.1",
              "AL136295.17",
              "AL136454.1",
              "AL139099.2",
              "AL161665.1",
              "AL354702.1",
              "AL354836.1",
              "AL355309.1",
              "AL512274.1",
              "AL590867.2",
              "AL592114.1",
              "AL603839.3",
              "AL606760.2",
              "AL627402.1",
              "AL645922.1",
              "AL731577.2",
              "ALDH1A3",
              "ALDH2",
              "ALG9",
              "AMPD3",
              "AMZ2",
              "ANGEL1",
              "ANGPTL4",
              "ANK3",
              "ANKHD1",
              "ANKLE2",
              "ANKRD29",
              "ANO6",
              "ANTXR2",
              "ANXA3",
              "ANXA6",
              "ANXA8",
              "ANXA9",
              "AP001324.1",
              "AP001830.1",
              "AP002026.1",
              "AP002840.2",
              "APC",
              "APEH",
              "APRT",
              "AQP3",
              "ARAP1-AS1",
              "ARF4",
              "ARG2",
              "ARHGAP21",
              "ARHGAP27",
              "ARHGAP29",
              "ARHGAP35",
              "ARHGEF16",
              "ARHGEF3",
              "ARID2",
              "ARL6IP1",
              "ARNTL2",
              "ARPIN",
              "ARRDC4",
              "ASAP2",
              "ASH1L",
              "ATAD3A",
              "ATF6",
              "ATF7",
              "ATG7",
              "ATG9A",
              "ATP13A2",
              "ATP13A3",
              "ATP1B1",
              "ATP2B4",
              "ATP5F1D",
              "ATP8B1",
              "ATPAF1",
              "AURKAIP1",
              "B3GAT2",
              "B4GALNT4",
              "B4GALT1",
              "BAG3",
              "BCLAF1P2",
              "BCR",
              "BCYRN1",
              "BEND7",
              "BHLHE40",
              "BHLHE41",
              "BIRC3",
              "BLNK",
              "BLOC1S4",
              "BLOC1S5-TXNDC5",
              "BLOC1S6",
              "BMP2",
              "BNIP3L",
              "BOK",
              "BOLA2B",
              "BORCS8",
              "BPGM",
              "BRCA1",
              "BRF1",
              "BSDC1",
              "BTG3",
              "BTN3A3",
              "BTRC",
              "BYSL",
              "BZW1P2",
              "C10orf55",
              "C11orf1",
              "C11orf52",
              "C11orf68",
              "C1orf74",
              "C22orf23",
              "C3orf14",
              "C9orf78",
              "CA2",
              "CALML3",
              "CAPG",
              "CAPN14",
              "CAPN7",
              "CAPNS2",
              "CAPRIN2",
              "CARD10",
              "CARMIL1",
              "CASK",
              "CASP9",
              "CAST",
              "CAV1",
              "CAVIN2",
              "CBLC",
              "CCAR2",
              "CCDC22",
              "CCDC47",
              "CCDC51",
              "CCDC6",
              "CCDC61",
              "CCDC71",
              "CCDC80",
              "CCDC82",
              "CCN1",
              "CCND2",
              "CCNH",
              "CCT2",
              "CCT6A",
              "CD24",
              "CD24P4",
              "CD276",
              "CDA",
              "CDC23",
              "CDC42EP5",
              "CDCA7L",
              "CDK5R1",
              "CDK5RAP1",
              "CDRT1",
              "CEACAM5",
              "CEL",
              "CELSR2",
              "CENPB",
              "CEP120",
              "CEP57",
              "CERS6",
              "CFB",
              "CHCHD4",
              "CHM",
              "CHMP3",
              "CHP1",
              "CISD1",
              "CKMT1A",
              "CLCA2",
              "CLCN3",
              "CLIC3",
              "CLK4",
              "CLPB",
              "CLU",
              "CLUH",
              "CNOT1",
              "CNTD1",
              "COL17A1",
              "COL8A1",
              "COLGALT1",
              "COMMD3-BMI1",
              "COPE",
              "COPS4",
              "COQ2",
              "CORO1A",
              "COX17",
              "COX6A1P2",
              "CPA4",
              "CPE",
              "CPEB4",
              "CPSF1",
              "CPTP",
              "CRCT1",
              "CREB3L2",
              "CRELD2",
              "CRYBG1",
              "CRYBG2",
              "CSF2",
              "CSNK1G1",
              "CSRP2",
              "CSTA",
              "CTNS",
              "CTPS2",
              "CTSH",
              "CTU2",
              "CWC22",
              "CWH43",
              "CXADR",
              "CXCL14",
              "CXCL16",
              "CYCS",
              "CYP27B1",
              "CYP2B7P",
              "CYSRT1",
              "DAG1",
              "DAPK3",
              "DAPP1",
              "DBNDD1",
              "DCAF5",
              "DCAF8",
              "DCBLD2",
              "DCK",
              "DDHD1",
              "DEGS1",
              "DENND4C",
              "DEPDC1B",
              "DEXI",
              "DGKQ",
              "DHRS4-AS1",
              "DHX30",
              "DHX40",
              "DIP2B",
              "DLEC1",
              "DLG5",
              "DNAJA1",
              "DNAJA4",
              "DOCK9",
              "DOHH",
              "DR1",
              "DRAM1",
              "DSC2",
              "DSC3",
              "DSG2",
              "DSG3",
              "DSP",
              "DTD2",
              "DUS3L",
              "DUSP5",
              "DYNC1I2",
              "DYNC1LI1",
              "DYNC1LI2",
              "ECHS1",
              "ECM1",
              "EED",
              "EEF1A1P19",
              "EEF1A1P25",
              "EEF1A1P4",
              "EEF1A1P5",
              "EEF1B2P3",
              "EEF1B2P6",
              "EEFSEC",
              "EFCAB7",
              "EFEMP1",
              "EFHD2",
              "EFNA1",
              "EFNB1",
              "EGFL6",
              "EIF2B3",
              "EIF3A",
              "EIF3K",
              "EIF4EBP2",
              "ELAVL1",
              "ELF1",
              "ELF2",
              "ELMO2",
              "ELOA",
              "ELOVL4",
              "ELP2",
              "EME2",
              "EML4",
              "EMP2",
              "EMSY",
              "ENDOG",
              "ENO1P1",
              "ENOPH1",
              "EP400",
              "EPB41L4A",
              "EPC1",
              "EPHB3",
              "EPN3",
              "EPS8L1",
              "ERI3",
              "ERMAP",
              "ERRFI1",
              "ERV3-1",
              "ETS1",
              "EXOC4",
              "EXOC6B",
              "EXOSC3",
              "EZR",
              "FAAP100",
              "FABP6",
              "FAHD2A",
              "FAM110C",
              "FAM111A",
              "FAM131A",
              "FAM133B",
              "FAM207A",
              "FAM214B",
              "FAM3C2",
              "FAM49A",
              "FAM83G",
              "FASN",
              "FAT2",
              "FBXL15",
              "FBXL19",
              "FBXO21",
              "FBXW5",
              "FEZ1",
              "FGD4",
              "FGF1",
              "FGF7P5",
              "FGF7P6",
              "FGGY",
              "FKBP5",
              "FLII",
              "FLNB",
              "FLRT2",
              "FLRT3",
              "FNBP1L",
              "FNDC3B",
              "FNDC4",
              "FOSL2",
              "FOXC1",
              "FOXD1-AS1",
              "FP565260.1",
              "FPGS",
              "FPGT",
              "FRYL",
              "FSIP1",
              "FSTL3",
              "FUT2",
              "FUT3",
              "FYCO1",
              "FZD8",
              "G0S2",
              "GADD45GIP1",
              "GALNT7",
              "GAS6",
              "GAS8",
              "GBP6",
              "GCLC",
              "GEMIN4",
              "GID8",
              "GJB2",
              "GJB4",
              "GJB5",
              "GJB6",
              "GLRX",
              "GLTP",
              "GNA13",
              "GNA15",
              "GOLGA1",
              "GOLGA3",
              "GOT2",
              "GPR153",
              "GPR87",
              "GPRC5C",
              "GPSM1",
              "GPX3",
              "GRHL1",
              "GSK3B",
              "GTF2E2",
              "GTF2IP1",
              "GTPBP4",
              "GULP1",
              "GXYLT2",
              "H2AC18",
              "H2AC19",
              "H2BC12",
              "H3P36",
              "H3P6",
              "HBEGF",
              "HCAR3",
              "HDDC2",
              "HDGFL3",
              "HEG1",
              "HELZ",
              "HEPHL1",
              "HERC1",
              "HGS",
              "HIPK1",
              "HK2",
              "HMGB1P1",
              "HMGCS1",
              "HMGN3",
              "HMGN5",
              "HMGXB3",
              "HMOX2",
              "HNRNPA1P35",
              "HNRNPA2B1",
              "HNRNPA3P6",
              "HNRNPCP1",
              "HNRNPH3",
              "HNRNPLL",
              "HOPX",
              "HPGD",
              "HSD17B12",
              "HSD17B2",
              "HSPA14",
              "HSPA4",
              "HSPA9",
              "HSPB1",
              "HSPB1P1",
              "HSPB8",
              "HYAL1",
              "HYI",
              "HYOU1",
              "IDI1",
              "IER5",
              "IFITM10",
              "IGFBP2",
              "IGFL2-AS1",
              "IL17RE",
              "IL1A",
              "IL1B",
              "IL1RN",
              "IL20RB",
              "IL32",
              "IL36G",
              "IL6R",
              "ILRUN",
              "IMPDH2",
              "INAVA",
              "INHBA",
              "IP6K1",
              "IRAK2",
              "IRF2BPL",
              "ISCA1",
              "ISCA2",
              "ISG20",
              "ITCH",
              "ITGA5",
              "ITGB5",
              "ITPKC",
              "IVL",
              "IWS1",
              "JMJD4",
              "JMJD6",
              "JPT1",
              "JPX",
              "JUP",
              "KAT6B",
              "KATNB1",
              "KCTD15",
              "KDELR3",
              "KDM3B",
              "KDM7A",
              "KIAA0319L",
              "KIAA1522",
              "KIAA1671",
              "KIDINS220",
              "KIF13A",
              "KIF16B",
              "KIF20A",
              "KIRREL1",
              "KLHDC8B",
              "KLHL2",
              "KLK11",
              "KLK12",
              "KLK8",
              "KMO",
              "KMT2C",
              "KPNA2",
              "KREMEN1",
              "KRT13",
              "KRT15",
              "KRT16",
              "KRT17",
              "KRT19",
              "KRT23",
              "KRT24",
              "KRT5",
              "KRT6A",
              "KRT6B",
              "KRT6C",
              "KRT7",
              "KRT7-AS",
              "KRT75",
              "KRT78",
              "KRT8P3",
              "KYNU",
              "LAMB3",
              "LARGE2",
              "LARS1",
              "LAS1L",
              "LCN2",
              "LCOR",
              "LENG9",
              "LEO1",
              "LETM1",
              "LGALSL",
              "LINC00342",
              "LINC00511",
              "LINC01278",
              "LINC02015",
              "LINC02210",
              "LINC02541",
              "LINC02677",
              "LIPE",
              "LIPG",
              "LLGL1",
              "LMAN2L",
              "LPCAT1",
              "LPGAT1",
              "LPXN",
              "LRBA",
              "LRRC47",
              "LRRC61",
              "LRRFIP1",
              "LRRFIP2",
              "LSM3",
              "LY6D",
              "LYN",
              "LYPD3",
              "LZTR1",
              "MAB21L4",
              "MAFF",
              "MAFK",
              "MALL",
              "MAML2",
              "MANBA",
              "MANCR",
              "MANF",
              "MAP2",
              "MAPK11",
              "MAPK13",
              "MARVELD2",
              "MBD5",
              "MCM8",
              "MCOLN3",
              "MED1",
              "MED13L",
              "MED18",
              "MED21",
              "MEF2A",
              "MEGF9",
              "MESD",
              "METTL16",
              "MEX3D",
              "MFSD2A",
              "MFSD3",
              "MGA",
              "MIA3",
              "MINCR",
              "MIR1287",
              "MIR205HG",
              "MIR221",
              "MIR4273",
              "MIR6510",
              "MISP",
              "MKKS",
              "MKNK1",
              "MLKL",
              "MLLT10",
              "MLLT11",
              "MMP1",
              "MMP9",
              "MN1",
              "MOB1A",
              "MOGS",
              "MORN2",
              "MPC1",
              "MPDZ",
              "MPHOSPH8",
              "MPST",
              "MREG",
              "MRFAP1",
              "MRM3",
              "MRPL12",
              "MRPL54",
              "MRPS14",
              "MRPS17",
              "MRPS2",
              "MRPS21",
              "MRPS26",
              "MRPS34",
              "MST1R",
              "MT-CO1",
              "MT-TD",
              "MT-TK",
              "MT-TL1",
              "MT1G",
              "MT2A",
              "MTATP8P1",
              "MTCO1P12",
              "MTCO1P40",
              "MTCO2P12",
              "MTCO2P2",
              "MTCO3P12",
              "MTHFD1",
              "MTLN",
              "MTND1P23",
              "MTR",
              "MTRNR2L12",
              "MTSS1",
              "MTUS1",
              "MUC1",
              "MUC20",
              "MUC20P1",
              "MXRA5",
              "MYH9",
              "MYL12A",
              "MYO10",
              "MYO1B",
              "MYO1C",
              "MYO6",
              "MYORG",
              "MYOSLID",
              "N4BP1",
              "NAA10",
              "NADSYN1",
              "NAMPT",
              "NARS2",
              "NCCRP1",
              "NCDN",
              "NCF2",
              "NCOA3",
              "NCOR2",
              "NCS1",
              "NDRG2",
              "NDST1",
              "NDUFA1",
              "NDUFA11",
              "NDUFA9",
              "NDUFB7",
              "NDUFC2",
              "NDUFS1",
              "NDUFS8",
              "NEBL",
              "NEK6",
              "NELFB",
              "NEMP1",
              "NEO1",
              "NFKB1",
              "NFKB2",
              "NFKBIZ",
              "NHS",
              "NIBAN1",
              "NIP7",
              "NIPAL4",
              "NIPSNAP2",
              "NIT2",
              "NKX2-1",
              "NMB",
              "NOC2L",
              "NOL8",
              "NOMO2",
              "NOTCH1",
              "NOTCH2",
              "NPNT",
              "NR1D1",
              "NR2F2",
              "NR2F6",
              "NRDC",
              "NRDE2",
              "NUDT12",
              "NUDT19",
              "NUDT3",
              "NUP133",
              "NYNRIN",
              "OAS2",
              "ODC1",
              "OGA",
              "OLFML2A",
              "OSBP",
              "OSBPL1A",
              "OSGEP",
              "OTUB2",
              "OTUD7B",
              "P2RY2",
              "P3H4",
              "PADI3",
              "PAFAH1B1",
              "PAICS",
              "PAK1",
              "PAN2",
              "PANX1",
              "PARD6G",
              "PARK7",
              "PARN",
              "PARP4",
              "PATJ",
              "PC",
              "PCBD1",
              "PCNA",
              "PCNP",
              "PCNPP3",
              "PCYOX1",
              "PDCD4",
              "PDGFB",
              "PDLIM7",
              "PDPN",
              "PDZK1IP1",
              "PEX11B",
              "PEX16",
              "PGF",
              "PGLS",
              "PGLYRP4",
              "PI4K2A",
              "PIAS1",
              "PIEZO1",
              "PIM3",
              "PINX1",
              "PJA1",
              "PKP4",
              "PLAU",
              "PLAUR",
              "PLCH2",
              "PLEK2",
              "PLEKHH3",
              "PLPP6",
              "PLRG1",
              "PLTP",
              "PLXNA1",
              "PMPCA",
              "PMS2P3",
              "PNO1",
              "PNP",
              "PNPLA4",
              "PNPLA6",
              "PNPLA8",
              "PNRC2P1",
              "POGLUT1",
              "POLG",
              "POLR3G",
              "POLRMT",
              "POP5",
              "POU5F1",
              "PPCS",
              "PPFIBP1",
              "PPIAP29",
              "PPIP5K1",
              "PPM1A",
              "PPP1CC",
              "PPP2R1A",
              "PPP2R5B",
              "PPP6R2",
              "PRICKLE4",
              "PRKAB2",
              "PRKAG2",
              "PRKAR1A",
              "PRKX",
              "PROM2",
              "PROS1",
              "PRPF6",
              "PRRT3-AS1",
              "PRSS22",
              "PRSS23",
              "PRSS3",
              "PSD3",
              "PSMC2",
              "PSME3IP1",
              "PTAFR",
              "PTDSS2",
              "PTGES3P3",
              "PTGR2",
              "PTK6",
              "PTPN13",
              "PTPRA",
              "PTPRS",
              "PTTG1",
              "PUSL1",
              "PWP2",
              "PWWP2B",
              "PYCR3",
              "RAB11FIP1",
              "RAB18",
              "RAB3GAP2",
              "RAB5A",
              "RABGAP1",
              "RAC1P2",
              "RAC2",
              "RACGAP1",
              "RAD50",
              "RAET1G",
              "RAET1L",
              "RALGAPA2",
              "RALGAPB",
              "RARB",
              "RASAL2",
              "RASIP1",
              "RASSF6",
              "RBAK",
              "RBFOX2",
              "RBM12B",
              "RBM14-RBM4",
              "RCAN1",
              "RCOR3",
              "RDH10",
              "RELL2",
              "REV1",
              "RGS19",
              "RHBDD1",
              "RHCG",
              "RHOBTB3",
              "RHOV",
              "RHOXF1-AS1",
              "RIPK3",
              "RLF",
              "RNA5SP108",
              "RNA5SP333",
              "RNA5SP334",
              "RNASEL",
              "RNF126",
              "RNF128",
              "RNF8",
              "RNU6-1016P",
              "RNU6-33P",
              "RNU6-3P",
              "RNU6-5P",
              "RNU6-652P",
              "RNU6-6P",
              "RNU6-8",
              "RPL10AP6",
              "RPL10P3",
              "RPL10P6",
              "RPL13AP25",
              "RPL13AP7",
              "RPL13P12",
              "RPL15P2",
              "RPL19",
              "RPL21P119",
              "RPL21P16",
              "RPL22P1",
              "RPL23AP2",
              "RPL23AP74",
              "RPL26P19",
              "RPL29P11",
              "RPL36A",
              "RPL36AL",
              "RPL37A",
              "RPL4P5",
              "RPL7AP50",
              "RPL7AP66",
              "RPP38",
              "RPS26P11",
              "RPS26P15",
              "RPS26P31",
              "RPS26P47",
              "RPS3AP47",
              "RPS4XP3",
              "RPS6KA1",
              "RPSAP12",
              "RPUSD1",
              "RRAD",
              "RRP12",
              "RRP1B",
              "RRP36",
              "RRP9",
              "RSL1D1",
              "RTF1",
              "RUVBL2",
              "RXRA",
              "S100A12",
              "S100A7",
              "S100A8",
              "S100A9",
              "S100P",
              "SAA1",
              "SAA2",
              "SAA2-SAA4",
              "SAMD1",
              "SASH1",
              "SATB1",
              "SBNO2",
              "SCEL",
              "SCNN1A",
              "SCO2",
              "SCRN2",
              "SDCBP2",
              "SDHAF2",
              "SECISBP2L",
              "SEL1L3",
              "SELENOP",
              "SELENOW",
              "SEMA4B",
              "SEMA7A",
              "SEPTIN6",
              "SERINC2",
              "SERINC3",
              "SERINC5",
              "SERPINB1",
              "SERPINB13",
              "SERPINB2",
              "SERPINB3",
              "SESN3",
              "SETD2",
              "SETX",
              "SF3A3",
              "SFN",
              "SFPQ",
              "SGPP2",
              "SGTA",
              "SH3BP4",
              "SH3BP5L",
              "SH3KBP1",
              "SH3RF2",
              "SH3TC1",
              "SHB",
              "SLA2",
              "SLAMF7",
              "SLAMF9",
              "SLC12A4",
              "SLC12A6",
              "SLC15A2",
              "SLC16A13",
              "SLC16A4",
              "SLC1A4",
              "SLC25A10",
              "SLC25A27",
              "SLC25A36",
              "SLC25A44",
              "SLC25A53",
              "SLC27A4",
              "SLC33A1",
              "SLC35C1",
              "SLC37A1",
              "SLC38A5",
              "SLC39A1",
              "SLC39A14",
              "SLC41A1",
              "SLC4A11",
              "SLC7A8",
              "SLITRK6",
              "SLPI",
              "SMAD5",
              "SMARCC1",
              "SMG9",
              "SMPD1",
              "SMTN",
              "SNAI2",
              "SNAPC4",
              "SNHG12",
              "SNHG16",
              "SNHG25",
              "SNHG30",
              "SNHG4",
              "SNORA21",
              "SNORA51",
              "SNORA52",
              "SNORD97",
              "SNX2",
              "SOCS3",
              "SOX15",
              "SOX2",
              "SPARC",
              "SPART",
              "SPDYA",
              "SPG11",
              "SPG21",
              "SPINK7",
              "SPOCK1",
              "SPRR1A",
              "SPRR1B",
              "SPRR2A",
              "SPRR2B",
              "SPRR2D",
              "SPRR2E",
              "SPRR3",
              "SPTLC1",
              "SRBD1",
              "SRGAP2B",
              "SRGAP2C",
              "SRGAP3",
              "SRM",
              "SSBP2",
              "SSH3",
              "ST6GALNAC2",
              "STAMBP",
              "STAP2",
              "STARD10",
              "STARD4",
              "STARD7",
              "STC1",
              "STIM2",
              "STIMATE",
              "STK17B",
              "STRADB",
              "STRN",
              "STX2",
              "SUGP2",
              "SULF2",
              "SUOX",
              "SUPT3H",
              "SURF6",
              "SUSD6",
              "SYMPK",
              "SYNJ2BP",
              "TANK",
              "TAOK1",
              "TAOK3",
              "TAP2",
              "TATDN3",
              "TBC1D15",
              "TBC1D5",
              "TBC1D8",
              "TBRG1",
              "TCEA1",
              "TCEAL9",
              "TCF7L2",
              "TDRKH",
              "TEAD1",
              "TENT5B",
              "TEX261",
              "TFCP2L1",
              "TGFA",
              "TGFBRAP1",
              "TGM1",
              "THSD4",
              "TICAM1",
              "TIMP2",
              "TLCD2",
              "TLCD3A",
              "TLE3",
              "TM7SF3",
              "TMA16",
              "TMEM102",
              "TMEM14B",
              "TMEM150A",
              "TMEM154",
              "TMEM203",
              "TMEM245",
              "TMEM43",
              "TMEM50B",
              "TMEM63A",
              "TMPRSS11E",
              "TMX2P1",
              "TNC",
              "TNFAIP1",
              "TNFAIP3",
              "TNFRSF10A",
              "TNFRSF10B",
              "TNFRSF10C",
              "TNFRSF12A",
              "TNFRSF21",
              "TNFRSF25",
              "TNFRSF6B",
              "TNFSF12-TNFSF13",
              "TNPO2",
              "TNRC18",
              "TNS4",
              "TOR1AIP2",
              "TOR1B",
              "TOR4A",
              "TP53RK",
              "TPM1",
              "TRAK1",
              "TRAPPC11",
              "TRIB1",
              "TRIB3",
              "TRIM2",
              "TRIM27",
              "TRIM38",
              "TRIM44",
              "TRIM47",
              "TRIM6",
              "TRIM65",
              "TRIM66",
              "TRMO",
              "TRMT1L",
              "TSC22D1",
              "TSPAN14",
              "TSPAN17",
              "TTC9",
              "TTLL12",
              "TUBA1A",
              "TUBB2A",
              "TULP3",
              "TUSC2",
              "TUSC3",
              "TUT4",
              "TXN2",
              "TXNDC11",
              "TXNDC9",
              "TXNIP",
              "TXNL4A",
              "TYK2",
              "U62317.1",
              "UBD",
              "UBE2W",
              "UBQLN2",
              "UBXN2A",
              "UBXN2B",
              "UBXN7",
              "UCK2",
              "ULBP2",
              "UNC13B",
              "UNC45A",
              "UNC93B1",
              "UPF3A",
              "UPF3B",
              "UPK2",
              "UPK3BL1",
              "URGCP",
              "USP32",
              "USP33",
              "USP4",
              "USP48",
              "UST",
              "UTP11",
              "VANGL2",
              "VARS1",
              "VCP",
              "VDAC2",
              "VEGFC",
              "VEZT",
              "VIM",
              "VPS35",
              "VPS36",
              "VPS37B",
              "VPS39",
              "VPS41",
              "VSNL1",
              "VTCN1",
              "VTI1B",
              "VWA5A",
              "VWA8",
              "WAC-AS1",
              "WASF2",
              "WDR1",
              "WDR46",
              "WDR81",
              "WFDC21P",
              "WNK1",
              "WNT7A",
              "WSB2",
              "WTAP",
              "WWC1",
              "XDH",
              "XPO5",
              "XPR1",
              "YPEL3",
              "YTHDC1",
              "YWHAH",
              "YWHAZP5",
              "ZBED2",
              "ZBTB11-AS1",
              "ZBTB17",
              "ZBTB21",
              "ZC3H12A",
              "ZC3H3",
              "ZC3H7A",
              "ZDHHC7",
              "ZDHHC8",
              "ZMYM4",
              "ZMYND11",
              "ZNF160",
              "ZNF260",
              "ZNF326",
              "ZNF37A",
              "ZNF436",
              "ZNF468",
              "ZNF524",
              "ZNF581",
              "ZNF585B",
              "ZNF607",
              "ZNF668",
              "ZNF761",
              "ZNF791",
              "ZNHIT2",
              "ZSCAN16-AS1",
              "ZSCAN30",
              "ZSCAN31",
              "ZSWIM1",
              "ZSWIM4",
              "ZSWIM7",
              "ZSWIM9"
          ],
          "type": "scatter3d",
          "mode": "markers",
          "opacity": 0.7,
          "name": "SARS-COV2-GSE120934",
          "marker": {
              color: "#dc2f02"
          }
      },
      {
          "x": [
              0.0678573974404441,
              -0.628239752347621,
              -3.23767976360093,
              -0.975631040684549,
              -0.0338841856817826,
              -0.107290327933741,
              -2.61007531027386,
              -0.257913085321968,
              -0.0784262212643996,
              -0.0340597567843924,
              -0.687676868956684,
              -0.0567248457602644,
              -0.50382198207127,
              -0.587654915041551,
              -0.30546006727097,
              0.108692075889504,
              0.0972418308228769,
              -0.204977531470603,
              -0.0485357793336656,
              0.0613507833210385,
              -0.153281310164909,
              0.0278488549562827,
              -1.10122986459776,
              -1.5769471503057,
              -2.15366005574318,
              -0.190036339935028,
              0.0507887730018762,
              -1.71552730583947,
              -0.568557103071912,
              0.0123965826270138,
              0.151054708515478,
              -0.0882808682930336,
              -0.414521962910805,
              0.0707657002375971,
              -1.44616524084319,
              -0.0780893805512223,
              -0.650636284483909,
              0.0612135862992711,
              -0.243483973424288,
              0.0191797845301298,
              -0.0349092194917701,
              0.0800446994069357,
              -0.128383673254756,
              0.0344389887570922,
              0.0749228506320429,
              -1.18560705184142,
              0.068186197033589,
              -0.100985316771769,
              -0.681971467812829,
              0.0118937700665941,
              -0.197677494037941,
              0.131935270470515,
              0.00811282619791109,
              0.123300602330208,
              -0.175598917322814,
              -1.69922529467416,
              -0.00444358011589857,
              -0.318227655184482,
              -0.119809554408713,
              0.0231755247738911,
              -0.0235179024499406,
              0.0393920289586063,
              -0.351571729296775,
              0.151291482878399,
              -0.13107636369961,
              0.0270471928225434,
              -0.0260544042486515,
              0.0824441095206436,
              -0.222992465319965,
              0.0233399131643105,
              0.0677027439439034,
              -0.462110322739141,
              -0.295593250452897,
              -0.228261174430858,
              -0.150263276444223,
              -0.0163093939137308,
              0.0355053094503945,
              0.0344792705992299,
              0.0400720866876801,
              0.101054465706311,
              -0.0360513300687917,
              -1.796954199875,
              -0.0846812380948572,
              -0.711100578428483,
              -0.601788187677098,
              -0.122256451479875,
              -0.0323306746112276,
              -1.74536735795818,
              -0.115844938732562,
              -0.167573253661246,
              0.0353464291394305,
              -3.20136213141196,
              -2.33462254762569,
              -0.0497391665122359,
              0.052235530318523,
              -0.0496746813420018,
              -0.359237002185362,
              -0.179140149830453,
              -0.138606111684483,
              -0.167898095224131,
              -0.36296655717696,
              0.00605739701156638,
              0.218123877739125,
              -0.318360810373412,
              -2.58989970741733,
              -0.260387959011465,
              -0.0789508958946463,
              -1.0022123027002,
              -0.570680464774654,
              -0.0530222033098893,
              0.10067323640365,
              -2.39306935736866,
              -0.145822842359064,
              -0.09427960049349,
              -0.263263632099644,
              0.0727535753229869,
              0.0156209136610908,
              0.136336995050533,
              -0.483715806691722,
              -2.05227126520819,
              -0.126065381148489,
              0.0611502940165704,
              -0.0469875464808952,
              0.0324176048868241,
              0.0861913308187747,
              -1.48733345372514,
              -0.0973722381600751,
              -0.0734998930009692,
              -0.07401992267499,
              0.0125038415743446,
              0.130107619164605,
              -0.225271575308123,
              0.0264147581820554,
              -0.207227020837631,
              0.164167462399062,
              0.0897689959298105,
              0.0316356771922872,
              -0.395384360360881,
              0.00738637592116981,
              -0.227910209575315,
              0.0741277820592699,
              -1.88699603022485,
              -0.441598571177318,
              -0.0363603300824322,
              -0.0223746248596762,
              0.0430712785139739,
              -1.76791194475363,
              0.0785805861692082,
              0.0548974079106035,
              -0.00780738822811577,
              -0.131164156287448,
              0.0224305556214429,
              -1.05689889896488,
              -0.216042671237565,
              -2.55452061555304,
              -1.43874596667486,
              -0.99472646299302,
              -0.959136654460041,
              -1.4480800142631,
              0.0799499651326351,
              0.0460789495748164,
              -0.019932741347082,
              0.0767641239349965,
              0.0799759529171702,
              -0.538768899981626,
              0.169967991587308,
              -0.00320043126027264,
              0.181550197347605,
              0.186205424713868,
              0.0114035558527426,
              -0.850523572379041,
              -0.106330947849051,
              -0.133178651508375,
              -0.0223052069439876,
              -1.42193344534735,
              -0.242032674656305,
              0.145677734772255,
              0.133683544325,
              -0.697544643671877,
              0.0733621671082885,
              0.041682256667852,
              -0.116585120267714,
              0.0537886844842949,
              0.0885476845762759,
              0.0145379540245772,
              -0.0145234034241345,
              -0.0102280903049572,
              0.00825352085874392,
              0.0574387234794308,
              -0.322148176473418,
              0.175325596135863,
              -1.52026900776593,
              0.00412300838977242,
              -0.971577765712078,
              -0.150677676835182,
              0.00556744968644723,
              -0.000838662110357824,
              -0.310031431066058,
              -0.0933147519240433,
              -0.893666262120724,
              -0.896034043284267,
              -0.0920393442836429,
              -0.0106051240772639,
              -0.0036163864395215,
              -0.489770886736637,
              0.0407549825051186,
              -0.42761247348092,
              0.0634207085093884,
              -0.445388655644372,
              0.0251202963928855,
              -0.221900423023252,
              -0.192796376396658,
              0.0744174519372361,
              -1.08729919999251,
              -0.212575510324367,
              -0.0275704346866385,
              -5.13893730368915,
              -0.589202865356271,
              -0.912015894669857,
              -0.262126954361841,
              0.0299908564990806,
              0.0861212796616143,
              -0.12844386856117,
              -0.192192440227094,
              -1.73418122436854,
              -0.517376736418504,
              -0.336191385735828,
              -0.889572678816905,
              -0.133689534520226,
              -1.03515190330563,
              0.00410335166713727,
              -0.982241182132059,
              -0.163971504589746,
              -0.513670459701124,
              0.170253958351219,
              -0.113093444234038,
              -0.219544759820031,
              -0.0900575862813403,
              -0.24441497361357,
              -1.99794672759211,
              -3.17668723158282,
              -0.0659759783478485,
              -0.702535987932046,
              -0.0651197317592109,
              -0.0155753968378105,
              -0.657531271310355,
              -1.91329840339108,
              -0.382319078933531,
              -0.00257438272458782,
              -0.239229328613597,
              0.0246653084932542,
              0.034189768776589,
              -0.342711337328364,
              0.0365300086807634,
              -0.0733308799976062,
              -0.063506605017165,
              -0.371529951172734,
              0.0294318118408953,
              -0.999394362232715,
              0.102874992144708,
              -0.148011540532719,
              -0.807969104997031,
              -0.676583325228474,
              -0.905703231513328,
              0.0674656187309153,
              0.0336085914775279,
              0.0896347520881953,
              -0.467667777940227,
              -0.648610829501552,
              -0.0507896087062243,
              -0.938878243254157,
              -1.3509195653566,
              0.102610073433201,
              -1.45265363574774,
              -1.69544804748323,
              -0.24038410878236,
              0.1087699992609
          ],
          "y": [
              0.175379177328376,
              -0.664468592464226,
              3.71831010175375,
              1.29380782495812,
              0.284427535759225,
              0.363105486953487,
              3.04563297919523,
              0.524545518958709,
              0.33216844672596,
              0.284615715851769,
              0.985173648384367,
              0.308908543530092,
              0.788114855026906,
              0.877968417771944,
              0.575507182526014,
              0.131611874763681,
              0.143884442084032,
              0.467808292418953,
              0.300131362917235,
              0.18235307695614,
              0.412399403570709,
              0.218261013321309,
              1.4284267796497,
              1.93830865382212,
              2.55643935017949,
              0.451794069325943,
              0.193673619173874,
              2.08684122043154,
              0.857499058233787,
              0.234823021497542,
              0.0862068849364454,
              0.342730824943497,
              0.692401576360961,
              0.172262008948281,
              1.79813437992464,
              0.331807415123173,
              0.945472920244302,
              0.182500127056464,
              0.509080151527117,
              0.227552670381114,
              0.285526184422682,
              0.16231661989254,
              0.385713693062373,
              0.211197595879155,
              0.167806304482588,
              1.51886368337745,
              0.175026764334742,
              0.356347668802817,
              0.979058502444684,
              0.235361944547779,
              0.459983988195584,
              0.106699423669784,
              0.239414424463526,
              0.11595420777477,
              0.436319794329229,
              2.069368447725,
              0.252872594213713,
              0.589191700304919,
              0.376523806720338,
              0.22326996805895,
              0.273316777161105,
              0.205888843187856,
              0.624930445798724,
              0.0859531061490241,
              0.388599764457792,
              0.219120248424771,
              0.27603544291033,
              0.159744891341905,
              0.487117004778512,
              0.223093773787442,
              0.175544937575129,
              0.743407589442773,
              0.564931760521265,
              0.492764096773359,
              0.40916462372131,
              0.265590575164975,
              0.21005469523227,
              0.211154421115947,
              0.205159945752629,
              0.139797995199917,
              0.286750317955391,
              2.17411594974286,
              0.338872680102192,
              1.01027957840702,
              0.893116699653016,
              0.379146432599266,
              0.282762456183604,
              2.11882429558309,
              0.372274464238867,
              0.427717751577833,
              0.210224985850579,
              3.67938424616189,
              2.75039802540117,
              0.301421173753205,
              0.192122960086541,
              0.301352057451479,
              0.633146215592877,
              0.440115347533036,
              0.396670276356178,
              0.428065922287346,
              0.637143616036536,
              0.241617468408423,
              0.0143210091645582,
              0.589334418300095,
              3.02400842506171,
              0.52719813065278,
              0.3327308019143,
              1.32229807347671,
              0.859774913404635,
              0.304939988405637,
              0.140206603247534,
              2.81304230969871,
              0.404405290979993,
              0.349160368096371,
              0.530280325956081,
              0.170131370637229,
              0.231367128680528,
              0.101981580434153,
              0.766564714443498,
              2.44776912084123,
              0.383228908171146,
              0.182567964801053,
              0.298471940625167,
              0.2133641494755,
              0.155728555850571,
              1.8422591703647,
              0.352475109723277,
              0.326888324344011,
              0.327445700989302,
              0.234708059534355,
              0.108658331410134,
              0.489559793609441,
              0.219798102624044,
              0.470219333364594,
              0.0721524124028815,
              0.151893953563077,
              0.214202232871533,
              0.671889568602401,
              0.240193046220031,
              0.49238792667467,
              0.168658472495313,
              2.27062431425261,
              0.721422745412274,
              0.287081509423112,
              0.272091392803764,
              0.201945360965958,
              2.14298796697586,
              0.163885881351144,
              0.189269914430553,
              0.256477980934234,
              0.388693862045941,
              0.224068438661265,
              1.38091209704336,
              0.479668097332206,
              2.98608851294534,
              1.79018227574092,
              1.31427462321681,
              1.27612886139269,
              1.80018666662788,
              0.162418157698249,
              0.198721687991548,
              0.269474140542141,
              0.165832796454229,
              0.162390303548984,
              0.825571555752348,
              0.0659353066080119,
              0.251540166136313,
              0.05352130157281,
              0.0485317497412499,
              0.235887364475988,
              1.15971551356008,
              0.362077207068938,
              0.390853032270813,
              0.272016989501602,
              1.77216232956369,
              0.507524624835036,
              0.0919700168047578,
              0.104825594031316,
              0.995750097079533,
              0.169479071615482,
              0.203434138194461,
              0.373067803391572,
              0.190458263047534,
              0.153202975834491,
              0.232527863229614,
              0.263676320195798,
              0.259072530572925,
              0.239263625534189,
              0.186546089200681,
              0.593393781672554,
              0.0601929349718277,
              1.87756005710089,
              0.243690779018506,
              1.28946345593562,
              0.409608785105283,
              0.242142602280752,
              0.24900878181058,
              0.58040684795628,
              0.348126226996894,
              1.20595658186516,
              1.20849440996931,
              0.346759223405563,
              0.259476641779782,
              0.251985993968807,
              0.773054652173994,
              0.204428006406045,
              0.706432208133004,
              0.180134495949856,
              0.725485022376748,
              0.221185528775953,
              0.485946535279816,
              0.454752323327047,
              0.168347999395626,
              1.4134956564999,
              0.475951935322562,
              0.277660350106782,
              5.75611025522513,
              0.879627537234927,
              1.22562402998112,
              0.529062015432808,
              0.215965179653006,
              0.155803637871708,
              0.385778211415127,
              0.454105014273395,
              2.10683480743376,
              0.802643071171562,
              0.608445532099191,
              1.20156900968786,
              0.391400605368094,
              1.35760329738968,
              0.243711847427997,
              1.30089268693614,
              0.423857335692078,
              0.798670620777949,
              0.0656288025689221,
              0.369325365659035,
              0.483421695411553,
              0.344635141488156,
              0.5100780133573,
              2.38954315788928,
              3.65293726904359,
              0.318824064709767,
              1.00109990471208,
              0.317906325059591,
              0.264803864620811,
              0.952863084341936,
              2.29881564496119,
              0.657885977854477,
              0.250869156672734,
              0.504519950888654,
              0.221673192541722,
              0.21146471409108,
              0.615433727057397,
              0.208956405176936,
              0.32670717333373,
              0.31617734839378,
              0.646322007301727,
              0.216564373221592,
              1.31927775697774,
              0.137846724013695,
              0.406751174891107,
              1.11410491198007,
              0.973283399622571,
              1.2188580102926,
              0.175799092409616,
              0.212087629800419,
              0.15203783839471,
              0.749364164405867,
              0.943302003160809,
              0.302547055554585,
              1.25441555186256,
              1.69604844573024,
              0.138130668392393,
              1.80508875188819,
              2.06531992997131,
              0.505757663905178,
              0.131528355169496
          ],
          "z": [
              0.142798868891652,
              -3.4467841301851,
              3.65098792766455,
              1.25026024150343,
              0.250777902659096,
              0.328684340417587,
              2.98490705513685,
              0.488541296708803,
              0.298050667802411,
              0.25096423746376,
              0.94465252164786,
              0.275018850462338,
              0.74952608042215,
              0.838498542047276,
              0.539003231857223,
              0.0994607470753563,
              0.111612969998893,
              0.432360433570983,
              0.266327738597691,
              0.149704382686016,
              0.377494882488386,
              0.185260206992648,
              1.38355912709461,
              1.88844111615807,
              2.50051044296954,
              0.416503245429852,
              0.160913916034193,
              2.03551717724022,
              0.818229904384379,
              0.201659808654256,
              0.0545009971046631,
              0.308509471681969,
              0.65475136306025,
              0.139712267363519,
              1.74964138664081,
              0.297693176463804,
              0.905341097559375,
              0.14984999081783,
              0.473227582168288,
              0.194460750364903,
              0.251865778009418,
              0.129864402470062,
              0.351070851191161,
              0.178266053192675,
              0.135300255391197,
              1.47310920947971,
              0.142449911648395,
              0.321992789212365,
              0.938597340630782,
              0.202193447042554,
              0.424612854220876,
              0.0747925866683066,
              0.206206188471778,
              0.0839566186607402,
              0.40118071067151,
              2.01821574197572,
              0.219532387846204,
              0.552553559698945,
              0.341971080576321,
              0.190220044082707,
              0.239776095799169,
              0.173009357957962,
              0.587941852214406,
              0.0542497068637944,
              0.35392862186415,
              0.186111016464574,
              0.242468102400296,
              0.127317892206124,
              0.451479805323845,
              0.190045577566506,
              0.142963003698805,
              0.705257212833278,
              0.528531512097408,
              0.457071522117878,
              0.3742918227852,
              0.232125656689044,
              0.177134359792439,
              0.178223301799794,
              0.172287608067327,
              0.107566594680291,
              0.253077907728436,
              2.12193609338857,
              0.304689159683755,
              0.969512263735572,
              0.853498280367888,
              0.344567989071002,
              0.24912915079975,
              2.0671866273949,
              0.337763407009302,
              0.392663019272139,
              0.177302980546472,
              3.61244377774922,
              2.69256716571729,
              0.267604901590467,
              0.159378462659541,
              0.267536463040952,
              0.596077058436616,
              0.404939044803792,
              0.361919994584803,
              0.393007775830975,
              0.600035260501267,
              0.208387629439256,
              -0.0166799681025954,
              0.552694878206093,
              2.96349455067929,
              0.491167896978697,
              0.298607508554027,
              1.27847111556975,
              0.820483442593289,
              0.271089210860628,
              0.107971195930655,
              2.75459716219625,
              0.369579159906272,
              0.314875966943369,
              0.494219868374893,
              0.137602522022591,
              0.198237804210038,
              0.0701210064503177,
              0.728187259817854,
              2.39290583037308,
              0.348610432019929,
              0.149917163347697,
              0.264684588546759,
              0.180411361634774,
              0.123340940770261,
              1.79333349081797,
              0.318158204321467,
              0.292822322129164,
              0.293374233157162,
              0.201545974004349,
              0.0767322854229346,
              0.453898640246784,
              0.186782223647569,
              0.434747831927367,
              0.0405843422725991,
              0.119543940468338,
              0.181241226812228,
              0.634440495384016,
              0.20697717508861,
              0.456699040730967,
              0.136144067072049,
              2.2174981000083,
              0.683487951469782,
              0.253405851543375,
              0.238562727521064,
              0.169104545394739,
              2.09111335061027,
              0.131418275801736,
              0.156553393876654,
              0.223102420261563,
              0.354021796734403,
              0.191010684908211,
              1.33651037192373,
              0.44410394162219,
              2.92594647999037,
              1.74176726053261,
              1.27052634300268,
              1.23275463728092,
              1.75167354868725,
              0.129964944599344,
              0.165912483652885,
              0.23597113995017,
              0.133346099518511,
              0.129937363586962,
              0.786615481956007,
              0.0344282012153662,
              0.218213025515285,
              0.0221359275106198,
              0.0171953030623748,
              0.202713714720001,
              1.11748283495874,
              0.327666143812211,
              0.356159794206129,
              0.238489053815267,
              1.72392401736273,
              0.471687308920462,
              0.060207615888928,
              0.0729371317424541,
              0.955125258030399,
              0.136956619423879,
              0.17057872372206,
              0.338548966704026,
              0.157730089585668,
              0.120840126509846,
              0.19938715663381,
              0.230230172841965,
              0.225671527830709,
              0.206056868271848,
              0.15385627838858,
              0.556714435593076,
              0.028742139089067,
              1.82828821820458,
              0.210440609232789,
              1.24595847322255,
              0.374731628737058,
              0.208907613865877,
              0.215706463862089,
              0.543854851327308,
              0.313851966597949,
              1.16327046484886,
              1.16578340709299,
              0.312498367799465,
              0.226071676336188,
              0.218654481574523,
              0.734613557429607,
              0.171562846094219,
              0.668644410912528,
              0.147507557013072,
              0.687510393878192,
              0.188156044743665,
              0.450320813411064,
              0.419432490888237,
              0.1358366384615,
              1.36877441805381,
              0.440424220176597,
              0.244077075809519,
              5.6688054789716,
              0.840141392238654,
              1.18274505460694,
              0.493013504565068,
              0.182986886194781,
              0.123415286539535,
              0.351134736879042,
              0.418791529326156,
              2.05531470777722,
              0.763911833350833,
              0.571618589043562,
              1.15892591706193,
              0.356701997819391,
              1.31343013760292,
              0.210461471046141,
              1.25727562955485,
              0.388840458499262,
              0.759978336676846,
              0.0341247027449356,
              0.334843227194426,
              0.4478207320406,
              0.310395114560399,
              0.474215658997752,
              2.335250829324,
              3.58625613883014,
              0.284837140363153,
              0.960422605622939,
              0.2839284000382,
              0.231346660602942,
              0.912658793947729,
              2.24541298744296,
              0.620574223392453,
              0.217548595948727,
              0.468712098709276,
              0.188638926494375,
              0.178530552052084,
              0.578538257988823,
              0.17604683953374,
              0.29264294747981,
              0.282216377661456,
              0.609123648759613,
              0.183580204090682,
              1.27548041619634,
              0.105634457595988,
              0.371902040155893,
              1.07231948945745,
              0.932878868279502,
              1.17604538228788,
              0.143214666299234,
              0.179147359470195,
              0.119686414369982,
              0.711155377815616,
              0.903191468418342,
              0.268719743031446,
              1.21125424775929,
              1.64855650380373,
              0.105915617625325,
              1.7565275642586,
              2.01420692385573,
              0.469937674752132,
              0.099378046471601
          ],
          "text": [
              "ABCB8",
              "ABHD11",
              "AC004542.4",
              "AC004551.1",
              "AC005082.2",
              "AC005586.1",
              "AC007383.4",
              "AC015912.1",
              "AC018638.5",
              "AC023355.2",
              "AC027796.4",
              "AC034102.6",
              "AC048341.2",
              "AC097709.1",
              "AC130343.1",
              "AC141586.3",
              "ACACA",
              "AD000091.1",
              "ADCK5",
              "ADI1",
              "AJUBA",
              "AKAP12",
              "AL078612.2",
              "AL137058.2",
              "AL163636.3",
              "AL355312.3",
              "AL358781.1",
              "AL392172.1",
              "AL513175.2",
              "AL589743.1",
              "ALG1",
              "AMH",
              "AP006621.3",
              "ARF6",
              "ARL6",
              "ARMCX7P",
              "ARPC4-TTLL3",
              "ATMIN",
              "ATP6V0E2-AS1",
              "ATP8B4",
              "ATP9A",
              "ATP9B",
              "BBIP1",
              "BEX3",
              "BX255925.3",
              "BX890604.2",
              "C19orf33",
              "C19orf71",
              "C1DP1",
              "C2orf74",
              "C6orf226",
              "CA12",
              "CAMKK1",
              "CAV2",
              "CBS",
              "CCDC150",
              "CD40",
              "CDH1",
              "CDKN2C",
              "CEBPD",
              "CERK",
              "CIT",
              "CKS1BP2",
              "CLSTN1",
              "COCH",
              "COL5A2",
              "COPRS",
              "COX14",
              "CP",
              "CYB5A",
              "CYP24A1",
              "DANCR",
              "DAZAP2",
              "DDX60L",
              "DGCR6L",
              "DHX36",
              "DIS3L",
              "DNAJC14",
              "DNAJC9-AS1",
              "DOCK10",
              "DPP7",
              "DPY19L3",
              "EEF2KMT",
              "EIF2AK2",
              "EIF3F",
              "ETS2",
              "EXD2",
              "EXOG",
              "FA2H",
              "FAM104B",
              "FAM160A2",
              "FAM228B",
              "FAM71E1",
              "FANCI",
              "FBXO41",
              "FDXR",
              "FGA",
              "FGB",
              "FIZ1",
              "FMC1",
              "FNBP4",
              "FRAT2",
              "FRG1CP",
              "FTLP3",
              "FXN",
              "GACAT2",
              "GALNT11",
              "GATAD2A",
              "GGT8P",
              "GHDC",
              "GLP2R",
              "GNB3",
              "GPANK1",
              "GPRC5A",
              "GSDME",
              "GTF2E1",
              "H2AJ",
              "HCN2",
              "HERC5",
              "HERC6",
              "HEXD",
              "HMCES",
              "HMGB1P10",
              "HOMER3",
              "HR",
              "HSD11B1L",
              "HSP90AA2P",
              "HSP90B1",
              "HSPA2",
              "HSPA5",
              "HSPH1",
              "IFT172",
              "IGFBP3",
              "JADE1",
              "JARID2",
              "KDM1A",
              "KLC1",
              "KLHL21",
              "KRT18",
              "LARS2",
              "LBH",
              "LINC01106",
              "LINC02313",
              "LPIN1",
              "LRFN4",
              "LRRC20",
              "LRRC28",
              "MAP3K11",
              "MAPKAP1",
              "MARVELD1",
              "MB",
              "MCOLN1",
              "MED17",
              "MED20",
              "METTL21A",
              "MFSD14C",
              "MFSD8",
              "MIR6784",
              "MMP17",
              "MORC4",
              "MSH6",
              "MT-RNR2",
              "MT-TA",
              "MTA3",
              "MYCBP2",
              "MYO1E",
              "MZF1",
              "NAAA",
              "NCAPG2",
              "NCKIPSD",
              "NDUFAF4",
              "NEIL2",
              "NFYC",
              "NIF3L1",
              "NIPA1",
              "NMRAL2P",
              "NNT",
              "NPC1",
              "NPIPA1",
              "NPIPA9",
              "NR4A1AS",
              "NSMF",
              "NTRK3",
              "PACSIN3",
              "PAQR5",
              "PCED1B",
              "PDCD6",
              "PDHX",
              "PDIA4",
              "PDK4",
              "PEX6",
              "PGPEP1",
              "PIGH",
              "PIK3R4",
              "PITPNA-AS1",
              "PLEKHG2",
              "PNMA2",
              "POLE4",
              "PPP1R8",
              "PPP2R2A",
              "PPT2-EGFL8",
              "PRAME",
              "PRPF40B",
              "PSME3",
              "PSRC1",
              "PTPRM",
              "RAD54L",
              "RANBP1",
              "RAP1GAP",
              "RARRES1",
              "RBP4",
              "RNF121",
              "RNF149",
              "RPL29",
              "RPL32",
              "RPS23P8",
              "RPS27AP16",
              "RREB1",
              "RTEL1",
              "RTN4R",
              "RUVBL1",
              "SAFB",
              "SARNP",
              "SEC11B",
              "SENP2",
              "SEPTIN7P6",
              "SERBP1P1",
              "SERHL",
              "SETP14",
              "SGK2",
              "SH2D3A",
              "SLC25A20",
              "SLC37A3",
              "SLC38A6",
              "SLC6A6",
              "SLTM",
              "SMIM11A",
              "SNORC",
              "SNORD116-4",
              "SNORD14D",
              "SNORD32A",
              "SPA17",
              "SPIRE2",
              "SSB",
              "STK16",
              "STOML1",
              "SURF4",
              "SUSD2",
              "TCP1",
              "TDRD7",
              "TERF1",
              "TERF2IP",
              "TEX41",
              "TGFB1I1",
              "TIMP4",
              "TMEM79",
              "TMEM97",
              "TNFSF12",
              "TNK2",
              "TP53BP2",
              "TP53I11",
              "TRIM14",
              "TRIM16L",
              "TRIM34",
              "TRIM4",
              "TRIP6",
              "USP40",
              "WASH6P",
              "WDR60",
              "WDR92",
              "WRN",
              "YTHDC2",
              "ZNF219",
              "ZNF250",
              "ZNF566",
              "ZNFX1",
              "ZZEF1"
          ],
          "type": "scatter3d",
          "mode": "markers",
          "opacity": 0.7,
          "name": "SARS-COV2-GSE147507",
          "marker": {
            color: "#d00000"
        }
      },
      {
        "x": [
            -0.401870085340389,
            -0.249632929717614,
            -0.0277908633778464,
            -0.335346078686832,
            -0.47612096542995,
            -1.69128142501565,
            -2.39624825742782,
            -0.372912469999854,
            0.543596844549782,
            5.26463699576947,
            -0.0528009042649324,
            -4.1144757034761,
            -0.0908965400802148,
            2.40210229809597,
            -0.352455867250908,
            -0.700574245614199,
            -2.17053724329739,
            -1.3034527211255,
            -2.86200968538522,
            -0.545684426026443,
            -0.777954876028919,
            -1.18811527156978,
            -0.11450488638018,
            -0.163426359373911,
            -0.423004935556617,
            -4.06761980203906,
            -3.34708257336431,
            -3.54039100780729,
            -3.4746485753409,
            -0.457253711048157,
            -2.29438406433233,
            -2.23498422924781,
            -0.418359140981151,
            -0.941144795538471,
            -0.550227397433268,
            -0.777627604830994,
            -0.00301165193174141,
            -1.24021711453208,
            -1.54383707218409,
            0.0495912554886913,
            -0.561639218950995,
            1.04534676820926,
            -2.49375001274432,
            -0.692674739181504,
            -2.63366540161558,
            -1.44468461747491,
            -1.41099228431711,
            -11.9214630818844,
            -3.07683274844881,
            -6.56024872755486,
            -5.99831517299621,
            -3.40385989680711,
            -0.216682968070087,
            -3.21752359317875,
            -4.11958845621666,
            -7.28094568675364,
            -1.37164031497731,
            -0.760579698304713,
            0.0793504835558312,
            -0.0707437705496668,
            0.712782358111731,
            0.84273082504472,
            -1.47965505794506,
            0.629453747662577,
            -0.623340174254777,
            -0.383026852598652,
            -0.236274802600224,
            0.538372320488677,
            -0.312759491188817,
            -0.0839421431317113,
            -0.0254596658291488,
            -0.727222783486412,
            -1.34766375816705,
            -4.31063231164976,
            -1.57986643933885,
            -0.48503592109324,
            -9.95606422561402,
            -0.928155592086025,
            -1.54386828961991,
            -0.420991469752721,
            -0.661710012658935,
            -1.21513931356658,
            -0.439813917997879,
            0.4108626802541,
            -3.83916169674037,
            -0.171559522440127,
            -4.28924929864521,
            0.0239725042552176,
            0.0525327600082593,
            -1.65223965647647,
            -3.68817597881351,
            -1.98693167198693,
            0.995614179930396,
            -1.00308174104798,
            -1.30416926295461,
            -0.228756326909071,
            -1.63288986700058,
            -0.302190966435552,
            -0.334520492126229,
            -0.256416456834775,
            0.0590411841913449,
            -0.762042730344532,
            -1.00434844325461,
            -0.233599132351559,
            -1.28523271367595,
            0.0158080289067468,
            -0.155687392085768,
            -0.762582447007006,
            -0.599263999265254,
            -0.348706710768181,
            -0.625064722504822,
            -0.801731960642828,
            -0.512315714350197,
            -0.227313640033603,
            -0.885273668197803,
            -1.02453328990927,
            0.931661977828413,
            -1.40798568396234,
            -2.27580145485029,
            -2.90166865504282,
            -0.864037161806583,
            -0.683230249663749,
            -1.74522074918817,
            -1.25907382173075,
            -0.414057692202982,
            -0.835632311940677,
            -0.496763567940592,
            -0.467788027020543,
            -0.698414153030935,
            -1.43644750955831,
            -1.24057872717478,
            -0.957907209559824,
            -1.28577680394817,
            -0.316697580999331,
            -1.08179623723218,
            0.193243773112155
        ],
        "y": [
            0.658587172024811,
            0.817860095966734,
            2.51264708512547,
            3.08239876840232,
            2.06934645774092,
            0.645954878340999,
            0.41881320496071,
            2.02473292768969,
            1.23252895150593,
            -0.288496542670841,
            0.861965824954067,
            -3.52702239210568,
            0.973410409815083,
            0.516987757562314,
            0.534187802213275,
            2.3605010879025,
            7.09424170352078,
            3.94788208917592,
            9.32115650999599,
            1.34406560633143,
            0.926834019714929,
            0.687798963257545,
            0.7617261288626,
            0.941089402303635,
            0.626066060699796,
            1.69073214047879,
            3.14258272770362,
            3.80263293203261,
            5.87889595684736,
            3.29303992075039,
            2.24639332132783,
            1.35133562761195,
            2.12189369751317,
            3.30693477607092,
            2.14411186511522,
            3.03623682553244,
            0.499088273734676,
            2.53025234453174,
            2.90759845799194,
            0.65965591894269,
            1.55757957650832,
            0.477173500757646,
            3.93288447292696,
            2.1575046510199,
            2.13649477380926,
            5.09940264159339,
            3.90512358631146,
            8.95297987529719,
            1.89992939778591,
            2.24385861609222,
            3.45818934113556,
            1.6706030802829,
            1.22895079951167,
            5.18841998417381,
            3.98229303749054,
            4.10735508645961,
            4.3415169837233,
            2.63469631238862,
            0.376364556426485,
            0.770717384075437,
            1.24342496265374,
            0.333359081237896,
            0.667211088437683,
            0.721870837175787,
            0.744720900215746,
            1.14923671847607,
            1.12256038819837,
            0.234572047782972,
            0.550013717358162,
            0.83783307087664,
            0.792833359819061,
            0.528523019147768,
            3.40376002316528,
            1.16568896312832,
            4.42977771919387,
            1.28743856752,
            5.81639941238938,
            0.920848198108124,
            1.67465499302808,
            1.85714155905523,
            0.57886609704201,
            0.716211351798641,
            0.347300098488568,
            4.34636883374431,
            3.10987461114775,
            0.856719791046674,
            2.78162349230109,
            0.515455716757758,
            0.729480422382972,
            0.450034575849854,
            1.2738915724834,
            3.18588676216327,
            0.519800785245236,
            1.4125138141258,
            0.32140418580052,
            0.954890734185856,
            0.765054159969556,
            1.08785629681199,
            0.743068122880287,
            1.29260213912678,
            0.618217344420993,
            2.94777659119453,
            3.94824118351924,
            1.12569256773185,
            1.73078301036671,
            0.529449648409288,
            1.57192747460334,
            -0.136443488291946,
            1.67942307856774,
            1.59822214412598,
            0.565260276033219,
            1.86478758297157,
            1.36276655656851,
            0.853399620589562,
            2.37321287044253,
            0.514095664896521,
            0.862911368439788,
            0.794038397409102,
            0.491357733677335,
            2.00474741361666,
            0.191799003014572,
            2.25183553646883,
            0.667241793990019,
            1.09614602911598,
            1.86710995036231,
            2.97108655816281,
            1.43322469812884,
            0.177136928867909,
            1.16472954117579,
            0.306551009667926,
            2.95290880830883,
            1.22631969605318,
            3.8617030888967,
            1.24602120794429,
            2.14030297702484,
            4.23706198736247
        ],
        "z": [
            -2.08296398930909,
            -0.0231852695240683,
            -0.255993482426048,
            -0.492483080336903,
            -0.149141389834243,
            -0.11767046972119,
            1.10233589046193,
            0.714461992053434,
            0.6019182186756,
            2.62861603123795,
            -0.0986649839421497,
            -7.80884781451873,
            -0.105057103770417,
            0.779245884099939,
            0.124361040808266,
            0.0555317801789758,
            -0.47858495494496,
            0.0712603855721087,
            -0.729938423732304,
            0.455058224982261,
            0.304526298039898,
            0.514056095995612,
            0.0771446495737744,
            0.0448995214479144,
            0.166532099096424,
            -5.30572751124576,
            1.27423271689353,
            0.938503583592265,
            0.338877077419896,
            3.76905823980407,
            1.55384996225489,
            1.82819096832746,
            -0.286340705597114,
            -0.145748285041488,
            -0.0673996257078988,
            -0.25600592664144,
            0.0537301468648051,
            0.899231037240636,
            1.18703625961029,
            -0.145955422546516,
            0.341750090908813,
            -0.19742477631178,
            0.165659796141824,
            0.176139942412934,
            0.698355172656533,
            -0.44204272122828,
            5.98179820145794,
            6.75711226986489,
            2.03109561328106,
            5.02050497681625,
            3.28810785798873,
            1.99083101410001,
            -0.0516083951031163,
            2.64044553311704,
            2.1428794302578,
            5.47105163223418,
            -0.0689275159338743,
            -0.0199550192939776,
            -0.0108399303695791,
            -0.00636322368158733,
            2.10604773419104,
            1.00384771726898,
            1.06319435225962,
            0.750902744724124,
            0.357669367554932,
            0.296015314523208,
            0.0536559705439889,
            -1.1732989308351,
            0.165504062918703,
            -0.0274795715115598,
            -0.101272831781714,
            0.493292357142813,
            0.510409056457366,
            1.81090380414264,
            0.241529016204983,
            0.385136752907579,
            6.06819280241381,
            0.404057957968678,
            0.460679975816981,
            -1.33350807695981,
            0.457246081663645,
            0.652086990707022,
            -2.59814235114117,
            1.53479482607309,
            2.02623517467927,
            0.115256910363142,
            3.38020121520631,
            -0.00493965735444436,
            0.394301549078297,
            0.961329687164701,
            2.0691386862703,
            1.78767898079723,
            0.333168167734474,
            0.323650711038896,
            0.701178479792323,
            0.151514252337935,
            0.585149797941529,
            0.193473246800986,
            -1.04040239479849,
            -0.0234066504281035,
            0.889244240706168,
            -0.224965019287889,
            -0.458998051356146,
            0.0468376771813971,
            -0.302318626531691,
            0.000248667602172167,
            0.0770532943952345,
            -0.341044915341001,
            -0.508504240417591,
            -0.0625216392655585,
            0.252069940168868,
            0.563491838693985,
            0.383527486286385,
            0.21625620702934,
            0.374394672120191,
            0.735057690777869,
            0.526215118923152,
            1.07564671375394,
            1.25070074487098,
            1.89758703863533,
            0.549411754606578,
            0.0968535609617037,
            0.943839574269013,
            -5.17842783592545,
            -0.125016694975781,
            -0.110019189463509,
            0.309248122787859,
            1.02025531633822,
            0.817414499118332,
            1.02342566391455,
            0.619609677166564,
            -0.237808430726714,
            0.0970832335551124,
            0.114300687850124,
            0.877079423977477,
            0.108148218545546
        ],
        "text": [
            "ABHD2",
            "ABL1",
            "AC007969.1",
            "AC011473.2",
            "AC024293.1",
            "AC073861.1",
            "AC096772.2",
            "ACOT8",
            "ACTG1",
            "AHNAK",
            "AMIGO2",
            "AREG",
            "ARL3",
            "ARL4C",
            "ASCC2",
            "BCAM",
            "BCL2A1",
            "C3",
            "CCL20",
            "CDC42BPA",
            "CETN3",
            "CIB1",
            "CKAP4",
            "CLDN1",
            "CTSA",
            "CXCL1",
            "CXCL2",
            "CXCL3",
            "CXCL5",
            "CXCL8",
            "DDX58",
            "DTX3L",
            "DUSP4",
            "EDN1",
            "EEF1A1P11",
            "EEF1A1P13",
            "EIF3L",
            "FUOM",
            "GNL3L",
            "HMGN1",
            "HMGN1P36",
            "HNRNPAB",
            "ICAM1",
            "ID1",
            "IER3",
            "IER3-AS1",
            "IFI27",
            "IFI6",
            "IFIH1",
            "IFIT1",
            "IFITM1",
            "IFITM3",
            "INPP5E",
            "IRF7",
            "IRF9",
            "ISG15",
            "KRT4",
            "KRT8",
            "LAMB1",
            "LAMC2",
            "LAP3",
            "LDHA",
            "LGALS3BP",
            "LSS",
            "LTV1",
            "MED15",
            "MFSD10",
            "MRPL16",
            "MRPL32",
            "MRPL57",
            "MRPS18B",
            "MT-RNR1",
            "MT-TF",
            "MT-TS2",
            "MT-TV",
            "MTX1",
            "MX1",
            "NAGK",
            "NFKBIA",
            "NME2",
            "NOP58",
            "NTMT1",
            "NUAK2",
            "OAS1",
            "OAS3",
            "PAIP1",
            "PARP9",
            "PDCD11",
            "PDIA3",
            "PHF21A",
            "PLSCR1",
            "POLR2J3",
            "PRDX6",
            "PSIP1",
            "PSME1",
            "QSOX1",
            "RAD17",
            "RBM19",
            "RHOB",
            "RHOBTB2",
            "RNH1",
            "RPL10P16",
            "RPL3P4",
            "RPL7A",
            "RPLP0P6",
            "RPS10",
            "RPS3AP26",
            "RPS7",
            "RPS7P1",
            "RRBP1",
            "RRS1",
            "SAMD9",
            "SAT1",
            "SEC31A",
            "SERPINA3",
            "SHC1",
            "SNX8",
            "SP100",
            "SPSB3",
            "STAT1",
            "STIP1",
            "SULT2B1",
            "TAP1",
            "TCIM",
            "TGM2",
            "THBD",
            "THOP1",
            "TNFRSF10D",
            "TNIP2",
            "TRIM25",
            "TSC22D3",
            "TST",
            "TYMP",
            "UQCRB",
            "VEGFA",
            "ZBTB4"
        ],
        "type": "scatter3d",
        "mode": "markers",
        "opacity": 0.7,
        "name": "SARS-CoV2-common",
        "marker": {
            color: "#f07167"
        }
    },
      {
        "x": [
            0.37901681548048,
            0.385119343360487,
            0.485092851872472,
            0.453676340259176,
            0.594615040580675,
            0.481776064283028,
            0.476265433159625,
            0.869339704300712,
            0.469977292422885,
            0.413686021638322,
            0.529164928015429,
            0.449884447593635,
            0.660487368311339,
            0.367202491819218,
            0.435972083184069,
            0.430910874883584,
            0.512556276884647,
            1.66474494408788,
            0.567571874463429,
            0.309667152964496,
            0.459333920665295,
            0.315984522858032,
            0.371480983416231,
            0.958391836538111,
            0.350210782022694,
            0.429267054721253,
            0.356362588391537,
            0.385002259962283,
            0.555776187746016,
            0.533335081279693,
            0.40089862876413,
            0.789562329734846,
            1.71594211987414,
            0.417882383546076,
            1.07863729190148,
            0.324099378842145,
            0.452707449346581,
            0.580446353250426,
            0.31873055560149,
            1.39829093496588,
            0.363869559020663,
            0.626279595484337,
            0.386776811095915,
            0.42640670244288,
            0.403955372953437,
            0.363774479570745,
            0.702633104097053,
            1.22034280644123,
            0.329722896628916,
            0.506933525150993,
            0.645958968570705,
            0.523328977325061,
            0.510288863642907,
            0.415170934795902,
            0.338614191247406,
            0.525701991856928,
            0.432764376573352,
            0.456457916347386,
            0.407085075577039,
            0.341760584545445,
            0.402022289269236,
            0.443711581458888,
            0.52669041494653,
            0.34264073895588,
            0.433033727043411,
            0.338465287512732,
            0.80540965223111,
            0.296876227732249,
            4.18900908272828,
            0.326829869484571,
            0.434043112855635,
            0.346708283934696,
            0.379696921034779,
            0.648261488466973,
            0.680302129204533,
            0.443633110789043,
            0.634668757095284,
            0.589437264916755,
            0.401639710950113,
            0.39711002912107,
            0.526738015251336,
            0.399963019923218,
            0.558209114903709,
            0.53522571367725,
            0.418709739587368,
            0.35358739359121,
            0.34715177520469,
            0.407445884309233,
            0.607413107630608,
            0.336824397675949,
            0.36564699061536,
            0.727983978429869,
            0.381988736980691,
            0.381124014063835,
            0.354367895114447,
            0.490615665609325,
            0.707741424138387,
            0.350657144664211,
            0.468026544954531,
            2.0060332180397,
            0.651576600095045,
            0.393876513842698,
            0.574972831880013,
            0.846252007604377,
            0.460863107332243,
            0.497894310949211,
            0.51433281754239,
            0.481249258439988,
            0.423545861742915,
            0.349352137037966,
            0.668433439087128,
            0.297103044951707,
            0.360724480314054,
            0.575822850075879,
            0.324618183869049,
            0.31135470589918,
            0.413676054665185,
            0.324827134590511,
            0.543603277389825,
            0.415998192288525,
            0.338206668360867,
            0.839843487391465,
            0.333275254598794,
            0.31070851471208,
            0.315402176299731,
            0.525051626063622,
            0.371938567952729,
            0.331796331423636,
            0.370109185643334,
            1.14460888054,
            0.518949665297512,
            0.537406083500595,
            0.436650593165926,
            0.53506005470342,
            0.377087027879033,
            0.465747113767711,
            0.911983982466939,
            0.41443292197035,
            0.488838318849063,
            0.350511485620964,
            0.344889152764667,
            0.427779407712382,
            0.339141324823839,
            0.384748124034703,
            0.464862549183208,
            0.427095339204863,
            0.581608972680289,
            0.380784430019404,
            0.381638091406565,
            0.340957889191924,
            0.571640763448668,
            0.390528960305989,
            1.32559133030943,
            0.621966682905464,
            0.36848584638238,
            0.365051111820309,
            0.336486681738604,
            0.386969079263106,
            0.381444958905433,
            0.53419179523095,
            0.497058776223325,
            0.464093546049813,
            0.419267600294661,
            0.698887202672071,
            0.784097108211038,
            0.352659756347783,
            0.436228980247902,
            0.369405154836123,
            0.398557460057113,
            0.347092542953675,
            0.391947224173352,
            0.330206616224639,
            0.385543327635443,
            0.399357044612427,
            0.420517857927047,
            0.54084287077526,
            1.08978073482388,
            0.536435826404623,
            0.370457410391036,
            0.376766208012927,
            0.351873176708764,
            0.363208058405887,
            0.473390422373725,
            0.329668169248476,
            0.363189358784557,
            0.343542004583864,
            0.483099225163978,
            0.345953142452967,
            0.388351733208188,
            0.655248827888839,
            0.453164189353178,
            0.377431055882205,
            1.26622320187309,
            0.791108474318278,
            0.424044175458247,
            0.371387679820624,
            0.565529741795475,
            0.44890393322621,
            0.385206565725969,
            0.349480432849842,
            0.336471950662546,
            0.321775835640924,
            0.364384927410872,
            0.381328613676873,
            0.320623258259276,
            0.650508115857697,
            0.376491647029856,
            0.35452566114555,
            0.402210183678337,
            0.358324641904866,
            0.84533112108873,
            0.3525219559369,
            0.821571157737734,
            0.414769519397647,
            0.543667277429761,
            1.09430180472382,
            0.403336564204117,
            0.362073982150876,
            0.286213057767358,
            0.510575360360958,
            0.394590452242043,
            0.446002352901891,
            0.393393452071132,
            0.437692087473026,
            0.45715080207799,
            0.3368073621458,
            0.483389997053408,
            0.368139453386083,
            0.417186521494285,
            0.369124132553874,
            0.57849861157936,
            0.394202255829776,
            0.366243446304703,
            0.430342372565578,
            0.343291928590209,
            1.01482564692282,
            0.453846785663391,
            0.428276360821159,
            1.22508900805861,
            0.431502761309603,
            0.371681618419463,
            0.349844333660324,
            0.386458537113392,
            0.420336006911945,
            0.628724527728731,
            0.471735050040815,
            0.343209017988157,
            0.403461900781272,
            0.365870228473829,
            0.364186648348263,
            0.504941932659271,
            0.394691075903364,
            0.969819893960737,
            0.492885306003462,
            0.418603115970517,
            1.3851201396768,
            0.314836189136979,
            1.51795756898195,
            0.416560028402208,
            0.325930630578441,
            0.430791503645068,
            0.526409125123286,
            0.335554071232429,
            0.320121415510586,
            0.691556397928828,
            0.511013983454313,
            0.395128714386438,
            0.403778160574993,
            0.470318312781926,
            0.409713679843211,
            0.338356064795252,
            0.412981583038215,
            0.359266562775213,
            0.403590889861353,
            0.363900499510845,
            0.480571919014136,
            0.319238672286369,
            0.42434629264414,
            0.558958754769795,
            0.388923780375902,
            0.487815950207327,
            0.433635811275357,
            0.360888958344203,
            1.05923083513234,
            0.409056818634411,
            0.345428185216677,
            0.412693196025725,
            0.352960934853951
        ],
        "y": [
            0.035376248477943,
            0.0398752551190646,
            0.113579380290739,
            0.0904179794469735,
            0.194323141570833,
            0.111134123229155,
            0.107071484514765,
            0.396860206678839,
            0.102435637290275,
            0.0609356546475669,
            0.146070925950824,
            0.0876224575550408,
            0.24288662964556,
            0.0266662971827566,
            0.0773657539228611,
            0.0736344461429188,
            0.133826421180552,
            0.983262026801524,
            0.174385930901619,
            -0.0157508579202351,
            0.0945889545445556,
            -0.0110934618928352,
            0.0298205575953972,
            0.46251269401195,
            0.0141393875607577,
            0.0724225618266891,
            0.0186747241053059,
            0.0397889369577321,
            0.165689719442742,
            0.149145315384076,
            0.0515083211564567,
            0.33804540975526,
            1.02100645638844,
            0.0640293660508998,
            0.551162039476948,
            -0.00511089340939057,
            0.0897036776468015,
            0.183877467311218,
            -0.00906898616859789,
            0.786822390610626,
            0.0242091372828013,
            0.217667408995888,
            0.0410972009250917,
            0.0703138055621734,
            0.053761864717144,
            0.0241390412365356,
            0.273958006773733,
            0.655632525074659,
            -0.000965030520007334,
            0.129681123053531,
            0.232175762247129,
            0.141768449759073,
            0.132154801249707,
            0.0620303869107866,
            0.0055899569086958,
            0.14351792282143,
            0.0750009153464303,
            0.0924686590243076,
            0.0560691959027092,
            0.00790959306961116,
            0.0523367247580855,
            0.0830715949811936,
            0.144246624456521,
            0.00855847507648122,
            0.0751994903595089,
            0.00548017963207263,
            0.34972863522454,
            -0.0251807955948347,
            2.84424182844985,
            -0.00309787589020132,
            0.0759436464800445,
            0.0115572179306861,
            0.0358776471549539,
            0.233873264087073,
            0.257494795737317,
            0.0830137435347586,
            0.22385220561513,
            0.190505896069254,
            0.052054674035446,
            0.048715227001079,
            0.144281717141332,
            0.0508185561162106,
            0.167483362283061,
            0.150539158702744,
            0.0646393231699062,
            0.0166287490466772,
            0.0118841759074811,
            0.0563351972900414,
            0.203758344454511,
            0.0042704556589589,
            0.0255195248313582,
            0.292647598074945,
            0.0375672576513949,
            0.0369297523057154,
            0.0172041633021291,
            0.11765100047312,
            0.277724047051277,
            0.0144684624176075,
            0.100997474943811,
            1.23487221871506,
            0.236317285568666,
            0.0463313613313741,
            0.17984218726334,
            0.379839112665435,
            0.0957163268573722,
            0.12301708390058,
            0.135136151897816,
            0.110745742703409,
            0.0682046892154045,
            0.0135063630888309,
            0.248744763503206,
            -0.0250135776489722,
            0.021890470286745,
            0.180468851751151,
            -0.00472841137778316,
            -0.0145067322055027,
            0.0609283066306113,
            -0.00457436526738279,
            0.156715404927325,
            0.0626402713761118,
            0.00528951613906758,
            0.375114517290441,
            0.00165389763769676,
            -0.0149831279712186,
            -0.0115227890642549,
            0.143038449383409,
            0.030157905643462,
            0.000563581408492192,
            0.0288092181288857,
            0.599798706321589,
            0.138539860839384,
            0.152146607043532,
            0.0778659762855386,
            0.150417028851299,
            0.0339535385115851,
            0.0993169949445172,
            0.428299127474966,
            0.0614862968765124,
            0.11634067546761,
            0.0143610772461188,
            0.0102160879307977,
            0.071325814068357,
            0.00597857905148033,
            0.0396015786615616,
            0.0986648615961028,
            0.0708214937573609,
            0.184734592856385,
            0.0366793985341055,
            0.0373087489157214,
            0.00731781671114177,
            0.177385664606491,
            0.0438634224887663,
            0.733225584403832,
            0.214487772177104,
            0.027612433081864,
            0.0250802212003132,
            0.00402147912418496,
            0.0412389480466253,
            0.0371663645756096,
            0.149776916227536,
            0.122401097156306,
            0.098097924373985,
            0.0650505984768416,
            0.271196391305626,
            0.334016248657714,
            0.0159448609595127,
            0.077555147829615,
            0.0282901808808013,
            0.0497823260003568,
            0.0118405077266999,
            0.0449090184587632,
            -0.000608414750871866,
            0.0401878318260078,
            0.0503718089646676,
            0.0659723341086681,
            0.154680332259847,
            0.559377392966292,
            0.151431298043031,
            0.0290659421428222,
            0.0337170183781916,
            0.0153649656949107,
            0.0237214548473416,
            0.104951921462634,
            -0.00100537754551759,
            0.0237076688029013,
            0.00922292104468385,
            0.112109605800922,
            0.011000500024912,
            0.0422582910801372,
            0.2390245861426,
            0.0900404030765494,
            0.0342071685320352,
            0.689457229820618,
            0.339185284064033,
            0.0685720643030277,
            0.0297517707738494,
            0.172880396045273,
            0.0868995865190533,
            0.039939558635456,
            0.0136009474514112,
            0.00401061883639613,
            -0.00682389439828865,
            0.0245890857002056,
            0.0370805906199233,
            -0.00767361657840788,
            0.235529559928687,
            0.0335146019844422,
            0.0173204741876563,
            0.052475247385265,
            0.0201212216814372,
            0.379160201461574,
            0.0158432694590876,
            0.361643487894536,
            0.0617344488047907,
            0.156762588096393,
            0.562710490971703,
            0.0533056562855698,
            0.0228853723741177,
            -0.0330420743027333,
            0.132366017103615,
            0.0468577028185681,
            0.084760435431907,
            0.0459752305342548,
            0.0786338039622761,
            0.0929794797144899,
            0.00425789644337109,
            0.112323973467456,
            0.0273570595020258,
            0.0635163511079334,
            0.0280830009810937,
            0.182441520948396,
            0.0465715102322841,
            0.0259592537699636,
            0.073215325451544,
            0.00903855588022059,
            0.504117762058653,
            0.0905436380298737,
            0.071692186067089,
            0.65913159841223,
            0.0740708064535658,
            0.0299684730543236,
            0.0138692284318936,
            0.0408625577101449,
            0.0658382668924711,
            0.21946990242499,
            0.103731520463945,
            0.00897743115345374,
            0.0533980589921342,
            0.0256841039414496,
            0.0244429071268314,
            0.128212848262682,
            0.0469318862601576,
            0.470937875715414,
            0.11932426234213,
            0.0645607163417617,
            0.77711239884335,
            -0.0119400554912302,
            0.875045007818623,
            0.0630544774979654,
            -0.00376082768496317,
            0.0735464413020723,
            0.144039247315812,
            0.00333392456591598,
            -0.00804359339843241,
            0.265791854059239,
            0.132689386082628,
            0.0472545293484771,
            0.0536312172734639,
            0.102687049965523,
            0.0580070990606994,
            0.00539965665192963,
            0.0604163167596521,
            0.0208156401805289,
            0.0534931544573782,
            0.024231947743244,
            0.11024638331741,
            -0.00869438397346074,
            0.0687947961368606,
            0.168036024196663,
            0.0426800251643045,
            0.115586947930549,
            0.0756433688654821,
            0.0220117295033368,
            0.536854890111672,
            0.0575228369649258,
            0.0106134823596408,
            0.0602037073115808,
            0.0161669007643371
        ],
        "z": [
            0.0150453243692776,
            0.0201207447882899,
            0.103267859629733,
            0.0771390147196329,
            0.194356530396104,
            0.100509315664347,
            0.0959261707323923,
            0.422842691421134,
            0.090696377682625,
            0.0438794076056599,
            0.139922229681375,
            0.0739853299123187,
            0.24914198386489,
            0.0052194520871307,
            0.0624145350237955,
            0.0582051712227193,
            0.126108956110336,
            1.08437444920815,
            0.171864959656068,
            -0.0426321987991779,
            0.0818443761174064,
            -0.0373780961088562,
            0.0087778370779133,
            0.496906590710321,
            -0.00891240811096047,
            0.0568380200058589,
            -0.00379600319283978,
            0.020023367524039,
            0.162054587561256,
            0.143390510604301,
            0.0332442419536949,
            0.356492529028047,
            1.1269547038978,
            0.047369486033971,
            0.596913710947191,
            -0.0306290395590209,
            0.0763331964065872,
            0.18257255391938,
            -0.035094244083684,
            0.86276692111211,
            0.00244748028895117,
            0.220691670796446,
            0.0214992465753622,
            0.0544590893979736,
            0.0357865100398328,
            0.00236840352092488,
            0.284194233061803,
            0.714768979472548,
            -0.025952007751405,
            0.121432561422567,
            0.237058837642688,
            0.135068519238644,
            0.124223167844924,
            0.0451143972212146,
            -0.0185571938078287,
            0.137042135196895,
            0.0597467127785959,
            0.079452427841659,
            0.0383894570338657,
            -0.0159403653221401,
            0.0341787808175545,
            0.0688514097664119,
            0.137864198255062,
            -0.015208348401539,
            0.0599707292685634,
            -0.0186810357746807,
            0.369672612063427,
            -0.053270302283227,
            3.18378341613971,
            -0.0283581137667941,
            0.0608102268444456,
            -0.0118254059149717,
            0.015610962361475,
            0.238973823813416,
            0.265621751596005,
            0.0687861463791963,
            0.2276688649979,
            0.190050218512495,
            0.0338605936906902,
            0.0300932959251081,
            0.137903787022818,
            0.0324661040559671,
            0.164078032339702,
            0.144962933453338,
            0.0480575910010166,
            -0.00610410905212899,
            -0.0114565580060985,
            0.038689538580848,
            0.205000573669044,
            -0.0200457498647624,
            0.00392575499518885,
            0.305278339150057,
            0.0175170461479341,
            0.0167978634690029,
            -0.00545497258835551,
            0.107861136737448,
            0.288442779296156,
            -0.00854117210686731,
            0.0890739576416358,
            1.36822099746556,
            0.241730973896015,
            0.0274040088310161,
            0.178020272852658,
            0.403640850881503,
            0.0831161876333086,
            0.113914724022454,
            0.127586489831903,
            0.100071175735257,
            0.052079752574013,
            -0.00962653582555102,
            0.25575066319571,
            -0.0530816603352248,
            -0.000168254862251041,
            0.178727225740488,
            -0.0301975538405109,
            -0.0412286754083351,
            0.0438711181590619,
            -0.0300237713065957,
            0.151930481781578,
            0.0458024202261725,
            -0.0188961271187816,
            0.398310939247534,
            -0.0229975419086465,
            -0.0417661071104236,
            -0.0378624287773933,
            0.13650123151041,
            0.00915840623640533,
            -0.0242275497068803,
            0.00763692456358855,
            0.651781718866923,
            0.131426282755191,
            0.146776328449642,
            0.0629788459919933,
            0.144825156296904,
            0.01344033647093,
            0.0871781741537431,
            0.458309574066276,
            0.044500598245126,
            0.106382932587286,
            -0.00866231549151833,
            -0.0133383618025599,
            0.0556007566694888,
            -0.0181187813056686,
            0.0198120048393603,
            0.0864424893289622,
            0.0550318227228801,
            0.183539494588869,
            0.0165154343139109,
            0.0172254172128848,
            -0.0166079602053776,
            0.17524901994132,
            0.0246198770895429,
            0.802303279620799,
            0.217104658168459,
            0.00628680713782095,
            0.0034301676806975,
            -0.0203266253311146,
            0.0216591543710948,
            0.0170647905579816,
            0.144103032294814,
            0.113219816913148,
            0.0858029159780064,
            0.0485215589959906,
            0.281078798777226,
            0.351947150872998,
            -0.00687561704017872,
            0.0626281941219594,
            0.00705138814248678,
            0.0312971118965138,
            -0.011505820964364,
            0.0257994350585519,
            -0.0255497022869346,
            0.0204733688956709,
            0.0319621195553993,
            0.0495613876114773,
            0.149634675130332,
            0.606181617437506,
            0.145969373893527,
            0.0079265401179367,
            0.0131735133230021,
            -0.00752980862103755,
            0.00189731586636466,
            0.0935350487687479,
            -0.0259975240472134,
            0.00188176355070234,
            -0.0144587734612572,
            0.101609777290228,
            -0.0124534506483956,
            0.0228090958712864,
            0.244785134449538,
            0.0767130631767588,
            0.0137264616286263,
            0.752927313262405,
            0.357778444298538,
            0.0524941958433598,
            0.00870023727278041,
            0.170166535323551,
            0.0731698444709706,
            0.0201932868861664,
            -0.00951983329242488,
            -0.0203388770415024,
            -0.0325615106332743,
            0.00287610778601677,
            0.0169680272231309,
            -0.0335200994168618,
            0.240842324663719,
            0.0129451632937782,
            -0.00532375992510617,
            0.0343350509959657,
            -0.00216418001061876,
            0.402874957416203,
            -0.00699022446728112,
            0.383113998430384,
            0.0447805434562064,
            0.151983710069248,
            0.609941752735065,
            0.0352718520778344,
            0.00095411431209419,
            -0.0621387698486956,
            0.12446144472319,
            0.0279977853120421,
            0.0707566248487057,
            0.0270022504732894,
            0.063845047929367,
            0.0800286949975481,
            -0.0200599181699742,
            0.101851609792087,
            0.00599871503550214,
            0.0467907434971205,
            0.00681766430581282,
            0.180952633774373,
            0.0276749256649992,
            0.00442182210774417,
            0.0577323526908259,
            -0.0146667595334978,
            0.543842109757697,
            0.0772807727094182,
            0.0560140683339622,
            0.71871635490045,
            0.0586974381179182,
            0.0089447034998609,
            -0.00921718009028742,
            0.0212345408171091,
            0.0494101436723404,
            0.222725100103169,
            0.0921582897100893,
            -0.0147357155744832,
            0.0353760934406681,
            0.00411142001916673,
            0.00271120077980247,
            0.119776170923811,
            0.0280814731534323,
            0.506411208654382,
            0.109748777306524,
            0.0479689130477566,
            0.851812882939856,
            -0.0383331554761008,
            0.962292640568382,
            0.046269694532754,
            -0.0291060030997862,
            0.0581058911811826,
            0.137630251906823,
            -0.0211022695394,
            -0.0339374777531706,
            0.274981830961061,
            0.124826243811049,
            0.0284454533493144,
            0.0356391240152636,
            0.090980001408335,
            0.0405756447954556,
            -0.0187718753777793,
            0.0432935320266827,
            -0.00138079245181508,
            0.0354833725590503,
            0.00247321323089437,
            0.0995078383085097,
            -0.0346716477681267,
            0.0527454641315786,
            0.164701501426292,
            0.0232848626244653,
            0.105532637302766,
            0.0604714775920234,
            -0.0000314598866093807,
            0.580773526275609,
            0.0400293389272717,
            -0.0128900531070099,
            0.0430536830066451,
            -0.00662512944388607
        ],
        "text": [
            "AARS1",
            "ABCC3",
            "AC004854.2",
            "AC010327.4",
            "AC011495.3",
            "AC011511.5",
            "AC020765.2",
            "AC027309.2",
            "AC040169.1",
            "AC044860.1",
            "AC073046.1",
            "AC073052.2",
            "AC078817.1",
            "AC089999.3",
            "AC092718.4",
            "AC114271.1",
            "AC122108.2",
            "AC137630.1",
            "AC138466.2",
            "ACAD9",
            "ADH5",
            "ADIPOR2",
            "AEN",
            "AGPAT5",
            "AHNAK2",
            "AKIRIN2",
            "AKT1S1",
            "AL118506.1",
            "AL133352.1",
            "AL356056.2",
            "ALG3",
            "ALS2CL",
            "AMIGO3",
            "AMMECR1L",
            "ANKRD16",
            "ANKRD40",
            "ANXA10",
            "AP2B1",
            "APEX2",
            "APOC1",
            "APOO",
            "ARF1",
            "ARHGAP1",
            "ASB3",
            "ASB7",
            "ATIC",
            "ATP5MD",
            "B3GALT5",
            "BAIAP2L1",
            "BANF1P3",
            "BBS4",
            "BNIP3",
            "BUD13",
            "C1orf174",
            "C4orf19",
            "C6orf132",
            "CASC11",
            "CCDC120",
            "CCDC167",
            "CCDC93",
            "CCDC97",
            "CCNE1",
            "CCNJL",
            "CDC25C",
            "CGAS",
            "CHCHD3",
            "CHST15",
            "CLASP1",
            "CLDN4",
            "CLMN",
            "CNOT3",
            "COL6A1",
            "COQ10B",
            "CTH",
            "CYP1A1",
            "CYP1B1",
            "DALRD3",
            "DAW1",
            "DDIT4-AS1",
            "DIDO1",
            "DNAJC19",
            "DND1",
            "DPM1",
            "DPM3",
            "DPP4",
            "EAPP",
            "ECPAS",
            "EIF4A1P10",
            "ENOSF1",
            "ENTPD4",
            "ESYT1",
            "EVPL",
            "FAM83H",
            "FCSK",
            "FOXK1",
            "FRG1",
            "FTH1",
            "FUT8",
            "GAPDHP1",
            "GEMIN7-AS1",
            "GNE",
            "GOLGA7",
            "GTF2H2C",
            "GTF3C2-AS1",
            "H1FX-AS1",
            "HIBCH",
            "HINT2",
            "HLA-DRA",
            "HMGB1P6",
            "HMGB2",
            "HNRNPA1P33",
            "HNRNPUL2",
            "HOOK2",
            "HOXB-AS3",
            "HOXB4",
            "HOXB8",
            "HPDL",
            "HSBP1",
            "HSBP1L1",
            "HSPG2",
            "IER5L",
            "IGHMBP2",
            "IGSF3",
            "IKBKGP1",
            "IMPDH1P10",
            "INTS12",
            "JUN",
            "LATS2",
            "LDHB",
            "LETMD1",
            "LGALS9",
            "LIMA1",
            "LRRC23",
            "LRRC41",
            "LRRC42",
            "LSM5",
            "LY6G5B",
            "LYZ",
            "MAP4",
            "MARK2",
            "MAT2A",
            "MCU",
            "MDN1",
            "MED13",
            "MELTF",
            "METTL27",
            "MIR1244-1",
            "MMAB",
            "MOB3B",
            "MROH8",
            "MRPS33",
            "MRPS6",
            "MT-TC",
            "MT1B",
            "MTPAP",
            "MTPN",
            "MYH10",
            "NARS1",
            "NBEAL2",
            "NDRG3",
            "NDUFB6",
            "NME1-NME2",
            "NSA2",
            "NUDT6",
            "OCEL1",
            "ODAM",
            "OIP5-AS1",
            "ORMDL3",
            "OSTC",
            "PAM16",
            "PANK2",
            "PARVB",
            "PATL1",
            "PDF",
            "PDLIM2",
            "PDLIM4",
            "PEX2",
            "PFDN4",
            "PFKFB2",
            "PHKG1",
            "PIK3AP1",
            "PIR",
            "PLCG1",
            "PLCXD1",
            "PLEC",
            "PLPBP",
            "PLPP2",
            "PLS1",
            "POLR2L",
            "PPAT",
            "PPCDC",
            "PREPL",
            "PRICKLE1",
            "PRMT3",
            "PRR12",
            "PRR15",
            "PRSS33",
            "PSMC6",
            "PSMD1",
            "PSPC1",
            "PTPRF",
            "PTPRR",
            "PYGO2",
            "RAB11A",
            "RAB25",
            "RAB3IP",
            "RAP1A",
            "RFWD3",
            "RHOQ",
            "RNASET2",
            "RNF214",
            "RPA2",
            "RPL35P1",
            "RRM1",
            "RWDD2B",
            "SACS",
            "SAFB2",
            "SAR1B",
            "SEC23B",
            "SERPINA4",
            "SF3B5",
            "SIK1B",
            "SIK2",
            "SLC15A4",
            "SLC25A17",
            "SLC25A19",
            "SLC25A46",
            "SLC30A1",
            "SLU7",
            "SMG8",
            "SMIM12",
            "SMIM20",
            "SORD",
            "SORD2P",
            "SPAG4",
            "SPIDR",
            "SRCAP",
            "SRP9P1",
            "STX6",
            "SUCLG2",
            "TAB2",
            "TADA3",
            "TAF4",
            "TAF9",
            "TBKBP1",
            "TEF",
            "TFDP1",
            "TM4SF4",
            "TM9SF2",
            "TMEM168",
            "TMEM53",
            "TONSL",
            "TPM1-AS",
            "TPRN",
            "TRAPPC9",
            "TRIM32",
            "TSPAN33",
            "TWNK",
            "TXNRD3",
            "UBASH3B",
            "UNC5A",
            "UQCRQ",
            "USP5",
            "VANGL1",
            "VAPB",
            "VPS9D1-AS1",
            "VSIG1",
            "WDR55",
            "WDR62",
            "WNK2",
            "WNT7B",
            "WWP2",
            "YIPF2",
            "YIPF5",
            "ZBED3",
            "ZC3HC1",
            "ZDHHC24",
            "ZMIZ2",
            "ZMYM1",
            "ZNF142",
            "ZNF384",
            "ZNF473",
            "ZNF526",
            "ZNF580",
            "ZNF768",
            "ZNF786",
            "ZNRD2",
            "ZNRF2"
        ],
        "type": "scatter3d",
        "mode": "markers",
        "opacity": 0.7,
        "name": "MERS-GSE139516",
        "marker": {
            color: "#0077b6"
        }
    },
    {
        "x": [
            0.147143019495434,
            0.195952635078871,
            0.0229968229198445,
            0.203093636064408,
            -0.131738801161871,
            0.0269062590929038,
            -0.254601853792332,
            0.0826600180919084,
            0.143549298708887,
            -0.242011789145323,
            -0.238091751471246,
            0.121145930773789,
            0.154003591932551,
            -0.00681022044088342,
            -0.129796556309702,
            0.176875560593406,
            0.189221080669097,
            -0.261849672022985,
            0.14230824785495,
            -0.0143668965031816,
            -0.118910339342738,
            0.000448787525499594,
            -0.118231645083635,
            0.142860609747954,
            0.0247465322471317,
            0.0405372894998552,
            0.102800610007898,
            0.139605104360189,
            0.0256704559326862,
            0.0491281408426397,
            0.236267864222448,
            0.151082722935844,
            -0.153145641502119,
            -0.00154495426774021,
            -0.0201406817831231,
            -0.187340563123037,
            0.190141154775925,
            -0.151497763990319,
            0.00839001777384329,
            0.0467252721089693,
            0.209901808968094,
            0.0478490026709216,
            0.233205602825142,
            0.0146889514796656,
            0.00869680282256791,
            0.105906707214187,
            0.0922979679834297,
            0.193046826117896,
            0.109474093507579,
            0.139237591968029,
            -0.102586812049654,
            -0.160222763114884,
            0.218738151027504,
            0.163536430956544,
            0.106161301336797,
            0.198790597041406,
            -0.0528500467066479,
            0.167438518956825,
            0.192411110509467,
            0.156415257743334,
            0.172653579015817,
            0.00153612065717457,
            0.211085490453283,
            0.197445052995997,
            -0.227811292727497,
            0.211370305627018,
            0.196528820307194,
            0.193361138336685,
            -0.175410682107225,
            -0.00465224151389199,
            0.0342243484661661,
            0.232027771227238,
            0.0731203679597761,
            0.0691181885576954,
            -0.20902667626618,
            0.219061681143666,
            0.0464746597729362,
            -0.019508694652168,
            0.170868227778542,
            0.189515104585801,
            0.0424906025148344,
            -0.0770696051098447,
            -0.104900538711458,
            0.219275743487803,
            0.140911919163871,
            0.151355349099846,
            0.168884969266095,
            -0.0233458142375596,
            0.0582265213321554,
            0.16140476016456,
            0.150303422092091,
            0.16215723525823,
            0.0708935706212455,
            0.243064211515873,
            0.110415979885985,
            0.0238816360101342,
            0.149743414499936,
            0.147417379111309,
            0.232056719776567,
            0.0221256162978741,
            0.074097818317737,
            0.117268351291579,
            0.174987381281399,
            0.149758835103417,
            0.0544259783233677,
            0.00212999283077592,
            0.0197086690602815,
            -0.134372185992949,
            0.075142803051871,
            0.17200817157133,
            -0.0783925607433361,
            0.0894372324683129,
            -0.0314941437468725,
            0.121691265051943,
            0.0471190288092816,
            0.16719223496161,
            0.191945303338288,
            0.0429326185513923,
            -0.0303700609189165,
            0.210267742858772,
            -0.0593415210914176,
            0.147589691448072,
            0.196294675398786,
            0.213075780244801,
            0.0217007770007569,
            0.0487204084886136,
            0.090812025852563,
            -0.205725949641932,
            0.192950873636539,
            0.239223433484505,
            0.247260533197006,
            0.218890065997285,
            0.187053728292975,
            0.196244257700193,
            0.115210846779815,
            -0.0506035741413233,
            0.186034387689508,
            0.101465934035362,
            0.156137413754113,
            0.184380145303782,
            0.0608229053704372,
            -0.0968002806388503,
            0.172737838200773,
            0.130600097005421,
            -0.0237589365613544,
            0.176923005210884,
            0.191177173444751,
            0.0069215656174122,
            0.210955990315459,
            0.0592715335682339,
            0.190115801655356,
            -0.194104324505555,
            0.0805321393599446,
            0.122512283784045,
            0.102333609909667,
            0.193129812034748,
            -0.0412676287180456,
            0.120207617920323,
            0.0956573094851422,
            0.236457759318966,
            0.213551477846985,
            0.112508195840845,
            0.209232389734727,
            0.126848134646719,
            -0.0856002517429113,
            0.0297882980599029,
            0.0287211887107066,
            0.180509498403637,
            -0.0101153556777099,
            0.152479558079068,
            0.185555422638233,
            -0.0495757409712356,
            0.202355039506324,
            -0.190819358389978,
            0.223997371233933,
            -0.0374667016714154,
            0.107996660340784,
            0.0420885864043691,
            0.128763802110833,
            -0.107425683082897,
            -0.834516189133706,
            -0.204142356450705,
            -0.129173167700507,
            0.0814064927164714,
            0.00380762676140145,
            -0.0648561335654604,
            0.232898015621815,
            0.212798870190222,
            0.215747513986246,
            0.108652873811909,
            0.212557295214907,
            -0.00791850317029402,
            0.212122596760561,
            0.174537025647181,
            0.00861957926107526,
            0.235313779028557,
            -0.021456208341851,
            -0.276380299211732,
            0.160976252824624,
            0.181160128550134,
            0.113027902426598,
            -0.122094412367677,
            0.143660023336791,
            0.189974118677883,
            0.108137178234495,
            -0.0072711891795062,
            0.239252667621872,
            0.0623421377209011,
            -0.053666704445788,
            -0.111106852441496,
            -0.286596525527472,
            -0.179297761742384,
            0.164218221759454,
            0.0981255908028817,
            0.0347633364421052,
            0.221881236082009,
            -0.103641658971929,
            0.157282062987318,
            0.121731748162021,
            0.199915590643588,
            -0.0933332124332026,
            0.0953422482274533,
            -0.0167463917141844,
            0.160803154377283,
            0.190287726397846,
            0.0593002816889508,
            0.176975776354008,
            -0.236274620092665,
            0.165507085935831,
            0.143895713025069,
            0.159215710730692,
            0.178210631421125,
            0.226270534175077,
            -0.138314980187592,
            -0.0370926178020879,
            -0.438727771115963,
            -0.190905322782241,
            -0.0289521265726567,
            0.0273723441209716,
            0.147766237296627,
            0.17210394507167,
            -0.0647941074050147,
            0.128420130293656,
            0.121638917798027,
            -0.0169332578693197,
            0.22048318055096,
            0.203554576836209,
            0.160106848798764,
            0.0240857103026423,
            0.197240783034083,
            0.212801000063445,
            0.214457849901517,
            0.233848720602789,
            0.121757954746472,
            0.194693277023055,
            -0.120238603230686,
            0.186823831047908,
            0.186354045724838,
            0.231280360939985,
            -0.220213209184124,
            0.217324326600153,
            0.157794523044056,
            0.00634256049964177,
            -0.327142884551384,
            0.136689482008652,
            0.112086550286929,
            0.225925737252213,
            -0.281910650914073,
            0.0781927694898297,
            -0.0494215088024911,
            0.186524697427401,
            0.228903066944502,
            0.197752148207036,
            0.0731424277720714,
            0.0322134913404448,
            -0.0715601170712055,
            -0.0804242449315378,
            -0.426003768608822,
            0.207529361684162,
            0.205838144597086,
            -0.0719692234463206,
            0.0785653245911525,
            0.0569279104592755,
            0.211253759051521,
            0.114042980410367,
            0.140132826333404,
            0.176944573910246,
            0.103017944775689,
            0.0989797890512822,
            0.141748517222318,
            0.216865205486077,
            0.116922376336046,
            0.233743394767789,
            0.218689549660394,
            0.0991825800289484,
            0.180202388386816,
            0.233627306835609,
            -0.0370897649910945,
            0.152328589439871,
            0.185401469811702,
            0.206200966946367,
            0.1680792461461,
            0.181261882555948,
            -0.159483566380875,
            0.176714639754277,
            -0.271791228442582,
            -0.0759741710749804,
            0.204213112284895,
            0.164241447192817,
            0.162994562324095,
            0.207647480363518,
            0.179298080798576,
            0.118320661678826,
            -0.117932781198363,
            -0.0208370237772821,
            0.0420659146686052,
            0.104267129451094,
            0.14281426709512,
            0.202492372388924,
            0.115612018634241,
            -0.0143443522286089,
            -0.029742447339062,
            0.107053450713071,
            0.111215292878836,
            0.210684932763739,
            0.211376213585921,
            0.127313699129147,
            0.0642421512419181,
            0.181256636241005,
            0.210749487351287,
            0.212772496406723,
            0.204347354171454,
            0.217167674231195,
            0.203646738446433,
            0.198001037699054,
            0.199022114924299,
            0.193181209057916,
            0.206320809518631,
            0.210231146301683,
            0.0276897201151665,
            0.113920521497895,
            0.157232175322878,
            0.165564960202224,
            0.170590140912838,
            0.153373348240477,
            0.177137901669235,
            0.136086908158773,
            0.167709248766386,
            0.19426257171306,
            0.0961252160882339,
            0.221762414162897,
            0.112399728407366,
            0.137500948735374,
            0.0939375943445009,
            0.057926626288307,
            0.116240995025021,
            -0.00731860174384064,
            0.101625587965022,
            -0.0503918892477445,
            0.164589220836094,
            -0.157607708469178,
            0.181529559543749,
            -0.171770283747252,
            0.209506646395722,
            0.21414441145697,
            0.0613216307863379,
            0.127006902217131,
            0.23576890366812,
            0.180845529914904,
            0.223815266998613,
            -0.231068183015854,
            -0.167567954012511,
            -0.0545204569820261,
            -0.077208579901957,
            -0.018688289396677,
            -0.0801961672039886,
            -0.114296920399194,
            0.222638538575744,
            0.167843680389384,
            0.0659710242741669,
            0.166930821713266,
            -0.263866476922059,
            0.161915624425442,
            0.138986295541169,
            0.166466307538129,
            0.144378791776636,
            0.183624378923618,
            -0.0258603488926741,
            -0.129639799753827,
            0.167750034188064,
            0.174973735042605,
            -0.139238101875165,
            0.229489466448269,
            0.140417149708575,
            -0.062017043036933,
            0.0831589716517871,
            0.199365837693328,
            0.0399348976282419,
            0.179361420195762,
            -0.0271713542543908,
            0.237915657050658,
            -0.00810002274318578,
            -0.629912365154691,
            0.115627012410724,
            0.129898814354511,
            -0.147735360103249,
            0.138189416011633,
            0.0617642941392772,
            0.145294842487372,
            0.179470411531766,
            0.18917881859845,
            0.227493654787207,
            -0.0800090930414929,
            0.177116658867331,
            0.0628181792757243,
            0.133644490684494,
            0.210731953110728,
            0.162134594583383,
            0.137864067676734,
            0.0213514148934989,
            0.223701266497507,
            0.125526021377534,
            0.121741213711057,
            0.164935667445247,
            0.222769489943569,
            0.192709716489198,
            0.0782360126561908,
            0.151583958785726,
            0.197148664950446,
            -0.184329121206307,
            -0.336854671510747,
            0.228055039404783,
            0.0746429945315685,
            0.118536310423853,
            0.0363723158075975,
            0.0449794000503779,
            0.189753060847713,
            -0.128320346353068,
            -0.145204385362233,
            0.00181794008056141,
            -0.0733176622775137,
            0.0638476321370431,
            0.193307268123869,
            0.119152761579618,
            0.087582079004218,
            0.178675324386119
        ],
        "y": [
            -0.456357535236123,
            -0.295022876472868,
            -0.866708733905986,
            -0.271419106120275,
            -1.37816982228657,
            -0.853786535208086,
            -1.78427973390558,
            -0.669498796504291,
            -0.468236172464821,
            -1.74266470048741,
            -1.72970745972806,
            -0.542287968975654,
            -0.433680689704101,
            -0.965232541394779,
            -1.37174995180176,
            -0.358079986542753,
            -0.317273267521136,
            -1.80823657656953,
            -0.472338325567942,
            -0.990210278656636,
            -1.33576679400398,
            -0.941238712326116,
            -1.33352344696286,
            -0.470512555861372,
            -0.860925267802463,
            -0.808730707314139,
            -0.602926349964498,
            -0.481273260377457,
            -0.85787134265369,
            -0.780334620737619,
            -0.161765450469935,
            -0.443335291512435,
            -1.44892770964566,
            -0.947828800119873,
            -1.00929487227158,
            -1.56195515198879,
            -0.314232066719047,
            -1.44348083708025,
            -0.914989874736178,
            -0.788277031317291,
            -0.248915461314064,
            -0.784562667157948,
            -0.171887408851962,
            -0.894169462449504,
            -0.913975831487567,
            -0.592659497278361,
            -0.637641644212897,
            -0.304627699037975,
            -0.580867905735559,
            -0.482488030985086,
            -1.28181122246008,
            -1.4723203339631,
            -0.219707932964792,
            -0.402170969486128,
            -0.591817965227691,
            -0.285642314480406,
            -1.1174119751256,
            -0.389273059341488,
            -0.306728985014732,
            -0.425709201381917,
            -0.372035268693271,
            -0.937644655752143,
            -0.245002936164775,
            -0.290089857998666,
            -1.69572656716157,
            -0.244061511850817,
            -0.293118361428347,
            -0.303588775580841,
            -1.52252228082671,
            -0.958099586348057,
            -0.829597419237362,
            -0.175780597861075,
            -0.70103103006916,
            -0.714259781011487,
            -1.63363614398246,
            -0.218638540791413,
            -0.789105402023195,
            -1.00720591035503,
            -0.377936545095374,
            -0.316301404749781,
            -0.802274252270137,
            -1.19746698362484,
            -1.28945898401262,
            -0.217930981946036,
            -0.476953731983335,
            -0.442434156590279,
            -0.384491981591241,
            -1.01988907475907,
            -0.750260954021989,
            -0.409216965970825,
            -0.445911182229826,
            -0.406729744733495,
            -0.708391456584559,
            -0.139300893879707,
            -0.577754606939051,
            -0.863784084402301,
            -0.4477622239294,
            -0.455450670585038,
            -0.175684911708419,
            -0.869588408768977,
            -0.697800178564294,
            -0.555104868988326,
            -0.364321149505117,
            -0.447711252870301,
            -0.762823218692763,
            -0.935681678512275,
            -0.87757735424959,
            -1.38687417773039,
            -0.694346099824295,
            -0.374168589936943,
            -1.20183986370465,
            -0.647097481605313,
            -1.04682245551124,
            -0.540485428254402,
            -0.786975513120081,
            -0.390087123206815,
            -0.308268657886839,
            -0.800813218300221,
            -1.0431069269765,
            -0.247705908264387,
            -1.13886880882975,
            -0.45488111166268,
            -0.293892300916451,
            -0.238424258571921,
            -0.870992666971184,
            -0.781682333876049,
            -0.642553257708716,
            -1.6227259657885,
            -0.304944859102691,
            -0.151996150862769,
            -0.125430427612071,
            -0.219205795229888,
            -0.324437205442828,
            -0.294058950911557,
            -0.561905717229831,
            -1.10998651437539,
            -0.32780652041198,
            -0.607337970298211,
            -0.426627583234644,
            -0.333274431347617,
            -0.741678900510044,
            -1.2626844979525,
            -0.371756759496054,
            -0.511038292766587,
            -1.0212546038324,
            -0.357923163730704,
            -0.310807624292909,
            -0.919843677101472,
            -0.245430984210144,
            -0.746806784377425,
            -0.314315868588959,
            -1.58431199953944,
            -0.676532258763876,
            -0.537771643779795,
            -0.604469965921928,
            -0.304353398484335,
            -1.07912760366502,
            -0.545389455890019,
            -0.626537721177045,
            -0.161137773725684,
            -0.236851893999788,
            -0.570839023951938,
            -0.251128150807597,
            -0.52343997959813,
            -1.22566407034893,
            -0.844260281667155,
            -0.847787490817602,
            -0.34606841649508,
            -0.976157291758533,
            -0.438718211076811,
            -0.329389685167188,
            -1.10658912818869,
            -0.273860453429362,
            -1.57345391592271,
            -0.202324175948418,
            -1.06656406960063,
            -0.585751393813905,
            -0.803603071012591,
            -0.517107957660805,
            -1.29780556287058,
            -3.70112091951756,
            -1.61749157776736,
            -1.36968941132548,
            -0.673642182726038,
            -0.930136449473041,
            -1.15709673607475,
            -0.1729041035318,
            -0.239339553409417,
            -0.229593145146219,
            -0.58358235447249,
            -0.240138052142551,
            -0.968895844492445,
            -0.24157489867286,
            -0.365809749071006,
            -0.9142310852279,
            -0.164919071070047,
            -1.01364319638578,
            -1.85626591978583,
            -0.410633348473326,
            -0.343917832201157,
            -0.569121192666706,
            -1.34629138693132,
            -0.467870184741991,
            -0.314784185631613,
            -0.585286927823731,
            -0.966756221375809,
            -0.151899520731187,
            -0.736657249962003,
            -1.12011134483167,
            -1.30997325145449,
            -1.89003449933304,
            -1.53537058251948,
            -0.399917387170009,
            -0.618379096705838,
            -0.827815855499639,
            -0.209318821133628,
            -1.28529789954651,
            -0.422844074775597,
            -0.540351615916975,
            -0.281923775484567,
            -1.25122449649212,
            -0.627579120497469,
            -0.998075430703156,
            -0.411205505795206,
            -0.313747590815592,
            -0.746711760718859,
            -0.357748734691125,
            -1.72370113766657,
            -0.395657192542324,
            -0.467091139158906,
            -0.416452621060655,
            -0.353667061059933,
            -0.194810493182451,
            -1.3999066375923,
            -1.06532757771916,
            -2.39288710943589,
            -1.57373806148964,
            -1.0384201055138,
            -0.852245943911492,
            -0.454297559346354,
            -0.373852021473714,
            -1.15689171562314,
            -0.518243925946727,
            -0.540658456176191,
            -0.998693095624561,
            -0.21393993542305,
            -0.269895518580411,
            -0.413507065058938,
            -0.863109539930876,
            -0.290765049233163,
            -0.239332513354593,
            -0.233855983780405,
            -0.169761655842825,
            -0.540264993018817,
            -0.299185541959312,
            -1.34015721991797,
            -0.32519710476062,
            -0.326749926963446,
            -0.178251077954161,
            -1.6706119621586,
            -0.224381169555805,
            -0.42115019607167,
            -0.921757512971332,
            -2.0240558989901,
            -0.490910519994132,
            -0.572232725597544,
            -0.195950180377853,
            -1.8745458712682,
            -0.684264781038526,
            -1.10607933121493,
            -0.326185857079444,
            -0.186108954131969,
            -0.289074789543639,
            -0.700958113856924,
            -0.836244079825075,
            -1.17925599462095,
            -1.20855536578965,
            -2.35082935958365,
            -0.256757317235521,
            -0.262347443860704,
            -1.18060824943054,
            -0.683033342326626,
            -0.754553365251579,
            -0.244446743362336,
            -0.565765967304409,
            -0.479528935136357,
            -0.357851870836672,
            -0.602207974493195,
            -0.61555564109623,
            -0.47418845180917,
            -0.225898742423058,
            -0.556248450037353,
            -0.170109798466886,
            -0.219868579281801,
            -0.614885338476737,
            -0.347083533888946,
            -0.170493513984842,
            -1.06531814807538,
            -0.439217220823103,
            -0.329898558806884,
            -0.261148175658872,
            -0.387155208151587,
            -0.343581495854116,
            -1.46987700284043,
            -0.35861189215927,
            -1.84109726586936,
            -1.19384615043245,
            -0.26771880420503,
            -0.39984061812929,
            -0.403962054907836,
            -0.256366889312666,
            -0.350072620248707,
            -0.551626576131267,
            -1.33253558622332,
            -1.01159655190309,
            -0.80367800986858,
            -0.598078935964009,
            -0.470665736254041,
            -0.273406515132852,
            -0.560579689080143,
            -0.990135761109186,
            -1.041032421338,
            -0.588869066461197,
            -0.575112568328315,
            -0.246326934261975,
            -0.244041983761481,
            -0.52190110890622,
            -0.730376970361464,
            -0.343598836954246,
            -0.246113556380811,
            -0.239426728965099,
            -0.267275082846015,
            -0.224898966227389,
            -0.269590888811074,
            -0.288252113503589,
            -0.284877058327744,
            -0.304183511442713,
            -0.260752049603166,
            -0.247826874040891,
            -0.851196893491589,
            -0.566170741376483,
            -0.423008972802812,
            -0.395465895706481,
            -0.378855729748821,
            -0.4357638888808,
            -0.35721284781522,
            -0.492902259639852,
            -0.38837819260426,
            -0.300609189603018,
            -0.624991108870422,
            -0.209711573535884,
            -0.571197550774125,
            -0.488228308591962,
            -0.632222044892135,
            -0.751252223139472,
            -0.558500678824402,
            -0.966912938239823,
            -0.606810252307524,
            -1.1092868139237,
            -0.398691091721547,
            -1.46367656687194,
            -0.342696719873616,
            -1.51048935616324,
            -0.250221626462214,
            -0.234892019075703,
            -0.740030420106559,
            -0.522915191367597,
            -0.163414708096871,
            -0.344957702375414,
            -0.202926100882952,
            -1.70649184930978,
            -1.49659903095455,
            -1.12293332719018,
            -1.19792634906737,
            -1.00449415365791,
            -1.20780148068103,
            -1.32051765995341,
            -0.206815643471874,
            -0.387933844092925,
            -0.724662376272394,
            -0.390951195105634,
            -1.81490289684874,
            -0.407528361989447,
            -0.483318662875774,
            -0.392486594125695,
            -0.465494377033081,
            -0.335772531559857,
            -1.02820058440081,
            -1.37123181075212,
            -0.388243381010063,
            -0.364366255602612,
            -1.40295791182754,
            -0.184170676956288,
            -0.478589136406878,
            -1.14771244373516,
            -0.667849561996715,
            -0.283740921626246,
            -0.810721845451303,
            -0.349863259041717,
            -1.03253396421012,
            -0.156318857816541,
            -0.96949583689151,
            -3.02482614176248,
            -0.560530128849365,
            -0.513356303179674,
            -1.43104463695873,
            -0.485952657949006,
            -0.738567246505624,
            -0.462466475111299,
            -0.349503000519043,
            -0.317412960011333,
            -0.19076760646381,
            -1.20718312821484,
            -0.3572830634921,
            -0.735083748493359,
            -0.500975394104445,
            -0.246171513827993,
            -0.406804580921139,
            -0.487028060038589,
            -0.872147443866792,
            -0.203302916633804,
            -0.527810075338094,
            -0.540320328616195,
            -0.397545951674871,
            -0.206382798550027,
            -0.305741976752759,
            -0.684121845647511,
            -0.441678513153621,
            -0.291069535130291,
            -1.55200117164673,
            -2.05615711135044,
            -0.188912013162594,
            -0.695998160306765,
            -0.550913773617342,
            -0.822497556353335,
            -0.794047813763541,
            -0.31551486726414,
            -1.36687050690612,
            -1.42267878647416,
            -0.936713133551824,
            -1.18506536133551,
            -0.731681008600646,
            -0.303766837470863,
            -0.548876164108011,
            -0.65322948136613,
            -0.352131071070241
        ],
        "z": [
            -1.43356288943494,
            -0.902269904425399,
            -2.78489505150604,
            -0.82454006197096,
            -4.46919333214206,
            -2.74234081318105,
            -5.80655846397425,
            -2.13546078165433,
            -1.47268056371187,
            -5.66951552790895,
            -5.62684589217601,
            -1.71654137028097,
            -1.35888551356502,
            -3.1093449135288,
            -4.4480519842172,
            -1.10992398502977,
            -0.975542918223451,
            -5.88545101284073,
            -1.48618941037774,
            -3.19159938191373,
            -4.32955544129826,
            -3.03033056431568,
            -4.32216784984691,
            -1.48017694755803,
            -2.76584945402936,
            -2.59396695800726,
            -1.91623030685959,
            -1.51561314500613,
            -2.75579253866645,
            -2.50045548492715,
            -0.463438371396425,
            -1.39067919170677,
            -4.70220692932049,
            -3.05203245678107,
            -3.25444707246643,
            -5.07441887491732,
            -0.965527905550158,
            -4.68426977182173,
            -2.94389022109933,
            -2.52661072681623,
            -0.750433055365326,
            -2.51437891229629,
            -0.496771106743892,
            -2.87532628649462,
            -2.94055086383652,
            -1.88242041844451,
            -2.03055163401956,
            -0.933899653979653,
            -1.84358939529789,
            -1.5196135197996,
            -4.15187373990067,
            -4.77924144438431,
            -0.654249414228387,
            -1.2551204984111,
            -1.87964915975398,
            -0.871378669893115,
            -3.61048872369146,
            -1.21264624499487,
            -0.940819422537183,
            -1.33263451543401,
            -1.15588028212821,
            -3.01849493606248,
            -0.737548674653671,
            -0.8860249256319,
            -5.51494303148052,
            -0.734448459623886,
            -0.895998124444859,
            -0.930478363421452,
            -4.94456204199749,
            -3.08585529878784,
            -2.66268336246745,
            -0.509591811394174,
            -2.23929993576491,
            -2.28286368474467,
            -5.31047235838268,
            -0.650727786796961,
            -2.52933864373382,
            -3.2475678884106,
            -1.17531384202832,
            -0.972342465966192,
            -2.57270513305779,
            -3.87411877539,
            -4.17705866975419,
            -0.648397716780316,
            -1.50138845731696,
            -1.38771165412769,
            -1.19690162391368,
            -3.28933496020563,
            -2.40141955376387,
            -1.27832374893035,
            -1.39916188649035,
            -1.27013305261196,
            -2.26353863936578,
            -0.389460086635853,
            -1.83333695590574,
            -2.7752638552285,
            -1.40525757279534,
            -1.43057648322087,
            -0.509276706245296,
            -2.7943781412869,
            -2.2286603822226,
            -1.75874884831763,
            -1.13047682919621,
            -1.40508971942555,
            -2.44278848928323,
            -3.01203063356685,
            -2.82068662778329,
            -4.4978577432598,
            -2.21728571655374,
            -1.16290554638465,
            -3.88851915611726,
            -2.06169075882072,
            -3.37802958023278,
            -1.7106054030949,
            -2.5223246825568,
            -1.21532704789435,
            -0.945889736643468,
            -2.56789378560754,
            -3.36579393129509,
            -0.746449862570817,
            -3.68114846484639,
            -1.42870086230769,
            -0.898546793304999,
            -0.715884357249612,
            -2.79900251981594,
            -2.50489365426871,
            -2.04672612383725,
            -5.27454392747956,
            -0.934944097367086,
            -0.431266980639279,
            -0.343783097678256,
            -0.652595818788275,
            -0.999134563019525,
            -0.899095590284089,
            -1.78114479839137,
            -3.58603585511819,
            -1.01023009215828,
            -1.93075826355405,
            -1.33565884907474,
            -1.02823653135138,
            -2.37315789651784,
            -4.08888730763013,
            -1.15496312034861,
            -1.61363270898669,
            -3.29383179940339,
            -1.10940755005808,
            -0.954250835560839,
            -2.95987433243084,
            -0.738958284501269,
            -2.39004458873616,
            -0.965803874433449,
            -5.14804246182444,
            -2.15862275557544,
            -1.70166860882367,
            -1.92131360598464,
            -0.932996351731705,
            -3.48441402809642,
            -1.72675491183077,
            -1.9939851797917,
            -0.461371362028254,
            -0.710706385737134,
            -1.81056317154676,
            -0.757719688100846,
            -1.65447284381198,
            -3.96697491981088,
            -2.71096980016675,
            -2.72258529241534,
            -1.07036854818688,
            -3.14532133220868,
            -1.37547463203264,
            -1.01544362987549,
            -3.5748478843362,
            -0.832579690338683,
            -5.11228558416134,
            -0.597002767867899,
            -3.44304091232263,
            -1.85967126498598,
            -2.57708108105078,
            -1.63362079093001,
            -4.20454488276048,
            -12.118929798812,
            -5.25730650523088,
            -4.44126639512699,
            -2.14910541356835,
            -2.99376957725445,
            -3.741175057711,
            -0.500119195464786,
            -0.718898525005658,
            -0.686802517991603,
            -1.85252837705887,
            -0.721528070192695,
            -3.12140857829044,
            -0.726259765712682,
            -1.13537895322155,
            -2.94139144280868,
            -0.473823594974947,
            -3.26876658766628,
            -6.04361698487083,
            -1.28298805412948,
            -1.06328643478489,
            -1.80490616196016,
            -4.36421409700957,
            -1.47147532541261,
            -0.967346094570338,
            -1.85814172679346,
            -3.11436256126504,
            -0.430948766862747,
            -2.356621042442,
            -3.61937804852577,
            -4.24461443531643,
            -6.15482067516714,
            -4.98687292926116,
            -1.24769920106015,
            -1.96711792149701,
            -2.65681647482251,
            -0.620036912843446,
            -4.16335575555198,
            -1.32319933468134,
            -1.7101647441768,
            -0.859133107172008,
            -4.05114824752503,
            -1.99741462364324,
            -3.21750020285563,
            -1.28487223186145,
            -0.963932472486459,
            -2.38973166525405,
            -1.10883313581987,
            -5.60706640522983,
            -1.23366990606666,
            -1.46890984161348,
            -1.30215156634196,
            -1.09539173033407,
            -0.572259374379194,
            -4.54077508386801,
            -3.4389690069572,
            -7.81077027886276,
            -5.11322130713363,
            -3.35035970665785,
            -2.73726747460072,
            -1.42677915959094,
            -1.16186305120676,
            -3.74049990254868,
            -1.63736166090878,
            -1.71117520329631,
            -3.21953424217703,
            -0.635254756447032,
            -0.819522718653766,
            -1.29245152263987,
            -2.7730425052192,
            -0.888248405503973,
            -0.71887534132169,
            -0.700840519992736,
            -0.489770765525984,
            -1.70987948533357,
            -0.915978025103513,
            -4.34401360241001,
            -1.00163699603641,
            -1.00675061235204,
            -0.51772737726157,
            -5.43223784239314,
            -0.669638902371405,
            -1.31762120361048,
            -2.96617680692647,
            -6.59616805845595,
            -1.54734971338087,
            -1.81515278616015,
            -0.576012491140738,
            -6.10381489933845,
            -2.18408681191922,
            -3.57316906617021,
            -1.00489306745299,
            -0.543604237958126,
            -0.882682192250279,
            -2.23905981456373,
            -2.6845715554389,
            -3.81414796203829,
            -3.91063405180008,
            -7.67226942831352,
            -0.776257159574943,
            -0.794666068634176,
            -3.81860108760839,
            -2.18003154720352,
            -2.41555494161258,
            -0.73571706986079,
            -1.79385703146471,
            -1.50986888787455,
            -1.10917277462439,
            -1.91386461649007,
            -1.95781996797375,
            -1.49228208197652,
            -0.674636438702366,
            -1.76251478797248,
            -0.49091723792915,
            -0.6547784404274,
            -1.9556125868549,
            -1.07371144272955,
            -0.492180855830552,
            -3.43893795409087,
            -1.37711792665817,
            -1.01711940739967,
            -0.790716744988143,
            -1.20567192534705,
            -1.06217884176578,
            -4.77119528309772,
            -1.11167560941668,
            -5.99366491952022,
            -3.86219496875257,
            -0.812354555985714,
            -1.24744639206603,
            -1.261018742021,
            -0.774971436977243,
            -1.08355483674484,
            -1.74729444286669,
            -4.31891471450013,
            -3.26202675962934,
            -2.57732786304292,
            -1.90026723312429,
            -1.48068138763737,
            -0.831084821012947,
            -1.7767780401309,
            -3.19135398733749,
            -3.35896235337161,
            -1.86993810795549,
            -1.82463642874829,
            -0.741908747725388,
            -0.734384151452568,
            -1.64940517137436,
            -2.33593938283307,
            -1.06223594793827,
            -0.741206070617519,
            -0.719185603811621,
            -0.810893332172117,
            -0.67134406443257,
            -0.818519538923417,
            -0.87997302850106,
            -0.868858596222885,
            -0.93243689479821,
            -0.78941225780486,
            -0.746848216334203,
            -2.73381283482717,
            -1.79518999752827,
            -1.3237423622352,
            -1.23303994429826,
            -1.17834081938116,
            -1.36574572027722,
            -1.10706840070276,
            -1.55390873367972,
            -1.2096993492463,
            -0.920666255221114,
            -1.98889201335532,
            -0.621330290210491,
            -1.81174384026993,
            -1.5385168927507,
            -2.01270429035047,
            -2.40468391327852,
            -1.76993162800157,
            -3.11487864733806,
            -1.92902042948501,
            -3.58373166366644,
            -1.24366087368331,
            -4.75077655745429,
            -1.05926517600204,
            -4.90493628202838,
            -0.75473440255133,
            -0.704252299512606,
            -2.36772926710237,
            -1.65274465776917,
            -0.468869560295213,
            -1.06671084298793,
            -0.598984973660951,
            -5.55039430358063,
            -4.85919389536795,
            -3.62867115046922,
            -3.87563151691151,
            -3.23863777183629,
            -3.90815142424329,
            -4.27933834591005,
            -0.611793670243764,
            -1.20823606015032,
            -2.31712058856422,
            -1.21817253281312,
            -5.90740394736402,
            -1.27276298810783,
            -1.52234888305032,
            -1.22322877264901,
            -1.46365152624167,
            -1.03646305334479,
            -3.31670568638031,
            -4.44634568808077,
            -1.20925539966445,
            -1.13062536859477,
            -4.55082326947765,
            -0.537221275522543,
            -1.50677402607536,
            -3.71027153873049,
            -2.13002966889016,
            -0.865117171632875,
            -2.6005239974715,
            -1.08286538699201,
            -3.33097598832111,
            -0.445502135679095,
            -3.12338442002913,
            -9.89181583598328,
            -1.77661483277577,
            -1.62126617523066,
            -4.64331598089183,
            -1.53102292194367,
            -2.36291087360907,
            -1.45368030826116,
            -1.08167901558642,
            -0.97600294113898,
            -0.558945698512721,
            -3.90611512076041,
            -1.10729962874049,
            -2.35143932700279,
            -1.58049446386911,
            -0.741396930940734,
            -1.27037949650582,
            -1.53456434069795,
            -2.80280532863948,
            -0.600225869861453,
            -1.66886405539827,
            -1.71006171161361,
            -1.23988980007572,
            -0.610368263748115,
            -0.937569094493897,
            -2.18361610977042,
            -1.38522323620099,
            -0.889251111447126,
            -5.04163930994846,
            -6.70188092305731,
            -0.552835023277007,
            -2.22272613556771,
            -1.74494710486598,
            -2.63930272390083,
            -2.54561455559804,
            -0.969752310498228,
            -4.43198342917971,
            -4.61576630427453,
            -3.01542732979484,
            -3.83327885310938,
            -2.34023372587115,
            -0.931064741040446,
            -1.73823703000175,
            -2.08188411641652,
            -1.09033354436942
        ],
        "text": [
            "ABCA1",
            "ABHD17A",
            "ABHD6",
            "ABT1",
            "AC000041.1",
            "AC004264.1",
            "AC005740.3",
            "AC007319.1",
            "AC007750.1",
            "AC008522.1",
            "AC009065.10",
            "AC011511.3",
            "AC011603.3",
            "AC011731.1",
            "AC016629.3",
            "AC036108.2",
            "AC069234.2",
            "AC087190.3",
            "AC091607.2",
            "AC092683.1",
            "AC093525.2",
            "AC109322.1",
            "AC112496.1",
            "AC112777.1",
            "AC113386.1",
            "ACSL4",
            "ACTR3",
            "ACYP1",
            "ADAMTS5",
            "ADAMTS6",
            "AFG3L2",
            "AGPS",
            "AL031591.1",
            "AL138785.2",
            "AL139393.3",
            "AL157935.3",
            "AL158212.3",
            "AL161787.1",
            "AL162274.2",
            "AL445183.3",
            "AL583722.2",
            "AL732414.1",
            "ALDH18A1",
            "ALDH4A1",
            "ANAPC10",
            "ANGPTL2",
            "ANKRD10-IT1",
            "ANPEP",
            "ANXA11",
            "AP000331.1",
            "AP000346.2",
            "AP003068.3",
            "AP2A2",
            "APBA3",
            "ARCN1",
            "ARFGEF2",
            "ARHGAP27P1-BPTFP1-KPNA2P3",
            "ARHGEF10L",
            "ARID1A",
            "ARPC2",
            "ASAH1",
            "ASDURF",
            "ATAD1",
            "ATE1",
            "ATF3",
            "ATP2C1",
            "ATXN1",
            "AURKA",
            "BBS1",
            "BBS12",
            "BCAP29",
            "BGN",
            "BMP6",
            "BRIX1",
            "BRWD1",
            "BTF3",
            "C16orf74",
            "C17orf80",
            "C1orf122",
            "C5orf30",
            "CABLES1",
            "CC2D1B",
            "CCDC189",
            "CCNB1",
            "CD58",
            "CDC25B",
            "CDC42",
            "CDKN1A",
            "CEMIP",
            "CEMIP2",
            "CEMP1",
            "CHCHD2",
            "CHCHD2P9",
            "CHPF",
            "CKB",
            "CLDN12",
            "CLDN23",
            "CLEC11A",
            "CLIP3",
            "CLMP",
            "CLTB",
            "CMTM3",
            "COL4A1",
            "COL4A2",
            "COL7A1",
            "COPS7B",
            "COX5B",
            "CREB5",
            "CSF1",
            "CSNK2A3",
            "CU633904.2",
            "CYLD",
            "CYP2S1",
            "CYTH3",
            "DDT",
            "DDX10",
            "DDX24",
            "DENND3",
            "DHPS",
            "DIMT1",
            "DIPK1B",
            "DLGAP1-AS2",
            "DNAJB11",
            "DNAJC24",
            "DNER",
            "DPP8",
            "DUSP14",
            "EBPL",
            "EEF1G",
            "EIF2S1",
            "EIF2S2",
            "EIF3E",
            "EMC6",
            "EMP3",
            "EPAS1",
            "EPB41L5",
            "ERGIC1",
            "ETFDH",
            "EVA1B",
            "FAM104A",
            "FAM120A",
            "FAM167A",
            "FAM189B",
            "FAM193A",
            "FAM216A",
            "FAT1",
            "FCHSD2",
            "FGF7",
            "FHL2",
            "FHOD3",
            "FOXL1",
            "FOXO3B",
            "FRG1HP",
            "FTH1P11",
            "FTH1P15",
            "FTH1P2",
            "FTX",
            "GADD45A",
            "GADD45G",
            "GANAB",
            "GAR1",
            "GGCT",
            "GINM1",
            "GJA1",
            "GK-AS1",
            "GNG11",
            "GON4L",
            "GPAA1",
            "GPAT3",
            "GPC6",
            "GPN3",
            "GRPEL2",
            "GRSF1",
            "GTF2IRD2",
            "GTF3C3",
            "H2BC4",
            "H3-5",
            "H4C15",
            "HACD2",
            "HAUS8",
            "HCG20",
            "HEATR5A",
            "HHEX",
            "HIF1A",
            "HIGD1A",
            "HLA-DMA",
            "HMGN4",
            "HNRNPL",
            "HNRNPU",
            "HOXA5",
            "HPS1",
            "HSF4",
            "HTRA1",
            "HUWE1",
            "IDUA",
            "IGF2BP2",
            "IL1R1",
            "IL33",
            "INCENP",
            "ISCU",
            "KCNMA1-AS1",
            "KCTD7",
            "KHDRBS3",
            "KIF3B",
            "KMT2D",
            "L3MBTL2",
            "LAMP2",
            "LHFPL6",
            "LINC00161",
            "LINC00680",
            "LINC00847",
            "LINC01705",
            "LINC01943",
            "LMBR1",
            "LNCOG",
            "LRRC75A",
            "LRRC8E",
            "LTBP1",
            "LTBP2",
            "LYSMD3",
            "LYST",
            "MAEA",
            "MAP4K3-DT",
            "MARCHF4",
            "MARF1",
            "MB21D2",
            "MCC",
            "MEDAG",
            "METTL2A",
            "METTL9",
            "MFSD5",
            "MIF",
            "MIF-AS1",
            "MIR1281",
            "MIR3615",
            "MIR3658",
            "MIR4746",
            "MIR7161",
            "MME-AS1",
            "MOSPD1",
            "MPC2",
            "MRRF",
            "MSMO1",
            "MSMP",
            "MSRB3",
            "MT-ND3",
            "MT-TS1",
            "MTG1",
            "MYL12BP1",
            "NADK",
            "NBAS",
            "NCAPD2",
            "NDFIP1",
            "NDUFB11",
            "NET1",
            "NFATC1",
            "NFYA",
            "NKIRAS1",
            "NOL7",
            "NPHP3-ACAD11",
            "NSMCE3",
            "NUP214",
            "NUP35",
            "OAZ3",
            "OGFOD3",
            "OLR1",
            "OPTN",
            "OSBPL6",
            "OSGIN2",
            "PABPC4-AS1",
            "PALB2",
            "PAPSS2",
            "PARG",
            "PAXX",
            "PCDHGB5",
            "PCYT2",
            "PDE10A",
            "PDE4B",
            "PDHA1",
            "PHLDA3",
            "PIK3R1",
            "PIMREG",
            "PKIG",
            "POLR2A",
            "POLR3H",
            "PPA1",
            "PPP1R3C",
            "PPP2R3C",
            "PRICKLE2",
            "PRKCI",
            "PRPF8",
            "PRPSAP2",
            "PSMB2",
            "PTCD1",
            "PTGS1",
            "PTN",
            "PTP4A2",
            "PTPRN",
            "PTX3",
            "PURB",
            "PYGL",
            "QPCTL",
            "RAB23",
            "RAB31",
            "RABEP2",
            "RAPGEF6",
            "RASD1",
            "RASSF3",
            "RBMS1",
            "REEP3",
            "RFLNB",
            "RGP1",
            "RGS10",
            "RMND5B",
            "RMRP",
            "RN7SK",
            "RN7SL1",
            "RN7SL4P",
            "RNF130",
            "RNF213",
            "RNF31",
            "RNMT",
            "ROBO1",
            "ROMO1",
            "RPL12",
            "RPL13",
            "RPL15",
            "RPL22L1",
            "RPL35A",
            "RPL37",
            "RPL38",
            "RPL6",
            "RPL9P7",
            "RPS12",
            "RPS13",
            "RPS15A",
            "RPS2",
            "RPS27",
            "RPS8",
            "RSAD2",
            "RSRC1",
            "RTN4",
            "S100A11",
            "S100A16",
            "SALL1",
            "SART3",
            "SATB2",
            "SC5D",
            "SEH1L",
            "SELENOM",
            "SERBP1",
            "SGIP1",
            "SGMS1",
            "SGMS2",
            "SH2D5",
            "SH3PXD2A",
            "SHC2",
            "SHQ1",
            "SIMC1",
            "SIPA1",
            "SLC16A6",
            "SLC23A2",
            "SLC25A14",
            "SLC25A3",
            "SLC26A2",
            "SLC2A13",
            "SLC38A7",
            "SLC7A11",
            "SMAGP",
            "SMC1A",
            "SNORA6",
            "SNORD124",
            "SNORD12B",
            "SNORD14A",
            "SNORD19",
            "SNORD26",
            "SNORD54",
            "SNRNP35",
            "SNX6",
            "SOX4",
            "SPATC1L",
            "SPIN1",
            "STARD13",
            "STK11",
            "STMN3",
            "STXBP1",
            "SUPT6H",
            "SYNGAP1",
            "SYS1-DBNDD2",
            "TBC1D2B",
            "TBX5",
            "TBXAS1",
            "TEAD3",
            "TEAD4",
            "TES",
            "THBS2",
            "TIMM17A",
            "TJP2",
            "TLE4",
            "TM4SF1",
            "TMED7",
            "TMEM138",
            "TMEM189-UBE2V1",
            "TMEM68",
            "TOR1A",
            "TPTEP2-CSNK1E",
            "TRAPPC2",
            "TRPA1",
            "TRRAP",
            "TSPAN5",
            "TSPYL2",
            "TSR2",
            "TTLL4",
            "TUBA1B",
            "TUBB2B",
            "TUFT1",
            "TXN",
            "UBAP2",
            "UBBP4",
            "UBE2V1",
            "USP46",
            "UTP25",
            "VLDLR-AS1",
            "VMP1",
            "WASHC2A",
            "WBP1L",
            "WDR77",
            "YAP1",
            "YBX1P1",
            "YPEL2",
            "Z84488.2",
            "ZCCHC24",
            "ZFAND5",
            "ZFPM2-AS1",
            "ZFYVE16",
            "ZKSCAN8",
            "ZNF217",
            "ZNF286A",
            "ZNF331",
            "ZNF35",
            "ZNF414",
            "ZNF451-AS1",
            "ZNF623",
            "ZNF703",
            "ZNRD1",
            "ZSCAN29"
        ],
        "type": "scatter3d",
        "mode": "markers",
        "opacity": 0.7,
        "name": "MERS-GSE56192",
        "marker": {
            color: "#023e8a"
        }
    },
      {
          "x": [
              -0.0909836360292609,
              -2.03963811343096,
              -0.214859274451308,
              -1.49551284460867,
              -0.428189142628161,
              -0.547868344570756,
              -0.30266471832431,
              -0.378344562806094,
              -0.131784152892825,
              -1.80612129119111,
              -0.563508333471029,
              -1.48585226268577,
              -1.60405745661017,
              -2.74484915626538,
              -2.23152874993242,
              -1.0296734957013,
              -1.81864974907391,
              -1.24156625580059,
              -1.86605088213963,
              -2.05546270305716,
              -1.42237107917371,
              -0.909427346585657,
              -1.86407744624521,
              -1.14394768468655,
              -1.36553918906506,
              -1.92970541857094,
              -2.15434639986023,
              -1.69755288759952,
              -0.537052049502423,
              -0.303941246620455,
              -1.18686675765903,
              -1.29011793516487,
              -1.27541040873758,
              -1.37096917103489,
              -1.58592939181337,
              -1.62968507027085,
              -1.57839750098012,
              -0.925623134913192,
              -1.03001632444768,
              -0.562463830606421,
              -2.84413030776141,
              -0.827193854764884,
              -1.14690091471568,
              -1.01587875186395,
              -1.30251873429226,
              -0.862460901405191,
              -1.59045014810375,
              -1.78857538260173,
              -2.5815995711662,
              -2.73915837768137,
              -0.879382258817603,
              -0.775091941332977,
              -0.425803573768436,
              -0.849034596953548,
              -2.18566680975551,
              -1.50218347822282,
              -1.52036365881137,
              -1.12488609111951,
              -0.907247609243906,
              -0.511986402069683,
              -1.6996542640305,
              -1.39192484207742,
              -0.476685677287497,
              -0.701087873555005,
              -0.933729223753947,
              -0.694678116467769,
              -1.48783528249767,
              -1.14649949229612,
              -0.924471292162886,
              -1.66921796570402,
              -0.899731811119965,
              -1.05493258272034,
              -0.865258619920165,
              -1.34337081353624,
              -1.64937372104363,
              -1.26401697100308,
              -0.571361647798377,
              -2.85341772241279,
              -2.06360184210389,
              -0.647572852479619,
              -0.298263249150791,
              -1.18999016163084,
              -0.991601149655901,
              -0.626796635563545,
              -1.1353413562209,
              -1.27209879253617,
              -0.36321370696954,
              -1.1386947813802,
              -1.40910030067836,
              -0.19031664129344,
              -0.618860666659723,
              -1.05334976342807,
              -0.998050244429937,
              -1.10065874803711,
              -0.776785726451089,
              -1.55057407461737,
              -1.32026012724776,
              -0.758865833606435,
              -0.850240216592705,
              -0.535153575077276,
              -3.68585708325098,
              -3.35223082104197,
              -0.609331403416008,
              -0.773599495245659,
              -0.877152442834018,
              -2.40315502610156,
              -1.11441831222712,
              -1.28541113195859,
              -1.70012349582715,
              -1.10000279565513,
              -2.24986113982414,
              -1.29460135824545,
              -1.0163652993507,
              -2.2839187250051,
              -0.347895274888173,
              -0.949421215291447,
              -0.909918172348988,
              -2.11216013502959,
              -1.01459316955598,
              -0.685224120277712,
              -1.0549598576772,
              -1.10737197519445,
              -1.02219459297859,
              -0.495200254180307,
              -0.603499767426384,
              -1.2543562438612,
              -1.01809302544009,
              -0.97364433003977,
              -0.745489220581106,
              -1.04609218576037,
              -0.88562876388132,
              -1.78124153067667,
              -0.612369840335536,
              -1.66346651653036,
              -0.655087304913111,
              -2.00826298587568,
              -1.04494757663832,
              -1.02599734899448,
              -0.656303738051108,
              -1.56431351322421,
              -1.77409839622144,
              -1.19991353172146,
              -0.926667317498352,
              -2.56254889980183,
              -0.55775059904206,
              -0.23524652795178,
              -1.20710361538873,
              -1.00403417580881,
              -0.193510939788207,
              -0.814931261825159,
              -3.29897204103627,
              -1.23013904437537,
              -1.31680361962298,
              -1.41002672415405,
              -0.745799269087201,
              -0.816072863315024,
              -0.231959584178746,
              -0.778881518472754,
              -0.702515240288895,
              -1.2397506166516,
              -0.823460505346936,
              -0.575981609164576,
              -2.31051930218631,
              -1.89432501700587,
              -2.26271726495361,
              -1.06929169355727,
              -0.434543192665525,
              -1.10941727517049,
              -1.20831283483399,
              -0.642751018348588,
              -1.01651741764156,
              -1.30022607598636,
              -0.794003541084222,
              -0.584457130093113,
              -1.06845874813355,
              -0.986340671280092,
              -1.25149798187581,
              -1.18525652433446,
              -1.34229137510396,
              -0.972777660144261,
              -1.88721285456022,
              -0.983363001431082,
              -0.610386581371034,
              -1.96144349661895,
              -1.36686891442111,
              -1.1920778221712,
              -1.1274021680367,
              -1.06981115155944,
              -1.94636946450268,
              -0.626018005245499,
              -0.310324554236155,
              -0.384150437418777,
              -0.959830279508541,
              -0.936341459658791,
              -1.25045597050789,
              -1.08029304312953,
              -1.40088989094419,
              -1.67468561920076,
              -0.429004188707046,
              -0.688157443595666,
              -0.494279821037929,
              -2.57070512523707,
              -1.28205193921826,
              -0.174648244154395,
              -1.99967558221265,
              -1.06348293533632,
              -0.946427951940685,
              -0.298070841123576,
              -2.39423630294598,
              -0.0890203093189396,
              -0.451302187820754,
              -1.18649191058583,
              -0.420479240348375,
              -0.179601117791054,
              -0.306291456699355,
              0.0988093698446288,
              -2.85390655538362,
              -0.288002292938636,
              -0.842228443168334,
              -0.220494834453337,
              -1.08386698278413,
              -0.952007264856678,
              -1.60220394505249,
              0.02708680400924,
              -0.128369681024827,
              -0.17093782649278,
              -0.593673958185809,
              -1.64741561300465,
              -1.03294499370655,
              -1.81359693651995,
              -0.459697280590598,
              -1.27428604498973,
              -0.639012211154488,
              -0.142995584683806,
              -0.249918434071652,
              -0.921595637962026,
              -0.342224656079841,
              -0.895885806141252,
              -2.07687838258539,
              -0.701694501576775,
              -0.0109692663060323,
              -0.606203764177648,
              -0.269877668467102,
              -0.496153314091193,
              -0.172368405517617,
              -1.13449367603746,
              -1.85562338759846,
              -0.848295590859166,
              -0.612248486552312,
              -0.602070219728083,
              -0.366892588019524,
              -0.73646044787919,
              -0.515981572325271,
              -2.25122511929859,
              -1.2269558434785,
              -1.39738863899768,
              -2.10057275282241,
              -1.02268483987678,
              -0.858388280239165,
              -0.933826586526734,
              -1.09442080561021,
              -1.81585088844269,
              -0.917595052716978,
              -0.690341530639038,
              -1.02104807634444,
              -3.69972407213641,
              -1.16970253491676,
              -1.70695367803367,
              -1.77990166026833,
              -1.15934855837745,
              -1.69924221976667,
              -3.02593712039373,
              -1.59573134580838,
              -0.809309400852025,
              -1.52288102048576,
              -2.27947588904614,
              -0.607338135067889,
              -1.14549156436046,
              -1.54662432715864,
              -1.50840785278703,
              -2.12363386055457,
              -1.17834082585016,
              -1.00485967217265,
              -2.69909383652791,
              -1.44558149447567,
              -0.909292296356544,
              -1.21735648790107,
              -0.754195556293689,
              -0.799313701219793,
              -1.22139975738329,
              -1.03745511986698,
              -1.85065626751157,
              -1.32679202303854,
              -0.908469378907376,
              -0.942344793613326,
              -1.26434821779386,
              -1.68500397940127,
              -1.87849373243695,
              -3.0667238171568,
              -0.99730903332818,
              -0.215394945205335,
              -0.458860795045268,
              -0.732526018804336,
              -0.734656871726931,
              -0.959551144444971,
              -1.47412178212366,
              -0.699205605733856,
              -1.12915300684489,
              -1.00346778683236,
              -2.09712209611527,
              -0.511693604770667,
              -0.663422070027689,
              -0.716540393030453,
              -0.712651481347497,
              -0.991265388758062,
              -1.27444957821296,
              -0.953196636146712,
              -1.24259188902966,
              -2.51896612117894,
              -0.27638168044334,
              -0.993712684465548,
              -0.320435738764396,
              -0.671296984407645,
              -0.380631285952548,
              -0.846025716880497,
              -1.3931347909198,
              -1.2527998958292,
              -0.421364632491309,
              -1.22486853223005,
              -0.291030844869085,
              -0.243813434461085,
              -0.140555765129916,
              -0.239780435096506,
              -0.820482154810677,
              -0.939035809588844,
              -0.795453998108321,
              -0.736953870009434,
              -1.12025191269842,
              -0.0181411872454347,
              -0.426370015551348,
              -0.415261894526071,
              -0.372816424297611,
              -0.39192297192402,
              -0.797247208956243,
              -0.672344654961565,
              -0.267609234006832,
              -1.90858126193454,
              -0.562612928433792,
              -1.50408747028274,
              -0.86190555510964,
              -0.568653054848794,
              -0.907127987153129,
              -2.51985399428453,
              -0.60934572943779,
              -1.42439841571921,
              -0.681214067798063,
              -1.0671544562487,
              -1.37649894381973,
              -0.860131412873477,
              -1.07948969229864,
              -0.697807307477823,
              -0.186546164404378,
              -1.11424813436923,
              -0.37591344709973,
              -1.58965768660898,
              -0.233187113465222,
              -0.0284893104359529,
              -0.298393426737879,
              -0.0988049335619539,
              -0.370906268555764,
              -0.254198604756594,
              -1.00431779822881,
              -0.444916285864244,
              -0.218492563298331,
              -0.347503393221676,
              -1.2066231005827,
              -0.922797131989973,
              -0.272662268551243,
              -0.868664663747409,
              -0.588338430607676,
              -0.393685951570335,
              -0.846790199684163,
              -0.542855626054016,
              0.0427022725271463,
              -0.709859296807702,
              -0.532030995431417,
              -1.45360318713706,
              -0.216477890882496,
              -1.2972093103967,
              -1.05585770171901,
              -0.304746821047077,
              -0.76037995426477,
              -0.121185602143556,
              -0.351037067700645,
              -1.34269160093033,
              -1.4235788250804,
              -0.489874850244315,
              -0.392315240211632,
              -0.223288356178664,
              -0.527208581729091,
              -0.103485558629483,
              -0.661668256972639,
              -0.132590402285086,
              -0.663507008501261,
              -1.0817075376694,
              -0.414603752004508,
              -0.181956562842645,
              -0.279400042466774,
              -0.015970670662774,
              -1.60470428286934,
              -0.322266338280563,
              -0.454502542400791,
              -0.00103369665357911,
              -0.172394203266271,
              -0.0591606357100392,
              -0.688626612232615,
              -0.248754491645935,
              -0.322979450354161,
              -0.669115388060202,
              -0.343103278619951,
              -0.305232149130166,
              -0.120196029296698,
              -0.230531431640447,
              -0.329609946601377,
              -0.611239162344548,
              -0.409345074707178,
              -0.632403855144866,
              -0.186513232417155,
              -0.569936976040186,
              -0.680889649579387,
              -0.558670958025153,
              -0.171641214493667,
              -0.567295124370673,
              -0.666210045531391,
              -0.520737150957743,
              -0.0601183060643756,
              -0.572638712941304,
              -0.221238773213531,
              -0.451369578491011,
              -0.302760740347144,
              -0.737647794596518,
              -0.156238094847585,
              -1.08548764270292,
              -0.974462449242626,
              -0.873981803986974,
              -0.0752475503212998,
              -1.34530453158323,
              -0.125609235691525,
              -0.624551199982589,
              -0.796263666441008,
              -0.873036541786434,
              -1.56951891557353,
              -0.0457493276305723,
              -0.681962415561302,
              -0.407282188865245,
              -0.389068552266827,
              -0.466068879177273,
              -0.460513637544941,
              -0.337995356995074,
              -0.599105510495449,
              -0.78563779888425,
              -0.592148508598445,
              -1.0044082038284,
              -0.125043986997646,
              -0.671103830199754,
              -0.806227406488943,
              -0.628316348443364,
              -0.332617690923845,
              -0.76400250069105,
              -0.128439491811017,
              -1.0533697882323,
              -2.27013879874468,
              -0.399321143938076,
              -0.748805299593689,
              -0.477475030583232,
              -0.329302064811633,
              -1.68964947552734,
              -0.651070093615047,
              -0.177758163614545,
              -0.611697628196356,
              -0.410542871699507,
              -0.614903818313364,
              -0.859567087989141,
              -1.99776982782337,
              -0.263954192770026,
              -0.240094368008543,
              -0.612887340509002,
              -0.319886538693457,
              -0.175735939634719,
              -0.296079692436673,
              -0.598176222202457,
              -1.40344676562308,
              -0.263635482339716,
              -0.353503303853045,
              -0.0624600690305324,
              -0.278603834563307,
              -0.265212182834997,
              -0.0231671052838162,
              -0.311122248662485,
              -0.0535414310739398,
              -0.780053085484478,
              -0.198481164543714,
              -0.58044409467382,
              -0.824167018180096,
              -0.356975679634872,
              -0.485688149152743,
              -0.665694430025031,
              -0.492468519119672,
              -0.514419410186868,
              -0.0222014825378646,
              -0.288307703632975,
              -0.78288600355075,
              -0.605557627469752,
              -0.32208214531341,
              -0.342026392205981,
              -0.61920825362595,
              0.0705351398009302,
              -0.931626488383824,
              -0.505260151560916,
              -0.72973557646057,
              -0.139225296795552,
              -0.735247187269536,
              -0.172405469486745,
              -0.655879485076582,
              -0.392849469309763,
              -0.554612035011662,
              -1.65213070275012,
              -1.47681098283447,
              -0.828048693161723,
              -0.857514175217881,
              -0.0589694712103803,
              -0.794245168630877,
              -0.043881715495977,
              -0.848032591493936,
              -0.241912957348193,
              -0.781732834522177,
              -0.761988021699751,
              -0.371619709498851,
              -0.503317080953794,
              -0.0699311693963613,
              -1.1168613043594,
              -0.370453313358482,
              -0.971437442988428,
              -0.647885789967391,
              -0.466362512394667,
              -0.00364703453411375,
              -0.614713418684613,
              -0.719110399090175,
              -0.939557277806556,
              -0.53141716784238,
              -0.493042428811017,
              -0.236951214187388,
              -0.490358172676068,
              -0.646330621743234,
              -0.323027265013018,
              -0.674598759901125,
              -0.388239560871696,
              -1.72119429870669,
              -0.805922311339594,
              -0.647866749075934,
              -0.893266153115792,
              -0.270889647107148,
              -0.481101227050255,
              -0.158616963292845,
              0.00623733729788062,
              -0.387376241267589,
              -0.168720598555045,
              0.070488099721814,
              -0.469493639599807,
              -0.135106815209342,
              -1.72602515943005,
              -0.724621064507246,
              -0.22451083006175,
              -0.472203887172504,
              -0.22029913145279,
              -0.240631878713772,
              -0.206317030626295,
              -0.296640266594323,
              0.0192384099773253,
              -0.344384384346843,
              -0.668109548076261,
              -0.466451122918933,
              -0.0735767870142759,
              -0.311043308074456,
              0.0366969536983102,
              -0.0910204330221196,
              -0.254334105115353,
              -0.055547220759063,
              -0.641385716686792,
              -0.597517716417741,
              -0.423950076537902,
              -0.500569353902961,
              -0.24010107123216,
              -0.288301770761791,
              -0.723764674963181,
              -0.181835392983012,
              -0.0200457718789313,
              -0.16840387862646,
              -1.26832828126465,
              -0.0774442688717563,
              -0.251073212392896,
              -0.182354094691225,
              -0.243783435346098,
              -0.489348605550431,
              -0.400826333896705,
              -0.897449874861172,
              -0.460592989875483,
              -0.660538273123612,
              -0.611809144192465,
              -0.51319323591052,
              -0.285210706545068,
              -0.131638137978813,
              -0.292633472883855,
              -0.464496790369628,
              -0.191858878991084,
              -1.29166071084876,
              -1.36032724048106,
              -0.393296675690819,
              -0.142459257221759,
              -0.158268506881965,
              -0.102744288158495,
              -0.0381265481801074,
              -0.282520178331552,
              -0.110188072671559,
              -0.0970014502118093,
              -0.611110260752208,
              -0.238993294196958,
              -0.124639264831112,
              -0.321164149906425,
              -0.675167387062457,
              -1.82702302209022,
              -2.13955863364015,
              -0.217805862233375,
              -0.361025596517258,
              -0.148709103580296,
              -0.165497708776614,
              0.0814250034843874,
              -0.587174368021077,
              -0.102410748163058,
              -0.44490215273123,
              -0.917228238713772,
              -0.706389452830173,
              -0.365345805358706,
              -1.37526286748487,
              -0.471396764111109,
              -0.686933437901259,
              -0.209562922879706,
              -0.341160221188346,
              -1.18651223732273,
              -0.345287558527987,
              -0.112622913808344,
              -1.20127868956045,
              -0.572092276093918,
              -0.416208875961059,
              -0.707954285795631,
              -0.0247646892554417,
              -0.0696535462783631,
              -0.0426121496903454,
              -0.328008218487109,
              -0.389099647704395,
              -0.0217540507543004,
              -0.625129167619602,
              -0.663371654313725,
              -0.251479609299395,
              -1.20155666412295,
              -0.121864576780649,
              -0.642710253542587,
              -0.170220224928754,
              -0.139273199657535,
              -0.473352316808362,
              -0.207935576607033,
              -0.341969068911276,
              -0.505815374670725,
              -0.365770145898446,
              -0.102573636862007,
              -0.1328061468274,
              -0.446092824724875,
              -0.149775739397612,
              -1.2986311263605,
              -0.0643157875407476,
              -0.172716756239973,
              -1.19299645484875,
              -0.144707983236484,
              -0.579429294551769,
              -0.388731879743004,
              -0.112149627156014,
              -0.700923491331443,
              -0.106409359836225,
              0.0150992727974938,
              -0.761070790205815,
              -0.0953092115846145,
              -0.0452137384931368,
              -0.0132363303571956,
              -0.204464980006636,
              -0.218641766241425,
              -0.295795694060707,
              -0.216127716649201,
              -0.710252268140356,
              0.0208520913326444,
              -0.0551702398198068,
              -0.0594304880147298,
              -0.739816566016555,
              0.00521541344601789,
              -0.490904554085436,
              -0.45996586630236,
              -0.578100681323912,
              -0.59733046289776,
              -0.537678422853622,
              -0.362564592940616,
              -0.211812201005185,
              -0.406541666137167,
              -0.329958430565425,
              -0.576444701448682,
              -1.74799284144783,
              -0.925664111952629,
              -0.79451002164559,
              -0.802441091658576,
              -0.335490813753481,
              -0.813906498176079,
              -0.151008498284756,
              -0.531285637308365,
              -1.01058354795518,
              -0.308249459458678,
              -0.230469392565902,
              -0.205738120302952,
              -1.04674440520824,
              -1.57302086703413,
              -1.11042702045841,
              -0.271186117216845,
              -0.0853911537421091,
              -0.901236044100422,
              -0.63467530792021,
              -1.08977963812854,
              -1.63006852057091,
              -0.735163002610616,
              -0.0456632401617351,
              -0.469267231272452,
              -0.0216583589332223,
              -0.146934085552728,
              -0.379403268049327,
              -0.186208231937152,
              -0.308242137125355,
              -0.0223305000452208,
              -0.33066928944841,
              -0.224836032870901,
              -1.21910029565672,
              -1.32212403906694,
              -0.446455411038777,
              -0.942528716263394,
              -0.0806203351798633,
              -1.22871431089646,
              -0.496550221584971,
              -0.397196459611767,
              -0.413534909634281,
              -0.662507636653286,
              -1.10786692367924,
              -0.122863788403068,
              -1.24298354057636,
              -0.165434427082305,
              0.0208299483252809,
              -0.177010837377991,
              -0.552764878992906,
              -0.475083081387041,
              -1.11710227983478,
              -0.703930398899694,
              -0.177055641290375,
              -0.418926425280056,
              -0.162334312906583,
              -0.431060280209639,
              -0.0265784183916655,
              -1.25193958590819,
              -0.0667750198947589,
              -0.542839728549095,
              -0.233105882363218,
              -0.10425941436022,
              -0.227038253134068,
              -0.0834459698349972,
              -1.42238413975208,
              -0.211609340535583,
              -0.215183078297253,
              -0.294774795264108,
              -0.998966627796379,
              -0.639651953484547,
              -0.455465538322239,
              -0.985598017508731,
              -0.195198196627896,
              -0.457527765951823,
              -0.673939109929605,
              -1.87936335902269,
              -0.624490233969687,
              -0.3865779188376,
              -0.14885149315889,
              -0.202924895345215,
              -0.346482884061511,
              -0.327066824961765,
              -0.243541223138696,
              -0.670094481140573,
              -1.19285421708097,
              -0.159302499443641,
              -1.05478601448978,
              -1.10746590039319,
              -0.45818235420903,
              -0.498862211899087,
              -0.204450642441584,
              -0.0627194896013331,
              -0.699659380438994,
              -0.869749142379946,
              -0.101265888547388,
              -0.458517616134661,
              -0.4238566161181,
              -0.405609099035489,
              -0.258658621016763,
              -0.538860186274398,
              -0.0329755852533502,
              -0.275082676482607,
              -0.293096652481881,
              -0.307092559351998,
              -0.888657858426069,
              -0.470435056555373,
              -0.415806562241767,
              -0.0694246137193567,
              -0.614808834332036,
              -0.244962488507507,
              -0.151727177321209,
              -0.320142674324392,
              -0.32459899865313,
              -0.412864422027412,
              -0.292746476140444,
              -0.36676472444286,
              -0.103416668578316,
              -0.426484736541106,
              0.0593572624192085,
              -0.345635641400901,
              -1.75958937668646,
              -0.138315764429527,
              -0.851005224144778,
              -1.3329080103218,
              -0.0791268311952638,
              -0.330347088902435,
              -0.402365926790274,
              -0.372885312119526,
              -1.32371198355063,
              -0.598845760092272,
              -0.305141490068921,
              -0.0353882952135654,
              -0.0971306043682928,
              -0.336411397886989,
              -0.382400302563717,
              -0.6254488046829,
              -0.730528088128688,
              -0.296249096885139,
              -0.306583044907216,
              -0.832690346399808,
              -0.234562071265928,
              -0.481888248700346,
              -2.89300842213544,
              -0.736338286224804,
              -0.0474821192150064,
              -1.17727863481458,
              -0.892242546645568,
              -0.372302908883187,
              -0.325085168452898,
              -1.62299805584464,
              -0.530430403914977,
              -0.049355540760779,
              -0.950488127890823,
              -0.818409032371868,
              -0.574997197213843,
              -0.827720912816254,
              -0.154205731349869,
              -0.242582559148296,
              -0.275951610725712,
              -0.203394666594134,
              -0.673735510034276,
              -1.65656275588957,
              -1.13665734657727,
              -0.383653791991873,
              -0.212057033031743,
              -1.23212768248919,
              -0.30415760143695,
              -1.02423355897273,
              -0.602826386840848,
              -0.429930387467151,
              -1.62012424491683,
              -0.223883509787997,
              -0.198782660882251,
              -0.0843968604915902,
              0.0209302580778172,
              -0.101167416888749,
              -0.214643501881939,
              -0.336458476389356,
              -0.898173851060452,
              -0.27878395503353,
              -0.113777339168904,
              -0.0236267561447023,
              -0.199751079947677,
              -0.626862170377724,
              -0.726226154044216,
              -0.427983924694885,
              -0.647069649307835,
              -0.672346101289899,
              -0.941522826608757,
              -1.03530875011402,
              -0.528875685360063,
              -0.306608040539925,
              0.0211011073191694,
              -0.865248647544176,
              -0.605377309785758,
              -1.71044822138302,
              -0.344273168338674,
              -0.448246067661544,
              -1.60080021042666,
              -0.797972269568352,
              0.0250533894252276,
              -0.57441162388955,
              -0.126330275211031,
              -1.04969127383053,
              -0.311101671240308,
              -0.616530400538887,
              -0.759518327459005,
              -0.113870997674571,
              -0.652320812676687,
              -1.01548620293872,
              -0.614465307462779,
              -1.05117173285606,
              -1.03398187577078,
              -2.01891494923094,
              -0.246471544891726,
              -0.170032490987102,
              -0.140972229123515,
              -0.442142838505881,
              -0.161707961143062,
              -0.0173884713818251,
              -1.15315814281416,
              -0.134353229294807,
              -0.875415811251432,
              -0.751420606229555,
              -0.872137114866809,
              -0.725382980957734,
              -0.813777100710648,
              -0.727574100282501,
              -0.377690053894808,
              -0.255538584401614,
              -0.774279521632858,
              -0.104251877624501,
              -0.151964308765412,
              -0.167325996028187,
              -1.17262853266016,
              -0.860948551263291,
              -0.663495018432311,
              -0.10096794719044,
              -0.27887044181096,
              -0.821066111857967,
              -0.459197875024304,
              -0.183658516927678,
              -1.14098965762184,
              -0.079914894322392,
              -0.381148493081846,
              -1.40244637857216,
              -0.733670756621735,
              -1.85992489281989,
              -0.982704531457098,
              -1.65092097538786,
              -0.0109572206580868,
              -1.01672299498235,
              -0.92672196094038,
              -1.17328050137101,
              0.00827644002993516,
              -1.63883532418703,
              -0.870681458020823,
              -0.0659121170845405,
              -0.907786686756457,
              -0.580234944513401,
              -0.302170816508596,
              -0.756339193776593,
              -0.997306267647554,
              -0.318181323483169,
              -0.107236705564118,
              -0.90121160420941,
              -0.398456416513312,
              -0.161308850302103,
              -0.404642617731392,
              -1.36560031428179,
              -0.674908377294601,
              -0.747122224787834,
              -0.973067126203406,
              -0.792741250235177,
              -0.355860782033512,
              -1.15951064596346,
              -0.339478936552858,
              -0.101125410881835,
              -0.941832396592729,
              -1.0057759309558,
              -0.877950466378591,
              -0.179280060091495,
              -1.03842021232465,
              -0.775237004025921,
              -1.06939006421257,
              -1.86515560193859,
              -1.25500102034407,
              -0.911275678481109,
              -0.309610776603761,
              -0.142865006211685,
              -0.856528371892593,
              -0.51697559997814,
              -0.790195847826343,
              -0.916801748888185,
              -0.256269493739437,
              -0.0199864728710513,
              -0.0864485338808963,
              -0.602430498473739,
              -0.0583727875918763,
              -0.396129648442396,
              -0.290901035265601,
              -0.360033853706483,
              -0.971888474064809,
              -1.71187017979781,
              -1.27099669952645,
              -0.947761666707563,
              0.034153769137881,
              -0.215834283390082,
              0.0183273715403138,
              -0.0840193611820059,
              -0.253058117302307,
              -0.136481635007071,
              -0.525735981153293,
              -0.787459115113594,
              -0.470827044848109,
              -1.51643733760473,
              -0.657514981623084,
              -0.119894439998482,
              -0.307680135984923,
              -1.01819854763299,
              -0.254705927241767,
              -0.208617772702234,
              -0.251256366798733,
              -1.0548414214052,
              -0.140454049002288,
              -0.538827508854267,
              -0.402174024589528,
              -0.457583379548012,
              -0.940536521232868,
              -0.214754087636752,
              -0.940076303724361,
              -0.546528864575239,
              -1.24185996781805,
              -0.213042912914332,
              -0.508527595028409,
              -1.07150640753771,
              -0.457390092001585,
              -0.436464662094856,
              -0.209039117264007,
              -0.196112558083729,
              -0.608468114196624,
              -0.352227935639759,
              -0.268657907740873,
              -0.122932206223787,
              -0.131054715138181,
              -0.282825334618851,
              -0.903504263526363,
              0.0988415950778934,
              -0.402008054663907,
              -1.03286838947615,
              -1.25848058674054,
              -0.204982597467805,
              -0.81901277009493,
              -1.00138717859661,
              -0.279580085828671,
              -0.313267677141577,
              -0.19700933339592,
              -0.505827126401134,
              -0.407665719793149,
              -0.353907675494325,
              -0.0874373932185266,
              -0.0899003764683702,
              -1.30841305878298,
              -0.0965932378384796,
              -0.0412687594971374,
              -0.515841296701731,
              -1.4064700627704,
              -0.246742903320685,
              -0.279236837649012,
              -0.625297700789658,
              -0.361417949363198,
              -0.281798400375413,
              -0.929086432216715,
              -0.117188812367657,
              -0.714603819369011,
              -0.162395833546947,
              -0.00563730926164419,
              -1.06688344016084,
              -1.67527762462431,
              -0.926772844307247,
              -0.873647284563624,
              -2.82506602624243,
              -0.28520274392471,
              -0.949192783625338,
              -1.02297616483096,
              -1.88270242469984,
              -1.127943766798,
              -1.11855730895033,
              -1.17145502987298,
              -1.25383794685655,
              -1.38759615819191,
              -1.81269069086776,
              -0.775441900109879,
              -0.690735170687029,
              -0.94028018900355,
              -0.398103416760152,
              -0.58517685172928,
              -0.0664256636143495,
              -0.312322072516257,
              -0.377639477864309,
              -1.38522513781094,
              -0.11108902579531,
              -0.371008475584444,
              -0.368650922966942,
              -0.00744325293678849,
              -0.787739591368014,
              -0.474672006712474,
              -0.40626722357722,
              -0.87622659223228,
              -0.221469008869644,
              -0.282907768266414,
              -0.355301754333617,
              -0.588158870377367,
              -0.218570165904922,
              -1.12109004466486,
              -0.618465004848909,
              -0.721066972020231,
              -0.37443213609054,
              -0.6134423216105,
              -0.152453212103993,
              -0.150971733858482,
              -0.713544644264648,
              -0.886057344009324,
              -0.928432754794418,
              -0.916142596345147,
              -0.256540408506769,
              -0.319009078813305,
              -0.0758353541531146,
              -0.494121453402893,
              -1.98291850791397,
              -0.348019637359034,
              -1.3471655737497,
              -0.125066359770595,
              -0.946365440042897,
              -0.0456505042827887,
              -0.00826315291119523,
              -0.228870809301635,
              -0.115539585172872,
              -1.06897090815627,
              -0.261494151729395,
              -0.276233188507939,
              -0.140125594682572,
              -0.467646969461195,
              -0.206197570658154,
              -0.0461359825715011,
              -1.57594370392873,
              -0.574351951536722,
              -0.974822922322228,
              -0.333573110742145,
              -0.892668177218677,
              -2.45798635622968,
              -0.514626991356289,
              -0.589379012696824,
              -0.909632442563454,
              -0.585352398048418,
              -0.596760422461935,
              -0.328630347883966,
              -0.93933735168444,
              -0.230353358964589,
              -0.536408071444909,
              -0.349558632695119,
              -1.51742018400748,
              -0.327989012512062,
              -0.365651034427679,
              -1.0085286967646,
              -0.608600552652518,
              -0.736529780946116,
              -0.411106100776232,
              -0.336537600694192,
              -0.864536078393621,
              -0.441309152176386,
              -0.148928272945997,
              -0.429439689553694,
              -0.206565798478856,
              -0.132998629769071,
              -0.823686629377068,
              -0.0694755025712285,
              -0.876471427749016,
              -0.157586991620897,
              -0.143379877889591,
              -0.637690369807349,
              -0.458753089854036,
              -1.20534736958492,
              -0.312713656394387,
              -2.45015427935442,
              -0.652619554720023,
              -0.369684358734245,
              -0.776140499045208,
              -0.723760872032868,
              -2.25991921193247,
              -0.287047765554098,
              -0.183845437055065,
              -0.671678820108069,
              -0.427971939860546,
              -0.705076792981927,
              -0.284872226014497,
              -0.201022182107508,
              -0.254796265242376,
              -0.536155222514053,
              -0.479430504547938,
              -0.705480531008295,
              -1.22515394827115,
              -0.625244649277602,
              -0.611075912194329,
              -0.483858507402132,
              -0.173287742876663,
              -0.531211182456871,
              -0.458181182345823,
              -0.60089106857452,
              -0.354654004406261,
              -0.259184248950661,
              -0.997989769055958,
              -0.328804147072538,
              -1.40191263257125,
              -0.619935637243887,
              -2.74462809364052,
              -0.161138450768241,
              -0.336964654255319,
              -1.06156534745631,
              -0.541116398286409,
              -2.57604711026594,
              -1.47958906702964,
              -0.153439485722652,
              -0.07960747881476,
              -0.188216688845649,
              -1.6158151678028,
              -0.439027327585816,
              -0.633536583246174,
              -1.18519114257573,
              -0.206982233793422,
              -0.871641153659525,
              -0.281858036992548,
              -1.39360674807404,
              -0.226393483928608,
              -0.139353318513672,
              -0.409051892084944,
              -0.219764776227019,
              -0.545216725207984,
              -0.674587723877152,
              -0.177274913059228,
              -0.752477172844562,
              -0.133589561508495,
              -1.06123354788586,
              -0.262108865893842,
              -0.570243057812235,
              -0.183237728281329,
              -0.528921734928587,
              0.0038239669024499,
              -0.136323362348607,
              -1.01151932306354,
              -0.456335241959236,
              -0.452994654894177,
              -0.87742561998997,
              -0.449983388497878,
              -0.81638204434539,
              -0.676626179220091,
              -0.312297198881937,
              -0.218638655937513,
              -0.773791502549674,
              -1.30974377479089,
              -0.120617199188553,
              -0.509281920835798,
              -0.497358589019433,
              -0.277974002761664,
              -0.30417529037136,
              -0.555437980471384,
              -0.140612362431438,
              -0.146269945830453,
              -1.78693192227915,
              -1.54540394007719,
              -0.249791043283086,
              -0.49521552188221,
              -1.52769915467865,
              -0.609367328930387,
              -0.406138647196643,
              -0.624194647267006,
              -0.279890425397136,
              -0.0802515346131555,
              -0.357067207223119,
              -0.0204897460138599,
              -1.35393024043656,
              -1.81642863984892,
              -3.72102561567417,
              -0.808888839233904,
              -0.978349876213663,
              -0.0492875597100884,
              -1.13284282819329,
              -0.278733522763644,
              -0.0530637193392657,
              -0.0995619590809536,
              -0.242197722209589,
              -0.659014139109389,
              -1.16073210850545,
              -0.54672206419562,
              -0.100841950472373,
              -0.438035075419107,
              -0.996291854407649,
              -0.339358900239869,
              -0.0505467956215562,
              -0.591955647559778,
              -0.045459888227964,
              -0.109437748189311,
              -0.485432907262232,
              -0.626849130316388,
              -0.682843984495595,
              -0.257982612764747,
              -0.094230539059605,
              -0.550937048010492,
              -0.807597493635561,
              -0.805030583035922,
              -0.170436364594139,
              -0.0909245831373193,
              -0.407545352705879,
              -0.240050945321819,
              -0.551848183632998,
              -0.397771827443056,
              -0.0779329562194279,
              -0.501848467858079,
              -0.627635877874037,
              -0.691829474760405,
              -0.420824529459404,
              -0.618864580409728,
              -0.232296262682425,
              -0.603494307518196,
              -0.102137691092381,
              -0.411860802685518,
              -0.165727755363488,
              -0.0550632315008051,
              -1.31286609671656,
              -0.267838869918466,
              -0.176078568020148,
              -0.316751447182798,
              -0.367185093307466,
              -0.163407212274253,
              -0.288424377071129,
              -0.638487090434461,
              -0.0633986613178071,
              -0.165445981695669,
              -0.63986024459051,
              -1.28286273435701,
              -0.0857167285229273,
              -0.0850325599211283,
              -0.283846443849971,
              -0.201323202125594,
              -0.408067587555517,
              -0.933973229655914,
              -0.527124955988141,
              -0.347680759098045,
              -1.07175714396557,
              -0.496747869510614,
              -0.221564160157634,
              -0.212414211195327,
              -0.0986168538063983,
              -0.0344516812866975,
              -0.572697456229132,
              -0.818665873380049,
              -0.230158382188081,
              -0.229974020623516,
              -0.0988486774851744,
              -0.298838627271902,
              -0.648902231552207,
              -0.166756069308255,
              -0.658130215984511,
              -0.564312698446028,
              -0.231052044389991,
              -0.296706448490795,
              -0.155081596072621,
              -0.154872184710394,
              -0.152739478969943,
              -0.434098473214269,
              -0.691983698760281,
              -0.00410671679287616,
              -0.637120407605275,
              -0.455923585770567,
              -0.447847889568806,
              -0.783501854688419,
              -0.038583650598939,
              -0.0291461272184199,
              -0.47304597483623,
              -0.220663040093591,
              -1.20784133339568,
              -0.187776800325438,
              -0.240715960020326,
              -1.35147200603505,
              -0.191558522410255,
              -0.482994657330432,
              -0.373075371553774,
              -1.45880157421807,
              -0.0531802335034408,
              -0.334923859342243,
              -0.609867181886365,
              -0.4549072608692,
              -0.53447690813925,
              -0.154881478963108,
              -0.336384404931906,
              -0.334412494057411,
              -0.695722714652483,
              -0.535384239197713,
              -0.672704916518641,
              -0.130758767120375,
              -0.196838624005247,
              -1.19420539980572,
              -0.365034886101061,
              -0.135029122467355,
              -0.0606775608112842,
              0.00848306579264918,
              -0.263171839387937,
              -0.230762000633258,
              -0.668451274830204,
              -0.250818418364783,
              -0.621502547910158,
              -0.104156338719193,
              -0.228094303681467,
              0.0342173160235873,
              -0.54845280980263,
              -1.4981695881522,
              -3.02224453472348,
              -0.529929669313163,
              -0.733598500171391,
              -0.248738322588253,
              -0.382084133143984,
              -0.08692908644168,
              -0.497713410980735,
              -0.401158155021227,
              -0.790826060855578,
              -0.694274588719048,
              -0.163510504151441,
              -0.584789917098034,
              -0.21997667503143,
              -0.0508374885263994,
              0.00517697291079816,
              -0.423713688467196,
              0.05803236563017,
              -0.377176765073912,
              -0.835075318009762,
              -0.0510010739994053,
              0.0326682348917554,
              -0.00154158930208742,
              -0.542424789345494,
              -1.08904977985378,
              -0.666243576685132,
              -1.90285962187251,
              -0.869718213973842,
              -0.039192232909086,
              -0.148055034035613,
              -0.257145212982422,
              -0.7456496182878,
              -1.05783424255181,
              -0.363641464541889,
              -1.01386955030654,
              -0.159603324813642,
              -1.04003662839789,
              -0.327052190614315,
              -0.458709933712731,
              -0.0603976339997147,
              -0.517978723122168,
              -1.31897609438605,
              -0.514716104774039,
              -0.469383918914963,
              -0.289998101367394,
              -0.368095189436361,
              -0.897202161467061,
              -1.71363752818441,
              -2.60260714576908,
              -0.307995319265787,
              -0.807418747155864,
              -0.0321333094517501,
              -1.52885489402426,
              -0.745378931797438,
              -0.361328791395626,
              -0.179882564019626,
              -0.2858931208196,
              -0.166650726402494,
              -0.289095809671646,
              -0.188785383711983,
              -1.13794249003547,
              -1.24217713556156,
              -0.680493063553837,
              -1.01537819459814,
              -0.619907330242008,
              -0.447676906626124,
              -0.257260996737969,
              -0.884551432600996,
              -0.579420865083777,
              -0.28833836798612,
              -0.837609702329819,
              -0.83657739236691,
              -0.678234199970474,
              -1.6327667816356,
              -0.34594327152992,
              -0.733838834461114,
              -0.688949490272562,
              -0.673229528035004,
              -0.651882182594169,
              -0.404275990945751,
              -0.384574606576156,
              -0.927483345136631,
              -0.583003019045287,
              -0.707472961572247,
              -0.929462057606998,
              -1.00271840437182,
              -1.0113739231027,
              -0.467442551295619,
              -0.716910484378154,
              -0.248974008714206,
              -0.344132545407992,
              -0.285491307279257,
              -1.13892517398445,
              -1.99323024358634,
              -0.212484879514203,
              -0.0611579185229995,
              -0.454539847640359,
              -0.1115778112256,
              -0.93830330091033,
              0.0533934683352911,
              -0.221531104773404,
              -0.111938649345683,
              -0.282103850143689,
              -0.264303791829331,
              -0.218590109553336,
              -0.69455019240147,
              -0.513437342062899,
              0.0151636599246414,
              -0.54567901846129,
              -0.460647225539457,
              -0.503532179444343,
              -0.151427518753472,
              -1.3960292245891,
              -0.198740355586032,
              -0.311382763961099,
              -0.484400242185746,
              -1.24968721682987,
              -1.0506931796095,
              -0.355902871633374,
              -0.266050056986144,
              -0.311670023151131,
              -0.135693287969144,
              -0.668383784246438,
              -0.180483104973697,
              -0.152266860533606,
              -0.530837027781089,
              -1.18500817363816,
              -0.135366437236678,
              -0.118489193929404,
              -0.369577899127463,
              -0.191454507446414,
              -0.228173656548358,
              -0.398815842497324,
              -0.616869863654751,
              -0.939964345156451,
              -0.895796389494141,
              -0.622645187615294,
              -0.16878030655348,
              -0.632855557611437,
              -0.131065927116939,
              -0.103461562380109,
              -0.462708740285561,
              -0.0382269369652848,
              -0.182531875731452,
              -0.641432945177416,
              -0.824442332642519,
              0.0119019229892343,
              -1.04820811025996,
              -0.696915560296188,
              -1.17652014574693,
              -1.4793017989822,
              -0.2611970342385,
              -0.102931643772503,
              -0.570360009189569,
              -0.622596428226769,
              -0.0964531731618252,
              -0.719162328149386,
              -0.288497426104617,
              -0.378507436320014,
              -0.436002621984297,
              -0.298223432305306,
              -0.285640584830335,
              -0.996083440683188,
              -0.731871488753946,
              -0.495974241626091,
              -0.304189347152089,
              -0.33843791617052,
              -0.721904727343867,
              -0.938697649182189,
              -0.163612511403292,
              -0.151063007701032,
              -0.294134232209899,
              -1.36891491746289,
              -1.28263595774476,
              -0.358320741010535,
              -0.0556843097217866,
              -0.137803959610272,
              -0.361312165724812,
              -0.751801810174382,
              -0.615966708487642,
              -0.519305609716717,
              -0.531976593379457,
              -0.206098595212041,
              -0.227460424607808,
              -1.27628836767256,
              -0.415515456951999,
              -0.162588637647665,
              -1.0281549613592,
              -0.514399514996363,
              -0.824833995599392,
              -0.334824200270523,
              -1.45828104571817,
              -0.890761745281443,
              -0.0964791925062323,
              -0.208391942732915,
              -1.04698375922055,
              -0.319038304562642,
              -0.29870736183817,
              -0.557632729394958,
              -0.817302795176242,
              -0.207390497099846,
              -0.973583032617423,
              -0.397714903085329,
              -0.321075799390156,
              -1.11561008187713,
              -0.574639678727548,
              -0.659775314053764,
              -0.271816908951422,
              -3.62394482923521,
              -1.82016470392967,
              -1.70078387658886,
              -0.824076920147537,
              -1.44568279897562,
              -1.64585021068186,
              -2.34068938878791,
              -2.32947758971956,
              -1.15074315961629,
              -2.75383052545567,
              -0.832426455850789,
              -0.719111649368316,
              -0.833867512433355,
              -1.26801513609121,
              -1.27255440700291,
              -0.692907559075748,
              -0.0509953668725819,
              -0.228317007594129,
              -0.786777175895475,
              -0.306141939728816,
              -0.0776800132905164,
              -0.0155987639258199,
              -1.40685546354016,
              -0.472537856492902,
              -0.176124543469075,
              -0.717971229626907,
              -0.324831392228631,
              -0.697633319442081,
              -0.450941693078388,
              -1.10695499412669,
              -0.354738189891521,
              -0.0650106565398105,
              -1.30612695585086,
              -0.145456281688097,
              -0.469181679555852,
              -0.578651677605157,
              -0.362336344392297,
              -0.584618000952253,
              -0.874470668129351,
              -0.544373964855718,
              -0.0563808223388782,
              -0.500946255373147,
              -0.0780427426512649,
              -0.468012578982933,
              -1.00579036600948,
              -0.410662079078266,
              -0.199465584973891,
              -0.304416980895817,
              -0.426373746075868,
              -0.226944477173007,
              -0.216350643786215,
              -0.0609248363045699,
              -1.60622662116275,
              -0.571924320176878,
              -0.384769740852823,
              -0.171545581500642,
              -0.688641189456651,
              -0.453849595001487,
              -0.119355399184364,
              -0.47155846236738,
              -0.328428695333536,
              -0.728144659079661,
              -0.667283778483015,
              -0.937430379713597,
              -0.885298975758732,
              -1.1254985643342,
              -0.982008256981192,
              -0.993048791990988,
              -0.31213790332347,
              -0.991976569797491,
              -0.509286238218938,
              -0.504345128978765,
              -0.0403859250035321,
              -0.499716027079175,
              -0.36301347522222,
              -0.418582563988606,
              -0.480501753696147,
              -0.329284677193039,
              -0.114383061754816,
              -0.555384161903308,
              -0.0963860519838003,
              -0.444420651768132,
              -0.298645254832527,
              -1.08135938490753,
              -0.367836470733088,
              -0.189097976250463,
              -0.794261617060896,
              -0.455893525782018,
              -0.837392279727938,
              -0.863786574552262,
              -0.192670033142345,
              -0.476186922729302,
              0.0268082373931908,
              -0.22448840340712,
              -0.158633186789746,
              -0.218120296193463,
              -0.0893242093867998,
              -0.474173703198682,
              -0.220682335023281,
              -0.801447248236793,
              -0.420848862005309,
              -0.421323942710958,
              -0.598775345479365,
              -0.416583685261455,
              -0.0940935599029926,
              -0.326292138870252,
              -0.0930367517349793,
              -0.474373272271115,
              0.0247483135792757,
              -0.265041968303303,
              -0.520586372497712,
              -1.6255902988506,
              -1.36427144590398,
              -0.187886806053674,
              -0.249662465024447,
              -0.493524144548536,
              -1.77861472437013,
              -0.269302408273212,
              -0.556150382234986,
              -0.338703682418167,
              -0.504020516054403,
              -0.374332550346671,
              -1.49734680508321,
              -3.16265344936287,
              -0.149303765061464,
              0.0231865119232257,
              -0.218304940348037,
              -0.343250836354048,
              -0.67526213874356,
              -0.304104034494389,
              -0.190055240448925,
              -0.786426930534463,
              -0.474679239078819,
              -0.473882409900757,
              -0.0448018066108969,
              -0.49128336623894,
              -0.395009562001765,
              -0.0852341959304105,
              -0.145447219303717,
              -0.283421335516692,
              -0.298264706825543,
              -0.708034275394428,
              0.0317099258521619,
              -0.00727448074777698,
              -0.239079802313168,
              -0.466833577840001,
              -0.728132458473439,
              0.0193422651795478,
              -0.441097048753819,
              -0.140253736490883,
              -0.32093240020475,
              -0.874906489945833,
              -0.291601206675859,
              -0.139259065828803,
              -0.655055004143666,
              -0.420533925712315,
              -1.22235487008747,
              -0.672002311289869,
              -0.104704099281177,
              -1.11948358254612,
              -1.3317832894431,
              -0.610365398920691,
              -1.28981367884131,
              -0.389281618684561,
              -0.806113231744298,
              -0.645096833195365,
              -0.153783974240494,
              -0.307544166636021,
              -0.29073505224422,
              -1.18307848036211,
              -0.836473028130874,
              -1.11405662207975,
              -1.03298440751946,
              -0.554870363195949,
              -0.182796453649186,
              -0.972837709692063,
              -0.210917217674271,
              -0.0574232440061842,
              -0.4988057866469,
              -0.239681395030387,
              -0.0152389198310765,
              -0.654163899926539,
              -0.740098351666646,
              -1.64039476854804,
              -0.653100277805276,
              -0.198324417598665,
              -0.375051162413803,
              -1.21651259131973,
              -0.302198338524801,
              -0.147501064649304,
              -0.294962216204038,
              -0.444304621325115,
              -0.291099015791314,
              -0.552717049916235,
              -0.344043071521519,
              -1.02155927494864,
              -0.955331837284678,
              -0.68292335375132,
              -1.15572848119572,
              -2.83364057995266,
              -0.100489585201675,
              -0.595129037233011,
              -0.794613569713979,
              -0.394149536662568,
              -0.841550782655133,
              -0.0667376305919291,
              -1.04208999613077,
              -0.435451173309719,
              -0.234369936941663,
              -1.9926183339685,
              -0.431858494322204,
              -0.340637352419338,
              -0.37951210370775,
              -0.120498663268093,
              -0.434349601424076,
              -0.28612777931645,
              -0.688054837310996,
              -0.338648591667777,
              -1.03933105196489,
              -0.208990180635381,
              -0.497624125316938,
              -1.7386574675966,
              -0.725785189777647,
              -0.332487805776667,
              -1.08439765894979,
              -0.117501492406743,
              -0.935139267945006,
              -0.379219772161782,
              -0.56044499500762,
              -0.0303059530342185,
              -0.0578809311827098,
              -0.816685912543747,
              -0.124529083092607,
              -1.24050871889747,
              -0.951437794166956,
              -0.845364716893,
              -2.01465475817091,
              -0.526930137166797,
              -0.360607618629404,
              -0.0827668507611785,
              -1.4623440558611,
              -0.228076386817741,
              -1.85981075625722,
              -1.11778309453099,
              -0.178929109852592,
              -0.238837700978323,
              0.0418318172539184,
              -0.0388600359869347,
              -0.470779045795563,
              -0.0183173427445096,
              -1.16297389159645,
              -0.784485267533093,
              -0.753418889791798,
              -0.266383055554644,
              -0.843045415234764,
              -0.823704062099686,
              -0.479613913136429,
              -1.73395865007237,
              -0.325227054276683,
              -0.54479956829928,
              -0.450031538426019,
              -0.63482370109375,
              -0.945684891616328,
              -0.114555486775709,
              -0.703122574426656,
              -0.59113824056915,
              -0.135108439745604,
              -1.60364082829382,
              -0.430973733605533,
              -0.377641116625551,
              -0.696597131169771,
              -1.01147960197599,
              -0.205735200038064,
              -0.743219789316595,
              -0.637447401010709,
              -0.622972024105172,
              -0.491240011162928,
              -0.576394267656187,
              -0.0114976764274972,
              -0.426078188953294,
              -0.0334793104858057,
              -0.348148029606156,
              -0.976636061989287,
              -0.723561931031268,
              -0.227745899399708,
              -0.3302445463832,
              -0.554267344158477,
              -0.506777753978256,
              -0.710890730043789,
              -0.184006351566104,
              -0.575449464587354,
              -0.34092169363584,
              -0.639089054595668,
              -0.160950617712356,
              -0.701705882561021,
              -0.361142844392347,
              -0.694669824944988,
              -0.218988558792486,
              -0.109726899923309,
              -0.681148553640633,
              -0.184185082589964,
              -1.5138622043359,
              -0.486623830163563,
              -0.669915387936054,
              -0.488791873821465,
              -1.35881528844074,
              -0.0540024382569073,
              -0.76130892918302,
              0.0379761331183076,
              -0.619843578918416,
              -0.005143940609389,
              -1.42421874744029,
              -0.248018224709501,
              -1.44543721379054,
              -0.678024329675011,
              -0.227532388283028,
              -0.747216780109998,
              -1.9751194897538,
              -0.244238986447617,
              -0.861330503859624,
              -0.467139246140583,
              -0.241777819465534,
              -0.225819040744337,
              -1.99246388204159,
              -1.25032975150991,
              -0.486329399782222,
              -0.192527773103882,
              -0.0398895828292931,
              -0.767696575774193,
              -0.322589376126702,
              -0.336830153603519,
              -0.146031009380936,
              -0.265784597558891,
              -0.288151605037781,
              -0.351007547528552,
              -0.649050406997395,
              -0.508974511077229,
              -0.0554953181740991,
              -0.709003779997603,
              -0.47818172207659,
              -0.560714103648313,
              -0.591874522455858,
              -0.465455434629755,
              -0.645096329436704,
              -0.589100676259471,
              -1.14968197519805,
              -1.0293556817033,
              -0.223269460930049,
              -0.25354997666474,
              -0.714502726626606,
              -0.433343540332843,
              -0.300700395585586,
              -1.41187916328231,
              -1.19302912473197,
              -0.216674792347654,
              -0.577667226335142,
              -0.957181780138142,
              -0.168730876195861,
              -1.59725897346793,
              -0.858055055845143,
              -1.17778241137286,
              -1.49759644746395,
              -1.78705051041568,
              -1.10961536967334,
              -0.68104089122899,
              -1.54849425669588,
              -0.570016025540464,
              -0.110672086077545
          ],
          "y": [
              -0.323530785835011,
              -1.82673859640284,
              -0.419089454328868,
              -1.40699596706221,
              -0.58365383851792,
              -0.675975342000934,
              -0.486823283271321,
              -0.545203326858763,
              -0.355004634244655,
              -1.64660183272272,
              -0.688040155822332,
              -1.39954371610159,
              -1.49072815788819,
              -2.37074409351943,
              -1.97476458403121,
              -1.04764372895733,
              -1.65626638637356,
              -1.21109951636236,
              -1.69283200345985,
              -1.83894581271594,
              -1.35057381816121,
              -0.954884877843635,
              -1.69130967906394,
              -1.13579576176818,
              -1.30673323888388,
              -1.74193562724296,
              -1.91522549548987,
              -1.56285128887188,
              -0.667631564580833,
              -0.487808007514345,
              -1.16890388147989,
              -1.2485526741607,
              -1.23720716942601,
              -1.31092197085404,
              -1.47674402221455,
              -1.51049750615783,
              -1.47093386076203,
              -0.967378439834531,
              -1.04790818982262,
              -0.687234417872148,
              -2.44733037605526,
              -0.891449297740139,
              -1.13807390727714,
              -1.03700235208854,
              -1.25811875081603,
              -0.918654582504659,
              -1.48023137014831,
              -1.63306677705177,
              -2.24481204438558,
              -2.36635418093364,
              -0.931707854350812,
              -0.851257460693275,
              -0.581813591422207,
              -0.908297422755291,
              -1.93938631277727,
              -1.41214174773626,
              -1.42616608595279,
              -1.12109149445752,
              -0.953203410844173,
              -0.648295721600566,
              -1.56447230763156,
              -1.32708734483498,
              -0.621064457245254,
              -0.794170124796781,
              -0.973631542270026,
              -0.789225586383679,
              -1.40107343360888,
              -1.13776424677887,
              -0.966489899029126,
              -1.54099350115267,
              -0.947405663437652,
              -1.06712879279762,
              -0.920812765174933,
              -1.28963237486259,
              -1.52568549046414,
              -1.22841817948945,
              -0.694098265955563,
              -2.45449476276714,
              -1.8452244103474,
              -0.752888205094687,
              -0.483427954383446,
              -1.17131330054337,
              -1.01827441356264,
              -0.736861263477035,
              -1.12915677044371,
              -1.23465256192771,
              -0.533531262396924,
              -1.13174362970997,
              -1.3403366323913,
              -0.400157068786614,
              -0.730739392935596,
              -1.06590779320511,
              -1.02324929738522,
              -1.10240232622727,
              -0.852564060220537,
              -1.44947064483008,
              -1.27180460470667,
              -0.838740510072981,
              -0.909227447487315,
              -0.666167066068069,
              -3.09664521249929,
              -2.83928321786192,
              -0.72338844226526,
              -0.850106175721349,
              -0.929987756282363,
              -2.10715848034684,
              -1.11301656523183,
              -1.24492180813261,
              -1.56483427683127,
              -1.1018963192592,
              -1.98890633773418,
              -1.25201122295473,
              -1.03737767875151,
              -2.01517863415554,
              -0.521714500104069,
              -0.985736471346004,
              -0.955263504803737,
              -1.88268266990046,
              -1.03601064350763,
              -0.781932697326753,
              -1.06714983291974,
              -1.10758096390474,
              -1.04187444296147,
              -0.635346751473085,
              -0.718889871138541,
              -1.22096581650574,
              -1.03871046061829,
              -1.00442237780517,
              -0.828421682691417,
              -1.06030923914516,
              -0.936526458833763,
              -1.62740938441334,
              -0.725732317058005,
              -1.53655678678376,
              -0.75868491442472,
              -1.80253556947036,
              -1.05942627841904,
              -1.04480791968146,
              -0.759623280777132,
              -1.46006935879714,
              -1.62189911277229,
              -1.1789682684201,
              -0.968183930718561,
              -2.23011620255031,
              -0.683598592956687,
              -0.434816346424586,
              -1.18451475706272,
              -1.02786535040588,
              -0.402621176457986,
              -0.881989834454792,
              -2.79819896459161,
              -1.20228447312786,
              -1.26913822679355,
              -1.3410512829467,
              -0.828660856614461,
              -0.882870475069135,
              -0.432280771436911,
              -0.85418077112174,
              -0.795271207029579,
              -1.209698917651,
              -0.888569361830659,
              -0.697662141486464,
              -2.03569853434724,
              -1.71464289957348,
              -1.99882365654692,
              -1.07820552693043,
              -0.588555404062593,
              -1.10915872483393,
              -1.18544755871425,
              -0.749168603281701,
              -1.03749502403032,
              -1.25635017567233,
              -0.865846021562367,
              -0.704200226819784,
              -1.07756298609969,
              -1.01421643803463,
              -1.21876093011314,
              -1.16766173448133,
              -1.2887996873332,
              -1.00375382164438,
              -1.7091565199909,
              -1.01191943945113,
              -0.724202415066456,
              -1.76641863711847,
              -1.30775899976879,
              -1.17292373875418,
              -1.12303241652336,
              -1.07860624103094,
              -1.75479040693364,
              -0.736260621757733,
              -0.492732142591371,
              -0.549682025451137,
              -0.993766107596706,
              -0.975646642155996,
              -1.21795711412364,
              -1.08669205689025,
              -1.33400305597563,
              -1.5452112932431,
              -0.584282571649402,
              -0.784195486637842,
              -0.634636721909212,
              -2.23640798075994,
              -1.24233049970773,
              -0.388070340620266,
              -1.79591117689154,
              -1.07372460389933,
              -0.983427443809243,
              -0.48327952927644,
              -2.10027850523415,
              -0.322016259745406,
              -0.601483428351537,
              -1.16861472141855,
              -0.577706357597063,
              -0.391891027366799,
              -0.489620978560802,
              -0.177122927423299,
              -2.454871852471,
              -0.475512569844586,
              -0.903047100726163,
              -0.423436770854303,
              -1.08944902282011,
              -0.98773137087799,
              -1.48929834409473,
              -0.232450294284909,
              -0.352370683053994,
              -0.385208094452928,
              -0.711310162489896,
              -1.52417499009977,
              -1.05016738895493,
              -1.65236860593863,
              -0.607959470753316,
              -1.23633982614516,
              -0.746284457199594,
              -0.363653223325631,
              -0.446134373366293,
              -0.964271596140976,
              -0.517340138932147,
              -0.944438824118251,
              -1.85546604095998,
              -0.794638082554818,
              -0.261807054449858,
              -0.720975756082941,
              -0.461531088065658,
              -0.636081949589835,
              -0.38631165467292,
              -1.12850286310026,
              -1.68478814990822,
              -0.907727347482319,
              -0.725638703768989,
              -0.717787106492172,
              -0.536369180967208,
              -0.821456814469393,
              -0.651377628219925,
              -1.98995852252282,
              -1.19982892623318,
              -1.33130216193115,
              -1.87374406963044,
              -1.04225262338032,
              -0.915512929627122,
              -0.973706648699724,
              -1.09759032703156,
              -1.65410732266558,
              -0.961185512354991,
              -0.785880309032284,
              -1.0409900107651,
              -3.10734231978196,
              -1.15566326135573,
              -1.57010313457876,
              -1.62637579755312,
              -1.14767612018483,
              -1.56415445335678,
              -2.58757762046554,
              -1.484305328734,
              -0.877653085470945,
              -1.42810799909073,
              -2.01175139459509,
              -0.721850818954305,
              -1.13698672302443,
              -1.44642377772326,
              -1.41694328057306,
              -1.89153359448739,
              -1.16232690878611,
              -1.02850214497162,
              -2.33544807013406,
              -1.36847852008402,
              -0.954780699005583,
              -1.19242390577021,
              -0.83513782041432,
              -0.869942322001324,
              -1.19554291652168,
              -1.05364653672054,
              -1.68095647333486,
              -1.27684336190267,
              -0.954145893835458,
              -0.980277662480306,
              -1.2286737059406,
              -1.55317095968245,
              -1.70243051872746,
              -2.61904080793799,
              -1.02267752115174,
              -0.419502675077176,
              -0.60731419904417,
              -0.818421764087689,
              -0.82006552125119,
              -0.993550780553032,
              -1.39049472860423,
              -0.792718128189304,
              -1.1243830277282,
              -1.02742843337256,
              -1.87108220516247,
              -0.648069855398066,
              -0.765114419585731,
              -0.806090323188964,
              -0.803090385291189,
              -1.01801540489283,
              -1.23646597699503,
              -0.988648861502201,
              -1.21189069812321,
              -2.19649609493661,
              -0.466548335461792,
              -1.01990326857771,
              -0.500531992042984,
              -0.771189192174091,
              -0.546967323572505,
              -0.905976348352761,
              -1.32802070914935,
              -1.2197652370573,
              -0.578389356250805,
              -1.19821875746897,
              -0.477848819276877,
              -0.44142492733338,
              -0.36177112680605,
              -0.438313839033655,
              -0.886271838159514,
              -0.97772508546456,
              -0.86696491583162,
              -0.821837444287912,
              -1.11751665177559,
              -0.26733953221742,
              -0.582250549190852,
              -0.573681654869375,
              -0.540938876141501,
              -0.55567782137683,
              -0.868348213170297,
              -0.771997373705408,
              -0.459781199392225,
              -1.72564028211342,
              -0.687349433141013,
              -1.41361050259707,
              -0.918226183884625,
              -0.692008835466639,
              -0.953111133396704,
              -2.19718100742499,
              -0.723399493474228,
              -1.35213772195492,
              -0.778839310439493,
              -1.07655684479999,
              -1.3151876822653,
              -0.916857596227148,
              -1.08607234556757,
              -0.791639469615222,
              -0.397248492445897,
              -1.11288528865708,
              -0.543327944557498,
              -1.47962005894752,
              -0.433227697447925,
              -0.275322158067769,
              -0.483528374426066,
              -0.329564197954124,
              -0.539465366566641,
              -0.449436131619889,
              -1.02808413903256,
              -0.596557291979046,
              -0.421892202705366,
              -0.521412199419813,
              -1.1841440840584,
              -0.965198438343176,
              -0.463679151072379,
              -0.92344021490685,
              -0.707194293400757,
              -0.557037798122296,
              -0.906566076565147,
              -0.672108490430312,
              -0.220404395684613,
              -0.800936471574087,
              -0.663758282896291,
              -1.37466651862477,
              -0.420338068123612,
              -1.25402301831857,
              -1.0678424370689,
              -0.488429434136732,
              -0.839908514984136,
              -0.346828826551828,
              -0.52413810446783,
              -1.28910842476981,
              -1.35150548311319,
              -0.631238691843301,
              -0.555980420303738,
              -0.42559171608713,
              -0.660038233997325,
              -0.333174869954442,
              -0.763761514022842,
              -0.355626581540991,
              -0.765179941810617,
              -1.08778320940856,
              -0.573173958409918,
              -0.393708036713492,
              -0.468876724317469,
              -0.26566517818603,
              -1.4912271248914,
              -0.501944131302476,
              -0.603952207736024,
              -0.254142675732538,
              -0.386331555264698,
              -0.29898226623325,
              -0.784557407115645,
              -0.445236498773501,
              -0.50249423171857,
              -0.769506291122615,
              -0.518017915459567,
              -0.48880382014187,
              -0.346065462061216,
              -0.431179083028242,
              -0.507609050103431,
              -0.724860102918967,
              -0.569117372248403,
              -0.741186717972924,
              -0.397223088444836,
              -0.692999262648798,
              -0.778589051604045,
              -0.684308565313488,
              -0.385750693640755,
              -0.690961316922643,
              -0.767265086418378,
              -0.655046120005925,
              -0.299721020883334,
              -0.695083404326534,
              -0.424010651225543,
              -0.601535414059144,
              -0.48689735543567,
              -0.822372743321859,
              -0.373868602676135,
              -1.09069921297771,
              -1.00505348156931,
              -0.927541899854433,
              -0.311391842159623,
              -1.29112406059004,
              -0.350241253217259,
              -0.735129116324954,
              -0.867589500526228,
              -0.926812716954455,
              -1.46408484823325,
              -0.288636674806561,
              -0.779416591951309,
              -0.567526045440155,
              -0.553475898987258,
              -0.612874573390734,
              -0.608589215104719,
              -0.51407762344201,
              -0.715500105832877,
              -0.859392620427364,
              -0.71013341835134,
              -1.02815387864263,
              -0.349805215807136,
              -0.771040191457282,
              -0.875275610114263,
              -0.738033582273033,
              -0.509929248378783,
              -0.842702976570466,
              -0.352424535658588,
              -1.0659232405009,
              -2.00454868768532,
              -0.561384831051671,
              -0.830979732838317,
              -0.621673370756195,
              -0.507371547602889,
              -1.55675453293346,
              -0.755586005167086,
              -0.390469357622484,
              -0.725213767181825,
              -0.570041362527452,
              -0.727687048146688,
              -0.916422271451171,
              -1.79444106255562,
              -0.456961671046471,
              -0.438556009418831,
              -0.726131520873636,
              -0.500108334670282,
              -0.388909397703244,
              -0.481743541089276,
              -0.714783245334264,
              -1.33597544976454,
              -0.456715815245093,
              -0.526040578964969,
              -0.301527475758761,
              -0.468262523106732,
              -0.457932094748164,
              -0.271216566005699,
              -0.493347490517856,
              -0.294647566369256,
              -0.85508452738179,
              -0.406455247997809,
              -0.701104538868778,
              -0.889114371539353,
              -0.528719197702668,
              -0.62800903678934,
              -0.766867336450183,
              -0.633239468972688,
              -0.65017256372283,
              -0.270471676816462,
              -0.475748166122164,
              -0.857269863270375,
              -0.720477321005164,
              -0.501802043359186,
              -0.517187196577719,
              -0.731007524330127,
              -0.198933896957596,
              -0.972009475213715,
              -0.643107037604573,
              -0.816269194314683,
              -0.360744792781664,
              -0.820520895430981,
              -0.386340246118212,
              -0.759296008604277,
              -0.556392528947039,
              -0.681177479301509,
              -1.52781224843116,
              -1.39256919976346,
              -0.892108726987245,
              -0.91483863795023,
              -0.298834800393449,
              -0.866032415004403,
              -0.287195983714121,
              -0.907524467646734,
              -0.439958883931107,
              -0.856380299363198,
              -0.841148991197963,
              -0.540015720675316,
              -0.641608137236661,
              -0.307290742953479,
              -1.11490110910402,
              -0.539115953267214,
              -1.00271996730034,
              -0.753129607601542,
              -0.613101084427425,
              -0.25615862569146,
              -0.727540172334487,
              -0.808072846631156,
              -0.978127350261586,
              -0.663284771333886,
              -0.633682187546245,
              -0.436131355161974,
              -0.63161153067279,
              -0.751929938266413,
              -0.502531116332794,
              -0.77373620847077,
              -0.552836408326135,
              -1.58108846444162,
              -0.87504025725064,
              -0.753114919304006,
              -0.942418002605501,
              -0.462311736566194,
              -0.624470648013449,
              -0.375703681017984,
              -0.248533741386562,
              -0.552170436607208,
              -0.383497706904769,
              -0.198970184054748,
              -0.615516461255504,
              -0.357567762805408,
              -1.58481502944088,
              -0.812323818464506,
              -0.426534742319118,
              -0.617607168134069,
              -0.423285803978244,
              -0.438970649520365,
              -0.412499898414031,
              -0.482175972524379,
              -0.238504608862483,
              -0.519006170769659,
              -0.768730378031004,
              -0.613169439301888,
              -0.31010300184347,
              -0.493286595110348,
              -0.225036947156998,
              -0.323559171332652,
              -0.449540657691588,
              -0.296194848740759,
              -0.748115398547052,
              -0.714275268650675,
              -0.58038378868082,
              -0.639488518385797,
              -0.438561180339697,
              -0.47574358945739,
              -0.811663192649897,
              -0.393614565304621,
              -0.268808744194279,
              -0.383253386592506,
              -1.23174395906409,
              -0.313086408600704,
              -0.447025178694841,
              -0.394014695993865,
              -0.441401785773662,
              -0.630832742433957,
              -0.562545946748906,
              -0.945645359367734,
              -0.60865042813373,
              -0.762889835350521,
              -0.725299791522363,
              -0.649226682977578,
              -0.473359117542318,
              -0.354891997160068,
              -0.479085099477998,
              -0.611661851380771,
              -0.401346763409101,
              -1.24974278379012,
              -1.30271269962943,
              -0.556737507563174,
              -0.363239495987449,
              -0.375434878926823,
              -0.332603047923059,
              -0.282756401140265,
              -0.471283622336773,
              -0.33834524344822,
              -0.328172976324222,
              -0.724760667189006,
              -0.43770663218301,
              -0.34949300985739,
              -0.501093894284094,
              -0.774174852057989,
              -1.66272559684114,
              -1.90381809313062,
              -0.42136247595476,
              -0.531843336312336,
              -0.368060677972225,
              -0.381011543686138,
              -0.190533368113294,
              -0.70629632611489,
              -0.332345752475307,
              -0.596546389566032,
              -0.960902549068764,
              -0.798259805890683,
              -0.535175980323402,
              -1.31423416299208,
              -0.616984546882303,
              -0.783251278754222,
              -0.41500380592774,
              -0.516519025255356,
              -1.16863040162766,
              -0.51970288663137,
              -0.340223499576617,
              -1.18002136220868,
              -0.69466187852681,
              -0.574412164000699,
              -0.79946693068535,
              -0.272448955191179,
              -0.307076582236837,
              -0.286216630392541,
              -0.50637346409283,
              -0.553499886259074,
              -0.27012652432301,
              -0.735574965230591,
              -0.76507552849658,
              -0.447338676552529,
              -1.18023579403245,
              -0.347352593073545,
              -0.749137156980939,
              -0.384654530807639,
              -0.360781745436491,
              -0.618493076035408,
              -0.41374845786273,
              -0.517142976924966,
              -0.64353534119813,
              -0.535503320044771,
              -0.332471406133948,
              -0.355793008624321,
              -0.597464883563519,
              -0.36888348946098,
              -1.25511981864246,
              -0.302958992013244,
              -0.3865803752351,
              -1.17363237942494,
              -0.364974181406728,
              -0.700321713854224,
              -0.553216187081796,
              -0.339858402428472,
              -0.794043319021185,
              -0.335430313831996,
              -0.241697572730572,
              -0.84044143141157,
              -0.326867569772551,
              -0.288223517017951,
              -0.263555885978632,
              -0.411071211599963,
              -0.422007299061349,
              -0.48152446244712,
              -0.420067940890359,
              -0.801239612835622,
              -0.237259802025143,
              -0.295904042597907,
              -0.299190432481712,
              -0.824045751120698,
              -0.249322061703858,
              -0.632033013707179,
              -0.608166659941758,
              -0.699296810873989,
              -0.714130819772202,
              -0.66811475404555,
              -0.533030530589647,
              -0.416738917249717,
              -0.566954800223694,
              -0.507877873449329,
              -0.698019374616583,
              -1.60176107686598,
              -0.96741004985388,
              -0.866236724760178,
              -0.872354816257639,
              -0.512145598546715,
              -0.881199323494975,
              -0.36983444962821,
              -0.663183307617074,
              -1.0329175890038,
              -0.491131397711585,
              -0.431131225584812,
              -0.412053322312542,
              -1.06081236649771,
              -1.46678628188855,
              -1.10993765050859,
              -0.462540436004531,
              -0.319216699806934,
              -0.948566040914193,
              -0.742938934998994,
              -1.09401009293182,
              -1.51079330281789,
              -0.82045595470481,
              -0.288570266237443,
              -0.61534180804222,
              -0.270052706878964,
              -0.366691414722181,
              -0.546020020638586,
              -0.396987808609911,
              -0.491125749204489,
              -0.270571201964202,
              -0.508426235735977,
              -0.426785606393998,
              -1.19376909316429,
              -1.2732424413459,
              -0.597744585576053,
              -0.980419541898811,
              -0.315536451815955,
              -1.20118542220923,
              -0.636388127237868,
              -0.559745832393193,
              -0.572349444768417,
              -0.764409018291358,
              -1.10796277116549,
              -0.348123392993515,
              -1.21219282129119,
              -0.380962727675781,
              -0.237276883319956,
              -0.389892864124607,
              -0.679752568222129,
              -0.619828201817374,
              -1.115086999533,
              -0.796362871817572,
              -0.389927426224672,
              -0.576508503505364,
              -0.378571274549206,
              -0.58586865724938,
              -0.273848080503256,
              -1.21910158703223,
              -0.304856063723709,
              -0.672096226966551,
              -0.433165035119426,
              -0.333771828518512,
              -0.428484416900721,
              -0.317716169222333,
              -1.3505838931969,
              -0.416582429044189,
              -0.419339239232226,
              -0.480736932865737,
              -1.02395620291921,
              -0.746777959602635,
              -0.604695070571613,
              -1.01364354891416,
              -0.403922740018518,
              -0.606285889629537,
              -0.773227349152236,
              -1.70310135570299,
              -0.735082086649947,
              -0.551554604233625,
              -0.368170518443775,
              -0.409883177847016,
              -0.520624970407124,
              -0.50564726552016,
              -0.441214941319602,
              -0.770261571436675,
              -1.17352265606147,
              -0.376232509144394,
              -1.06701572888018,
              -1.10765341856204,
              -0.606790844300747,
              -0.638171615248924,
              -0.411060151486423,
              -0.301727594883404,
              -0.793068173663713,
              -0.924276790487452,
              -0.33146259851639,
              -0.607049468059366,
              -0.58031169255775,
              -0.566235410425565,
              -0.452876624203513,
              -0.669026375897938,
              -0.278782906714629,
              -0.465546273309482,
              -0.47944239996278,
              -0.490238955620607,
              -0.93886312684311,
              -0.616242677902436,
              -0.574101815946617,
              -0.306899981810859,
              -0.727613776735944,
              -0.442311316910073,
              -0.370388844444435,
              -0.500305919765768,
              -0.503743564363651,
              -0.571832225210397,
              -0.479172271103288,
              -0.536270545970929,
              -0.333121727612285,
              -0.58233904588939,
              -0.207556601896123,
              -0.519971400572326,
              -1.61070673785842,
              -0.360043172164757,
              -0.909817580494862,
              -1.28156128391508,
              -0.314384350773518,
              -0.508177687631171,
              -0.563733601148159,
              -0.540992016763995,
              -1.27446739455248,
              -0.715299732272873,
              -0.488733885009427,
              -0.280644090674581,
              -0.328272606884204,
              -0.512855744586365,
              -0.548331957281442,
              -0.735821535844144,
              -0.816880544219603,
              -0.481874221049747,
              -0.489845912060614,
              -0.895689335803406,
              -0.434288351006158,
              -0.6250777628741,
              -2.48503534845798,
              -0.821362577982035,
              -0.289973364237147,
              -1.16150752603791,
              -0.941628384302804,
              -0.540542746201195,
              -0.504118599675836,
              -1.50533908919299,
              -0.662523573666439,
              -0.291418536756313,
              -0.986559496346677,
              -0.884672614757715,
              -0.696902758152826,
              -0.89185587458002,
              -0.37230082105086,
              -0.440475420170629,
              -0.466216576206303,
              -0.410245563184564,
              -0.773070290547728,
              -1.53123117003749,
              -1.13017193603887,
              -0.549298909155528,
              -0.416927782653443,
              -1.20381852463866,
              -0.487974905368111,
              -1.04344731780583,
              -0.7183704199134,
              -0.58499704885738,
              -1.50312220822056,
              -0.426050822390691,
              -0.40668782470969,
              -0.318449693958792,
              -0.237199503566266,
              -0.331386636683185,
              -0.41892300562524,
              -0.512892061323523,
              -0.94620384045817,
              -0.468401469492981,
              -0.341114032628441,
              -0.271571144394137,
              -0.407434871002367,
              -0.736911817562267,
              -0.813561997503744,
              -0.583495531745864,
              -0.752500030101685,
              -0.771998489414772,
              -0.979643590490825,
              -1.0519908097487,
              -0.661324251209798,
              -0.48986519389367,
              -0.237067709080887,
              -0.920805072403509,
              -0.720338222486619,
              -1.57279885355717,
              -0.518920377842243,
              -0.599125912564806,
              -1.48821549186106,
              -0.868907530785553,
              -0.234018886726646,
              -0.696451042158561,
              -0.350797468929188,
              -1.06308560476601,
              -0.493331616928107,
              -0.728941806819553,
              -0.83924384910353,
              -0.341186281556549,
              -0.756550819958054,
              -1.0366995366755,
              -0.727348777333025,
              -1.06422764282161,
              -1.05096724815812,
              -1.81075258007906,
              -0.443475415199252,
              -0.384509711328007,
              -0.362092390496077,
              -0.594417832275112,
              -0.378088101737398,
              -0.26675888111768,
              -1.14290078359575,
              -0.356986440541353,
              -0.928648104646172,
              -0.832997201511012,
              -0.926118891760562,
              -0.812911566971313,
              -0.881099505244506,
              -0.81460181412445,
              -0.544698433395637,
              -0.450469802746174,
              -0.850630753571597,
              -0.333766014619675,
              -0.370571769556707,
              -0.382421899246037,
              -1.15792039965941,
              -0.917487943384188,
              -0.765170692574539,
              -0.331232764146033,
              -0.468468186091973,
              -0.886722307344638,
              -0.607574225263877,
              -0.395020937847849,
              -1.13351391578722,
              -0.314992269037971,
              -0.547366301331496,
              -1.33520374310952,
              -0.819304824090436,
              -1.68810636579566,
              -1.01141149039223,
              -1.52687905496834,
              -0.261797762339694,
              -1.03765360805224,
              -0.968226083111304,
              -1.1584233335914,
              -0.24696076106146,
              -1.51755608597021,
              -0.924995986306686,
              -0.304190413522956,
              -0.953619259593536,
              -0.700943198744929,
              -0.486442283419553,
              -0.836791439690952,
              -1.02267538768336,
              -0.498792917877551,
              -0.336068535012113,
              -0.948547187784772,
              -0.560717773328513,
              -0.377780224409545,
              -0.565489858937636,
              -1.30678039137001,
              -0.773975049830056,
              -0.829681395332479,
              -1.00397711810152,
              -0.864872280201086,
              -0.527859156683707,
              -1.14780115585847,
              -0.515222068701404,
              -0.331354232910009,
              -0.979882395278036,
              -1.02920895440105,
              -0.93060335809332,
              -0.391643360862954,
              -1.05439101684111,
              -0.851369363226836,
              -1.07828141084883,
              -1.69214137707817,
              -1.22146320229494,
              -0.9563106960038,
              -0.492181528757843,
              -0.363552494037057,
              -0.914078181299017,
              -0.652144429183893,
              -0.862908736214006,
              -0.960573551370924,
              -0.451033632115707,
              -0.268763000460417,
              -0.320032371390479,
              -0.718065028427915,
              -0.29837451382845,
              -0.558922885636446,
              -0.477748683099783,
              -0.531078297894022,
              -1.00306789631735,
              -1.57389576376891,
              -1.23380239847421,
              -0.984456282157904,
              -0.226998780277896,
              -0.419841584103097,
              -0.239207391274719,
              -0.31815848794088,
              -0.448556350381594,
              -0.358628309907029,
              -0.658902258013353,
              -0.860797598484384,
              -0.616545060839034,
              -1.42313729004615,
              -0.76055764385638,
              -0.345832813639487,
              -0.490692216983338,
              -1.0387918612906,
              -0.449827484284527,
              -0.414274709443263,
              -0.447166465483539,
              -1.06705847022246,
              -0.361692662163249,
              -0.669001168271989,
              -0.563585566239778,
              -0.60632879040704,
              -0.978882746553721,
              -0.419008312370125,
              -0.97852773104873,
              -0.674942056308314,
              -1.21132608818605,
              -0.417688298361578,
              -0.645627569898976,
              -1.07991397519161,
              -0.606179686831806,
              -0.590037641107401,
              -0.414599738043018,
              -0.404628085834326,
              -0.722722493985353,
              -0.525056749619237,
              -0.460590154784794,
              -0.348176171053289,
              -0.354441940066277,
              -0.471519022362705,
              -0.950315763708406,
              -0.177098068617953,
              -0.563457535697983,
              -1.05010829583257,
              -1.22414736793088,
              -0.411470505892276,
              -0.885138342915973,
              -1.02582343536651,
              -0.469015611221731,
              -0.495002491383421,
              -0.405319865556818,
              -0.643544406577931,
              -0.567821904297179,
              -0.526352514516701,
              -0.320795185474308,
              -0.322695150656129,
              -1.26266568035907,
              -0.327858078000751,
              -0.285180328341824,
              -0.651269418470386,
              -1.33830764561465,
              -0.443684743284146,
              -0.468750826802221,
              -0.735704973079856,
              -0.532146000468222,
              -0.47072683698886,
              -0.970050055360704,
              -0.343745670621415,
              -0.804596434617451,
              -0.378618732068318,
              -0.257693939699303,
              -1.07634778079979,
              -1.54566797101071,
              -0.968265334951684,
              -0.927283848868074,
              -2.43262403523675,
              -0.473352975112629,
              -0.985560257312855,
              -1.04247735380411,
              -1.70567713794869,
              -1.12345021018439,
              -1.11620942075055,
              -1.15701515012653,
              -1.22056599800809,
              -1.32374816310643,
              -1.65166952071933,
              -0.851527421721727,
              -0.786183966146234,
              -0.978685009800654,
              -0.560445466466403,
              -0.704755425905855,
              -0.304586567465921,
              -0.494273044334201,
              -0.544659418637015,
              -1.32191913882479,
              -0.33904024596831,
              -0.53954420989448,
              -0.537725574754411,
              -0.259087059243791,
              -0.861013960133518,
              -0.619511095491598,
              -0.566743093015234,
              -0.929273547646562,
              -0.424188256871158,
              -0.471582612344565,
              -0.527427918198613,
              -0.707055779188105,
              -0.421952065983182,
              -1.11816319354728,
              -0.730434176217467,
              -0.809582162800089,
              -0.54218524927482,
              -0.726559637780027,
              -0.370948913542822,
              -0.369806089252695,
              -0.803779378382956,
              -0.936857069007778,
              -0.969545803314903,
              -0.960065075772741,
              -0.451242617956438,
              -0.499431455028149,
              -0.311845278785415,
              -0.634514555835807,
              -1.78298463436686,
              -0.52181043431904,
              -1.29255968355598,
              -0.349822474344979,
              -0.983379221626143,
              -0.288560441677508,
              -0.259719536709501,
              -0.429898065536914,
              -0.342473443436271,
              -1.07795807047989,
              -0.455063975508612,
              -0.466433787582889,
              -0.361439289846845,
              -0.614091924987994,
              -0.412407746029275,
              -0.288934943552477,
              -1.46904098188793,
              -0.696405010423389,
              -1.00533155341583,
              -0.510666266947183,
              -0.941956719166339,
              -2.14945581148906,
              -0.650332693514345,
              -0.707997006833069,
              -0.955043090538249,
              -0.704890843754993,
              -0.713691085973621,
              -0.506853379736873,
              -0.977957697473806,
              -0.431041716327115,
              -0.667134794703405,
              -0.522997627757619,
              -1.42389546570342,
              -0.506358648448479,
              -0.535411436493704,
              -1.03133246019053,
              -0.72282465808044,
              -0.821510298557486,
              -0.570475841988583,
              -0.512953098451662,
              -0.920255390802638,
              -0.593774719903682,
              -0.368229746991992,
              -0.584618520521704,
              -0.412691799945742,
              -0.355941491520944,
              -0.888743795734768,
              -0.306939237882416,
              -0.929462415742641,
              -0.374909152547242,
              -0.363949670209972,
              -0.745264778102866,
              -0.607231114389309,
              -1.18315997485777,
              -0.494575115302104,
              -2.14341408409798,
              -0.75678127198436,
              -0.538522775456304,
              -0.852066326585682,
              -0.811660259038722,
              -1.99666521583588,
              -0.474776239706802,
              -0.39516512954458,
              -0.771483743318939,
              -0.583486286547808,
              -0.797247209476395,
              -0.47309801092584,
              -0.408415409479992,
              -0.4498971717482,
              -0.666939744994919,
              -0.623181839174377,
              -0.797558656252464,
              -1.19843892970947,
              -0.735664048714757,
              -0.724734170433895,
              -0.626597636357937,
              -0.387020838940675,
              -0.663125872542977,
              -0.606789940316,
              -0.716877499763821,
              -0.526928238670309,
              -0.45328209783922,
              -1.02320264619304,
              -0.506987449835374,
              -1.33479200713132,
              -0.731568633930849,
              -2.37057356402425,
              -0.377648776832157,
              -0.513282531019653,
              -1.07224536111303,
              -0.670766836076017,
              -2.24052883117876,
              -1.39471223636078,
              -0.371709732982142,
              -0.314755126231218,
              -0.398537148499078,
              -1.49979815131398,
              -0.592014501975533,
              -0.742060513583629,
              -1.16761129846431,
              -0.413013041512531,
              -0.925736303277496,
              -0.470772841157229,
              -1.32838478071192,
              -0.427987036725374,
              -0.360843549769541,
              -0.56889120880446,
              -0.422873598039063,
              -0.673929861397269,
              -0.773727695192698,
              -0.390096574239058,
              -0.833812245535739,
              -0.356397341039941,
              -1.07198940824318,
              -0.455538170982453,
              -0.693235376601144,
              -0.394696338085744,
              -0.661359774219075,
              -0.250395434811577,
              -0.358506217099319,
              -1.0336394534842,
              -0.605365966985099,
              -0.602789011128474,
              -0.930198487347956,
              -0.600466095896907,
              -0.883108979814391,
              -0.775300176116605,
              -0.494253856611687,
              -0.422004899747777,
              -0.85025429170724,
              -1.26369220544083,
              -0.346390355919185,
              -0.646209462922357,
              -0.637011708409073,
              -0.467776665765395,
              -0.487988550755056,
              -0.681814620303444,
              -0.361814786421795,
              -0.366179091973633,
              -1.63179899847845,
              -1.44548236126692,
              -0.446036103082573,
              -0.635358529101708,
              -1.43182474674154,
              -0.723416155497359,
              -0.566643908156256,
              -0.73485406867892,
              -0.469255009672639,
              -0.315251956078591,
              -0.528789802823858,
              -0.269151229429632,
              -1.29777800210218,
              -1.65455300476904,
              -3.12377450260064,
              -0.877328660840249,
              -1.00805227414832,
              -0.291366095624469,
              -1.12722938573309,
              -0.468362565632457,
              -0.294279055676832,
              -0.330148173556858,
              -0.440178553846317,
              -0.761714106055718,
              -1.14874340193377,
              -0.675091092056684,
              -0.331135569259562,
              -0.591249070635935,
              -1.02189286111282,
              -0.515129471719574,
              -0.292337480382217,
              -0.70998464378764,
              -0.288413398912485,
              -0.337766437079387,
              -0.627812141132439,
              -0.736901758353578,
              -0.780096641351011,
              -0.452355145975216,
              -0.326035473070215,
              -0.678342564631946,
              -0.876332506410573,
              -0.874352370831303,
              -0.384821262692099,
              -0.323485231956973,
              -0.567729052153395,
              -0.438522512807403,
              -0.679045422013859,
              -0.560189675787685,
              -0.313463385969685,
              -0.640475237227048,
              -0.737508661777103,
              -0.787028121151296,
              -0.577972716407525,
              -0.730742412033976,
              -0.432540487955282,
              -0.718885659321244,
              -0.332135114044465,
              -0.571058025140006,
              -0.381189003482214,
              -0.295821495515915,
              -1.26610078980517,
              -0.459958342390103,
              -0.389173704008478,
              -0.497689899744891,
              -0.536594821910006,
              -0.379398917791318,
              -0.475838168955171,
              -0.745879374832765,
              -0.302251513433748,
              -0.380971640997901,
              -0.746938637044935,
              -1.24295595362964,
              -0.319467850823764,
              -0.318940077635702,
              -0.472306714274977,
              -0.408647618754428,
              -0.568131908336486,
              -0.973819770394568,
              -0.659973724424992,
              -0.521549020890104,
              -1.08010739529821,
              -0.636540594444863,
              -0.424261657343613,
              -0.417203312775121,
              -0.329419111710853,
              -0.279921579122799,
              -0.695128719373458,
              -0.884870743986908,
              -0.430891309666147,
              -0.430749091665451,
              -0.329597942369983,
              -0.483871805715591,
              -0.753913698853737,
              -0.381982253168814,
              -0.761032240614375,
              -0.688660649463965,
              -0.431580687910211,
              -0.48222702577412,
              -0.372976470175685,
              -0.372814928558649,
              -0.371169742116483,
              -0.588212343884202,
              -0.787147090791054,
              -0.256513228300473,
              -0.744825104654432,
              -0.605048412074646,
              -0.598818754766468,
              -0.857744935814548,
              -0.283109013639908,
              -0.275828831841373,
              -0.618256761362614,
              -0.423566526044433,
              -1.18508383869463,
              -0.398197814939933,
              -0.439035510519686,
              -1.29588170022034,
              -0.401115065915526,
              -0.625931255432022,
              -0.541138630147407,
              -1.37867659642622,
              -0.294368935644605,
              -0.511708245332437,
              -0.723801746106816,
              -0.604264410833006,
              -0.665645079724061,
              -0.372822098220298,
              -0.51283492200269,
              -0.511313774019474,
              -0.790031397864564,
              -0.666345002234527,
              -0.77227528238174,
              -0.354213643373842,
              -0.405188178953383,
              -1.174564969334,
              -0.534936134695575,
              -0.357507829996419,
              -0.300152434514329,
              -0.246801368278399,
              -0.456358157325482,
              -0.43135694581248,
              -0.768993988810423,
              -0.446828628522613,
              -0.732777361480713,
              -0.333692315136089,
              -0.429299062826725,
              -0.226949759696752,
              -0.676426203203753,
              -1.40904540050032,
              -2.58472913004044,
              -0.66213730294826,
              -0.81924908488075,
              -0.445224025831746,
              -0.548088061636156,
              -0.32040307351912,
              -0.637285420937269,
              -0.562801916245745,
              -0.863394887637388,
              -0.788914301817486,
              -0.379478597980063,
              -0.704456941404568,
              -0.423037058489099,
              -0.292561723238046,
              -0.249351715043357,
              -0.580201437012871,
              -0.208578637985422,
              -0.54430247825141,
              -0.897529122175819,
              -0.292687914393826,
              -0.228144733399673,
              -0.254534468225779,
              -0.67177613951185,
              -1.09344707436083,
              -0.767290952621333,
              -1.7212265627341,
              -0.924252932065056,
              -0.283578478951791,
              -0.367556123440047,
              -0.451709169016264,
              -0.828545414778504,
              -1.06936715663936,
              -0.533861238044861,
              -1.03545243777118,
              -0.376464568265724,
              -1.05563793326195,
              -0.505635976466279,
              -0.60719782339317,
              -0.299936496709849,
              -0.652918246483241,
              -1.27081409138112,
              -0.650401436324905,
              -0.615431821832583,
              -0.477052152594272,
              -0.537296877418146,
              -0.945454271253793,
              -1.57525911059594,
              -2.26101745719239,
              -0.490935351913131,
              -0.876194619931719,
              -0.278133168355006,
              -1.43271629341205,
              -0.828336605032474,
              -0.532077223291568,
              -0.392108137261832,
              -0.47388553742815,
              -0.381900990800055,
              -0.476356117488927,
              -0.398975844314481,
              -1.13116330608752,
              -1.21157075394637,
              -0.778283121939201,
              -1.03661621816879,
              -0.731546797680857,
              -0.598686857142802,
              -0.451798485540919,
              -0.935695396778415,
              -0.700315211294498,
              -0.475771820851973,
              -0.899484166720181,
              -0.898687834472896,
              -0.776540616317555,
              -1.51287476320732,
              -0.520208708939751,
              -0.819434480693937,
              -0.784806477844776,
              -0.772679971944747,
              -0.756212457167915,
              -0.565207040072552,
              -0.550009232966768,
              -0.96881342103289,
              -0.703078513807101,
              -0.799095633289943,
              -0.970339815822125,
              -1.02685035368689,
              -1.03352729077946,
              -0.613934235163205,
              -0.806375814645218,
              -0.44540583601384,
              -0.518811900177167,
              -0.473575575216151,
              -1.13192135642665,
              -1.79093919059167,
              -0.417257826887358,
              -0.300522986334824,
              -0.603980985299283,
              -0.339417298999016,
              -0.977160022350693,
              -0.212157120844724,
              -0.424236158153104,
              -0.339695652440712,
              -0.470962463408388,
              -0.457231354585862,
              -0.421967450674729,
              -0.789126904725206,
              -0.649414988436098,
              -0.241647903980391,
              -0.674286478148572,
              -0.608692265963188,
              -0.641774065950439,
              -0.3701576854038,
              -1.3302534986712,
              -0.406655190062326,
              -0.493548454124381,
              -0.627015534947671,
              -1.21736409132426,
              -1.06385848298012,
              -0.527891624941159,
              -0.458578437639059,
              -0.493770048184858,
              -0.358020172631492,
              -0.768941926028728,
              -0.392571399406657,
              -0.370805160435555,
              -0.662837246602607,
              -1.16747015474733,
              -0.35776803733525,
              -0.344748795466279,
              -0.538440651655352,
              -0.401034827931894,
              -0.42936027626948,
              -0.560995037437032,
              -0.729203671410266,
              -0.978441365304729,
              -0.94436984739411,
              -0.733658802982706,
              -0.38354376613725,
              -0.741535164905757,
              -0.354450589077293,
              -0.333156359053767,
              -0.610282535097035,
              -0.282833841860373,
              -0.39415183772491,
              -0.748151830986363,
              -0.889326751340428,
              -0.24416403420983,
              -1.06194148040252,
              -0.790951568633272,
              -1.16092242144193,
              -1.39449063546762,
              -0.454834776675187,
              -0.33274757555769,
              -0.693325593838681,
              -0.733621189596382,
              -0.327750030977344,
              -0.80811290512706,
              -0.475894519569899,
              -0.54532896880355,
              -0.58968121963246,
              -0.483397239347087,
              -0.473690729125336,
              -1.02173208908162,
              -0.817916854317688,
              -0.635943811643205,
              -0.4879993942693,
              -0.514419017166184,
              -0.81022841402648,
              -0.977464225794257,
              -0.379557287198442,
              -0.369876498632405,
              -0.480242797349455,
              -1.30933730304858,
              -1.24278101631841,
              -0.529756788917035,
              -0.296300600274393,
              -0.359648361791388,
              -0.532064398114754,
              -0.833291265314487,
              -0.728506970216136,
              -0.65394181752459,
              -0.663716316713797,
              -0.412331395570342,
              -0.42881008338705,
              -1.23788443404307,
              -0.573877254973724,
              -0.378767462709625,
              -1.04647231929485,
              -0.650157216412106,
              -0.889628883310313,
              -0.511631367519186,
              -1.37827505653511,
              -0.940486082164448,
              -0.327770102509877,
              -0.414100502380041,
              -1.06099700611697,
              -0.499454000007355,
              -0.483770546499279,
              -0.68350766735843,
              -0.88381925444572,
              -0.413327979126204,
              -1.00437509247824,
              -0.56014576387814,
              -0.501025739981901,
              -1.1139359059703,
              -0.696626965503461,
              -0.762301282558716,
              -0.46302703384589,
              -3.04888559945056,
              -1.65743503479135,
              -1.56534369988726,
              -0.889044869188971,
              -1.36855666719391,
              -1.52296742609826,
              -2.05897198295035,
              -2.05032311054865,
              -1.1410378460419,
              -2.37767239428953,
              -0.895485768501444,
              -0.808073811105817,
              -0.896597411194135,
              -1.23150239634683,
              -1.23500402660908,
              -0.787859764103942,
              -0.292683511870076,
              -0.42947085842458,
              -0.860271545060908,
              -0.489505639961511,
              -0.31326826375034,
              -0.265378286323837,
              -1.3386049468828,
              -0.617864794766565,
              -0.389209169841299,
              -0.807194082101783,
              -0.50392283464572,
              -0.791505253838487,
              -0.601205339794187,
              -1.10725930133953,
              -0.526993180033925,
              -0.303495019574223,
              -1.26090216208367,
              -0.365551424879157,
              -0.615275812756708,
              -0.699721853857835,
              -0.532854457815041,
              -0.704324323900491,
              -0.92791901360428,
              -0.673279749251347,
              -0.296837895735602,
              -0.639779263225567,
              -0.313548076110367,
              -0.614373959127482,
              -1.0292200897181,
              -0.570133320062718,
              -0.407214637872559,
              -0.488174992778676,
              -0.582253426947613,
              -0.428412077366573,
              -0.420239908685282,
              -0.300343184828035,
              -1.49240146895265,
              -0.694532315975186,
              -0.550159761124631,
              -0.385676921577144,
              -0.784568652104062,
              -0.603448518835859,
              -0.345416993199592,
              -0.617109282223843,
              -0.506697823329956,
              -0.815041947791154,
              -0.768093372693889,
              -0.976486643885626,
              -0.936272057611044,
              -1.12156396124461,
              -1.01087437863506,
              -1.01939113655804,
              -0.494130974730649,
              -1.01856401569356,
              -0.646212793386599,
              -0.642401181790581,
              -0.284499302679442,
              -0.638830255178359,
              -0.533376802009007,
              -0.576243246126462,
              -0.624008209423862,
              -0.5073581346534,
              -0.341581291925941,
              -0.681773104225132,
              -0.327698253158222,
              -0.596174955832181,
              -0.483722636653252,
              -1.0875146415547,
              -0.537097299719785,
              -0.399216980724665,
              -0.866045103456236,
              -0.60502522355657,
              -0.89931644516814,
              -0.919677217482818,
              -0.401972494276164,
              -0.620679713948723,
              -0.232665182823572,
              -0.426517442216511,
              -0.375716195954593,
              -0.421605032852452,
              -0.322250690713511,
              -0.619126700134365,
              -0.423581410309115,
              -0.87158815741102,
              -0.577991486730063,
              -0.578357967825436,
              -0.71524541387147,
              -0.574701294923785,
              -0.325929806241902,
              -0.505049666409078,
              -0.325114575881234,
              -0.619280649329519,
              -0.234254224699472,
              -0.457800789882945,
              -0.654929808283445,
              -1.50733876639519,
              -1.30575529156503,
              -0.39828267424763,
              -0.445936916774842,
              -0.634053786958818,
              -1.62538304480176,
              -0.461087327703525,
              -0.682364172780667,
              -0.514624031397224,
              -0.642150772757594,
              -0.542108428027267,
              -1.40841069899215,
              -2.69304170141057,
              -0.368519404644142,
              -0.235459011117567,
              -0.421747468845364,
              -0.518131742688035,
              -0.774247944270461,
              -0.487933583395755,
              -0.399955422062825,
              -0.860001362959158,
              -0.619516674597441,
              -0.618901994130461,
              -0.287905749435249,
              -0.6323252324635,
              -0.558058841904941,
              -0.319095621282644,
              -0.365544434082615,
              -0.471978782271467,
              -0.483429078845529,
              -0.799528635308242,
              -0.228883980736725,
              -0.258956867013372,
              -0.43777336524291,
              -0.613464468118544,
              -0.815032536144924,
              -0.238424494120255,
              -0.593611101609547,
              -0.361538139473265,
              -0.500915120691498,
              -0.928255210075305,
              -0.478288800983606,
              -0.360770842486795,
              -0.758659997350154,
              -0.577748542328709,
              -1.19627969817976,
              -0.771733287030648,
              -0.334114862059951,
              -1.11692395568737,
              -1.2806936651406,
              -0.72418607475309,
              -1.24831796837407,
              -0.553640260143647,
              -0.87518753479362,
              -0.75097818381058,
              -0.37197547420855,
              -0.490587329128853,
              -0.477620642455813,
              -1.16598157376071,
              -0.89860732705787,
              -1.1127375545294,
              -1.0501977930887,
              -0.681376755750368,
              -0.394355935268653,
              -1.0038001443508,
              -0.416048519876063,
              -0.297642028233369,
              -0.638128088353426,
              -0.438237438726328,
              -0.265100699681322,
              -0.757972592356221,
              -0.824263122848233,
              -1.51875905395186,
              -0.757152105656954,
              -0.406334332137757,
              -0.542662771182818,
              -1.191772917128,
              -0.486463514125254,
              -0.367128786978929,
              -0.480881510893311,
              -0.596085449010819,
              -0.477901406877161,
              -0.679715672485888,
              -0.518742879298121,
              -1.04138435349928,
              -0.990295972914176,
              -0.780157867436245,
              -1.1448835633937,
              -2.43923851525813,
              -0.330863751842349,
              -0.71243262222512,
              -0.866316602576885,
              -0.557395411408585,
              -0.902524347930237,
              -0.30482722131337,
              -1.05722191772396,
              -0.58925582766874,
              -0.43414013703582,
              -1.79046715856775,
              -0.586484406066026,
              -0.516115680061741,
              -0.546103977344972,
              -0.346298916352276,
              -0.588406066214565,
              -0.474066554888849,
              -0.784116335320706,
              -0.514581533947196,
              -1.05509364589991,
              -0.414561987932249,
              -0.637216545254716,
              -1.5945596940398,
              -0.813221834105165,
              -0.509829053926673,
              -1.0898583907026,
              -0.343986874530273,
              -0.974719261753304,
              -0.545878470428138,
              -0.685677071777413,
              -0.276723530848008,
              -0.297995091819823,
              -0.883343386198105,
              -0.34940801477395,
              -1.21028372384954,
              -0.987292076586156,
              -0.905466447620992,
              -1.80746623426957,
              -0.659823439611914,
              -0.531520904792047,
              -0.317192291280959,
              -1.38140929539176,
              -0.429285241613264,
              -1.6880183199289,
              -1.11561218549119,
              -0.391372635012703,
              -0.437586606316836,
              -0.221075871916362,
              -0.283322219561625,
              -0.616508033982029,
              -0.267475419992885,
              -1.15047273152558,
              -0.858503548429698,
              -0.83453869359867,
              -0.458835315425696,
              -0.90367731958,
              -0.888757243477866,
              -0.623323322041628,
              -1.59093498823137,
              -0.504228051546856,
              -0.67360806318693,
              -0.600503239140566,
              -0.7430534066922,
              -0.982854241070508,
              -0.341714301980391,
              -0.795739709491197,
              -0.709354089429761,
              -0.357569015985808,
              -1.49040676743827,
              -0.585801894499606,
              -0.544660682790679,
              -0.79070592983199,
              -1.03360881231629,
              -0.412051069596609,
              -0.826671025075138,
              -0.745077350009754,
              -0.7339109272921,
              -0.632291788007521,
              -0.697980469581507,
              -0.262214674287536,
              -0.582025431794919,
              -0.279171484429451,
              -0.521909477135983,
              -1.00673022400663,
              -0.811506794342484,
              -0.429030300948388,
              -0.508098585503207,
              -0.680911581991981,
              -0.64427772837276,
              -0.801732127507217,
              -0.395289260298715,
              -0.697251640859438,
              -0.516335023173857,
              -0.746343734851077,
              -0.377503880895006,
              -0.794646861938033,
              -0.531933782270637,
              -0.789219190236004,
              -0.422274817637601,
              -0.337989491063573,
              -0.778788772289044,
              -0.395427134854811,
              -1.42115081143342,
              -0.628730828682143,
              -0.770123417491491,
              -0.630403275079391,
              -1.30154636760774,
              -0.295003191035507,
              -0.840625133742941,
              -0.224050177815611,
              -0.731497619394676,
              -0.257313351134136,
              -1.3519991243927,
              -0.444668536509105,
              -1.36836722079761,
              -0.776378720675713,
              -0.42886559674764,
              -0.82975433607208,
              -1.77696840873575,
              -0.441753201574594,
              -0.917782584703484,
              -0.61370026311566,
              -0.4398546374764,
              -0.427543906611063,
              -1.79034801310323,
              -1.21785974776865,
              -0.628503702706742,
              -0.401862753732917,
              -0.284116420315389,
              -0.84555261594071,
              -0.502193325307394,
              -0.51317877612998,
              -0.365994774465677,
              -0.458373660091749,
              -0.475627750404428,
              -0.524115332368531,
              -0.754028002589532,
              -0.645972324550477,
              -0.296154810667303,
              -0.800276518993511,
              -0.622218518284809,
              -0.685884664357458,
              -0.709922063226919,
              -0.612401357309652,
              -0.750977795207079,
              -0.707782295856112,
              -1.14021923980645,
              -1.04739856467108,
              -0.425577140139659,
              -0.448935774668395,
              -0.804518450859048,
              -0.587629982559004,
              -0.485307988837357,
              -1.34248026945944,
              -1.17365758123685,
              -0.420489959504958,
              -0.698962440192985,
              -0.991723033780369,
              -0.383505635159946,
              -1.48548375305504,
              -0.915255877636852,
              -1.16189614334589,
              -1.40860327514196,
              -1.63189047832525,
              -1.10931153653419,
              -0.778705720634703,
              -1.44786625647883,
              -0.693060242072096,
              -0.338718615300817
          ],
          "z": [
              0.136668642204099,
              1.2670104648424,
              0.208524282359024,
              0.951383679675113,
              0.332268986622726,
              0.401690430405858,
              0.259456947239313,
              0.303356003916916,
              0.160335501121869,
              1.13155606103283,
              0.410762604957372,
              0.945779936217708,
              1.01434636289586,
              1.67607710274374,
              1.37831906999825,
              0.681167638397899,
              1.13882335242919,
              0.804078729836674,
              1.16631898275564,
              1.27618971939369,
              0.908956868040977,
              0.61141732969369,
              1.16517426615677,
              0.747453835646338,
              0.875990807102842,
              1.20324260649878,
              1.33354846583633,
              1.06857957719754,
              0.395416300834137,
              0.260197413718951,
              0.772349589989793,
              0.83224174918218,
              0.823710461351979,
              0.879140537230912,
              1.00383094826441,
              1.02921198626369,
              0.99946197915721,
              0.620811902774506,
              0.681366500574098,
              0.410156727781391,
              1.73366639783791,
              0.563716746494074,
              0.749166894299125,
              0.673165821722461,
              0.839434990493239,
              0.584173845605676,
              1.0064532704689,
              1.12137833351635,
              1.58138210385815,
              1.67277609422147,
              0.593989294265699,
              0.533494368707483,
              0.330885207053695,
              0.576385746883627,
              1.35171626809033,
              0.955253065574462,
              0.965798710634,
              0.736396915774283,
              0.610152945315484,
              0.380876653126807,
              1.06979850733246,
              0.89129614084126,
              0.360400018580515,
              0.490567367628083,
              0.625513942741563,
              0.486849306477337,
              0.946930212089856,
              0.748934044117298,
              0.620143761732124,
              1.05214354524262,
              0.605793310989072,
              0.695819493198425,
              0.585796697826077,
              0.863131758825806,
              1.04063263864608,
              0.817101552833673,
              0.415318019851839,
              1.7390536808716,
              1.28091093055323,
              0.459525298773714,
              0.256903819044664,
              0.774161360203174,
              0.659083289674133,
              0.447473789812639,
              0.742461625320241,
              0.821789516240161,
              0.294579158476788,
              0.744406822250017,
              0.901258984128654,
              0.194288015736222,
              0.442870430079462,
              0.694901358729501,
              0.662824169150607,
              0.722343537171235,
              0.534476870315525,
              0.983322646693897,
              0.849726111203462,
              0.524082208473515,
              0.577085081894599,
              0.394315066589257,
              2.2219207233759,
              2.02839656520488,
              0.437342859692708,
              0.53262865636592,
              0.592695861134139,
              1.47787307511686,
              0.73032494744464,
              0.829511508097015,
              1.07007069120621,
              0.721963043646291,
              1.38895300600067,
              0.834842415783329,
              0.673448049782569,
              1.40870854160462,
              0.285693507049296,
              0.634616282084437,
              0.611702039422559,
              1.30907778617918,
              0.672420103348073,
              0.481365395702691,
              0.695835314384174,
              0.726237629997241,
              0.676829405718401,
              0.371139634470912,
              0.433960145040153,
              0.811497725140156,
              0.674450239282836,
              0.648667207988503,
              0.516322933895531,
              0.690691508464108,
              0.597612659003123,
              1.11712423939752,
              0.439105343686366,
              1.0488073439729,
              0.463884152515259,
              1.24881092291354,
              0.690027563379826,
              0.679035242728447,
              0.464589760033815,
              0.991292382866719,
              1.11298077337361,
              0.779917537280754,
              0.621417594168319,
              1.57033151954872,
              0.407422757845335,
              0.220350168142039,
              0.784088236792464,
              0.666295224681375,
              0.196140909219648,
              0.556603673440588,
              1.99750313224318,
              0.797450230459361,
              0.84772111997805,
              0.901796367852751,
              0.516502781476285,
              0.55726587390955,
              0.218443534586215,
              0.535692561142766,
              0.491395329862676,
              0.803025545247655,
              0.561551169664232,
              0.41799788722276,
              1.42413854484169,
              1.18271975442084,
              1.39641036495242,
              0.704148678132497,
              0.335954734190425,
              0.727424032270999,
              0.784789659916761,
              0.456728332537095,
              0.673536287932608,
              0.838105104873066,
              0.544464282758296,
              0.422914220972674,
              0.703665517541776,
              0.656031882262394,
              0.809839753909436,
              0.771415553662638,
              0.862505616829303,
              0.648164485088842,
              1.17859425410514,
              0.654304646981138,
              0.437954929090707,
              1.22165268247882,
              0.876762131213913,
              0.775372334261225,
              0.737856398202517,
              0.704449996355798,
              1.21290879836063,
              0.447022135390027,
              0.263900132517212,
              0.306723775355011,
              0.640654192219639,
              0.627029203414035,
              0.809235321957811,
              0.710530150923698,
              0.896496431500085,
              1.05531512721917,
              0.332741764470737,
              0.48306690721438,
              0.370605725515867,
              1.5750626418853,
              0.827562965608481,
              0.185199362624366,
              1.24382969015998,
              0.700779234020735,
              0.632880001594092,
              0.256792210320442,
              1.47269965627622,
              0.135529789566079,
              0.34567600255741,
              0.772132155175746,
              0.3277967597111,
              0.18807233999346,
              0.26156068297729,
              0.0265767943822391,
              1.73933723465583,
              0.250951820842128,
              0.572437750784804,
              0.211793260640271,
              0.71260326009211,
              0.636116353037444,
              1.01327120993433,
              0.0681803812319548,
              0.158354893272002,
              0.18304708765155,
              0.428260559374921,
              1.03949681316477,
              0.683065312439606,
              1.13589240421957,
              0.350545682930575,
              0.823058259854592,
              0.454559589854756,
              0.166838834776946,
              0.22886079395972,
              0.618475701925538,
              0.282404192461395,
              0.603562386867875,
              1.28861215677892,
              0.490919249930329,
              0.090255289011385,
              0.435528632759077,
              0.240438401815115,
              0.371692468998144,
              0.183876913216376,
              0.741969917644675,
              1.16027038187647,
              0.575957076996096,
              0.439034950880405,
              0.433130917709404,
              0.296713140236783,
              0.511085679415364,
              0.383194102464708,
              1.38974419964894,
              0.795603774278793,
              0.894465485761559,
              1.30235637770191,
              0.677113779669181,
              0.581811469881756,
              0.625570419256679,
              0.71872513930024,
              1.13719983770973,
              0.616155111554106,
              0.484333814692353,
              0.676164354157458,
              2.22996444671065,
              0.762393264205173,
              1.07403262529653,
              1.1163470305198,
              0.756387308378357,
              1.06955949581472,
              1.83912575266047,
              1.00951669639094,
              0.553342641455346,
              0.967258938301999,
              1.40613141807976,
              0.436186639026731,
              0.748349382694202,
              0.981031545427232,
              0.958863593234079,
              1.31573326665186,
              0.767404014767351,
              0.666774064350133,
              1.64953614737827,
              0.922420364746451,
              0.611338992090029,
              0.79003554594207,
              0.521373154697622,
              0.547544508706893,
              0.792380895848353,
              0.685681468501971,
              1.15738914067266,
              0.85351502046319,
              0.610861648353537,
              0.630511513655676,
              0.817293696749167,
              1.06130042333552,
              1.17353661638284,
              1.86278459505311,
              0.662394220220493,
              0.208835004995316,
              0.350060468847276,
              0.508803463772166,
              0.510039492121077,
              0.640492276374538,
              0.938975521719001,
              0.489475534230051,
              0.738871994529393,
              0.665966683549333,
              1.30035478037572,
              0.380706812328209,
              0.468718839064429,
              0.499530798154526,
              0.497274985453624,
              0.658888527293405,
              0.823153119381382,
              0.636806262986777,
              0.804673661440479,
              1.54505077429832,
              0.244211136713447,
              0.660308112305841,
              0.269765253748927,
              0.473286783344233,
              0.304682446772336,
              0.574640407714824,
              0.891997987061639,
              0.810594945662548,
              0.328310342688585,
              0.794393002831957,
              0.252708570922103,
              0.22531951126079,
              0.165423586402524,
              0.222980118666914,
              0.559823539541677,
              0.628592095371578,
              0.545305638809506,
              0.511371895199895,
              0.733708801619783,
              0.0944154530017047,
              0.331213778816796,
              0.324770371885804,
              0.30014933683974,
              0.311232332885892,
              0.546345813577132,
              0.473894497978703,
              0.239122567544806,
              1.19098927067604,
              0.410243213873151,
              0.956357500393594,
              0.583851709921188,
              0.413746866049602,
              0.610083556999759,
              1.54556579638976,
              0.437351169683915,
              0.910132850398296,
              0.479039313741375,
              0.70290894643927,
              0.882348152290885,
              0.582822596144425,
              0.710064157053085,
              0.488664433535882,
              0.192100902644382,
              0.73022623361297,
              0.301945804319992,
              1.00599359309625,
              0.219155578566873,
              0.100418013519079,
              0.256979330210323,
              0.141205485349472,
              0.299041326698486,
              0.23134356142277,
              0.666459743474667,
              0.341971778878754,
              0.210631817781616,
              0.285466191102675,
              0.783809508065563,
              0.619172643823236,
              0.242053644522803,
              0.587772416883673,
              0.425165618718512,
              0.312254971660391,
              0.575083855691719,
              0.398782739252658,
              0.0591224300402091,
              0.495655343285936,
              0.39250377453663,
              0.927073449635884,
              0.209463181413833,
              0.836355191610029,
              0.696356120244034,
              0.260664697414557,
              0.524960493425765,
              0.154187676912814,
              0.287515943943668,
              0.862737772912022,
              0.909657436420481,
              0.368050566161932,
              0.31145987309701,
              0.213413678459441,
              0.389706472112308,
              0.143920541472183,
              0.467701517487823,
              0.160803176339881,
              0.46876810870671,
              0.711350646478371,
              0.324388607942526,
              0.189438645864314,
              0.24596197600821,
              0.0931564172421263,
              1.01472156269716,
              0.27082711628927,
              0.347532408950149,
              0.0844920354227455,
              0.183891877528712,
              0.118209305980157,
              0.483339054451545,
              0.22818563434667,
              0.271240766020592,
              0.472021320626123,
              0.282913848644631,
              0.260946218144054,
              0.153613662592511,
              0.217615116535777,
              0.275086869729582,
              0.438449479531909,
              0.321338245269275,
              0.450726328872275,
              0.192081800026195,
              0.414491620872189,
              0.47885113082601,
              0.407956623783343,
              0.183455096810774,
              0.412959181198616,
              0.470336039727179,
              0.385952636356409,
              0.118764814853773,
              0.416058797736284,
              0.212224791783366,
              0.345715093373114,
              0.25951264603536,
              0.511774414985539,
              0.174520321283877,
              0.713543344497902,
              0.649141768441172,
              0.5908566917304,
              0.127540725476632,
              0.864253436581945,
              0.156753661834862,
              0.446171296334894,
              0.545775297227412,
              0.590308380364265,
              0.99431184272855,
              0.11042990609459,
              0.479473402382782,
              0.320141642090257,
              0.309576590446531,
              0.354241609757575,
              0.351019221168573,
              0.279950933717273,
              0.431411200398578,
              0.539611627556617,
              0.427375702933248,
              0.666512184392948,
              0.156425782138235,
              0.473174741788416,
              0.551554891412367,
              0.448355318604112,
              0.276831550091809,
              0.527061797570527,
              0.158395387906744,
              0.69491297437197,
              1.40071532005321,
              0.315523736690691,
              0.518246467717747,
              0.360857893002766,
              0.274908278980215,
              1.06399510246879,
              0.461553917990239,
              0.187003310975195,
              0.43871541848238,
              0.322033042654425,
              0.440575209852585,
              0.582495252315277,
              1.24272423307928,
              0.237002414371762,
              0.223162219446756,
              0.439405526246217,
              0.269446683260224,
              0.18583029422664,
              0.255637219190923,
              0.430872154900754,
              0.897979579189072,
              0.23681754233166,
              0.288946515602159,
              0.120123184256891,
              0.245500125483531,
              0.237732127514543,
              0.0973308007053724,
              0.26436284531839,
              0.114949814837009,
              0.536372143493938,
              0.19902395132599,
              0.420586408719266,
              0.561960991422174,
              0.290960711353962,
              0.365622016925743,
              0.470036950392463,
              0.369555056792718,
              0.382287950440705,
              0.096770678945821,
              0.251128978201165,
              0.538015413661918,
              0.435153832940768,
              0.270720272815158,
              0.282289186978821,
              0.443072052321623,
              0.0429776212563308,
              0.624294224336707,
              0.376975005940108,
              0.507184832187451,
              0.164651831317429,
              0.510381912162238,
              0.183898412643239,
              0.464343666698107,
              0.311769759482457,
              0.405602193847085,
              1.04223186096242,
              0.940535426806411,
              0.564212606382396,
              0.581304434142792,
              0.118098418579915,
              0.544604441890997,
              0.10934657391401,
              0.575804520868115,
              0.224217115331403,
              0.537346503294953,
              0.525893273401107,
              0.299455167194738,
              0.37584790311247,
              0.124456891080014,
              0.731742036113521,
              0.298778584273285,
              0.647387075075819,
              0.459706822145046,
              0.354411935441263,
              0.0860079353102371,
              0.440464766125445,
              0.501021562868038,
              0.628894579645979,
              0.392147716033789,
              0.369887960411121,
              0.22133899308198,
              0.368330923487853,
              0.458804727029986,
              0.271268501521815,
              0.475202020228207,
              0.309095723440404,
              1.08229307850345,
              0.551377917089216,
              0.459695777233696,
              0.60204282380022,
              0.241025412900829,
              0.362961314400101,
              0.175900214192248,
              0.0802743796687523,
              0.308594943919898,
              0.181760956376145,
              0.0430049074527201,
              0.356228185614403,
              0.162262853673292,
              1.0850952807298,
              0.504218094456227,
              0.214122789989042,
              0.35780029920183,
              0.211679740624845,
              0.223474009370153,
              0.203569245144083,
              0.255962387363336,
              0.0727329420464543,
              0.283656970321214,
              0.471437870345986,
              0.354463335103269,
              0.126571577963022,
              0.264317054825932,
              0.0626058916334423,
              0.136689986767981,
              0.23142216012986,
              0.116113298663826,
              0.455936371937233,
              0.430490180242062,
              0.329810062402802,
              0.374254049076894,
              0.223166107736901,
              0.25112553676375,
              0.503721334805221,
              0.189368359745571,
              0.0955202315506786,
              0.181577238951894,
              0.819602383204342,
              0.128814960021002,
              0.229530637817374,
              0.18966923927094,
              0.225302109892458,
              0.367745311231755,
              0.31639684127695,
              0.604469644828744,
              0.351065250497515,
              0.467046055979242,
              0.438780104754757,
              0.381576692450911,
              0.249332525636769,
              0.160250803313226,
              0.253638195692545,
              0.35332969964278,
              0.195182610334861,
              0.833136655846584,
              0.872967550014291,
              0.312029167233662,
              0.166527731208811,
              0.175698087617654,
              0.143490558104192,
              0.106008215888588,
              0.247771850514527,
              0.147808420019375,
              0.140159351886233,
              0.438374708523238,
              0.22252352757322,
              0.156191017896196,
              0.270187777899544,
              0.475531859647867,
              1.1436803759767,
              1.32497063389342,
              0.210233488091888,
              0.293309917169286,
              0.170153034106807,
              0.179891478154859,
              0.0366608172733822,
              0.424490389404614,
              0.14329708398616,
              0.341963580775131,
              0.615942336424516,
              0.493642616139428,
              0.29581590927443,
              0.881631150486061,
              0.35733211720092,
              0.482356907138132,
              0.205452066243646,
              0.281786753459619,
              0.772143945958107,
              0.284180867996206,
              0.149220780599614,
              0.780709414454365,
              0.415741830090561,
              0.325319680515755,
              0.494550317410645,
              0.0982574996144129,
              0.124295852258179,
              0.108610146115579,
              0.274157766957875,
              0.309594627750724,
              0.0965111404470233,
              0.446506553816312,
              0.468689594788098,
              0.229766373513637,
              0.780870657136055,
              0.154581524789755,
              0.456704686392717,
              0.182630833734184,
              0.164679617981997,
              0.358466460423751,
              0.204508103333213,
              0.282255935872395,
              0.377297070169139,
              0.296062053403454,
              0.143391569648442,
              0.1609283217066,
              0.342654245214142,
              0.170771749783608,
              0.837179934049804,
              0.121199617389325,
              0.184078978484997,
              0.77590519883374,
              0.167832133344528,
              0.419997760997017,
              0.309381299265553,
              0.148946244655233,
              0.490472015627847,
              0.145616529562113,
              0.075133901230475,
              0.525361221602977,
              0.139177747339925,
              0.11011923080104,
              0.0915703283584562,
              0.202494939618234,
              0.210718364847089,
              0.25547248231959,
              0.209260058394491,
              0.495883291307274,
              0.071796905645193,
              0.115894626073626,
              0.118365837242864,
              0.513032438441333,
              0.0808671596011147,
              0.368647858976049,
              0.350701479489938,
              0.419227081990054,
              0.430381561455343,
              0.395779636665942,
              0.294202631625536,
              0.206756788638231,
              0.319712092460055,
              0.275289012286742,
              0.418266509794148,
              1.09783791418231,
              0.620835672027588,
              0.544758073251945,
              0.549358591321164,
              0.27849814154431,
              0.556009246247718,
              0.171486827260671,
              0.392071420074051,
              0.670094271323516,
              0.262696447389796,
              0.217579129981255,
              0.203233440845466,
              0.69106983665313,
              0.996343194229121,
              0.728009747872396,
              0.241197384159993,
              0.133424651699451,
              0.606665860467966,
              0.452043913954646,
              0.716032971052234,
              1.02943441148894,
              0.510333079779738,
              0.110379969962987,
              0.356096854583494,
              0.0964556331887056,
              0.169123412316097,
              0.303970119363318,
              0.191904880617202,
              0.262692199977189,
              0.096845517192472,
              0.27570135502618,
              0.214311428016094,
              0.791047063817458,
              0.850807296969009,
              0.342864568018761,
              0.630618200328923,
              0.130657277692584,
              0.796623795677818,
              0.371922700239823,
              0.314291286514541,
              0.323768612326635,
              0.468188410351135,
              0.72652473116315,
              0.155161130204458,
              0.804900843903186,
              0.179854770802932,
              0.071809749978343,
              0.186569814883339,
              0.404530727496764,
              0.359470412438389,
              0.731881817003981,
              0.492216210620144,
              0.186595803962764,
              0.326896029574025,
              0.17805651013209,
              0.333934426506775,
              0.0993095762762257,
              0.810095911947011,
              0.122626126405449,
              0.398773517702662,
              0.21910845943264,
              0.144369426334679,
              0.215588853898921,
              0.132296323025266,
              0.908964443995631,
              0.206639116841814,
              0.208712108899669,
              0.254880296983575,
              0.663355728981594,
              0.454930680532843,
              0.348091006986725,
              0.655601096493421,
              0.197119624016729,
              0.349287228361295,
              0.474819381869402,
              1.17404105434828,
              0.44613593222343,
              0.308131866837207,
              0.170235628993514,
              0.20160159391565,
              0.284874231780231,
              0.27361169966601,
              0.225161611619853,
              0.472589256024539,
              0.775822692006827,
              0.176297868158696,
              0.695734474431482,
              0.726292112503794,
              0.349666930608312,
              0.373263799637324,
              0.202486622931207,
              0.120273664459631,
              0.48973875202121,
              0.588401482512459,
              0.142632993599871,
              0.349861403553862,
              0.329755849497185,
              0.319171145047536,
              0.233930650599933,
              0.396465133573915,
              0.103020334306454,
              0.243457632938602,
              0.253906868911484,
              0.262025372763505,
              0.599369723833427,
              0.356774266497267,
              0.325086313324182,
              0.124163057014584,
              0.44052011318572,
              0.225986034680003,
              0.171903706179626,
              0.2695952579918,
              0.272180205617163,
              0.323379687459557,
              0.253703744669287,
              0.296638971342312,
              0.143880580921505,
              0.331280324186518,
              0.0494614912493989,
              0.28438277789535,
              1.10456463199192,
              0.1641242454964,
              0.577528834258483,
              0.857062676701461,
              0.129790951704244,
              0.275514458500082,
              0.317289901723335,
              0.300189296097312,
              0.851728404370423,
              0.431260528872372,
              0.26089363020211,
              0.104419857416145,
              0.140234269397949,
              0.27903213808368,
              0.305708587365107,
              0.446691963361668,
              0.507644538663787,
              0.255735484396613,
              0.261729822427181,
              0.566905056399594,
              0.219953140332966,
              0.36341783632163,
              1.7620187699641,
              0.511014817993456,
              0.111435033899707,
              0.766787877342751,
              0.601449067843669,
              0.29985146569007,
              0.272462214595129,
              1.02533309846589,
              0.391575331062955,
              0.112521735903154,
              0.635235158312194,
              0.5586209984944,
              0.417426866545918,
              0.564022473222609,
              0.173341422978962,
              0.224605526374996,
              0.243961669301895,
              0.201874090705555,
              0.474701281159685,
              1.04480272977563,
              0.743224982269991,
              0.306435689856242,
              0.20689880657027,
              0.798603765299019,
              0.260322913082974,
              0.678012133885366,
              0.433569542063991,
              0.3332790178457,
              1.02366610787328,
              0.213758904882763,
              0.199198838113141,
              0.132847899248946,
              0.0717515640301284,
              0.142575873861407,
              0.208399120734855,
              0.279059446567965,
              0.604889596434393,
              0.245604606653984,
              0.149890419717933,
              0.0975974270354358,
              0.199760581913382,
              0.447511804115413,
              0.50514914706394,
              0.332149947349511,
              0.459233409371591,
              0.473895336939855,
              0.630034721236667,
              0.684436439418182,
              0.390673496784261,
              0.261744321461956,
              0.0716524607539417,
              0.585790913222504,
              0.435049237373959,
              1.07605967962792,
              0.283592458060658,
              0.343903261175588,
              1.01245695580469,
              0.54676639421024,
              0.0693598892328481,
              0.417087197288825,
              0.157171909982045,
              0.692779205290934,
              0.264350909122847,
              0.441518729567748,
              0.524460695834475,
              0.149944747525776,
              0.462279413495028,
              0.672938118723924,
              0.440320846054464,
              0.693637964384796,
              0.683666769073367,
              1.25498972978427,
              0.226861382035618,
              0.182521936272762,
              0.165665161640744,
              0.340363005451551,
              0.177693186822493,
              0.0939788305881019,
              0.752796479069289,
              0.16182572657558,
              0.591688505889238,
              0.519763509606818,
              0.589786656335994,
              0.50466005378731,
              0.555934187601552,
              0.505931040429579,
              0.30297634769551,
              0.232120833664625,
              0.533023114323892,
              0.144365054555234,
              0.172041257290895,
              0.180951999436705,
              0.764090526424136,
              0.58329658766401,
              0.468761153714664,
              0.142460168925021,
              0.245654774409616,
              0.56016227125673,
              0.350255996377835,
              0.190425885985553,
              0.745737994412035,
              0.130248077747779,
              0.304982459348189,
              0.897399291952112,
              0.509467483507819,
              1.16276552470885,
              0.653922693094917,
              1.0415301432144,
              0.0902483017800356,
              0.673655535684726,
              0.621449290792104,
              0.76446870916996,
              0.079091572185216,
              1.03451970746781,
              0.588942284061941,
              0.122125588651541,
              0.610465644085403,
              0.420465088507666,
              0.259170453207121,
              0.5226165988934,
              0.662392615952258,
              0.26845755148179,
              0.14609644197802,
              0.606651683798232,
              0.315022140545901,
              0.177461677501247,
              0.318610525270409,
              0.876026263562511,
              0.475381617736601,
              0.517270178762599,
              0.648332393559369,
              0.543732074890993,
              0.290314000815285,
              0.756481329344887,
              0.280811502915569,
              0.142551507742648,
              0.630214291244575,
              0.667305551914995,
              0.593158764844542,
              0.187886106389966,
              0.686241282661054,
              0.53357851416818,
              0.704205739282683,
              1.16579966408424,
              0.811871735942634,
              0.612489478126249,
              0.263486096720043,
              0.166763091072823,
              0.580732606381436,
              0.383770700851916,
              0.542255581838214,
              0.615694945574891,
              0.232544806925497,
              0.0954858344066878,
              0.13403799850216,
              0.433339901979703,
              0.117752304655308,
              0.313672469122549,
              0.252633273210015,
              0.292734644133805,
              0.647648701390209,
              1.0768845046982,
              0.82115023316778,
              0.633653639813671,
              0.0640810981950356,
              0.209089848699144,
              0.0732614014831207,
              0.132628925971442,
              0.230682007164319,
              0.163060335389003,
              0.388852271412199,
              0.540668105208326,
              0.357001644293794,
              0.963521198062922,
              0.465292357278572,
              0.153438721882915,
              0.262366204065258,
              0.674511448773401,
              0.231637840285034,
              0.204903819857916,
              0.22963687886078,
              0.695766613917719,
              0.165364584668543,
              0.396446178620608,
              0.317178586410192,
              0.349319487735345,
              0.629462602254472,
              0.208463267408934,
              0.629195647233247,
              0.400913447992055,
              0.80424910122934,
              0.207470678739663,
              0.378870328095598,
              0.705433351154986,
              0.349207368834813,
              0.337069306980051,
              0.205148226131802,
              0.197650011012743,
              0.436842097797247,
              0.288206722043342,
              0.239730864086669,
              0.155200816831856,
              0.159912381471542,
              0.247948860301524,
              0.607981570004877,
              0.0265581017256776,
              0.317082313443175,
              0.683020877181115,
              0.813890102701947,
              0.20279519021231,
              0.558971204242107,
              0.664759800270295,
              0.246066412450996,
              0.265607328404294,
              0.198170196942385,
              0.377303886909882,
              0.320364114084709,
              0.289181076517564,
              0.134611598942357,
              0.136040283713332,
              0.842854068408451,
              0.139922563105337,
              0.107830895541855,
              0.383112733804525,
              0.89973328116523,
              0.22701878694487,
              0.245867306977187,
              0.446604313625876,
              0.293537506429538,
              0.247353174027781,
              0.622820832439462,
              0.151869288151551,
              0.498407463962891,
              0.178092195962269,
              0.0871624194885032,
              0.702751740109328,
              1.05565852749728,
              0.621478806336452,
              0.590662649482746,
              1.72260791878513,
              0.249327906817521,
              0.634483777390141,
              0.677282766415421,
              1.17597792187775,
              0.738170559454855,
              0.732725825155011,
              0.76340982120178,
              0.811197080368236,
              0.888785232678978,
              1.13536672489872,
              0.533697366748603,
              0.484562150610532,
              0.629313913483502,
              0.314817378547812,
              0.423331704664859,
              0.122423477850085,
              0.265058818410309,
              0.302947010425532,
              0.887409892140148,
              0.148331029341767,
              0.299100613185867,
              0.297733084794591,
              0.0882099800945613,
              0.540830799028244,
              0.359231963343242,
              0.319552898561383,
              0.592158809712866,
              0.212358342905016,
              0.247996676987609,
              0.289989729685368,
              0.42506146252235,
              0.210676832160918,
              0.734194970730596,
              0.442640921412035,
              0.502156497889886,
              0.30108655102217,
              0.439727450095248,
              0.172324851892828,
              0.171465501587451,
              0.497793075967562,
              0.597861262359261,
              0.622441658533824,
              0.615312595755806,
              0.232701954483177,
              0.268937701492689,
              0.127881688567992,
              0.370513862354229,
              1.23410953601027,
              0.285765645082801,
              0.865332957768923,
              0.156438759749836,
              0.632843740772432,
              0.110372582354364,
              0.0886855735064256,
              0.216651851419803,
              0.150912632933853,
              0.703962602479242,
              0.235575436266675,
              0.244125002077032,
              0.165174060561419,
              0.355157001105041,
              0.203499950869657,
              0.110654190212544,
              0.998038622957526,
              0.417052583581347,
              0.649350865437348,
              0.277385753513362,
              0.601695960272963,
              1.50967868578486,
              0.382408360539113,
              0.425769221598803,
              0.611536298225078,
              0.423433532540777,
              0.430050902247833,
              0.274518641029967,
              0.628767008700693,
              0.2175118232145,
              0.395042753168447,
              0.286658358908364,
              0.964091310623734,
              0.274146626287689,
              0.295992961279362,
              0.66890232874624,
              0.436918920408622,
              0.511125896942969,
              0.322359750846427,
              0.279105343627695,
              0.585377578420601,
              0.339879415089012,
              0.170280166085907,
              0.332994382277777,
              0.203713546102072,
              0.161039973885906,
              0.56168233578492,
              0.124192575740579,
              0.592300829669427,
              0.175302766019451,
              0.167061748940381,
              0.453792838963363,
              0.349997993080753,
              0.783069504068987,
              0.265285961620998,
              1.50513558994469,
              0.462452702618205,
              0.298332542359972,
              0.534102597949419,
              0.503719128867107,
              1.39478731869746,
              0.250398135088132,
              0.190534311383656,
              0.473508272000416,
              0.332142995393868,
              0.492881191093285,
              0.249136185698473,
              0.200497900893614,
              0.231690241991671,
              0.39489608492907,
              0.361992190555781,
              0.493115384472299,
              0.794558562037988,
              0.446573540421325,
              0.438354784205219,
              0.364560709949496,
              0.184410186548357,
              0.392028231590143,
              0.349666250854149,
              0.432446936080264,
              0.289613994098586,
              0.234235547770633,
              0.662789089640493,
              0.274619455460571,
              0.897089685793352,
              0.443493980443817,
              1.67594887255558,
              0.177362835083612,
              0.279353061479293,
              0.699666912773178,
              0.397773878057604,
              1.57816132826817,
              0.942146889889799,
              0.172896952453838,
              0.130069757471284,
              0.193069911600873,
              1.02116657286826,
              0.338555813703257,
              0.451383382219307,
              0.771377628141623,
              0.203955104704654,
              0.58949896772752,
              0.247387767006315,
              0.892271751813737,
              0.215214847317799,
              0.164726091943864,
              0.321168180959042,
              0.211369781077456,
              0.400152324857534,
              0.475195618642089,
              0.186722995342115,
              0.520376384514707,
              0.161382751359871,
              0.699474448210803,
              0.235932009038863,
              0.414669167498391,
              0.190181802177482,
              0.390700208422379,
              0.0816742858722932,
              0.162968527319734,
              0.670637079581125,
              0.348595489646735,
              0.34665773961686,
              0.592854321019123,
              0.344911016230895,
              0.55744521829997,
              0.476378050599332,
              0.26504439014225,
              0.210716560675731,
              0.532740032645552,
              0.843625967159737,
              0.153857967546889,
              0.379307884377574,
              0.372391604055163,
              0.245134783533544,
              0.260333173774437,
              0.406081294019624,
              0.165456416387367,
              0.168738169620243,
              1.12042502344624,
              0.980323644373469,
              0.228786899312,
              0.371148490695654,
              0.970053758342424,
              0.437363698744409,
              0.319478316195934,
              0.445964473395747,
              0.246246428866181,
              0.130443350231561,
              0.291013803096044,
              0.0957777643963931,
              0.869256888748493,
              1.13753496976373,
              2.24232067806244,
              0.553098689337887,
              0.651396719916035,
              0.112482302629768,
              0.74101232234868,
              0.245575352774179,
              0.114672712067314,
              0.141644607633517,
              0.224382296812362,
              0.466161962652507,
              0.757189854233218,
              0.401025515889964,
              0.142387082925631,
              0.337980245209385,
              0.66180419264592,
              0.28074187432498,
              0.113212738441661,
              0.42726383143397,
              0.110262013086526,
              0.147373184756956,
              0.365473960619671,
              0.447504240061925,
              0.479984767659452,
              0.233538523412398,
              0.138552049617682,
              0.403470470879648,
              0.552349627893586,
              0.550860658741078,
              0.182756208297068,
              0.13663438782279,
              0.32029429362429,
              0.223137031564849,
              0.403998986689998,
              0.31462503594557,
              0.129098429334661,
              0.374996015400917,
              0.447960602992645,
              0.485196915611287,
              0.327997049053117,
              0.442872700299947,
              0.218638829235884,
              0.433956977950941,
              0.143138693758168,
              0.322797525291093,
              0.180024919604492,
              0.115832554536706,
              0.845437109718488,
              0.239255770777041,
              0.18602904018092,
              0.26762813354123,
              0.296882811650643,
              0.178678859060965,
              0.25119665611342,
              0.454254986899914,
              0.120667626654974,
              0.179861473203425,
              0.455051502438976,
              0.828033277644577,
              0.133613505493401,
              0.133216644791148,
              0.248541167702761,
              0.200672511385028,
              0.320597222593294,
              0.625655481469522,
              0.389657963937287,
              0.285569074435916,
              0.705578794010123,
              0.372037348433797,
              0.212413536620239,
              0.207105992308488,
              0.141096387294296,
              0.103876562591187,
              0.416092872527789,
              0.558769982389021,
              0.217398724454568,
              0.217291783183382,
              0.141230859568697,
              0.257237574444436,
              0.460296422018656,
              0.180621406191545,
              0.465649231797636,
              0.411229187095176,
              0.217917104584983,
              0.256000777014427,
              0.173849479455153,
              0.17372800773012,
              0.172490904630639,
              0.335696769014492,
              0.48528637520463,
              0.0862745798530382,
              0.453462225136336,
              0.348356703236934,
              0.343672292906816,
              0.538372645949889,
              0.106273363962414,
              0.100799008450527,
              0.358288762865181,
              0.211890830462006,
              0.784516159508492,
              0.192814748667957,
              0.223522781801799,
              0.867830958607415,
              0.195008384678669,
              0.364059622724513,
              0.300299542490302,
              0.930088840202074,
              0.114740297590671,
              0.278169272424626,
              0.437653644811228,
              0.347767171047043,
              0.393922557322521,
              0.173733398979659,
              0.279016480476649,
              0.277872648484982,
              0.487455238944959,
              0.394448866247091,
              0.474103472278546,
              0.159740713058423,
              0.198071174788364,
              0.776606462737619,
              0.29563555660316,
              0.162217787009807,
              0.119089217685198,
              0.0789717162826233,
              0.236548600338483,
              0.217748861013621,
              0.471636093297451,
              0.229382841299585,
              0.444402886911826,
              0.144309635997654,
              0.216201429455228,
              0.0640442370154651,
              0.402029456899845,
              0.952924757569682,
              1.83698382136113,
              0.391284873586252,
              0.509425570234467,
              0.22817625527904,
              0.30552518927052,
              0.134316749129184,
              0.372597423048269,
              0.316589318342039,
              0.542621144924117,
              0.486615235072548,
              0.178738774828526,
              0.423107258308978,
              0.211492695674975,
              0.113381358559644,
              0.0808894575226536,
              0.329672942494788,
              0.0502300144887401,
              0.302678607984299,
              0.568288489526297,
              0.113476248394584,
              0.0649428012351745,
              0.0847866450155066,
              0.39853282693828,
              0.715609607473862,
              0.470355489899529,
              1.18767036056078,
              0.588383542096992,
              0.106626379874498,
              0.16977363274559,
              0.233052779014297,
              0.516415974626063,
              0.69750263790192,
              0.294827284699053,
              0.672000358795715,
              0.176472365742011,
              0.687178905370243,
              0.273603210826576,
              0.349972959811907,
              0.118926842576597,
              0.384352575194495,
              0.848981291605087,
              0.382460051910883,
              0.356164540735167,
              0.252109514914197,
              0.297410724489497,
              0.604325955522796,
              1.07790967761609,
              1.59356781478906,
              0.262549030137447,
              0.552245943723819,
              0.102531761511335,
              0.970724159654487,
              0.516258959483344,
              0.293485789216077,
              0.188235596459226,
              0.24972836871917,
              0.180560300698765,
              0.251586129136087,
              0.193399790293679,
              0.743970446083995,
              0.804433078414338,
              0.478621086056067,
              0.672875467111766,
              0.443477560607223,
              0.343573112075472,
              0.233119940854836,
              0.596987739286925,
              0.419992871376859,
              0.251146765449354,
              0.569758591396496,
              0.569159786868277,
              0.477310803494679,
              1.03099957214989,
              0.284561222665712,
              0.50956497919703,
              0.483526343966642,
              0.474407779863323,
              0.462024980534908,
              0.31839785873875,
              0.306969820071516,
              0.621890941382343,
              0.422070745358511,
              0.494271119170911,
              0.623038718726234,
              0.665531994718593,
              0.67055273848389,
              0.355038425747256,
              0.499745474349487,
              0.228312968015068,
              0.283510887940549,
              0.24949529166276,
              0.744540464411436,
              1.24009098948478,
              0.207146984365975,
              0.119367855287542,
              0.347554048329001,
              0.148614555549497,
              0.628167194392788,
              0.0529208658860165,
              0.212394362424048,
              0.148823864292049,
              0.247530354052152,
              0.237205203754113,
              0.210688400727927,
              0.486775102495083,
              0.381718289330397,
              0.0750965526581661,
              0.40042048394094,
              0.351096710584452,
              0.375972673728643,
              0.171729885414809,
              0.893676940137828,
              0.199174298387813,
              0.264513960531926,
              0.364874950103304,
              0.808789396605903,
              0.693360373485425,
              0.290338415423197,
              0.238218147076314,
              0.264680588879946,
              0.162603044659396,
              0.471596944525644,
              0.188583947880406,
              0.172216756293447,
              0.391811198410029,
              0.771271494681443,
              0.162413450733459,
              0.152623591021391,
              0.298270789110557,
              0.194948049475495,
              0.216247459095287,
              0.315230630160957,
              0.441715639467145,
              0.629130704241465,
              0.603510519604056,
              0.445065689610765,
              0.18179559076031,
              0.450988344635088,
              0.159918885122472,
              0.143906622142426,
              0.352292518441889,
              0.106066447680692,
              0.189772363425258,
              0.455963767424114,
              0.56212069107897,
              0.0769885646671142,
              0.691918877391317,
              0.488147164237342,
              0.766347906108694,
              0.941980256403927,
              0.235403089485811,
              0.143599236111851,
              0.414737006632803,
              0.445037406107078,
              0.13984131680758,
              0.501051684979534,
              0.251239029134709,
              0.303450480770929,
              0.336801294735316,
              0.256880722776845,
              0.249581882005544,
              0.661683299613367,
              0.508423795288754,
              0.371588595736397,
              0.260341327588946,
              0.280207645797736,
              0.502642448524246,
              0.628395941125232,
              0.178797945432816,
              0.171518446141113,
              0.254508730234002,
              0.8779489413099,
              0.827901732985328,
              0.291740931318332,
              0.116192818860857,
              0.163827366599222,
              0.293476145284191,
              0.519984631805129,
              0.441191752821485,
              0.385122252645839,
              0.392472217934226,
              0.20344253890286,
              0.215833739833614,
              0.824219732602617,
              0.324917453997076,
              0.178204034433966,
              0.680286793232225,
              0.382276409982323,
              0.56234788016029,
              0.278111463912097,
              0.929786901022948,
              0.600590110171952,
              0.139856409659351,
              0.204772824310944,
              0.691208676993308,
              0.268954654260436,
              0.25716143225949,
              0.40735438605686,
              0.557979311534256,
              0.204191923029941,
              0.648631651638774,
              0.314592016247614,
              0.270136529058486,
              0.731016248593188,
              0.417219483399181,
              0.466603491863535,
              0.241563282931291,
              2.18600773271521,
              1.13970212126827,
              1.07045375346916,
              0.561908728912057,
              0.92247912771056,
              1.03858878163059,
              1.44163908743346,
              1.43513554073447,
              0.751395637339176,
              1.68128686021387,
              0.566751983329116,
              0.501022288107781,
              0.567587886534612,
              0.819420739362294,
              0.822053801208444,
              0.485822272135029,
              0.113472937903057,
              0.216330611693263,
              0.540272537688442,
              0.261473953756203,
              0.128951706570515,
              0.0929406880075312,
              0.899956837785244,
              0.357994022355268,
              0.186055708825023,
              0.500360773127046,
              0.272315008467411,
              0.488563509562075,
              0.345466892995472,
              0.725995754823577,
              0.289662826960416,
              0.121602684993153,
              0.841527985316244,
              0.168266193382099,
              0.356047229221793,
              0.419546694393398,
              0.294070233151043,
              0.423007536161303,
              0.591140263596078,
              0.399663470992636,
              0.116596839866235,
              0.374472675570049,
              0.129162112351277,
              0.35536907755983,
              0.66731392515154,
              0.322102190411167,
              0.199594976921442,
              0.260473369438213,
              0.331215942755008,
              0.215534457959581,
              0.209389370116651,
              0.119232652981202,
              1.01560461439319,
              0.415644405123954,
              0.307083010191419,
              0.183399623676417,
              0.483347510155815,
              0.347153658503635,
              0.153126044400389,
              0.357425912331781,
              0.274401669902435,
              0.506262000319176,
              0.470958872187033,
              0.627660845346317,
              0.597421361206672,
              0.736752188655051,
              0.653518810226364,
              0.659923013029169,
              0.26495198872682,
              0.659301056903788,
              0.379310388730595,
              0.376444235449363,
              0.107318796161404,
              0.373759065995752,
              0.294463011504177,
              0.32669656845692,
              0.362613582253862,
              0.274898193070824,
              0.150241776810589,
              0.406050075874469,
              0.139802382314273,
              0.341684280015277,
              0.257125406300671,
              0.711148696039251,
              0.297260651413947,
              0.193581113572786,
              0.544613983012105,
              0.348339266558119,
              0.569632472649975,
              0.584942819181372,
              0.195653130620735,
              0.360110709653305,
              0.0683419673418387,
              0.214109781122687,
              0.175909624838039,
              0.210415879511027,
              0.135706070667007,
              0.358942916050077,
              0.211902022731465,
              0.548782099799541,
              0.328011163455957,
              0.328286740063791,
              0.431219683980259,
              0.325537093419204,
              0.138472593115082,
              0.273162333142181,
              0.137859578091298,
              0.359058678629689,
              0.069536852358818,
              0.23763339240977,
              0.38586517539229,
              1.02683676200298,
              0.87525543655257,
              0.19287855889024,
              0.228712315857156,
              0.37016738575361,
              1.11560052697817,
              0.240104714820528,
              0.406494531726595,
              0.280361806891068,
              0.376255939592488,
              0.301028785044395,
              0.95244749178212,
              1.91842979874126,
              0.170497975064925,
              0.0704427952804451,
              0.210522984702143,
              0.282999441385693,
              0.47558682156603,
              0.260291840896401,
              0.194136386850519,
              0.540069373410563,
              0.359236158569359,
              0.358773947666448,
              0.109880284471676,
              0.368867593785373,
              0.313022748731634,
              0.133333606323777,
              0.168260936630737,
              0.248294578205325,
              0.25690466458745,
              0.494596716395146,
              0.0654986805862995,
              0.0881120816390115,
              0.222573707706683,
              0.354685182946265,
              0.506254923202307,
              0.07267269951504,
              0.339756381800129,
              0.165248390847697,
              0.270053348536502,
              0.591393067585754,
              0.25303941654492,
              0.164671419474814,
              0.463865416042975,
              0.327828480652224,
              0.79293492112445,
              0.473695917176246,
              0.144627371480873,
              0.733263121939361,
              0.85641026804578,
              0.437942641940878,
              0.832065261430601,
              0.309700182333013,
              0.551488662899073,
              0.458089052285119,
              0.173096777401591,
              0.262287333314469,
              0.252536992646636,
              0.770152151544898,
              0.569099249065322,
              0.730115144472818,
              0.683088174923249,
              0.405752040397128,
              0.189925835212704,
              0.648199317593064,
              0.206237642170128,
              0.117201509817242,
              0.373231069451886,
              0.22292266921646,
              0.0927319558620253,
              0.463348519704179,
              0.513195891792869,
              1.03542428301046,
              0.462731552160117,
              0.1989330282662,
              0.301445625116943,
              0.789546032993042,
              0.259186417702787,
              0.169452295754826,
              0.254989012884366,
              0.341616975080533,
              0.25274811433289,
              0.404502983632304,
              0.28345898747431,
              0.676460881411883,
              0.638044813573336,
              0.480030806806062,
              0.754287436550315,
              1.72758169776007,
              0.142182688967167,
              0.429104596489438,
              0.544818137626472,
              0.312523880091402,
              0.572044665182147,
              0.122604438264633,
              0.688369987449001,
              0.336481419915463,
              0.219841690373623,
              1.23973604352553,
              0.334397440758565,
              0.281483456777618,
              0.304033250871718,
              0.153789209278076,
              0.335842439127733,
              0.249864485365863,
              0.483007389133482,
              0.280329850800376,
              0.686769626783124,
              0.20511983981774,
              0.372545631762989,
              1.09242281180455,
              0.504893360130663,
              0.27675620855964,
              0.712911085553874,
              0.152050662186498,
              0.626331856814789,
              0.303863680239102,
              0.40898567650636,
              0.101471780171618,
              0.117466997087208,
              0.557621480914588,
              0.156127105576918,
              0.803465292100815,
              0.635786024318411,
              0.574256986262075,
              1.25251855175685,
              0.389544956801257,
              0.293067463777442,
              0.131902391365964,
              0.932143701750637,
              0.216191036550465,
              1.1626993183435,
              0.732276732230626,
              0.187682533238698,
              0.222433273747115,
              0.0596273486963772,
              0.106433684823213,
              0.356973801832666,
              0.0945176342401958,
              0.758490229037692,
              0.53894308708255,
              0.520922639411556,
              0.238411307132763,
              0.572911645826394,
              0.561692447857473,
              0.362098579041069,
              1.08969720291586,
              0.272544517272451,
              0.39991034768509,
              0.344938946209332,
              0.452129991302986,
              0.632448979998882,
              0.150341794137748,
              0.491747621756487,
              0.426789684109064,
              0.162263796006221,
              1.01410469234014,
              0.333884224047917,
              0.302947961009841,
              0.487962455371143,
              0.670614038858913,
              0.203231746908663,
              0.515006521416239,
              0.453651901821543,
              0.445255275275108,
              0.368842445121919,
              0.418237255031135,
              0.0905618000253814,
              0.331044501085641,
              0.103312526536511,
              0.285840120639298,
              0.650402600170072,
              0.503603730607973,
              0.215999333118794,
              0.275454977407136,
              0.405402251532141,
              0.377855310530968,
              0.496253639257607,
              0.190627651893124,
              0.417689209990188,
              0.281648392517966,
              0.454604163870503,
              0.177253880129718,
              0.490925851615043,
              0.293377928290994,
              0.486844496874053,
              0.210919526278625,
              0.147540910899183,
              0.479001311420811,
              0.190731327097535,
              0.962027459246527,
              0.366164770600878,
              0.472485370732628,
              0.367422371908987,
              0.872090522996517,
              0.115217227918953,
              0.525499357146582,
              0.0618638873356823,
              0.443440580840856,
              0.0868762347245597,
              0.910028631527162,
              0.227758553342557,
              0.922336672899336,
              0.477189065559585,
              0.21587548327903,
              0.517325026780262,
              1.2295856162984,
              0.225566358104939,
              0.583518144127153,
              0.354862489733081,
              0.224138726883188,
              0.214881634240036,
              1.23964645172021,
              0.809162107022129,
              0.365993982512099,
              0.195570610875428,
              0.107030886568201,
              0.529204592822772,
              0.271014498501982,
              0.279275042664944,
              0.168599571492677,
              0.238064163958056,
              0.251038431224957,
              0.287498820392256,
              0.460382373070896,
              0.379129567435895,
              0.116083191909053,
              0.49515908987537,
              0.36126781839483,
              0.409141776397303,
              0.427216773785274,
              0.35388577344284,
              0.458088760073499,
              0.425607769007001,
              0.750780083815768,
              0.680983286344764,
              0.213402718030074,
              0.230967316445498,
              0.498348823831441,
              0.335258860591498,
              0.258317516842345,
              0.902870898737958,
              0.775924149415162,
              0.209577396613905,
              0.418975650908906,
              0.639117896462587,
              0.181766918052464,
              1.01040281625109,
              0.58161817883234,
              0.767080099345005,
              0.952592300021307,
              1.12049381200365,
              0.727538939507762,
              0.478938860469133,
              0.9821162218467,
              0.414537474540584,
              0.148089178153692
          ],
          "text": [
              "AACS",
              "AARSD1",
              "AASDHPPT",
              "ABALON",
              "ABCD3",
              "ABCE1",
              "ABCF1",
              "ABHD16A",
              "ABR",
              "ABTB1",
              "AC002524.1",
              "AC004079.2",
              "AC004079.5",
              "AC004528.2",
              "AC004542.1",
              "AC004542.2",
              "AC004707.2",
              "AC004974.1",
              "AC005041.5",
              "AC005045.1",
              "AC005045.2",
              "AC005062.1",
              "AC005104.1",
              "AC005288.1",
              "AC005363.1",
              "AC005540.1",
              "AC005696.2",
              "AC005726.2",
              "AC005944.1",
              "AC006001.3",
              "AC006064.4",
              "AC006116.8",
              "AC006369.1",
              "AC006449.9",
              "AC006547.2",
              "AC007193.3",
              "AC007229.1",
              "AC007292.1",
              "AC007308.1",
              "AC007314.1",
              "AC007378.1",
              "AC007383.3",
              "AC008149.1",
              "AC008569.1",
              "AC008738.7",
              "AC008761.1",
              "AC008764.3",
              "AC008878.4",
              "AC008894.3",
              "AC008914.1",
              "AC009019.1",
              "AC009065.8",
              "AC009093.8",
              "AC009511.2",
              "AC009630.2",
              "AC009690.2",
              "AC010245.1",
              "AC010335.1",
              "AC010343.1",
              "AC010422.8",
              "AC010542.2",
              "AC010618.3",
              "AC010642.2",
              "AC010735.1",
              "AC010761.1",
              "AC010834.1",
              "AC010976.1",
              "AC011446.3",
              "AC011497.2",
              "AC011510.1",
              "AC011979.1",
              "AC012157.2",
              "AC012363.2",
              "AC012615.2",
              "AC013451.1",
              "AC015688.6",
              "AC015802.6",
              "AC015813.2",
              "AC015909.1",
              "AC016026.1",
              "AC016394.4",
              "AC016588.1",
              "AC016825.1",
              "AC017083.3",
              "AC018362.2",
              "AC018521.2",
              "AC018557.1",
              "AC018630.2",
              "AC018638.1",
              "AC018638.4",
              "AC018761.4",
              "AC018804.1",
              "AC019257.9",
              "AC020651.1",
              "AC020763.4",
              "AC020934.2",
              "AC020978.2",
              "AC021078.1",
              "AC021088.1",
              "AC022400.1",
              "AC022966.2",
              "AC023509.1",
              "AC025043.1",
              "AC025165.2",
              "AC025257.1",
              "AC025262.3",
              "AC025442.1",
              "AC026347.2",
              "AC027031.2",
              "AC027277.1",
              "AC027601.4",
              "AC027644.3",
              "AC036103.1",
              "AC037198.2",
              "AC060766.1",
              "AC064836.4",
              "AC067751.1",
              "AC068533.4",
              "AC068831.5",
              "AC069234.3",
              "AC069288.1",
              "AC073254.1",
              "AC073896.2",
              "AC074044.1",
              "AC074212.1",
              "AC078909.1",
              "AC080038.4",
              "AC083798.2",
              "AC087164.2",
              "AC087190.1",
              "AC087284.2",
              "AC087289.3",
              "AC087289.4",
              "AC087292.2",
              "AC087588.3",
              "AC090197.1",
              "AC090948.4",
              "AC090984.1",
              "AC091045.2",
              "AC091053.1",
              "AC091117.2",
              "AC091180.4",
              "AC091564.4",
              "AC092115.3",
              "AC092115.4",
              "AC092368.3",
              "AC092567.1",
              "AC092691.1",
              "AC092849.1",
              "AC093503.2",
              "AC093752.1",
              "AC096536.2",
              "AC097451.1",
              "AC097534.1",
              "AC098595.1",
              "AC099508.1",
              "AC100793.3",
              "AC104066.5",
              "AC104116.1",
              "AC104117.2",
              "AC104563.1",
              "AC105020.2",
              "AC105020.4",
              "AC105020.6",
              "AC105105.1",
              "AC106760.1",
              "AC106795.1",
              "AC107072.2",
              "AC107398.2",
              "AC108010.1",
              "AC108449.3",
              "AC108863.2",
              "AC109587.1",
              "AC110597.3",
              "AC112211.1",
              "AC112497.2",
              "AC114490.2",
              "AC114498.2",
              "AC115618.2",
              "AC116317.1",
              "AC117378.1",
              "AC120114.2",
              "AC123768.5",
              "AC124068.1",
              "AC124283.1",
              "AC125494.1",
              "AC127496.6",
              "AC130324.3",
              "AC130456.5",
              "AC131238.1",
              "AC133644.3",
              "AC134312.5",
              "AC135050.7",
              "AC135457.1",
              "AC135507.1",
              "AC136469.2",
              "AC137590.1",
              "AC137630.3",
              "AC138028.4",
              "AC139887.2",
              "AC141424.1",
              "AC145207.3",
              "AC145207.4",
              "AC240274.1",
              "AC242498.1",
              "AC244669.1",
              "AC245033.3",
              "AC245060.7",
              "ACAD10",
              "ACADVL",
              "ACAP2",
              "ACBD3-AS1",
              "ACD",
              "ACP1",
              "ACTR2",
              "ACTR8",
              "AD000671.1",
              "ADAMTS12",
              "ADAMTSL4-AS1",
              "ADAR",
              "ADARB1",
              "ADCY7",
              "ADGRB2",
              "ADIPOR1",
              "ADSS2",
              "AEBP1",
              "AF111169.3",
              "AF127577.1",
              "AF129075.4",
              "AF230666.1",
              "AFAP1L1",
              "AFF3",
              "AFMID",
              "AGAP2-AS1",
              "AGAP3",
              "AGAP6",
              "AGPAT3",
              "AGTRAP",
              "AHI1",
              "AIDA",
              "AIFM1",
              "AIFM2",
              "AIP",
              "AK2",
              "AKT2",
              "AL020996.1",
              "AL020996.3",
              "AL022328.4",
              "AL023584.1",
              "AL031282.1",
              "AL031587.5",
              "AL031775.1",
              "AL034380.1",
              "AL035252.5",
              "AL035427.1",
              "AL035661.2",
              "AL035699.1",
              "AL049829.2",
              "AL049873.1",
              "AL050331.2",
              "AL117190.4",
              "AL121748.1",
              "AL121845.1",
              "AL121845.3",
              "AL121987.2",
              "AL133346.1",
              "AL133410.2",
              "AL133453.1",
              "AL135905.2",
              "AL136038.4",
              "AL136295.5",
              "AL136988.1",
              "AL137060.1",
              "AL137060.5",
              "AL137782.1",
              "AL138478.1",
              "AL138689.2",
              "AL138963.4",
              "AL139095.2",
              "AL157871.1",
              "AL158151.1",
              "AL158847.1",
              "AL159978.1",
              "AL161909.1",
              "AL162258.2",
              "AL353763.2",
              "AL354740.1",
              "AL354919.2",
              "AL354920.1",
              "AL354956.1",
              "AL355032.1",
              "AL355816.2",
              "AL355987.6",
              "AL356652.1",
              "AL357140.1",
              "AL358333.3",
              "AL358790.1",
              "AL359632.1",
              "AL365205.1",
              "AL390719.1",
              "AL390728.4",
              "AL391056.2",
              "AL391069.1",
              "AL391839.2",
              "AL445183.1",
              "AL450306.1",
              "AL450467.1",
              "AL450998.1",
              "AL451165.2",
              "AL513217.1",
              "AL589765.7",
              "AL591684.1",
              "AL592146.1",
              "AL603839.1",
              "AL606534.1",
              "AL606534.2",
              "AL645933.1",
              "AL645941.3",
              "AL669831.3",
              "AL671710.1",
              "AL929472.2",
              "ALDH3B1",
              "ALDOC",
              "ALG12",
              "ALKBH2",
              "AMBRA1",
              "AMN",
              "AMPD2",
              "AMPH",
              "ANAPC2",
              "ANAPC4",
              "ANKIB1",
              "ANKMY2",
              "ANKRD11",
              "ANKRD13D",
              "ANKRD36BP1",
              "ANKZF1",
              "ANO1-AS1",
              "ANO10",
              "ANO4",
              "ANP32B",
              "ANP32E",
              "AP000688.1",
              "AP000763.3",
              "AP000779.1",
              "AP000943.2",
              "AP000944.2",
              "AP000944.3",
              "AP000944.5",
              "AP001001.1",
              "AP001267.1",
              "AP001496.3",
              "AP002770.1",
              "AP002784.2",
              "AP003071.3",
              "AP003096.1",
              "AP003108.2",
              "AP003307.2",
              "AP003396.5",
              "AP003692.1",
              "AP006621.5",
              "APBA2",
              "APEX1",
              "APLP1",
              "APOM",
              "APP",
              "ARAF",
              "ARAP1",
              "ARFGAP2",
              "ARFIP2",
              "ARFRP1",
              "ARHGAP18",
              "ARHGDIA",
              "ARHGEF18",
              "ARHGEF25",
              "ARID1B",
              "ARL10",
              "ARL14EP",
              "ARL16",
              "ARL2",
              "ARL5A",
              "ARL6IP4",
              "ARL8A",
              "ARMCX1",
              "ARMT1",
              "ARSD-AS1",
              "ARSG",
              "ARV1",
              "ARVCF",
              "ASB1",
              "ASB13",
              "ASCC3",
              "ASF1A",
              "ASPHD1",
              "ASPM",
              "ATAD2",
              "ATF1",
              "ATF7IP",
              "ATG4B",
              "ATL3",
              "ATP10A",
              "ATP11C",
              "ATP2A2",
              "ATP5ME",
              "ATP5MG",
              "ATP6V0C",
              "ATP6V0D1",
              "ATP6V0E1",
              "ATP8B2",
              "ATR",
              "ATRAID",
              "ATXN2L",
              "ATXN7L3",
              "AXL",
              "AZIN1",
              "B4GALT3",
              "B4GALT4",
              "BABAM1",
              "BACE1-AS",
              "BAG2",
              "BAHD1",
              "BAIAP2",
              "BAMBI",
              "BBS7",
              "BCAP31",
              "BCAT1",
              "BCKDHA",
              "BCL2L12",
              "BCLAF1",
              "BFAR",
              "BIN3",
              "BIRC6",
              "BLZF1",
              "BMERB1",
              "BMPR2",
              "BOD1",
              "BRD2",
              "BRD3",
              "BRF2",
              "BTAF1",
              "BTBD19",
              "BTBD2",
              "BTN3A1",
              "BTN3A2",
              "C11orf24",
              "C11orf58",
              "C11orf96",
              "C12orf10",
              "C12orf4",
              "C12orf57",
              "C15orf40",
              "C17orf58",
              "C19orf12",
              "C19orf25",
              "C19orf48",
              "C1orf109",
              "C1S",
              "C22orf39",
              "C4orf46",
              "C5orf66",
              "C6orf120",
              "C7orf26",
              "C8orf76",
              "CABIN1",
              "CACNA2D1",
              "CALD1",
              "CALU",
              "CAMLG",
              "CAMTA1",
              "CAND1",
              "CAPN10",
              "CAPN12",
              "CAPZA1",
              "CARD19",
              "CASKIN1",
              "CASP4",
              "CATSPER2P1",
              "CBSL",
              "CBX3",
              "CBX3P9",
              "CBY1",
              "CCDC130",
              "CCDC14",
              "CCDC142",
              "CCDC174",
              "CCDC28B",
              "CCDC39",
              "CCDC50",
              "CCDC59",
              "CCDC71L",
              "CCDC84",
              "CCDC85B",
              "CCDC85C",
              "CCDC9",
              "CCM2",
              "CCNB1IP1",
              "CCND1",
              "CCNY",
              "CCS",
              "CCT4",
              "CD2AP",
              "CD2BP2",
              "CD302",
              "CD44",
              "CD63",
              "CD68",
              "CD82",
              "CD9",
              "CD99",
              "CDC16",
              "CDC27",
              "CDC34",
              "CDC37",
              "CDC73",
              "CDIPT",
              "CDK1",
              "CDK16",
              "CDK2",
              "CDK2AP1",
              "CDK6",
              "CDK7",
              "CDKN2AIP",
              "CDR2",
              "CDV3",
              "CDYL",
              "CEBPZOS",
              "CELF2",
              "CENPE",
              "CENPX",
              "CEP131",
              "CEP89",
              "CFAP126",
              "CFAP20",
              "CFAP73",
              "CFDP1",
              "CFH",
              "CFL1",
              "CHCHD5",
              "CHCHD6",
              "CHD3",
              "CHD9",
              "CHERP",
              "CHML",
              "CHMP1B",
              "CHMP7",
              "CHPT1",
              "CHRNB1",
              "CIAO3",
              "CIP2A",
              "CIRBP",
              "CISD2",
              "CISD3",
              "CIZ1",
              "CKAP2L",
              "CLIC4",
              "CLIP2",
              "CLK3",
              "CLN3",
              "CLN6",
              "CLOCK",
              "CMBL",
              "CMIP",
              "CMPK1",
              "CMTR2",
              "CNDP2",
              "CNIH4",
              "CNOT11",
              "CNOT9",
              "CNPPD1",
              "CNPY3",
              "COA1",
              "COA6",
              "COG6",
              "COL12A1",
              "COL27A1",
              "COMMD4",
              "COPB1",
              "COPS9",
              "COPZ1",
              "COX20P1",
              "COX4I1",
              "CPNE1",
              "CPNE3",
              "CPOX",
              "CPSF6",
              "CRAT",
              "CREB3",
              "CRKL",
              "CRYAB",
              "CSE1L",
              "CSNK1D",
              "CSNK1G3",
              "CSNK2A1",
              "CSNK2B",
              "CTBP1",
              "CTBP2",
              "CTDSP2",
              "CTR9",
              "CTRL",
              "CTSK",
              "CTSL",
              "CTTNBP2NL",
              "CUEDC2",
              "CUL2",
              "CUL4B",
              "CUTA",
              "CYB5B",
              "CYB5R3",
              "CYBA",
              "DAB2IP",
              "DCAF11",
              "DCAF13",
              "DCTN2",
              "DDA1",
              "DDAH2",
              "DDIT3",
              "DDIT4",
              "DDR1",
              "DDRGK1",
              "DDX17",
              "DDX18",
              "DDX19B",
              "DDX47",
              "DDX54",
              "DEAF1",
              "DEDD",
              "DEF8",
              "DENND5A",
              "DENR",
              "DEPDC1",
              "DFFA",
              "DGCR6",
              "DGCR8",
              "DHRS7",
              "DHRS7B",
              "DHRSX",
              "DHX15",
              "DHX29",
              "DHX38",
              "DHX8",
              "DIABLO",
              "DIAPH3",
              "DICER1",
              "DIO2",
              "DIPK1A",
              "DIS3",
              "DKC1",
              "DLD",
              "DLG1",
              "DLG4",
              "DLGAP4",
              "DNAJB2",
              "DNAJB6",
              "DNAJC10",
              "DNAJC15",
              "DNAJC5",
              "DNAJC7",
              "DNAJC8",
              "DNASE2",
              "DNPEP",
              "DNTTIP1",
              "DOC2A",
              "DOCK7",
              "DONSON",
              "DOP1A",
              "DPF2",
              "DPH1",
              "DPH3",
              "DPY30",
              "DPYSL4",
              "DRAM2",
              "DRG1",
              "DSEL",
              "DTX3",
              "DUSP11",
              "DUSP12",
              "DUSP22",
              "DYNC2LI1",
              "E2F6",
              "ECD",
              "ECHDC1",
              "ECT2",
              "EDC3",
              "EDEM3",
              "EDIL3",
              "EEF1A1",
              "EEF1AKMT2",
              "EEF1AKNMT",
              "EFCAB14",
              "EFNA4",
              "EFNB2",
              "EFTUD2",
              "EHBP1",
              "EHMT2",
              "EID2",
              "EIF1AX",
              "EIF1AY",
              "EIF1B",
              "EIF2AK4",
              "EIF2B2",
              "EIF2D",
              "EIF4A1",
              "EIF4A3",
              "EIF4EP2",
              "ELK1",
              "ELMOD2",
              "ELOA-AS1",
              "ELOCP2",
              "ELP5",
              "ELP6",
              "EMC2",
              "EMC4",
              "EMC9",
              "EME1",
              "EML4-AS1",
              "ENDOV",
              "ENOX2",
              "ENSA",
              "ENSAP2",
              "ENTPD6",
              "ENY2",
              "EPHA1",
              "EPN2",
              "EPRS1",
              "EPS8",
              "EPS8L2",
              "EPSTI1",
              "ERCC8",
              "ERICH1",
              "ERP29",
              "ERVK3-1",
              "ETV4",
              "EVI5",
              "EXD3",
              "EXOC6",
              "EXOC7",
              "EXOSC1",
              "EXOSC10",
              "EXOSC5",
              "EXOSC7",
              "FAM114A2",
              "FAM118B",
              "FAM149B1",
              "FAM160B1",
              "FAM162A",
              "FAM166A",
              "FAM200B",
              "FAM20B",
              "FAM219A",
              "FAM32A",
              "FAM86C1",
              "FAM89B",
              "FAM98B",
              "FANCL",
              "FAR1",
              "FAR2",
              "FARSB",
              "FASTKD3",
              "FBH1",
              "FBL",
              "FBLN5",
              "FBN1",
              "FBRS",
              "FBRSL1",
              "FBXL12",
              "FBXO11",
              "FBXO17",
              "FBXO7",
              "FCGRT",
              "FCHSD1",
              "FERP1",
              "FGD1",
              "FGFR1",
              "FKBP10",
              "FKBP11",
              "FKBP14",
              "FKBP1A",
              "FKBP1B",
              "FLCN",
              "FLNA",
              "FLNC",
              "FMN1",
              "FMN2",
              "FNTB",
              "FO704657.1",
              "FOCAD",
              "FOXK2",
              "FOXRED1",
              "FP671120.4",
              "FTH1P20",
              "FTL",
              "FTSJ3",
              "FXYD5",
              "FZR1",
              "G6PD",
              "GABARAPL2",
              "GABPA",
              "GAL3ST4",
              "GALNS",
              "GAS5-AS1",
              "GAS6-AS1",
              "GATD1",
              "GATD3A",
              "GBA",
              "GBA2",
              "GCC2",
              "GDF5OS",
              "GDI1",
              "GEMIN7",
              "GET4",
              "GFER",
              "GFM2",
              "GGA1",
              "GGCX",
              "GIPC1",
              "GIT1",
              "GLCE",
              "GLIPR1",
              "GLIPR2",
              "GLIS2",
              "GLRX5",
              "GMPR",
              "GMPR2",
              "GNAI3",
              "GNAS",
              "GNB5",
              "GNG10",
              "GOLGA2P10",
              "GOLGA4",
              "GOLGA5",
              "GOLIM4",
              "GOT1",
              "GPD2",
              "GPRASP2",
              "GPS1",
              "GPT2",
              "GPX1P1",
              "GRB2",
              "GRHPR",
              "GRIK2",
              "GRN",
              "GSDMD",
              "GSE1",
              "GSK3A",
              "GSPT1",
              "GSS",
              "GSTM3",
              "GTF2A1",
              "GTF2A2",
              "GTF2IRD2B",
              "GTF3C2",
              "GUF1",
              "GUK1",
              "H1-0",
              "H1-10",
              "H2AZ1-DT",
              "H3-3B",
              "HABP4",
              "HADH",
              "HARBI1",
              "HARS2",
              "HAUS6",
              "HAUS7",
              "HAX1",
              "HBS1L",
              "HCFC1R1",
              "HDDC3",
              "HDHD5",
              "HEATR5B",
              "HECTD1",
              "HEIH",
              "HERC4",
              "HERPUD1",
              "HGF",
              "HLA-DPB1",
              "HLA-H",
              "HLTF",
              "HMBS",
              "HMG20A",
              "HMG20B",
              "HMGA1P2",
              "HMGA1P3",
              "HMOX1",
              "HNRNPA1P48",
              "HNRNPF",
              "HNRNPM",
              "HNRNPR",
              "HNRNPUL1",
              "HOXB6",
              "HPF1",
              "HRH1",
              "HSPA6",
              "HSPA8",
              "HSPBP1",
              "IARS1",
              "IARS2",
              "IBTK",
              "ICK",
              "IDE",
              "IDI2",
              "IFITM2",
              "IFNWP19",
              "IFT122",
              "IFT20",
              "IFT27",
              "IFT46",
              "IFT80",
              "IFT81",
              "IGFBP7-AS1",
              "IGSF8",
              "IL10RB-DT",
              "IL11",
              "IL6ST",
              "ILF2",
              "ILK",
              "ILVBL",
              "IMMP2L",
              "IMP4",
              "IMPA2",
              "IMPACT",
              "IMPDH1",
              "ING1",
              "INO80B",
              "INO80E",
              "INPP5F",
              "INSIG1",
              "INSIG2",
              "INTS11",
              "INTS13",
              "INTS8",
              "IPO8",
              "IPO9",
              "IRAK1",
              "IRF1-AS1",
              "IRF2",
              "IRGQ",
              "IST1",
              "ISY1",
              "ISYNA1",
              "ITGA4",
              "ITGA6",
              "ITGAV",
              "ITGB1",
              "ITM2C",
              "ITPK1",
              "ITPRID2",
              "ITPRIPL2",
              "JAM3",
              "JDP2",
              "JMJD8",
              "JOSD1",
              "JOSD2",
              "JPT2",
              "JTB",
              "KAT5",
              "KCP",
              "KCTD17",
              "KCTD9",
              "KDM6A",
              "KDM6B",
              "KF456478.1",
              "KF459542.1",
              "KHDC4",
              "KHDRBS1",
              "KHNYN",
              "KIF11",
              "KIF18A",
              "KIF1C",
              "KIF20B",
              "KIF5B",
              "KIF7",
              "KIFC2",
              "KIT",
              "KLC2",
              "KLC3",
              "KLF4",
              "KLHDC4",
              "KMT5B",
              "KNTC1",
              "KPNA3",
              "KPNB1",
              "KRI1",
              "KRTAP2-3",
              "KRTCAP2",
              "KTN1",
              "KXD1",
              "LAMA5",
              "LAMTOR4",
              "LAMTOR5",
              "LARP7",
              "LCMT1",
              "LDAH",
              "LDLR",
              "LDLRAP1",
              "LEMD2",
              "LIG4",
              "LIMD1-AS1",
              "LIN7A",
              "LINC00339",
              "LINC00667",
              "LINC01504",
              "LINC02637",
              "LIX1L",
              "LIX1L-AS1",
              "LMBR1L",
              "LMO7",
              "LNPK",
              "LONP1",
              "LONP2",
              "LOXL2",
              "LPAR1",
              "LPCAT4",
              "LRCH3",
              "LRCH4",
              "LRPPRC",
              "LRRC40",
              "LRRC49",
              "LRRC57",
              "LRRN3",
              "LSG1",
              "LSM1",
              "LSM12",
              "LSM14B",
              "LTBR",
              "LUC7L",
              "LXN",
              "LYPD1",
              "LYPLA2",
              "LYRM9",
              "LZTS1",
              "LZTS2",
              "MACF1",
              "MAFG",
              "MAGED4B",
              "MAGEH1",
              "MAGOH",
              "MAGOHB",
              "MAK16",
              "MALSU1",
              "MAMLD1",
              "MAN2C1",
              "MANEA",
              "MAP1A",
              "MAP1B",
              "MAP3K20",
              "MAP3K4",
              "MAP4K3",
              "MAP4K5",
              "MAPK7",
              "MAPK8IP1",
              "MAPKAPK2",
              "MARS1",
              "MAST2",
              "MAZ",
              "MBD1",
              "MBD3",
              "MBD6",
              "MBOAT2",
              "MCCC2",
              "MCM10",
              "MCM3AP",
              "MCM6",
              "MCRIP1",
              "MDP1",
              "MEAF6",
              "MED22",
              "MED4-AS1",
              "MED8",
              "MEF2D",
              "MEIS2",
              "MEIS3",
              "MELK",
              "MET",
              "METAP2",
              "METTL1",
              "METTL14",
              "METTL17",
              "METTL3",
              "MFAP2",
              "MFAP4",
              "MFN1",
              "MGAT2",
              "MGRN1",
              "MIB1",
              "MIB2",
              "MICU3",
              "MIDN",
              "MIIP",
              "MINDY3",
              "MINPP1",
              "MIR1184-1",
              "MIR1244-3",
              "MIR1279",
              "MIR1282",
              "MIR22",
              "MIR222HG",
              "MIR3074",
              "MIR3120",
              "MIR3661",
              "MIR4253",
              "MIR4292",
              "MIR4442",
              "MIR6080",
              "MIR6126",
              "MIR6720",
              "MIR762",
              "MIS18BP1",
              "MKNK2",
              "MKRN1",
              "MKS1",
              "MLLT1",
              "MMGT1",
              "MNT",
              "MOB2",
              "MOB3A",
              "MOB4",
              "MORC3",
              "MORF4L1",
              "MOSPD2",
              "MOSPD3",
              "MPP5",
              "MRAP",
              "MRAS",
              "MRGBP",
              "MRPL1",
              "MRPL10",
              "MRPL20",
              "MRPL22",
              "MRPL43",
              "MRPL9",
              "MRPS11",
              "MRPS16",
              "MRPS5",
              "MRTFA",
              "MSANTD2",
              "MSC",
              "MSC-AS1",
              "MSH2",
              "MSRA",
              "MSRB1",
              "MT-CYB",
              "MT-TN",
              "MT-TW",
              "MTA1",
              "MTAP",
              "MTATP6P1",
              "MTBP",
              "MTCH1",
              "MTDH",
              "MTERF3",
              "MTERF4",
              "MTFP1",
              "MTFR1L",
              "MTMR1",
              "MTMR14",
              "MTMR3",
              "MTMR6",
              "MUL1",
              "MX2",
              "MYADM",
              "MYC",
              "MYCBP",
              "MYL6B",
              "MYLK-AS1",
              "MYOCD",
              "MYPN",
              "MYSM1",
              "MZT2B",
              "NAA15",
              "NAA25",
              "NABP1",
              "NAE1",
              "NAPA",
              "NAT9",
              "NAV2-AS1",
              "NAV3",
              "NAXE",
              "NBEAL1",
              "NBN",
              "NCAPG",
              "NCAPH2",
              "NCBP1",
              "NCBP3",
              "NCK2",
              "NCKAP1",
              "NCLN",
              "NDC1",
              "NDEL1",
              "NDST2",
              "NDUFA10",
              "NDUFA13",
              "NDUFAF1",
              "NDUFAF2",
              "NDUFAF7",
              "NDUFV1",
              "NEAT1",
              "NECAB3",
              "NECAP1",
              "NECAP2",
              "NECTIN3",
              "NEDD1",
              "NEDD4",
              "NEK3",
              "NELFA",
              "NELFCD",
              "NES",
              "NEXN-AS1",
              "NFATC2IP",
              "NFE2L1",
              "NFX1",
              "NFXL1",
              "NFYB",
              "NGDN",
              "NGF",
              "NICN1",
              "NIFK-AS1",
              "NINJ1",
              "NIPSNAP1",
              "NIPSNAP3A",
              "NMD3",
              "NOB1",
              "NOC3L",
              "NOL11",
              "NONO",
              "NPAS2",
              "NPIPB12",
              "NPIPB3",
              "NPIPB5",
              "NPIPP1",
              "NPM1P27",
              "NPM3",
              "NPR3",
              "NQO1",
              "NR4A1",
              "NR4A2",
              "NRAS",
              "NRBP1",
              "NRBP2",
              "NRF1",
              "NRIP1",
              "NRP2",
              "NRSN2",
              "NSDHL",
              "NSUN4",
              "NT5C",
              "NT5DC4",
              "NTAN1",
              "NUB1",
              "NUCB1",
              "NUDCD1",
              "NUDT14",
              "NUDT17",
              "NUDT21",
              "NUDT22",
              "NUDT9",
              "NUF2",
              "NUFIP2",
              "NUMA1",
              "NUMBL",
              "NUP107",
              "NUP50",
              "NUP88",
              "NUTM2B-AS1",
              "NXF1",
              "OBI1-AS1",
              "OCIAD1-AS1",
              "OGFRL1",
              "OPN1SW",
              "ORC3",
              "ORMDL1",
              "OSBPL3",
              "OSTN-AS1",
              "OXTR",
              "P3H2",
              "P4HA2",
              "P4HB",
              "P4HTM",
              "PAFAH1B3",
              "PAGR1",
              "PAK2",
              "PAN3",
              "PARP10",
              "PARPBP",
              "PAXBP1",
              "PBK",
              "PBLD",
              "PBRM1",
              "PCBP2",
              "PCGF2",
              "PCGF3",
              "PCMTD2",
              "PCOLCE",
              "PDCD6IP",
              "PDE4A",
              "PDE5A",
              "PDIA3P2",
              "PDPR",
              "PEA15",
              "PELP1",
              "PEX1",
              "PEX14",
              "PEX19",
              "PEX5",
              "PFAS",
              "PFDN1",
              "PFKFB3",
              "PFKFB4",
              "PFKL",
              "PGD",
              "PGM5P2",
              "PGS1",
              "PHC2",
              "PHF11",
              "PHF23",
              "PHF5A",
              "PHGDH",
              "PHKG2",
              "PHPT1",
              "PHYKPL",
              "PIGG",
              "PIGK",
              "PIGQ",
              "PIK3C2A",
              "PINK1",
              "PINK1-AS",
              "PIP5K1A",
              "PISD",
              "PITPNM1",
              "PJA2",
              "PKD2",
              "PKN2",
              "PLEKHA4",
              "PLEKHB2",
              "PLEKHJ1",
              "PLEKHO1",
              "PLEKHO2",
              "PLK4",
              "PLOD3",
              "PLS3",
              "PLXNB3",
              "PLXND1",
              "PML",
              "PMM2",
              "PNKD",
              "POLB",
              "POLD2",
              "POLDIP3",
              "POLE",
              "POLR1C",
              "POLR2C",
              "POLR2D",
              "POLR2H",
              "POLR3C",
              "POLR3K",
              "POM121",
              "PON2",
              "POP1",
              "POR",
              "POT1",
              "PPIH",
              "PPIL4",
              "PPME1",
              "PPP1CB",
              "PPP1R12C",
              "PPP1R14BP3",
              "PPP1R7",
              "PPP1R9B",
              "PPP2R3A",
              "PPP2R3B",
              "PPP2R5D",
              "PPP3CA",
              "PPP3CB",
              "PPP4R2",
              "PRC1-AS1",
              "PRCP",
              "PRDM2",
              "PRIM1",
              "PRIM2",
              "PRKAB1",
              "PRKACA",
              "PRKCA",
              "PRKCD",
              "PRKCSH",
              "PRKCZ",
              "PRKD3",
              "PRKDC",
              "PRMT2",
              "PRMT5-AS1",
              "PRNP",
              "PRPF19",
              "PRPF3",
              "PRPF31",
              "PRPF4B",
              "PRR13",
              "PRR13P5",
              "PRR14",
              "PRR5",
              "PRRG1",
              "PRRX1",
              "PRTFDC1",
              "PRUNE1",
              "PSEN1",
              "PSENEN",
              "PSMA6P1",
              "PSMC5",
              "PSMD7",
              "PSME4",
              "PSMF1",
              "PSTPIP2",
              "PTBP1",
              "PTGER2",
              "PTGES3",
              "PTK2",
              "PTMA",
              "PTMS",
              "PTPN11",
              "PTPN14",
              "PTPN21",
              "PWWP3A",
              "PYM1",
              "QDPR",
              "QKI",
              "QSER1",
              "RAB11FIP1P1",
              "RAB11FIP3",
              "RAB24",
              "RAB35",
              "RAB3B",
              "RAB40C",
              "RAB4B-EGLN2",
              "RAB5C",
              "RAB5IF",
              "RAB7A",
              "RAB8B",
              "RABEP1",
              "RABEPK",
              "RAC3",
              "RACK1",
              "RAD23A",
              "RAE1",
              "RANBP6",
              "RAP1B",
              "RAP1GDS1",
              "RAPGEF1",
              "RARA",
              "RARS1",
              "RASA1",
              "RASGRF2",
              "RBBP7",
              "RBM10",
              "RBM17",
              "RBM24",
              "RBM38",
              "RBM45",
              "RBM5-AS1",
              "RBM8A",
              "RCC1L",
              "RCN3",
              "RDH11",
              "RECQL5",
              "RELN",
              "REXO2",
              "RFC3",
              "RGL2",
              "RGS2",
              "RGS3",
              "RHBDD2",
              "RHEBP2",
              "RILPL1",
              "RIMKLB",
              "RIN2",
              "RIPOR1",
              "RLIM",
              "RNASE4",
              "RNASEH2B",
              "RNASEK",
              "RNASEK-C17orf49",
              "RNF113A",
              "RNF114",
              "RNF19A",
              "RNF216P1",
              "RNF220",
              "RNF24",
              "RNF40",
              "RNF41",
              "RNF5",
              "RNPEPL1",
              "RNPS1",
              "RNU6-395P",
              "RNU7-111P",
              "ROCK1",
              "RPAIN",
              "RPAP3",
              "RPL10",
              "RPL10A",
              "RPL10P9",
              "RPL14",
              "RPL18",
              "RPL21P75",
              "RPL23AP7",
              "RPL23AP82",
              "RPL24P2",
              "RPL24P4",
              "RPL28",
              "RPL30",
              "RPL31",
              "RPL35P2",
              "RPL4",
              "RPL41",
              "RPL41P5",
              "RPL4P4",
              "RPL7L1",
              "RPL7P23",
              "RPP21",
              "RPS10-NUDT3",
              "RPS20",
              "RPS3",
              "RPS4Y1",
              "RPS6",
              "RPS6KB1",
              "RPS7P10",
              "RPSAP8",
              "RPUSD4",
              "RRAGB",
              "RRM2B",
              "RRP7A",
              "RRP7BP",
              "RTCB",
              "RTN2",
              "RTRAF",
              "RUBCN",
              "RWDD4",
              "SACM1L",
              "SAMD4A",
              "SAMD4B",
              "SAMM50",
              "SAP18",
              "SAP30BP",
              "SARAF",
              "SARS-GSE561921",
              "SAT2",
              "SCAMP3",
              "SCAMP4",
              "SCFD1",
              "SCLT1",
              "SCN9A",
              "SCNM1",
              "SCP2",
              "SCRN3",
              "SCYL1",
              "SCYL2",
              "SDAD1",
              "SDCCAG8",
              "SDF2",
              "SDR39U1",
              "SEC23A",
              "SEC24C",
              "SEC61G",
              "SEC63",
              "SELENOH",
              "SELENOK",
              "SEMA3C",
              "SERF1A",
              "SERF1B",
              "SERPINB7",
              "SERTAD3",
              "SETD5",
              "SETDB1",
              "SF3A1",
              "SF3A2",
              "SF3B2",
              "SF3B4",
              "SFRP1",
              "SFT2D3",
              "SFXN3",
              "SGCE",
              "SGF29",
              "SGK1",
              "SGO2",
              "SGSM2",
              "SH2B1",
              "SH3BGRL",
              "SHCBP1",
              "SHKBP1",
              "SHROOM3",
              "SIAH2",
              "SINHCAF",
              "SIPA1L1",
              "SIRT6",
              "SLAIN2",
              "SLC14A1",
              "SLC19A1",
              "SLC25A37",
              "SLC25A38",
              "SLC25A39",
              "SLC25A5-AS1",
              "SLC2A3",
              "SLC2A4RG",
              "SLC30A9",
              "SLC31A1",
              "SLC35A3",
              "SLC35B2",
              "SLC35C2",
              "SLC35G2",
              "SLC38A2",
              "SLC38A4",
              "SLC4A3",
              "SLC4A7",
              "SLC52A2",
              "SLC66A1",
              "SLC66A2",
              "SLC6A8",
              "SLC8A1",
              "SLC9A3",
              "SLC9A3R2",
              "SLC9A7",
              "SLF2",
              "SMAD1-AS1",
              "SMAP2",
              "SMARCA5-AS1",
              "SMARCAD1",
              "SMARCB1",
              "SMARCE1",
              "SMC4",
              "SMG6",
              "SMIM15-AS1",
              "SMIM29",
              "SMIM7",
              "SMURF1",
              "SNAP23",
              "SNAPC2",
              "SNAPC3",
              "SNHG15",
              "SNHG29",
              "SNHG32",
              "SNN",
              "SNORA18",
              "SNORA24",
              "SNORA25",
              "SNORA44",
              "SNORA63B",
              "SNORA64",
              "SNORA67",
              "SNORA8",
              "SNORD17",
              "SNORD3A",
              "SNORD4A",
              "SNORD58A",
              "SNORD6",
              "SNORD68",
              "SNORD87",
              "SNRK",
              "SNRNP70",
              "SNRPA",
              "SNRPEP4",
              "SNUPN",
              "SNW1",
              "SNX14",
              "SNX15",
              "SNX32",
              "SNX7",
              "SOCS7",
              "SOD1",
              "SORBS3",
              "SPAG16",
              "SPATA21",
              "SPATS2",
              "SPATS2L",
              "SPC24",
              "SPCS1",
              "SPCS2",
              "SPCS2P4",
              "SPCS3",
              "SPINDOC",
              "SPNS1",
              "SPOP",
              "SPPL2B",
              "SPRN",
              "SPRYD3",
              "SPSB1",
              "SPTLC1P1",
              "SPTY2D1OS",
              "SRC",
              "SREBF1",
              "SREBF2",
              "SRP68",
              "SRPRB",
              "SRRM1",
              "SRRM3",
              "SRRM5",
              "SRSF2",
              "SRSF3",
              "SRSF5",
              "SRSF7",
              "SSH2",
              "SSR4",
              "SSU72",
              "SSX2IP",
              "ST20-MTHFS",
              "ST6GALNAC6",
              "STAG2",
              "STAG3L3",
              "STAMBPL1",
              "STEAP1",
              "STEAP3",
              "STK36",
              "STRADA",
              "STUB1",
              "STX18",
              "STX4",
              "STX5",
              "STYX",
              "SUCLA2",
              "SUCO",
              "SUPT16H",
              "SUPT4H1",
              "SUPT5H",
              "SUPT7L",
              "SVBP",
              "SVIL-AS1",
              "SYDE1",
              "SYNCRIP",
              "SYTL4",
              "SYVN1",
              "SZT2-AS1",
              "TAB3-AS2",
              "TACC1",
              "TAF11",
              "TAOK2",
              "TAPBP",
              "TARS2",
              "TASOR2",
              "TBC1D14",
              "TBC1D20",
              "TBC1D22A",
              "TBC1D23",
              "TBC1D31",
              "TBC1D9B",
              "TBL1XR1",
              "TBL2",
              "TBP",
              "TBX2",
              "TCAF1",
              "TCAIM",
              "TCF25",
              "TCF3",
              "TCF7L1",
              "TCHP",
              "TCP11L1",
              "TCTN2",
              "TEAD2",
              "TECR",
              "TEN1",
              "TEPSIN",
              "TERF2",
              "TEX264",
              "TFIP11",
              "TFPT",
              "TGIF1",
              "TGIF2-RAB5IF",
              "THAP4",
              "THRA",
              "THUMPD3",
              "TIA1",
              "TIMM10",
              "TIMM17B",
              "TIMM50",
              "TIMM8B",
              "TIMM9",
              "TINF2",
              "TIPRL",
              "TJAP1",
              "TKT",
              "TLK2",
              "TLN1",
              "TM2D2",
              "TMBIM1",
              "TMBIM6",
              "TMCO1",
              "TMCO3",
              "TMED1",
              "TMED2",
              "TMED2-DT",
              "TMEM101",
              "TMEM120A",
              "TMEM131L",
              "TMEM14C",
              "TMEM159",
              "TMEM161A",
              "TMEM167A",
              "TMEM184A",
              "TMEM184B",
              "TMEM185A",
              "TMEM199",
              "TMEM219",
              "TMEM234",
              "TMEM241",
              "TMEM267",
              "TMEM44",
              "TMEM45A",
              "TMEM47",
              "TMEM54",
              "TMEM59",
              "TMEM9",
              "TMSB10",
              "TMSB4XP1",
              "TMSB4XP8",
              "TMTC3",
              "TMUB2",
              "TMX3",
              "TNFRSF1A",
              "TNFSF4",
              "TNRC6A",
              "TOLLIP",
              "TOM1",
              "TOMM70",
              "TOR1AIP1",
              "TP53TG1",
              "TP73-AS1",
              "TPGS1",
              "TPM3",
              "TPRA1",
              "TPST1",
              "TPT1",
              "TRA2B",
              "TRADD",
              "TRAF4",
              "TRAM1",
              "TRAPPC2B",
              "TRAPPC3",
              "TRAPPC4",
              "TRBV12-4",
              "TREH",
              "TRHDE",
              "TRHDE-AS1",
              "TRIM13",
              "TRIM28",
              "TRIM41",
              "TRIM5",
              "TRIM52-AS1",
              "TRIM55",
              "TRIP12",
              "TRMT112",
              "TRNAU1AP",
              "TRNT1",
              "TRPC1",
              "TRPM7",
              "TRUB1",
              "TSC2",
              "TSEN34",
              "TSLP",
              "TSPYL4",
              "TSSK3",
              "TTC21B",
              "TTC37",
              "TTC8",
              "TTC9C",
              "TTK",
              "TTLL3",
              "TUB",
              "TUBB2BP1",
              "TUBG2",
              "TUBGCP4",
              "TUT7",
              "TWISTNB",
              "TXLNA",
              "TXNDC12",
              "TYW1",
              "TYW3",
              "U2AF1",
              "U2AF1L4",
              "U2AF1L5",
              "U62317.2",
              "UBA6",
              "UBA7",
              "UBAC1",
              "UBALD1",
              "UBALD2",
              "UBB",
              "UBC",
              "UBE2A",
              "UBE2I",
              "UBE2J1",
              "UBE2J2",
              "UBE2M",
              "UBE2Q1",
              "UBE2Z",
              "UBLCP1",
              "UBR3",
              "UBTD1",
              "UBXN1",
              "UBXN6",
              "UCHL1",
              "UCHL5",
              "UEVLD",
              "UFD1",
              "UFM1",
              "UGGT1",
              "UGGT2",
              "UGP2",
              "UHMK1",
              "UHRF1BP1L",
              "UIMC1",
              "UNC119",
              "UNC5B",
              "UQCC2",
              "UQCRHL",
              "USE1",
              "USF1",
              "USF2",
              "USO1",
              "USP1",
              "USP44",
              "USP9Y",
              "UTP14A",
              "UXT",
              "VAPA",
              "VBP1",
              "VCAN-AS1",
              "VGLL3",
              "VKORC1L1",
              "VPS13B",
              "VPS26C",
              "VPS4A",
              "VPS50",
              "VPS54",
              "VPS8",
              "VRK2",
              "WARS1",
              "WASF3",
              "WASHC4",
              "WBP1",
              "WBP2",
              "WDR33",
              "WDR43",
              "WDR45",
              "WDR45B",
              "WDR47",
              "WDR54",
              "WDR59",
              "WDR66",
              "WDR7",
              "WDR75",
              "WDR76",
              "WDR82",
              "WIPI1",
              "WIPI2",
              "WWTR1-AS1",
              "XAB2",
              "XAF1",
              "XBP1",
              "XPA",
              "XRCC3",
              "XRN1",
              "YAE1",
              "YDJC",
              "YES1",
              "YJU2",
              "YWHAE",
              "Z83844.3",
              "Z94160.2",
              "ZBED5",
              "ZBTB18",
              "ZBTB22",
              "ZBTB46",
              "ZC3H13",
              "ZC3H15",
              "ZCCHC17",
              "ZDHHC17",
              "ZDHHC2",
              "ZDHHC4",
              "ZFAND2A",
              "ZFAND2B",
              "ZFAND3",
              "ZFAS1",
              "ZFC3H1",
              "ZFHX2-AS1",
              "ZFPL1",
              "ZFYVE19",
              "ZFYVE27",
              "ZMAT3",
              "ZMYM3",
              "ZMYM4-AS1",
              "ZMYND19",
              "ZNF12",
              "ZNF146",
              "ZNF205",
              "ZNF22",
              "ZNF271P",
              "ZNF276",
              "ZNF280D",
              "ZNF302",
              "ZNF32-AS1",
              "ZNF511",
              "ZNF605",
              "ZNF638",
              "ZNF644",
              "ZNF667-AS1",
              "ZNF75A",
              "ZNF814",
              "ZNRF1",
              "ZSCAN9",
              "ZSWIM8",
              "ZW10"
          ],
          "type": "scatter3d",
          "mode": "markers",
          "opacity": 0.7,
          "name": "SARS-GSE56192",
          "marker": {
              color: "#fcbf49"
          }
      }
  ]
};